import React, { useState } from 'react';
import style from './../../Css/Courses.module.css'

function Pythoncoursedata() {
  // State to keep track of the selected chapter
  const [selectedChapter, setSelectedChapter] = useState('chapter1')

  // Function to handle chapter selection
  const handleChapterClick = (chapter) => {
    setSelectedChapter(chapter)
  }

  // State to track the active chapter
  const [activeChapter, setActiveChapter] = useState('chapter1');

  // Function to handle chapter click
  const handleChapterActive = (chapter) => {
    setActiveChapter(chapter);
  };
  const handleClick = (chapter) => {
    handleChapterActive(chapter);
    handleChapterClick(chapter);
    window.scrollTo(0, 0);
  };


  return (
    <div className={`${style.firstcontainer} container-fluid`}>

      <div className={`${style.therow} row d-flex`}>


        <div className={`${style.droupdownbtnbar} dropdown`}>
          <button className={`${style.droupdownbtn} btn dropdown-toggle`} type="button" data-bs-toggle="dropdown" aria-expanded="false">
            Python
          </button>

          <ul className={`${style.dropdownmenu} dropdown-menu`}>

           

            <li onClick={() => handleClick('chapter1')}
              className={`${style.chapter1} ${activeChapter === 'chapter1' ? style.active : ''} text-decoration-none dropdown-item`} >
              Introduction
            </li>


            <li
              onClick={() => handleClick('chapter2')}
              className={`${style.chapter2} ${activeChapter === 'chapter2' ? style.active : ''} dropdown-item `}>
              Syntax
            </li>


            <li onClick={() => handleClick('chapter3')}
              className={`${style.chapter3} ${activeChapter === 'chapter3' ? style.active : ''} dropdown-item `}>
              Comments
            </li>
            

            <li onClick={() => handleClick('chapter4')}
              className={`${style.chapter4} ${activeChapter === 'chapter4' ? style.active : ''} dropdown-item `}>
              Variables Names
            </li>


            <li onClick={() => handleClick('chapter5')}
              className={`${style.chapter5} ${activeChapter === 'chapter5' ? style.active : ''} dropdown-item  `}>
              Assign Multiple values
            </li>


            <li onClick={() => handleClick('chapter6')}
              className={`${style.chapter6} ${activeChapter === 'chapter6' ? style.active : ''} dropdown-item `}>
              Output Variables
            </li>

            <li onClick={() => handleClick('chapter7')}
              className={`${style.chapter7} ${activeChapter === 'chapter7' ? style.active : ''} dropdown-item `}>
              Global Variables
            </li>


            <li onClick={() => handleClick('chapter8')}
              className={`${style.chapter8} ${activeChapter === 'chapter8' ? style.active : ''} dropdown-item `}>
              Data Types
            </li>

            

            <li onClick={() => handleClick('chapter9')}
              className={`${style.chapter9} ${activeChapter === 'chapter9' ? style.active : ''} dropdown-item `}>
              Numbers
            </li>

            <li onClick={() => handleClick('chapter10')}
              className={`${style.chapter10} ${activeChapter === 'chapter10' ? style.active : ''} dropdown-item `}>
              Casting
            </li>

            <li onClick={() => handleClick('chapter11')}
              className={`${style.chapter11} ${activeChapter === 'chapter11' ? style.active : ''} dropdown-item `}>
              Strings
            </li>            

            
            <li onClick={() => handleClick('chapter12')}
              className={`${style.chapter12} ${activeChapter === 'chapter12' ? style.active : ''} dropdown-item `}>
              Boolean 
            </li>


            <li onClick={() => handleClick('chapter13')}
              className={`${style.chapter13} ${activeChapter === 'chapter13' ? style.active : ''} dropdown-item `}>              
            Operators
            </li>


            <h5>List</h5>
            <li onClick={() => handleClick('chapter14')}
              className={`${style.chapter14} ${activeChapter === 'chapter14' ? style.active : ''} dropdown-item `}>
              Python List
            </li>

            <li onClick={() => handleClick('chapter15')}
            className={`${style.chapter15} ${activeChapter === 'chapter15' ? style.active : ''} dropdown-item `}>
            Access List Items
            </li>

            
            <li onClick={() => handleClick('chapter16')}
            className={`${style.chapter16} ${activeChapter === 'chapter16' ? style.active : ''} dropdown-item `}>
            Change List Items
            </li>

            <li onClick={() => handleClick('chapter17')}
            className={`${style.chapter17} ${activeChapter === 'chapter17' ? style.active : ''} dropdown-item `}>
            Add List Items
            </li>


            <li onClick={() => handleClick('chapter18')}
            className={`${style.chapter18} ${activeChapter === 'chapter18' ? style.active : ''} dropdown-item `}>
            Remove List Items
            </li>



            <li onClick={() => handleClick('chapter19')}
            className={`${style.chapter19} ${activeChapter === 'chapter19' ? style.active : ''}  dropdown-item `}>
            Loop List
            </li>

            <li onClick={() => handleClick('chapter20')}
            className={`${style.chapter20} ${activeChapter === 'chapter20' ? style.active : ''} dropdown-item `}>
             List Comprehension
            </li>

            
            <li onClick={() => handleClick('chapter21')}
              className={`${style.chapter21} ${activeChapter === 'chapter21' ? style.active : ''} dropdown-item `}>
              Sort List
            </li>


            <li onClick={() => handleClick('chapter22')}
              className={`${style.chapter22} ${activeChapter === 'chapter22' ? style.active : ''} dropdown-item `}>
              Copy List
            </li>

            <li onClick={() => handleClick('chapter23')}
              className={`${style.chapter23} ${activeChapter === 'chapter23' ? style.active : ''} dropdown-item `}>
              Join Methods
            </li>


            <li onClick={() => handleClick('chapter24')}
              className={`${style.chapter24} ${activeChapter === 'chapter24' ? style.active : ''} dropdown-item `}>
              List Methods
            </li>


            <h5>Tuples In Python</h5>
            <li onClick={() => handleClick('chapter25')}
              className={`${style.chapter25} ${activeChapter === 'chapter25' ? style.active : ''} dropdown-item `}>
              What is python Tuples
            </li>

            <li onClick={() => handleClick('chapter26')}
              className={`${style.chapter26} ${activeChapter === 'chapter26' ? style.active : ''} dropdown-item  `}>
              Access Tuples
            </li>

            <li onClick={() => handleClick('chapter27')}
              className={`${style.chapter27} ${activeChapter === 'chapter27' ? style.active : ''} dropdown-item `}>
              Update Tuples
            </li>


            <li onClick={() => handleClick('chapter28')}
              className={`${style.chapter28} ${activeChapter === 'chapter28' ? style.active : ''} dropdown-item `}>
              Unpack Tuples
            </li>

            
            <li onClick={() => handleClick('chapter29')}
              className={`${style.chapter29} ${activeChapter === 'chapter29' ? style.active : ''} dropdown-item `}>
              Loop Tuples
            </li>

            <li onClick={() => handleClick('chapter30')}
              className={`${style.chapter30} ${activeChapter === 'chapter30' ? style.active : ''} dropdown-item `}>
              Join Tuples
            </li>


            <li onClick={() => handleClick('chapter31')}
              className={`${style.chapter31} ${activeChapter === 'chapter31' ? style.active : ''} dropdown-item `}>
              Tuple Methods
            </li>

            <h5>Sets in Python</h5>
            <li onClick={() => handleClick('chapter32')}
              className={`${style.chapter32} ${activeChapter === 'chapter32' ? style.active : ''} dropdown-item `}>
              What is Python Sets
            </li>

            
            <li onClick={() => handleClick('chapter33')}
              className={`${style.chapter33} ${activeChapter === 'chapter33' ? style.active : ''} dropdown-item `}>
              Access Set Python
            </li>

            <li onClick={() => handleClick('chapter34')}
              className={`${style.chapter34} ${activeChapter === 'chapter34' ? style.active : ''} dropdown-item `}>
              Add set Iteams
            </li>


            <li onClick={() => handleClick('chapter35')}
              className={`${style.chapter35} ${activeChapter === 'chapter35' ? style.active : ''} dropdown-item `}>
              Remove Set Items
            </li>

            <li onClick={() => handleClick('chapter36')}
              className={`${style.chapter36} ${activeChapter === 'chapter36' ? style.active : ''} dropdown-item `}>
              Loop Sets
            </li>

            <li onClick={() => handleClick('chapter113')}
              className={`${style.chapter113} ${activeChapter === 'chapter113' ? style.active : ''} dropdown-item `}>
              Join Sets
            </li>




            <li onClick={() => handleClick('chapter37')}
              className={`${style.chapter37} ${activeChapter === 'chapter37' ? style.active : ''} dropdown-item `}>
              Set Methods
            </li>

            <h5>Dictionaries in Python</h5>
            <li onClick={() => handleClick('chapter38')}
              className={`${style.chapter38} ${activeChapter === 'chapter38' ? style.active : ''} dropdown-item `}>
              Dictionaries in Python
            </li>

            <li onClick={() => handleClick('chapter39')}
              className={`${style.chapter39} ${activeChapter === 'chapter39' ? style.active : ''} dropdown-item `}>
              Access Items
            </li>

            <li onClick={() => handleClick('chapter40')}
              className={`${style.chapter40} ${activeChapter === 'chapter40' ? style.active : ''} dropdown-item `}>
              Change Items
            </li>

            
            <li onClick={() => handleClick('chapter41')}
              className={`${style.chapter41} ${activeChapter === 'chapter41' ? style.active : ''} dropdown-item `}>
              Add Items
            </li>

            <li onClick={() => handleClick('chapter42')}
              className={`${style.chapter42} ${activeChapter === 'chapter42' ? style.active : ''} dropdown-item  `}>
              Remove Items
            </li>

            <li onClick={() => handleClick('chapter43')}
              className={`${style.chapter43} ${activeChapter === 'chapter43' ? style.active : ''} dropdown-item `}>
              Loop Dictionaries
            </li>

            
            <li onClick={() => handleClick('chapter44')}
              className={`${style.chapter44} ${activeChapter === 'chapter44' ? style.active : ''} dropdown-item `}>
              Copy Dictionaries
            </li>

            <li onClick={() => handleClick('chapter45')}
              className={`${style.chapter45} ${activeChapter === 'chapter45' ? style.active : ''} dropdown-item `}>
              Nested Dictionaries
            </li>

            <li onClick={() => handleClick('chapter46')}
              className={`${style.chapter46} ${activeChapter === 'chapter46' ? style.active : ''} dropdown-item `}>
              Dictionary Methods
            </li>

            <h5>Conditional Statements</h5>
            <li onClick={() => handleClick('chapter47')}
              className={`${style.chapter47} ${activeChapter === 'chapter47' ? style.active : ''} dropdown-item `}>
              If...else and elif in python
            </li>

            <h5>Loops</h5>
            <li onClick={() => handleClick('chapter48')}
              className={`${style.chapter48} ${activeChapter === 'chapter48' ? style.active : ''} dropdown-item   `}>
              While Loop
            </li>

            <li onClick={() => handleClick('chapter49')}
              className={`${style.chapter49} ${activeChapter === 'chapter49' ? style.active : ''} dropdown-item `}>
              For Loop
            </li>

            <h5>Functions</h5>
            <li onClick={() => handleClick('chapter50')}
              className={`${style.chapter50} ${activeChapter === 'chapter50' ? style.active : ''} dropdown-item `}>
              Functions in Python
            </li>

             
            <li onClick={() => handleClick('chapter51')}
              className={`${style.chapter51} ${activeChapter === 'chapter51' ? style.active : ''} dropdown-item `}>
              Lambda Functions
            </li>


            <h5>Object-Oriented Programming in Python. OOPS Concepts</h5>
            <li onClick={() => handleClick('chapter52')}
              className={`${style.chapter52} ${activeChapter === 'chapter52' ? style.active : ''} dropdown-item `}>
              Classes/Objects in Python
            </li>


            <li onClick={() => handleClick('chapter53')}
              className={`${style.chapter53} ${activeChapter === 'chapter53' ? style.active : ''} dropdown-item `}>
              Polymorphism in Python
            </li>

            <li onClick={() => handleClick('chapter54')}
              className={`${style.chapter54} ${activeChapter === 'chapter54' ? style.active : ''} dropdown-item `}>
              Encapsulation in Python
            </li>


            <li onClick={() => handleClick('chapter55')}
              className={`${style.chapter55} ${activeChapter === 'chapter55' ? style.active : ''} dropdown-item `}>
              Inheritance in Python
            </li>


            <li onClick={() => handleClick('chapter56')}
              className={`${style.chapter56} ${activeChapter === 'chapter56' ? style.active : ''} dropdown-item `}>
              Data Abstraction in Python
            </li>



            <li onClick={() => handleClick('chapter57')}
              className={`${style.chapter57} ${activeChapter === 'chapter57' ? style.active : ''} dropdown-item `}>
              Python Iterators
            </li>

            <li onClick={() => handleClick('chapter58')}
              className={`${style.chapter58} ${activeChapter === 'chapter58' ? style.active : ''} dropdown-item `}>
              Python Scope
            </li>

            
            <li onClick={() => handleClick('chapter59')}
              className={`${style.chapter59} ${activeChapter === 'chapter59' ? style.active : ''} dropdown-item `}>
              Python module
            </li>

            <li onClick={() => handleClick('chapter60')}
              className={`${style.chapter60} ${activeChapter === 'chapter60' ? style.active : ''} dropdown-item `}>
              Python Dates
            </li>

            <li onClick={() => handleClick('chapter61')}
              className={`${style.chapter61} ${activeChapter === 'chapter61' ? style.active : ''} dropdown-item `}>
              Python Math
            </li>

            <li onClick={() => handleClick('chapter62')}
              className={`${style.chapter62} ${activeChapter === 'chapter62' ? style.active : ''} dropdown-item `}>
              Python RegEx
            </li>


            
            <li onClick={() => handleClick('chapter63')}
              className={`${style.chapter63} ${activeChapter === 'chapter63' ? style.active : ''} dropdown-item `}>
              Python Json
            </li>

            <li onClick={() => handleClick('chapter64')}
              className={`${style.chapter64} ${activeChapter === 'chapter64' ? style.active : ''} dropdown-item `}>
              Python Pip
            </li>


            <li onClick={() => handleClick('chapter65')}
              className={`${style.chapter65} ${activeChapter === 'chapter65' ? style.active : ''} dropdown-item `}>
              Python Try.....Except
            </li>

            <li onClick={() => handleClick('chapter66')}
              className={`${style.chapter66} ${activeChapter === 'chapter66' ? style.active : ''} dropdown-item `}>
              User Input in Python
            </li>


            
            <li onClick={() => handleClick('chapter67')}
              className={`${style.chapter67} ${activeChapter === 'chapter67' ? style.active : ''} dropdown-item `}>
            String Formatting in Python
            </li>


            <h5>File Handling</h5>
            <li onClick={() => handleClick('chapter68')}
              className={`${style.chapter68} ${activeChapter === 'chapter68' ? style.active : ''} dropdown-item `}>
              Python File Handling
            </li>

            <li onClick={() => handleClick('chapter69')}
              className={`${style.chapter69} ${activeChapter === 'chapter69' ? style.active : ''} dropdown-item `}>
              Python Read Files
            </li>

            <li onClick={() => handleClick('chapter70')}
              className={`${style.chapter70} ${activeChapter === 'chapter70' ? style.active : ''} dropdown-item `}>
              Python Write/Create Files
            </li>

            <li onClick={() => handleClick('chapter71')}
              className={`${style.chapter71} ${activeChapter === 'chapter71' ? style.active : ''} dropdown-item `}>
              Python delete Files
            </li>

            <h5>Modules in Python</h5>
            <li onClick={() => handleClick('chapter72')}
              className={`${style.chapter72} ${activeChapter === 'chapter72' ? style.active : ''} dropdown-item `}>
              NumPy Module
            </li>


            <li onClick={() => handleClick('chapter73')}
              className={`${style.chapter73} ${activeChapter === 'chapter73' ? style.active : ''} dropdown-item `}>
              Pandas Module
            </li>

            <li onClick={() => handleClick('chapter74')}
              className={`${style.chapter74} ${activeChapter === 'chapter74' ? style.active : ''} dropdown-item `}>
              SciPy Module
            </li>

            <li onClick={() => handleClick('chapter75')}
              className={`${style.chapter75} ${activeChapter === 'chapter75' ? style.active : ''} dropdown-item `}>
              Django Module
            </li>


            <h5>Matplotlib</h5>
            <li onClick={() => handleClick('chapter76')}
              className={`${style.chapter76} ${activeChapter === 'chapter76' ? style.active : ''} dropdown-item `}>
              Inro/Get Startes
            </li>

            <li onClick={() => handleClick('chapter77')}
              className={`${style.chapter77} ${activeChapter === 'chapter77' ? style.active : ''} dropdown-item `}>
              Matplotlib Pyplot
            </li>

            <li onClick={() => handleClick('chapter78')}
              className={`${style.chapter78} ${activeChapter === 'chapter78' ? style.active : ''} dropdown-item `}>
              Matplotlib Plotting
            </li>

            <li onClick={() => handleClick('chapter79')}
              className={`${style.chapter79} ${activeChapter === 'chapter79' ? style.active : ''} dropdown-item `}>
              Matplotlib Markers
            </li>

            <li onClick={() => handleClick('chapter80')}
              className={`${style.chapter80} ${activeChapter === 'chapter80' ? style.active : ''} dropdown-item `}>
              Matplotlib Line
            </li>

            
            <li onClick={() => handleClick('chapter81')}
              className={`${style.chapter81} ${activeChapter === 'chapter81' ? style.active : ''} dropdown-item `}>
              Matplotlib Labels
            </li>

            <li onClick={() => handleClick('chapter82')}
              className={`${style.chapter82} ${activeChapter === 'chapter82' ? style.active : ''} dropdown-item `}>
              Matplotlib Grid
            </li>

            <li onClick={() => handleClick('chapter83')}
              className={`${style.chapter83} ${activeChapter === 'chapter83' ? style.active : ''} dropdown-item `}>
              Matplotlib Subplot
            </li>

            <li onClick={() => handleClick('chapter84')}
              className={`${style.chapter84} ${activeChapter === 'chapter84' ? style.active : ''} dropdown-item `}>
              Matplotlib Scatter
            </li>

            <li onClick={() => handleClick('chapter85')}
              className={`${style.chapter85} ${activeChapter === 'chapter85' ? style.active : ''} dropdown-item `}>
              Matplotlib Bars
            </li>


            <li onClick={() => handleClick('chapter86')}
              className={`${style.chapter86} ${activeChapter === 'chapter86' ? style.active : ''} dropdown-item `}>
              Matplotlib Histograms
            </li>

            
            <li onClick={() => handleClick('chapter87')}
              className={`${style.chapter87} ${activeChapter === 'chapter87' ? style.active : ''} dropdown-item `}>
              Matplotlib Pie Charts
            </li>

            <h5>Python MySQL</h5>
            <li onClick={() => handleClick('chapter88')}
              className={`${style.chapter88} ${activeChapter === 'chapter88' ? style.active : ''} dropdown-item `}>
              Intro/Get Started
            </li>

            <li onClick={() => handleClick('chapter89')}
              className={`${style.chapter89} ${activeChapter === 'chapter89' ? style.active : ''} dropdown-item `}>
              Create Database
            </li>

            <li onClick={() => handleClick('chapter90')}
              className={`${style.chapter90} ${activeChapter === 'chapter90' ? style.active : ''} dropdown-item `}>
              Create Table
            </li>

            <li onClick={() => handleClick('chapter91')}
              className={`${style.chapter91} ${activeChapter === 'chapter91' ? style.active : ''} dropdown-item `}>
              Insert
            </li>


            
            <li onClick={() => handleClick('chapter92')}
              className={`${style.chapter92} ${activeChapter === 'chapter92' ? style.active : ''} dropdown-item `}>
              Select
            </li>


            <li onClick={() => handleClick('chapter93')}
              className={`${style.chapter93} ${activeChapter === 'chapter93' ? style.active : ''} dropdown-item `}>
              Where
            </li>

            <li onClick={() => handleClick('chapter94')}
              className={`${style.chapter94} ${activeChapter === 'chapter94' ? style.active : ''} dropdown-item `}>
              Order By
            </li>

            <li onClick={() => handleClick('chapter95')}
              className={`${style.chapter95} ${activeChapter === 'chapter95' ? style.active : ''} dropdown-item `}>
              Delete
            </li>

            <li onClick={() => handleClick('chapter96')}
              className={`${style.chapter96} ${activeChapter === 'chapter96' ? style.active : ''} dropdown-item `}>
              Drop Table
            </li>

            
            <li onClick={() => handleClick('chapter97')}
              className={`${style.chapter97} ${activeChapter === 'chapter97' ? style.active : ''} dropdown-item `}>
              Update
            </li>


            <li onClick={() => handleClick('chapter98')}
              className={`${style.chapter98} ${activeChapter === 'chapter98' ? style.active : ''} dropdown-item `}>
              Join
            </li>

            <li onClick={() => handleClick('chapter99')}
              className={`${style.chapter99} ${activeChapter === 'chapter99' ? style.active : ''} dropdown-item `}>
              Limit
            </li>

            <h5>MongoDB in python</h5>
            <li onClick={() => handleClick('chapter100')}
              className={`${style.chapter100} ${activeChapter === 'chapter100' ? style.active : ''} dropdown-item `}>
              Intro/Get Started
            </li>


            <li onClick={() => handleClick('chapter101')}
              className={`${style.chapter101} ${activeChapter === 'chapter101' ? style.active : ''} dropdown-item `}>
              Create Database
            </li>

            
            <li onClick={() => handleClick('chapter102')}
              className={`${style.chapter102} ${activeChapter === 'chapter102' ? style.active : ''} dropdown-item `}>
              Collection
            </li>


            <li onClick={() => handleClick('chapter103')}
              className={`${style.chapter103} ${activeChapter === 'chapter103' ? style.active : ''} dropdown-item `}>
              Insert
            </li>


            <li onClick={() => handleClick('chapter104')}
              className={`${style.chapter104} ${activeChapter === 'chapter104' ? style.active : ''} dropdown-item `}>
              Find
            </li>


            <li onClick={() => handleClick('chapter105')}
              className={`${style.chapter105} ${activeChapter === 'chapter105' ? style.active : ''} dropdown-item `}>
              Query
            </li>

            
            <li onClick={() => handleClick('chapter106')}
              className={`${style.chapter106} ${activeChapter === 'chapter106' ? style.active : ''} dropdown-item `}>
              Sort
            </li>


            <li onClick={() => handleClick('chapter107')}
              className={`${style.chapter107} ${activeChapter === 'chapter107' ? style.active : ''} dropdown-item `}>
              Delete
            </li>


            <li onClick={() => handleClick('chapter108')}
              className={`${style.chapter108} ${activeChapter === 'chapter108' ? style.active : ''}  dropdown-item `}>
              Drop Collection
            </li>

            <li onClick={() => handleClick('chapter109')}
              className={`${style.chapter109} ${activeChapter === 'chapter109' ? style.active : ''} dropdown-item `}>
              Update
            </li>

            
            <li onClick={() => handleClick('chapter110')}
              className={`${style.chapter110} ${activeChapter === 'chapter110' ? style.active : ''} dropdown-item `}>
              Limit
            </li>


            <h5>Python Excersise</h5>
            <li onClick={() => handleClick('chapter111')}
              className={`${style.chapter111} ${activeChapter === 'chapter111' ? style.active : ''} dropdown-item `}>
              Questions and Answers
            </li>


            <li onClick={() => handleClick('chapter112')}
              className={`${style.chapter112} ${activeChapter === 'chapter112' ? style.active : ''} dropdown-item `}>
              Practices Questions
            </li>




          </ul>
        </div>





        <div className={`${style.leftcolumn} col-2`}>

          <ul className={`${style.chapters} `}>
            <h5 className={style.stickyheading} >Python</h5>

            <li
              onClick={() => handleClick('chapter1')}
              className={`${style.chapter1} ${activeChapter === 'chapter1' ? style.active : ''} `}>
              Introduction
            </li>


            <li
              onClick={() => handleClick('chapter2')}
              className={`${style.chapter2} ${activeChapter === 'chapter2' ? style.active : ''}  `}>
              Syntax
            </li>


            <li onClick={() => handleClick('chapter3')}
              className={`${style.chapter3} ${activeChapter === 'chapter3' ? style.active : ''} `}>
              Comments
            </li>
            

            <li onClick={() => handleClick('chapter4')}
              className={`${style.chapter4} ${activeChapter === 'chapter4' ? style.active : ''}  `}>
              Variables Names
            </li>


            <li onClick={() => handleClick('chapter5')}
              className={`${style.chapter5} ${activeChapter === 'chapter5' ? style.active : ''}  `}>
              Assign Multiple values
            </li>


            <li onClick={() => handleClick('chapter6')}
              className={`${style.chapter6} ${activeChapter === 'chapter6' ? style.active : ''} `}>
              Output Variables
            </li>

            <li onClick={() => handleClick('chapter7')}
              className={`${style.chapter7} ${activeChapter === 'chapter7' ? style.active : ''} `}>
              Global Variables
            </li>


            <li onClick={() => handleClick('chapter8')}
              className={`${style.chapter8} ${activeChapter === 'chapter8' ? style.active : ''}  `}>
              Data Types
            </li>

            

            <li onClick={() => handleClick('chapter9')}
              className={`${style.chapter9} ${activeChapter === 'chapter9' ? style.active : ''} `}>
              Numbers
            </li>

            <li onClick={() => handleClick('chapter10')}
              className={`${style.chapter10} ${activeChapter === 'chapter10' ? style.active : ''}  `}>
              Casting
            </li>

            <li onClick={() => handleClick('chapter11')}
              className={`${style.chapter11} ${activeChapter === 'chapter11' ? style.active : ''} `}>
              Strings
            </li>            

            
            <li onClick={() => handleClick('chapter12')}
              className={`${style.chapter12} ${activeChapter === 'chapter12' ? style.active : ''} `}>
              Boolean 
            </li>


            <li onClick={() => handleClick('chapter13')}
              className={`${style.chapter13} ${activeChapter === 'chapter13' ? style.active : ''}  `}>              
            Operators
            </li>


            <h5>List</h5>
            <li onClick={() => handleClick('chapter14')}
              className={`${style.chapter14} ${activeChapter === 'chapter14' ? style.active : ''}  `}>
              Python List
            </li>

            <li onClick={() => handleClick('chapter15')}
            className={`${style.chapter15} ${activeChapter === 'chapter15' ? style.active : ''}  `}>
            Access List Items
            </li>

            
            <li onClick={() => handleClick('chapter16')}
            className={`${style.chapter16} ${activeChapter === 'chapter16' ? style.active : ''}  `}>
            Change List Items
            </li>

            <li onClick={() => handleClick('chapter17')}
            className={`${style.chapter17} ${activeChapter === 'chapter17' ? style.active : ''}  `}>
            Add List Items
            </li>


            <li onClick={() => handleClick('chapter18')}
            className={`${style.chapter18} ${activeChapter === 'chapter18' ? style.active : ''}  `}>
            Remove List Items
            </li>



            <li onClick={() => handleClick('chapter19')}
            className={`${style.chapter19} ${activeChapter === 'chapter19' ? style.active : ''}  `}>
            Loop List
            </li>

            <li onClick={() => handleClick('chapter20')}
            className={`${style.chapter20} ${activeChapter === 'chapter20' ? style.active : ''}  `}>
             List Comprehension
            </li>

            
            <li onClick={() => handleClick('chapter21')}
              className={`${style.chapter21} ${activeChapter === 'chapter21' ? style.active : ''}  `}>
              Sort List
            </li>


            <li onClick={() => handleClick('chapter22')}
              className={`${style.chapter22} ${activeChapter === 'chapter22' ? style.active : ''}  `}>
              Copy List
            </li>

            <li onClick={() => handleClick('chapter23')}
              className={`${style.chapter23} ${activeChapter === 'chapter23' ? style.active : ''}  `}>
              Join Methods
            </li>


            <li onClick={() => handleClick('chapter24')}
              className={`${style.chapter24} ${activeChapter === 'chapter24' ? style.active : ''}  `}>
              List Methods
            </li>


            <h5>Tuples In Python</h5>
            <li onClick={() => handleClick('chapter25')}
              className={`${style.chapter25} ${activeChapter === 'chapter25' ? style.active : ''}  `}>
              What is python Tuples
            </li>

            <li onClick={() => handleClick('chapter26')}
              className={`${style.chapter26} ${activeChapter === 'chapter26' ? style.active : ''}  `}>
              Access Tuples
            </li>

            <li onClick={() => handleClick('chapter27')}
              className={`${style.chapter27} ${activeChapter === 'chapter27' ? style.active : ''}  `}>
              Update Tuples
            </li>


            <li onClick={() => handleClick('chapter28')}
              className={`${style.chapter28} ${activeChapter === 'chapter28' ? style.active : ''}  `}>
              Unpack Tuples
            </li>

            
            <li onClick={() => handleClick('chapter29')}
              className={`${style.chapter29} ${activeChapter === 'chapter29' ? style.active : ''} `}>
              Loop Tuples
            </li>

            <li onClick={() => handleClick('chapter30')}
              className={`${style.chapter30} ${activeChapter === 'chapter30' ? style.active : ''} `}>
              Join Tuples
            </li>


            <li onClick={() => handleClick('chapter31')}
              className={`${style.chapter31} ${activeChapter === 'chapter31' ? style.active : ''} `}>
              Tuple Methods
            </li>

            <h5>Sets in Python</h5>
            <li onClick={() => handleClick('chapter32')}
              className={`${style.chapter32} ${activeChapter === 'chapter32' ? style.active : ''} `}>
              What is Python Sets
            </li>

            
            <li onClick={() => handleClick('chapter33')}
              className={`${style.chapter33} ${activeChapter === 'chapter33' ? style.active : ''} `}>
              Access Set Python
            </li>

            <li onClick={() => handleClick('chapter34')}
              className={`${style.chapter34} ${activeChapter === 'chapter34' ? style.active : ''} `}>
              Add set Iteams
            </li>


            <li onClick={() => handleClick('chapter35')}
              className={`${style.chapter35} ${activeChapter === 'chapter35' ? style.active : ''}  `}>
              Remove Set Items
            </li>

            <li onClick={() => handleClick('chapter36')}
              className={`${style.chapter36} ${activeChapter === 'chapter36' ? style.active : ''}  `}>
              Loop Sets
            </li>

            <li onClick={() => handleClick('chapter113')}
              className={`${style.chapter113} ${activeChapter === 'chapter113' ? style.active : ''}  `}>
              Join Sets
            </li>




            <li onClick={() => handleClick('chapter37')}
              className={`${style.chapter37} ${activeChapter === 'chapter37' ? style.active : ''}  `}>
              Set Methods
            </li>

            <h5>Dictionaries in Python</h5>
            <li onClick={() => handleClick('chapter38')}
              className={`${style.chapter38} ${activeChapter === 'chapter38' ? style.active : ''}  `}>
              Dictionaries in Python
            </li>

            <li onClick={() => handleClick('chapter39')}
              className={`${style.chapter39} ${activeChapter === 'chapter39' ? style.active : ''}  `}>
              Access Items
            </li>

            <li onClick={() => handleClick('chapter40')}
              className={`${style.chapter40} ${activeChapter === 'chapter40' ? style.active : ''}  `}>
              Change Items
            </li>

            
            <li onClick={() => handleClick('chapter41')}
              className={`${style.chapter41} ${activeChapter === 'chapter41' ? style.active : ''}  `}>
              Add Items
            </li>

            <li onClick={() => handleClick('chapter42')}
              className={`${style.chapter42} ${activeChapter === 'chapter42' ? style.active : ''}  `}>
              Remove Items
            </li>

            <li onClick={() => handleClick('chapter43')}
              className={`${style.chapter43} ${activeChapter === 'chapter43' ? style.active : ''}  `}>
              Loop Dictionaries
            </li>

            
            <li onClick={() => handleClick('chapter44')}
              className={`${style.chapter44} ${activeChapter === 'chapter44' ? style.active : ''}  `}>
              Copy Dictionaries
            </li>

            <li onClick={() => handleClick('chapter45')}
              className={`${style.chapter45} ${activeChapter === 'chapter45' ? style.active : ''}  `}>
              Nested Dictionaries
            </li>

            <li onClick={() => handleClick('chapter46')}
              className={`${style.chapter46} ${activeChapter === 'chapter46' ? style.active : ''}  `}>
              Dictionary Methods
            </li>

            <h5>Conditional Statements</h5>
            <li onClick={() => handleClick('chapter47')}
              className={`${style.chapter47} ${activeChapter === 'chapter47' ? style.active : ''}  `}>
              If...else and elif in python
            </li>

            <h5>Loops</h5>
            <li onClick={() => handleClick('chapter48')}
              className={`${style.chapter48} ${activeChapter === 'chapter48' ? style.active : ''}  `}>
              While Loop
            </li>

            <li onClick={() => handleClick('chapter49')}
              className={`${style.chapter49} ${activeChapter === 'chapter49' ? style.active : ''}  `}>
              For Loop
            </li>

            <h5>Functions</h5>
            <li onClick={() => handleClick('chapter50')}
              className={`${style.chapter50} ${activeChapter === 'chapter50' ? style.active : ''}  `}>
              Functions in Python
            </li>

             
            <li onClick={() => handleClick('chapter51')}
              className={`${style.chapter51} ${activeChapter === 'chapter51' ? style.active : ''}  `}>
              Lambda Functions
            </li>


            <h5>Object-Oriented Programming in Python. OOPS Concepts</h5>
            <li onClick={() => handleClick('chapter52')}
              className={`${style.chapter52} ${activeChapter === 'chapter52' ? style.active : ''}  `}>
              Classes/Objects in Python
            </li>


            <li onClick={() => handleClick('chapter53')}
              className={`${style.chapter53} ${activeChapter === 'chapter53' ? style.active : ''}  `}>
              Polymorphism in Python
            </li>

            <li onClick={() => handleClick('chapter54')}
              className={`${style.chapter54} ${activeChapter === 'chapter54' ? style.active : ''}  `}>
              Encapsulation in Python
            </li>


            <li onClick={() => handleClick('chapter55')}
              className={`${style.chapter55} ${activeChapter === 'chapter55' ? style.active : ''}  `}>
              Inheritance in Python
            </li>


            <li onClick={() => handleClick('chapter56')}
              className={`${style.chapter56} ${activeChapter === 'chapter56' ? style.active : ''}  `}>
              Data Abstraction in Python
            </li>



            <li onClick={() => handleClick('chapter57')}
              className={`${style.chapter57} ${activeChapter === 'chapter57' ? style.active : ''}  `}>
              Python Iterators
            </li>

            <li onClick={() => handleClick('chapter58')}
              className={`${style.chapter58} ${activeChapter === 'chapter58' ? style.active : ''}  `}>
              Python Scope
            </li>

            
            <li onClick={() => handleClick('chapter59')}
              className={`${style.chapter59} ${activeChapter === 'chapter59' ? style.active : ''}  `}>
              Python module
            </li>

            <li onClick={() => handleClick('chapter60')}
              className={`${style.chapter60} ${activeChapter === 'chapter60' ? style.active : ''}  `}>
              Python Dates
            </li>

            <li onClick={() => handleClick('chapter61')}
              className={`${style.chapter61} ${activeChapter === 'chapter61' ? style.active : ''}  `}>
              Python Math
            </li>

            <li onClick={() => handleClick('chapter62')}
              className={`${style.chapter62} ${activeChapter === 'chapter62' ? style.active : ''}  `}>
              Python RegEx
            </li>


            
            <li onClick={() => handleClick('chapter63')}
              className={`${style.chapter63} ${activeChapter === 'chapter63' ? style.active : ''}  `}>
              Python Json
            </li>

            <li onClick={() => handleClick('chapter64')}
              className={`${style.chapter64} ${activeChapter === 'chapter64' ? style.active : ''}  `}>
              Python Pip
            </li>


            <li onClick={() => handleClick('chapter65')}
              className={`${style.chapter65} ${activeChapter === 'chapter65' ? style.active : ''}  `}>
              Python Try.....Except
            </li>

            <li onClick={() => handleClick('chapter66')}
              className={`${style.chapter66} ${activeChapter === 'chapter66' ? style.active : ''}  `}>
              User Input in Python
            </li>


            
            <li onClick={() => handleClick('chapter67')}
              className={`${style.chapter67} ${activeChapter === 'chapter67' ? style.active : ''}  `}>
            String Formatting in Python
            </li>


            <h5>File Handling</h5>
            <li onClick={() => handleClick('chapter68')}
              className={`${style.chapter68} ${activeChapter === 'chapter68' ? style.active : ''}  `}>
              Python File Handling
            </li>

            <li onClick={() => handleClick('chapter69')}
              className={`${style.chapter69} ${activeChapter === 'chapter69' ? style.active : ''}  `}>
              Python Read Files
            </li>

            <li onClick={() => handleClick('chapter70')}
              className={`${style.chapter70} ${activeChapter === 'chapter70' ? style.active : ''}  `}>
              Python Write/Create Files
            </li>

            <li onClick={() => handleClick('chapter71')}
              className={`${style.chapter71} ${activeChapter === 'chapter71' ? style.active : ''}  `}>
              Python delete Files
            </li>

            <h5>Modules in Python</h5>
            <li onClick={() => handleClick('chapter72')}
              className={`${style.chapter72} ${activeChapter === 'chapter72' ? style.active : ''}  `}>
              NumPy Module
            </li>


            <li onClick={() => handleClick('chapter73')}
              className={`${style.chapter73} ${activeChapter === 'chapter73' ? style.active : ''}  `}>
              Pandas Module
            </li>

            <li onClick={() => handleClick('chapter74')}
              className={`${style.chapter74} ${activeChapter === 'chapter74' ? style.active : ''}  `}>
              SciPy Module
            </li>

            <li onClick={() => handleClick('chapter75')}
              className={`${style.chapter75} ${activeChapter === 'chapter75' ? style.active : ''}  `}>
              Django Module
            </li>


            <h5>Matplotlib</h5>
            <li onClick={() => handleClick('chapter76')}
              className={`${style.chapter76} ${activeChapter === 'chapter76' ? style.active : ''}  `}>
              Inro/Get Startes
            </li>

            <li onClick={() => handleClick('chapter77')}
              className={`${style.chapter77} ${activeChapter === 'chapter77' ? style.active : ''}  `}>
              Matplotlib Pyplot
            </li>

            <li onClick={() => handleClick('chapter78')}
              className={`${style.chapter78} ${activeChapter === 'chapter78' ? style.active : ''}  `}>
              Matplotlib Plotting
            </li>

            <li onClick={() => handleClick('chapter79')}
              className={`${style.chapter79} ${activeChapter === 'chapter79' ? style.active : ''}  `}>
              Matplotlib Markers
            </li>

            <li onClick={() => handleClick('chapter80')}
              className={`${style.chapter80} ${activeChapter === 'chapter80' ? style.active : ''}  `}>
              Matplotlib Line
            </li>

            
            <li onClick={() => handleClick('chapter81')}
              className={`${style.chapter81} ${activeChapter === 'chapter81' ? style.active : ''}  `}>
              Matplotlib Labels
            </li>

            <li onClick={() => handleClick('chapter82')}
              className={`${style.chapter82} ${activeChapter === 'chapter82' ? style.active : ''}  `}>
              Matplotlib Grid
            </li>

            <li onClick={() => handleClick('chapter83')}
              className={`${style.chapter83} ${activeChapter === 'chapter83' ? style.active : ''}  `}>
              Matplotlib Subplot
            </li>

            <li onClick={() => handleClick('chapter84')}
              className={`${style.chapter84} ${activeChapter === 'chapter84' ? style.active : ''}  `}>
              Matplotlib Scatter
            </li>

            <li onClick={() => handleClick('chapter85')}
              className={`${style.chapter85} ${activeChapter === 'chapter85' ? style.active : ''}  `}>
              Matplotlib Bars
            </li>


            <li onClick={() => handleClick('chapter86')}
              className={`${style.chapter86} ${activeChapter === 'chapter86' ? style.active : ''}  `}>
              Matplotlib Histograms
            </li>

            
            <li onClick={() => handleClick('chapter87')}
              className={`${style.chapter87} ${activeChapter === 'chapter87' ? style.active : ''}  `}>
              Matplotlib Pie Charts
            </li>

            <h5>Python MySQL</h5>
            <li onClick={() => handleClick('chapter88')}
              className={`${style.chapter88} ${activeChapter === 'chapter88' ? style.active : ''}  `}>
              Intro/Get Started
            </li>

            <li onClick={() => handleClick('chapter89')}
              className={`${style.chapter89} ${activeChapter === 'chapter89' ? style.active : ''}  `}>
              Create Database
            </li>

            <li onClick={() => handleClick('chapter90')}
              className={`${style.chapter90} ${activeChapter === 'chapter90' ? style.active : ''}  `}>
              Create Table
            </li>

            <li onClick={() => handleClick('chapter91')}
              className={`${style.chapter91} ${activeChapter === 'chapter91' ? style.active : ''}  `}>
              Insert
            </li>


            
            <li onClick={() => handleClick('chapter92')}
              className={`${style.chapter92} ${activeChapter === 'chapter92' ? style.active : ''}  `}>
              Select
            </li>


            <li onClick={() => handleClick('chapter93')}
              className={`${style.chapter93} ${activeChapter === 'chapter93' ? style.active : ''} `}>
              Where
            </li>

            <li onClick={() => handleClick('chapter94')}
              className={`${style.chapter94} ${activeChapter === 'chapter94' ? style.active : ''}  `}>
              Order By
            </li>

            <li onClick={() => handleClick('chapter95')}
              className={`${style.chapter95} ${activeChapter === 'chapter95' ? style.active : ''}  `}>
              Delete
            </li>

            <li onClick={() => handleClick('chapter96')}
              className={`${style.chapter96} ${activeChapter === 'chapter96' ? style.active : ''}  `}>
              Drop Table
            </li>

            
            <li onClick={() => handleClick('chapter97')}
              className={`${style.chapter97} ${activeChapter === 'chapter97' ? style.active : ''}  `}>
              Update
            </li>


            <li onClick={() => handleClick('chapter98')}
              className={`${style.chapter98} ${activeChapter === 'chapter98' ? style.active : ''}  `}>
              Join
            </li>

            <li onClick={() => handleClick('chapter99')}
              className={`${style.chapter99} ${activeChapter === 'chapter99' ? style.active : ''}  `}>
              Limit
            </li>

            <h5>MongoDB in python</h5>
            <li onClick={() => handleClick('chapter100')}
              className={`${style.chapter100} ${activeChapter === 'chapter100' ? style.active : ''}  `}>
              Intro/Get Started
            </li>


            <li onClick={() => handleClick('chapter101')}
              className={`${style.chapter101} ${activeChapter === 'chapter101' ? style.active : ''}  `}>
              Create Database
            </li>

            
            <li onClick={() => handleClick('chapter102')}
              className={`${style.chapter102} ${activeChapter === 'chapter102' ? style.active : ''}  `}>
              Collection
            </li>


            <li onClick={() => handleClick('chapter103')}
              className={`${style.chapter103} ${activeChapter === 'chapter103' ? style.active : ''}  `}>
              Insert
            </li>


            <li onClick={() => handleClick('chapter104')}
              className={`${style.chapter104} ${activeChapter === 'chapter104' ? style.active : ''} `}>
              Find
            </li>


            <li onClick={() => handleClick('chapter105')}
              className={`${style.chapter105} ${activeChapter === 'chapter105' ? style.active : ''} `}>
              Query
            </li>

            
            <li onClick={() => handleClick('chapter106')}
              className={`${style.chapter106} ${activeChapter === 'chapter106' ? style.active : ''} `}>
              Sort
            </li>


            <li onClick={() => handleClick('chapter107')}
              className={`${style.chapter107} ${activeChapter === 'chapter107' ? style.active : ''} `}>
              Delete
            </li>


            <li onClick={() => handleClick('chapter108')}
              className={`${style.chapter108} ${activeChapter === 'chapter108' ? style.active : ''} `}>
              Drop Collection
            </li>

            <li onClick={() => handleClick('chapter109')}
              className={`${style.chapter109} ${activeChapter === 'chapter109' ? style.active : ''} `}>
              Update
            </li>

            
            <li onClick={() => handleClick('chapter110')}
              className={`${style.chapter110} ${activeChapter === 'chapter110' ? style.active : ''} `}>
              Limit
            </li>


            <h5>Python Excersise</h5>
            <li onClick={() => handleClick('chapter111')}
              className={`${style.chapter111} ${activeChapter === 'chapter111' ? style.active : ''} `}>
              Questions and Answers
            </li>


            <li onClick={() => handleClick('chapter112')}
              className={`${style.chapter112} ${activeChapter === 'chapter112' ? style.active : ''} `}>
              Practices Questions
            </li>



          </ul>
        </div>




        <div className={`${style.rightcolumn} col`}>


          {/* Chapter Content */}


          {selectedChapter === 'chapter1' && (
            <div className={style.chaptercontent}>
              <h1 className={style.heading}> Introduction </h1>

          <p>
            Python is a versatile, high-level programming language known for its simplicity and readability, making it a popular choice for beginners and professionals alike. Created by Guido van Rossum and first released in 1991, Python has grown to become one of the most widely used languages in software development, data science, web development, automation, and more.
          </p><br/>

          <h2 style={{paddingBottom:"6px"}} >Key Features of Python</h2>
          <ul>
            <li><strong>Simple and Readable Syntax</strong>: Python code resembles English, making it easy to learn and understand.</li><br/>
            <li><strong>Interpreted Language</strong>: Python code is executed line by line, which simplifies debugging and testing.</li><br/>
            <li><strong>Dynamically Typed</strong>: Variables don’t require explicit declarations; their types are determined at runtime.</li><br/>
            <li><strong>Extensive Libraries</strong>: Python has a rich ecosystem of libraries like NumPy, Pandas, Matplotlib, and TensorFlow, catering to various domains.</li><br/>
            <li><strong>Cross-Platform Compatibility</strong>: Python runs on multiple platforms, including Windows, Mac, and Linux.</li><br/>
            <li><strong>Community Support</strong>: A large and active community helps maintain Python’s growth and offers support through forums and documentation.</li>
          </ul><br/>

          <h2 style={{paddingBottom:"6px"}}>Installing Python</h2>
          <p>
            If Python isn’t already installed, you can download it from <a href="https://www.python.org/" target="_blank" rel="noopener noreferrer">python.org</a>. Once installed, you can use the command line or terminal to start writing and running Python scripts.
          </p><br/>

          <h2 style={{paddingBottom:"6px"}}>Writing Your First Python Program</h2>
          <p>Python scripts usually have a <code>.py</code> extension. Here's a classic example: the "Hello, World!" program.</p>
          <pre>
            <code>print("Hello, World!")</code>
          </pre>
          <p>This will output:</p>
          <pre>
            <code>Hello, World!</code>
          </pre><br/>

          <h2 >Basic Syntax</h2>
          <h3>1. Variables and Data Types</h3>
          <p>Variables are created by assigning values without needing a specific declaration. Common data types include integers, floating-point numbers, strings, and booleans.</p>
          <pre>
            <code>
              {`x = 10         # integer
y = 3.14       # float
name = "Alice" # string
is_valid = True  # boolean`}
            </code>
          </pre><br/>

          <h3 >2. Operators</h3>
          <p>Python supports various operators:</p>
          <ul>
            <li>Arithmetic: <code>+</code>, <code>-</code>, <code>*</code>, <code>/</code>, <code>**</code> (exponent), <code>%</code> (modulus)</li>
            <li>Comparison: <code>==</code>, <code>!=</code>, <code>&lt;</code>, <code>&gt;</code>, <code>&lt;=</code>, <code>&gt;=</code></li>
            <li>Logical: <code>and</code>, <code>or</code>, <code>not</code></li>
          </ul>
          <pre>
            <code>
              {`result = x + y
is_greater = x > y`}
            </code>
          </pre><br/>

          <h3 >3. Control Flow (If-Else)</h3>
          <p>Python uses indentation to define blocks of code, eliminating the need for braces <code>{'{}'}</code>.</p>
          <pre>
            <code>
              {`age = 18
if age >= 18:
    print("You are an adult.")
else:
    print("You are a minor.")`}
            </code>
          </pre><br/>

          <h3 >4. Loops</h3>
          <p><code>for</code> and <code>while</code> loops are used for iteration.</p>
          <pre>
            <code>
              {`# For loop
for i in range(5):
    print(i)  # Prints 0 to 4

# While loop
count = 0
while count < 5:
    print(count)
    count += 1`}
            </code>
          </pre><br/>

          <h3 >5. Functions</h3>
          <p>Functions are defined using the <code>def</code> keyword.</p>
          <pre>
            <code>
              {`def greet(name):
    return f"Hello, {name}!"

print(greet("Alice"))  # Outputs: Hello, Alice!`}
            </code>
          </pre><br/>

          <h3 >6. Lists and Dictionaries</h3>
          <p>Lists are ordered collections of items, while dictionaries store key-value pairs.</p>
          <pre >
            <code>
              {`# List
fruits = ["apple", "banana", "cherry"]
print(fruits[1])  # Outputs: banana

# Dictionary
person = {"name": "Alice", "age": 25}
print(person["name"])  # Outputs: Alice`}
            </code>
          </pre><br/>

          <h2>Running Python Code</h2>
          <p>To run a Python file (<code>example.py</code>), use the command:</p>
          <pre >
            <code>python example.py</code>
          </pre><br/>

          <h2 >Exploring Further</h2>
          <p>Python offers a wide range of libraries and features that cater to various fields:</p>
          <ul>
            <li><strong>Data Science</strong>: <code>pandas</code>, <code>numpy</code>, <code>matplotlib</code>, <code>scikit-learn</code></li><br/>
            <li><strong>Web Development</strong>: <code>Django</code>, <code>Flask</code></li><br/>
            <li><strong>Automation</strong>: <code>selenium</code>, <code>beautifulsoup4</code></li><br/>
            <li><strong>Machine Learning</strong>: <code>tensorflow</code>, <code>keras</code></li>
          </ul><br/>
          <p>
            Starting with Python basics is easy, and the language is very supportive of gradual learning and specialization. Let me know if you need further help with any specific Python topics!
          </p>        


            </div>
          )}



        {selectedChapter === 'chapter2' && (
          <div className={style.chaptercontent}>
             <h1 className={style.heading}>Syntax</h1>
    <p>
      In Python, syntax refers to the structure of the code, like how you write statements and expressions.
      Here’s a quick overview of basic syntax in Python:
    </p>
    <p>
      In Python, proper indentation and the <code>print</code> function are essential parts of writing and
      running code smoothly. Here’s a quick look at both.
    </p><br/>

    <h3>1. Printing in Python</h3>
    <p>The <code>print()</code> function outputs data to the console. It can display strings, numbers, and even variable values.</p>
    <pre style={{paddingBottom:"6px"}}>
      <code>
{`print("Hello, World!")  # Prints a string
print(42)               # Prints an integer
name = "Alice"
print("Hello,", name)   # Prints a variable`}
      </code>
    </pre>

    
    <ul>
      <li>Concatenating strings: Use <code>+</code> to join strings.</li>
      <pre>
        <code>{`print("Hello, " + name)`}</code>
      </pre>
      <li>Using commas: Commas separate different elements, automatically adding a space.</li>
      <pre>
        <code>{`print("Hello,", name)`}</code>
      </pre>
      <li>Formatted strings: Use <code>f""</code> to embed variables directly.</li>
      <pre>
        <code>{`age = 25
print(f"{name} is {age} years old")`}</code>
      </pre>
    </ul><br/>

    <h3>2. Ind</h3>
    <p>
      Python uses indentation (spaces or tabs) to define blocks of code. Unlike other languages that use braces
      <code>{`{}`}</code>, Python requires consistent indentation to mark the start and end of code blocks.
    </p>
    <ul>
      <li>Typical Indentation Level: 4 spaces is standard.</li>
      <li>Where Indentation Is Required: After control structures like <code>if</code>, <code>for</code>, <code>while</code>, and function definitions.</li>
    </ul>

    
    <ul>
      <li>
        Using <code>if</code> statements with indentation:
        <pre>
          <code>{`age = 20
if age >= 18:
    print("You are an adult.")  # Indented code block`}</code>
        </pre>
      </li>
      <li>
        Using <code>for</code> loop with indentation:
        <pre>
          <code>{`for i in range(3):
    print("This is loop number", i)`}</code>
        </pre>
      </li>
      <li>
        Defining functions with indentation:
        <pre>
          <code>{`def greet(name):
    print(f"Hello, {name}!")
    print("Welcome to Python.")`}</code>
        </pre>
      </li>
    </ul><br/>

    <h3>Indentation Errors</h3>
    <p>
      If you mix tabs and spaces or use inconsistent indentation, Python will raise an <code>IndentationError</code>. Ensure you stick to one indentation style (4 spaces is recommended) throughout your code.
    </p>
  </div>
)}



{selectedChapter === 'chapter3' && (
  <div className={style.chaptercontent}>
    <h1 className={style.heading}> Comments</h1>
    
    <p>
      In Python, comments are lines that are not executed by the interpreter, and they serve as notes or explanations for the code. Here’s a breakdown:
    </p>

    <h3>1. Single-Line Comments</h3>
    <p>
      Single-line comments are created using the <code>#</code> symbol. Anything after <code>#</code> on that line is ignored by Python.
    </p>
    <pre>
      <code>
{`# This is a single-line comment
x = 10  # Inline comment after a line of code`}
      </code>
    </pre><br/>

    <h3>2. Multi-Line Comments</h3>
    <p>
      Python doesn’t have a dedicated multi-line comment syntax, but you can use <code>#</code> on each line for longer comments.
    </p>
    <pre >
      <code>
{`# This is a multi-line comment
# that spans multiple lines
# by using \`#\` at the start of each line.`}
      </code>
    </pre>
    <p>
      Alternatively, you can use triple quotes (<code>'''</code> or <code>"""</code>) as a workaround. These are technically strings, but if they’re not assigned to a variable, Python will ignore them, effectively treating them as comments.
    </p>
    <pre>
      <code>
{`"""
This is a multi-line comment
using triple quotes. It’s often
used when a longer explanation
is needed.
"""`}
      </code>
    </pre><br/>

    <h3>3. Docstrings (Documentation Strings)</h3>
    <p>
      Docstrings are specific multi-line comments used to describe the purpose of functions, classes, and modules. They are placed directly below the definition and are written with triple quotes. Docstrings are accessible using the <code>__doc__</code> attribute, making them useful for documentation.
    </p>
    <pre >
      <code>
{`def add(a, b):
    """Returns the sum of two numbers.""" 
    return a + b

print(add.__doc__)  # Prints: Returns the sum of two numbers.`}
      </code>
    </pre><br/>

    <h3 style={{paddingBottom:"6px"}}>Quick Summary</h3>
    <ul>
      <li>Single-line: Use <code>#</code> for brief explanations.</li><br/>
      <li>Multi-line: Use multiple <code>#</code> or triple quotes.</li><br/>
      <li>Docstrings: Use triple quotes right under functions, classes, or modules for documentation.</li>
    </ul><br/>

    <p>
      Using comments effectively makes code clearer for both you and others who may read it.
    </p>
  </div>
)}




{selectedChapter === 'chapter4' && (
  <div className={style.chaptercontent}>
    <h1 className={style.heading}> Variables Names</h1>

    <p>
      In Python, variable names follow specific rules and conventions. Here’s an overview of how variable names should be used:
    </p>

    <h3 style={{paddingBottom:"6px"}}>1. Rules for Naming Variables in Python</h3>
    <ul>
      <li><strong>Start with a letter or underscore</strong>: Variable names must begin with a letter (a-z, A-Z) or an underscore (_).</li><br/>
      <li><strong>Contain letters, numbers, or underscores</strong>: After the first character, the variable name can contain letters, numbers, or underscores.</li><br/>
      <li><strong>No special characters or spaces</strong>: Variable names cannot contain spaces or special characters like <code>!@#$</code>, etc.</li><br/>
      <li><strong>Case-sensitive</strong>: Variable names are case-sensitive, meaning <code>age</code> and <code>Age</code> are different variables.</li><br/>
      <li><strong>Cannot be a reserved keyword</strong>: Keywords like <code>if</code>, <code>while</code>, <code>class</code>, and <code>def</code> cannot be used as variable names.</li>
    </ul><br/>

    <h3 style={{paddingBottom:"6px"}}>2. Examples of Valid and Invalid Variable Names</h3>

    <h4>Valid Variable Names:</h4>
    <pre>
      <code>
{`name = "Alice"
age = 25
user_score = 100
name_1 = "Bob"
my_variable = "Python"
total_amount_2024 = 2000`}
      </code>
    </pre>

    <h4>Invalid Variable Names:</h4>
    <pre>
      <code>
{`1name = "Alice"  # Cannot start with a number
total$amount = 1000  # Cannot contain special characters
my variable = "text"  # Cannot contain spaces
class = "Python"  # Cannot be a keyword`}
      </code>
    </pre><br/>

    <h3>3. Naming Conventions</h3>
    <p>
      While Python allows flexibility in naming variables, it's good practice to follow these conventions for readability and maintainability:
    </p>

    <ul >
      <li style={{paddingBottom:"6px"}}>Use lowercase letters: For regular variables, it’s common to use lowercase letters and separate words with underscores (snake_case).
        <pre><code>user_name = "John"</code></pre>
      </li>
      <li style={{paddingBottom:"6px"}}>Use descriptive names: Variable names should be descriptive of what the variable holds. For example, <code>total_price</code> is more descriptive than just <code>tp</code>.
        <pre><code>total_price = 150.5</code></pre>
      </li>
      <li style={{paddingBottom:"6px"}}>Avoid single-letter variables: Except for loop counters (e.g., <code>i</code>, <code>j</code>, <code>k</code>), avoid using single-letter variable names.
        <pre><code>total_cost = 300
for i in range(5):
    print(i)</code></pre>
      </li>
      <li>Use constants in all uppercase: For values that should not change, Python uses all uppercase letters with underscores between words (UPPERCASE_SNAKE_CASE).
        <pre><code>MAX_USERS = 100
PI = 3.14159</code></pre>
      </li>
    </ul><br/>

    <h3>4. Commonly Used Naming Styles</h3>
    <ul>
      <li>Camel Case: Reserved for class names in Python. The first letter of each word is capitalized, except the first word. Example: <code>myVariableName</code>.</li><br/>
      <li>Snake Case: The preferred style in Python for variable and function names. It uses lowercase letters and separates words with underscores. Example: <code>my_variable_name</code>.</li>
    </ul><br/>

    <h3>Summary:</h3>
    <ul>
      <li>Variable names must start with a letter or an underscore, and can include letters, numbers, and underscores.</li><br/>
      <li>Avoid starting with numbers or using special characters.</li><br/>
      <li>Follow conventions like lowercase with underscores for variable names, and use uppercase for constants.</li>
    </ul>

  </div>
)}



        {selectedChapter === 'chapter5' && (
        <div className={style.chaptercontent}>
        <h1 className={style.heading}>Assign Multiple values </h1>
    <p>
      In Python, you can assign multiple values to variables in various ways. Below are different techniques to assign multiple values to a single or multiple variables.
    </p><br/>

    <h3>1. Assign Multiple Variables on a Single Line</h3>
    <p>
      You can assign multiple values to multiple variables in one line, separating each variable and its value by commas.
    </p>
    <pre>
      <code>
        {`x, y, z = 10, 20, 30
print(x)  # Output: 10
print(y)  # Output: 20
print(z)  # Output: 30`}
      </code>
    </pre>
    <p>In this case, <code>x</code> gets <code>10</code>, <code>y</code> gets <code>20</code>, and <code>z</code> gets <code>30</code>.</p><br/>

    <h3>2. Assign the Same Value to Multiple Variables</h3>
    <p>You can assign the same value to multiple variables in a single line.</p>
    <pre>
      <code>
        {`a = b = c = 100
print(a)  # Output: 100
print(b)  # Output: 100
print(c)  # Output: 100`}
      </code>
    </pre>
    <p>In this example, all three variables <code>a</code>, <code>b</code>, and <code>c</code> are assigned the value <code>100</code>.</p><br/>

    <h3>3. Unpacking a List or Tuple into Variables</h3>
    <p>You can also assign values from a list or tuple to variables by "unpacking" them.</p>

    <h4>Example with List:</h4>
    <pre>
      <code>
        {`my_list = [1, 2, 3]
a, b, c = my_list
print(a)  # Output: 
print(b)  # Output: 2
print(c)  # Output: 3`}
      </code>
    </pre>

    <h4>Example with Tuple:</h4>
    <pre>
      <code>
        {`my_tuple = (10, 20, 30)
x, y, z = my_tuple
print(x)  # Output: 10
print(y)  # Output: 20
print(z)  # Output: 30`}
      </code>
    </pre>
    <p>You can assign each value in the list or tuple to a separate variable.</p><br/>

    <h3>4. Using * (Asterisk) for Variable Length Assignments (Extended Unpacking)</h3>
    <p>Python allows you to use the <code>*</code> operator for extended unpacking, which is useful when you don’t know the exact number of elements in a list or tuple.</p>
    <pre>
      <code>
        {`numbers = [1, 2, 3, 4, 5]
a, *b, c = numbers
print(a)  # Output: 1
print(b)  # Output: [2, 3, 4]
print(c)  # Output: 5`}
      </code>
    </pre>
    <p>Here, <code>a</code> gets the first value, <code>c</code> gets the last value, and <code>b</code> collects the middle values into a list.</p>
    <br/>
    <h3>5. Using Multiple Assignments with Expressions</h3>
    <p>You can also assign values resulting from expressions to multiple variables.</p>
    <pre>
      <code>
        {`x, y = 5 + 3, 10 * 2
print(x)  # Output: 8
print(y)  # Output: 20`}
      </code>
    </pre>
    <p>This assigns the result of expressions to <code>x</code> and <code>y</code> respectively.</p><br/>

    <h3>Summary:</h3>
    <ul>
      <li>Multiple variables: You can assign different values to multiple variables in a single line.</li><br/>
      <li>Same value: You can assign the same value to multiple variables.</li><br/>
      <li>Unpacking: You can unpack values from lists or tuples into separate variables.</li><br/>
      <li>Extended unpacking: Use <code>*</code> to collect multiple values into a list.</li><br/>
      <li>Expressions: You can assign results of expressions directly to variables.</li>
    </ul>
  </div>
)}


      {selectedChapter === 'chapter6' && (
         <div className={style.chaptercontent}>
           <h1 className={style.heading}>Output Variables</h1>

    <p>
      In Python, output refers to displaying information to the user or system. The most common way to produce output is by using the <code>print()</code> function.
    </p><br/>

    <h3>1. Using the <code>print()</code> Function</h3>
    <p>
      The <code>print()</code> function is the most straightforward method to display output. You can print strings, numbers, and the results of expressions.
    </p>
    <pre>
      <code>{`
# Outputting a simple string
print("Hello, World!")

# Outputting a number
print(42)

# Outputting a variable
name = "Alice"
print(name)  # Output: Alice
      `}</code>
    </pre><br/>

    <h3>2. Concatenating Multiple Values in Output</h3>
    <p>
      You can output multiple values by separating them with commas in the <code>print()</code> function. Python automatically adds spaces between values.
    </p>
    <pre>
      <code>{`
age = 25
city = "New York"
print("Age:", age, "City:", city)  # Output: Age: 25 City: New York
      `}</code>
    </pre><br/>

    <h3>3. Using Formatted Strings</h3>
    <p>
      You can use formatted strings (f-strings) to embed variables directly within strings. This method is both clean and efficient.
    </p>
    <pre>
      <code>{`
name = "Bob"
age = 30
print(f"Name: {name}, Age: {age}")  # Output: Name: Bob, Age: 30
      `}</code>
    </pre><br/>

    <h3>4. Printing Multiple Values Without Space</h3>
    <p>
      If you want to print values without spaces, use the <code>sep</code> parameter in <code>print()</code>.
    </p>
    <pre>
      <code>{`
x = 5
y = 10
print(x, y, sep="")  # Output: 510
      `}</code>
    </pre><br/>

    <h3>5. Outputting to a File</h3>
    <p>
      Python can write output to a file using the <code>file</code> argument in the <code>print()</code> function.
    </p>
    <pre>
      <code>{`
with open("output.txt", "w") as file:
    print("This is written to a file.", file=file)
      `}</code>
    </pre><br/>

    <h3>6. Using <code>return</code> for Output in Functions</h3>
    <p>
      In functions, the <code>return</code> statement is used to send a value back to the caller. It does not display output to the console.
    </p>
    <pre>
      <code>{`
def add(a, b):
    return a + b

result = add(5, 3)
print(result)  # Output: 8
      `}</code>
    </pre><br/>

    <h3>Summary</h3>
    <ul>
      <li><strong><code>print()</code></strong> is the most common way to output values.</li><br/>
      <li>Use <strong>concatenation</strong> with commas or <strong>formatted strings (f-strings)</strong> for more readable output.</li><br/>
      <li>Use the <code>sep</code> parameter to control spacing between printed values.</li><br/>
      <li><strong>return</strong> is used in functions to return values to the caller, without displaying them in the console.</li><br/>
      <li>Python can also write output to a file using the <code>file</code> parameter in <code>print()</code>.</li>
    </ul>
  </div>
)}

          
{selectedChapter === 'chapter7' && (
  <div className={style.chaptercontent}>
    <h1 className={style.heading}>Global Variables </h1>
    
    <p>
      In Python, <strong>global variables</strong> are variables that are defined outside of any function or class and can be accessed from any part of the program.
      These variables are available throughout the entire code and are not limited to the scope of a function or method.
    </p><br/>

    <h2>1. Defining and Accessing Global Variables</h2>
    <p>
      Global variables are typically declared outside of functions or classes, at the top level of your program.
    </p>
    <pre>
      <code>{`
x = 10  # This is a global variable

def print_global():
    print(x)  # Accessing the global variable inside the function

print_global()  # Output: 10
      `}</code>
    </pre>

    <p>
      In the above example, <code>x</code> is a global variable because it is defined outside of any function. The function <code>print_global()</code> can access <code>x</code> because it is in the global scope.
    </p><br/>

    <h2 style={{paddingBottom:"6px"}}>2. Modifying Global Variables Inside Functions</h2>
    <p>
      If you want to modify a global variable inside a function, you need to declare it as <code>global</code> within the function.
      Without this declaration, Python will treat any assignment to the variable as a local variable and will not change the global one.
    </p>
    <pre>
      <code>{`
x = 10  # Global variable

def modify_global():
    global x  # Declaring that we are using the global variable
    x = 20  # Modifying the global variable

modify_global()
print(x)  # Output: 20
      `}</code>
    </pre>

    <p>
      Here, the <code>global</code> keyword tells Python that we are referring to the global <code>x</code>, so its value is changed inside the function.
    </p><br/>

    <h2 style={{paddingBottom:"6px"}}>3. Global Variables and Scope</h2>
    <p>
      Global variables are accessible from any function in the program, but if a variable with the same name is defined locally within a function, that variable will shadow the global one.
    </p>
    <pre>
      <code>{`
x = 10  # Global variable

def local_scope():
    x = 5  # Local variable, this does not affect the global x
    print("Inside function:", x)

local_scope()
print("Outside function:", x)
      `}</code>
    </pre>

    <p>
      In this example, the local <code>x</code> inside <code>local_scope()</code> does not change the global <code>x</code>. The global <code>x</code> remains unaffected outside the function.
    </p><br/>

    <h2 style={{paddingBottom:"6px"}}>4. Using Global Variables in Larger Programs</h2>
    <p>
      Global variables can be useful for managing state across different parts of a program. However, they should be used sparingly as they can make debugging and understanding the flow of the program more complex.
    </p>
    <p>
      It is generally a good practice to minimize the use of global variables and prefer passing variables as function arguments to make the code more modular and easier to maintain.
    </p><br/>

    <h2>Summary</h2>
    <ul>
      <li><strong>Global variables</strong> are defined outside of functions and can be accessed from anywhere in the program.</li><br/>
      <li>To modify a global variable inside a function, you must use the <code>global</code> keyword.</li><br/>
      <li><strong>Scope:</strong> Local variables can shadow global ones if they have the same name.</li>
    </ul>
  </div>
)}



      {selectedChapter === 'chapter8' && (
        <div className={style.chaptercontent}>
           <h1 className={style.heading}> Data Types</h1>
    
    <p>In Python, data types define the type of value a variable can hold. Python has a variety of built-in data types, each serving specific purposes. Here’s a rundown of the main data types:</p>
    <br/>
    <h3>1. Numeric Data Types</h3>
    <p>Integer (<code>int</code>): Whole numbers, positive or negative, without a decimal point.</p>
    <pre>
      <code>{`age = 25`}</code>
    </pre>
    
    <p>Floating-Point (<code>float</code>): Numbers with a decimal point.</p>
    <pre>
      <code>{`price = 19.99`}</code>
    </pre>
    
    <p>Complex (<code>complex</code>): Numbers with real and imaginary parts, represented as <code>a + bj</code>.</p>
    <pre>
      <code>{`z = 3 + 5j`}</code>
    </pre><br/>

    <h3>2. String (<code>str</code>)</h3>
    <p>A sequence of characters enclosed in single (<code>'</code>), double (<code>"</code>), or triple quotes (<code>'''</code> or <code>"""</code>). Strings are immutable (they cannot be changed once created).</p>
    <pre>
      <code>{`name = "Alice"\nmessage = 'Hello, World!'\nparagraph = """This is a\nmulti-line string"""`}</code>
    </pre><br/>

    <h3>3. Boolean (<code>bool</code>)</h3>
    <p>Represents <code>True</code> or <code>False</code>.</p>
    <pre>
      <code>{`is_active = True`}</code>
    </pre><br/>

    <h3>4. Collection Data Types</h3>
    <p><strong>List (<code>list</code>)</strong>: Ordered, mutable collection that can hold values of different data types.</p>
    <pre>
      <code>{`fruits = ["apple", "banana", "cherry"]`}</code>
    </pre>

    <p>Tuple (<code>tuple</code>): Ordered, immutable collection.</p>
    <pre>
      <code>{`coordinates = (10, 20)`}</code>
    </pre>

    <p>Set (<code>set</code>): Unordered collection of unique items, without duplicates.</p>
    <pre>
      <code>{`unique_numbers = {1, 2, 3, 4, 5}`}</code>
    </pre>

    <p>Dictionary (<code>dict</code>): Unordered collection of key-value pairs.</p>
    <pre>
      <code>{`person = {"name": "Alice", "age": 30}`}</code>
    </pre><br/>

    <h3>5. Special Data Types</h3>
    <p>None (<code>NoneType</code>): Represents the absence of a value.</p>
    <pre>
      <code>{`x = None`}</code>
    </pre>

    <p>Bytes (<code>bytes</code>) and Bytearray (<code>bytearray</code>): Represent binary data.</p>
    <pre>
      <code>{`data = b"hello"\nbyte_data = bytearray([65, 66, 67])`}</code>
    </pre><br/>

    <h3>6. Type Conversion</h3>
    <p>Python provides functions to convert between different data types.</p>
    <pre>
      <code>{`number = int("10")  # Convert string to integer\ntext = str(100)       # Convert integer to string\nitems = list((1, 2, 3))  # Convert tuple to list`}</code>
    </pre><br/>

    <h3>Summary:</h3>
    <p>Each of these data types serves a unique purpose, and understanding their properties and operations helps in writing efficient Python code.</p>
  </div>
)}


{selectedChapter === 'chapter9' && (
  <div className={style.chaptercontent}>
    <h1 className={style.heading}> Numbers</h1>

    <p>
      In Python, numbers are a fundamental data type used to represent numeric values. Python categorizes numbers into three primary types:
    </p><br/>

    <h3>1. Integers (<code>int</code>)</h3>
    <ul>
      <li>Integers are whole numbers, which can be positive, negative, or zero, without any fractional or decimal part.</li><br/>
      <li>Python integers are unbounded, meaning they can be very large, limited only by the memory available.</li>
    </ul>
    <pre>
      <code>
        {`x = 42
y = -100`}
      </code>
    </pre><br/>

    <h3>2. Floating-Point Numbers (<code>float</code>)</h3>
    <ul>
      <li>Floats are numbers with a decimal point or are written in scientific notation. They are used to represent real numbers (both whole and fractional parts).</li><br/>
      <li>Floats are limited in precision due to the way they are stored in memory, which may lead to minor rounding errors in some calculations.</li>
    </ul>
    <pre>
      <code>
        {`temperature = 98.6
speed = 2.5e3  # This is scientific notation for 2500.0`}
      </code>
    </pre><br/>

    <h3>3. Complex Numbers (<code>complex</code>)</h3>
    <ul>
      <li>Complex numbers have both a real part and an imaginary part. The imaginary part is represented with a <code>j</code> suffix in Python.</li><br/>
      <li>This type is commonly used in scientific and engineering calculations.</li>
    </ul>
    <pre>
      <code>
        {`z = 3 + 5j`}
      </code>
    </pre><br/>

    <h3>Operations with Python Numbers</h3>
    <p>
      Python supports arithmetic operations like addition, subtraction, multiplication, and division on all numeric types. Additionally, there are operations for exponentiation (<code>**</code>), modulus (<code>%</code>), and floor division (<code>//</code>).
    </p><br/>

    <h3>Type Conversion</h3>
    <p>
      You can convert between number types using functions like <code>int()</code>, <code>float()</code>, and <code>complex()</code>. For instance:
    </p>
    <pre>
      <code>
        {`int_value = int(4.7)  # Converts 4.7 to 4
float_value = float(3)  # Converts 3 to 3.0`}
      </code>
    </pre><br/>

    <h3>Summary</h3>
    <ul>
      <li>Integers are used for whole numbers.</li><br/>
      <li>Floats are used for numbers with decimals.</li><br/>
      <li>Complex numbers are used in advanced mathematical applications.</li>
    </ul>
    <p>Each type serves a different purpose and can be used according to the needs of the program.</p>
  </div>
)}



{selectedChapter === 'chapter10' && (
  <div className={style.chaptercontent}>
    <h1 className={style.heading}> Casting</h1>
    <p>
      In Python, casting (or type conversion) is the process of converting one data type to another. 
      This is useful when you want to change the data type of a variable to perform specific operations or to match the requirements of a function.
    </p><br/>

    <h2>Types of Casting in Python</h2>
    <p>There are two primary types of casting in Python:</p>
    <ol>
      <li>Implicit Casting: Python automatically converts one data type to another when it makes sense to do so, usually without loss of data.</li><br/>
      <li>Explicit Casting: This requires the use of specific functions to convert data types manually.</li>
    </ol><br/>

    <h3 style={{paddingBottom:"6px"}}>1. Implicit Casting</h3>
    <p>
      In implicit casting, Python automatically changes the type of a variable without any explicit command. This typically occurs when Python can safely convert data types without losing information.
    </p>
    <pre>
      <code>
        {`x = 10     # int
y = 3.5    # float

result = x + y  # Implicitly converts x to float
print(result)   # Output: 13.5
print(type(result))  # Output: <class 'float'>`}
      </code>
    </pre>
    <p>
      In this example, <code>x</code> is implicitly converted to a <code>float</code> to match the type of <code>y</code>, as adding an <code>int</code> and a <code>float</code> results in a <code>float</code>.
    </p><br/>

    <h3 style={{paddingBottom:"6px"}}>2. Explicit Casting</h3>
    <p>
      Explicit casting (or type conversion) is done using Python's built-in functions. You can specify the target data type you want to convert a value to by using functions like <code>int()</code>, <code>float()</code>, <code>str()</code>, etc.
    </p>

    <h4>Common Explicit Casting Functions</h4>
    <ul>
      <li><code>int()</code>: Converts a value to an integer.</li><br/>
      <li><code>float()</code>: Converts a value to a floating-point number.</li><br/>
      <li><code>str()</code>: Converts a value to a string.</li><br/>
      <li><code>list()</code>: Converts a value to a list.</li><br/>
      <li><code>tuple()</code>: Converts a value to a tuple.</li><br/>
      <li><code>set()</code>: Converts a value to a set.</li>
    </ul>

    <pre>
      <code>
        {`# Convert string to integer
num_str = "100"
num_int = int(num_str)
print(num_int)           # Output: 100
print(type(num_int))     # Output: <class 'int'>

# Convert integer to string
age = 30
age_str = str(age)
print(age_str)           # Output: "30"
print(type(age_str))     # Output: <class 'str'>

# Convert float to integer
pi = 3.14159
pi_int = int(pi)
print(pi_int)            # Output: 3 (truncates decimal)`}
      </code>
    </pre><br/>

    <h3>Summary</h3>
    <ul>
      <li>Implicit casting is handled automatically by Python when it’s safe.</li><br/>
      <li>Explicit casting is done manually using functions like <code>int()</code>, <code>float()</code>, <code>str()</code>, etc.</li>
    </ul>
    <p>
      Casting is useful for ensuring that your variables match the expected data type when performing operations or calling functions.
    </p>
  </div>
)}


        {selectedChapter === 'chapter11' && (
         <div className={style.chaptercontent}>
          <h1 className={style.heading}> Strings</h1>

    <p>In Python, strings are a sequence of characters used to represent text. They’re one of the most commonly used data types and are enclosed in either single quotes (<code>'...'</code>), double quotes (<code>"..."</code>), or triple quotes (<code>'''...'''</code> or <code>"""..."""</code>). Triple quotes are typically used for multi-line strings or docstrings.</p>
    <br/>
    <h2 style={{paddingBottom:"6px"}}>Key Features of Python Strings</h2>

    <h3>1. Immutability</h3>
    <p>Strings in Python are immutable, meaning once created, they cannot be changed. Any modification creates a new string.</p>
    <br/>
    <h3>2. Accessing Characters</h3>
    <p>You can access individual characters in a string by using an index, with indexing starting at <code>0</code> for the first character.</p>
    <pre><code>
{`text = "Hello"
print(text[0])  # Output: H`}
    </code></pre><br/>

    <h3>3. String Slicing</h3>
    <p>You can extract substrings using slicing.</p>
    <pre><code>
{`text = "Hello, World!"
print(text[0:5])  # Output: Hello`}
    </code></pre><br/>

    <h3>4. Concatenation</h3>
    <p>Strings can be combined using the <code>+</code> operator.</p>
    <pre><code>
{`first = "Hello"
second = "World"
greeting = first + " " + second
print(greeting)  # Output: Hello World`}
    </code></pre><br/>

    <h3>5. Repetition</h3>
    <p>Repeat a string using the <code>*</code> operator.</p>
    <pre><code>
{`text = "Hi! "
print(text * 3)  # Output: Hi! Hi! Hi!`}
    </code></pre><br/>

    <h3>6. Escape Characters</h3>
    <p>Certain characters have special meanings and can be used by prefixing with a backslash (<code>\</code>).</p>
    <ul>
      <li><code>\n</code> for a new line</li>
      <li><code>\t</code> for a tab</li>
      <li><code>\'</code> or <code>\"</code> to include quotes in a string</li>
    </ul>
    <pre><code>
{`text = "She said, \\"Hello!\\""
print(text)  # Output: She said, "Hello!"`}
    </code></pre><br/>

    <h2>Common String Methods</h2>
    <p>Python provides various methods to manipulate and work with strings:</p>
    <br/>
    <h3>.lower() and .upper()</h3>
    <p>Convert a string to lowercase or uppercase.</p>
    <pre><code>
{`text = "Hello"
print(text.lower())  # Output: hello`}
    </code></pre>
    <br/>
    <h3>.strip()</h3>
    <p>Removes leading and trailing whitespace.</p>
    <pre><code>
{`text = "  Hello  "
print(text.strip())  # Output: Hello`}
    </code></pre>
    <br/>
    <h3>.find(substring)</h3>
    <p>Finds the position of the first occurrence of a substring.</p>
    <pre><code>
{`text = "Hello, World!"
print(text.find("World"))  # Output: 7`}
    </code></pre>
    <br/>
    <h3>.replace(old, new)</h3>
    <p>Replaces occurrences of a substring with another substring.</p>
    <pre><code>
{`text = "Hello, World!"
print(text.replace("World", "Python"))  # Output: Hello, Python!`}
    </code></pre>
    <br/>
    <h3>.split(delimiter)</h3>
    <p>Splits the string into a list of substrings based on a delimiter.</p>
    <pre><code>
{`text = "Hello, World!"
print(text.split(", "))  # Output: ['Hello', 'World!']`}
    </code></pre>
    <br/>
    <h3>.join(list)</h3>
    <p>Joins elements of a list into a single string, with a specified delimiter.</p>
    <pre><code>
{`words = ["Hello", "World"]
text = " ".join(words)
print(text)  # Output: Hello World`}
    </code></pre>
    <br/>
    <h2>f-Strings (Formatted Strings)</h2>
    <p>Python provides f-strings to make string formatting easier and more readable by using expressions inside <code>{'{}'}</code> brackets, prefixed with an <code>f</code> before the opening quotes.</p>
    <pre><code>
{`name = "Alice"
age = 25
message = f"My name is {name} and I am {age} years old."
print(message)  # Output: My name is Alice and I am 25 years old.`}
    </code></pre>
    <br/>
    <h2 style={{paddingBottom:"6px"}}>String Methods in Python</h2>

<table>
  <thead>
    <tr>
      <th>Method</th>
      <th>Description</th>
    </tr>
  </thead>
  <tbody>
    <tr>
      <td><strong>capitalize()</strong></td>
      <td>Capitalizes the first character of the string.</td>
    </tr>
    <tr>
      <td><strong>casefold()</strong></td>
      <td>Converts all characters in the string to lowercase.</td>
    </tr>
    <tr>
      <td><strong>center(width</strong></td>
      <td>Centers the string within the specified width.</td>
    </tr>
    <tr>
      <td><strong>count(substring)</strong></td>
      <td>Returns the number of occurrences of the substring in the string.</td>
    </tr>
    <tr>
      <td><strong>encode(encoding)</strong></td>
      <td>Encodes the string into a byte object using the specified encoding.</td>
    </tr>
    <tr>
      <td><strong>expandtabs(tabsize)</strong></td>
      <td>Replaces tabs with spaces, up to the specified tab size.</td>
    </tr>
    <tr>
      <td><strong>find(substring)</strong></td>
      <td>Returns the index of the first occurrence of the substring, or -1 if not found.</td>
    </tr>
    <tr>
      <td><strong>format(*args, **kwargs)</strong></td>
      <td>Formats the string using placeholders and arguments.</td>
    </tr>
    <tr>
      <td><strong>index(substring)</strong></td>
      <td>Similar to `find()`, but raises a `ValueError` if the substring is not found.</td>
    </tr>
    <tr>
      <td><strong>isalnum()</strong></td>
      <td>Returns `True` if the string contains only alphanumeric characters.</td>
    </tr>
    <tr>
      <td><strong>isalpha()</strong></td>
      <td>Returns `True` if the string contains only alphabetic characters.</td>
    </tr>
    <tr>
      <td><strong>isdecimal()</strong></td>
      <td>Returns `True` if the string contains only decimal characters.</td>
    </tr>
    <tr>
      <td><strong>isdigit()</strong></td>
      <td>Returns `True` if the string contains only digit characters.</td>
    </tr>
    <tr>
      <td><strong>islower()</strong></td>
      <td>Returns `True` if all characters in the string are lowercase.</td>
    </tr>
    <tr>
      <td><strong>isnumeric()</strong></td>
      <td>Returns `True` if the string contains only numeric characters.</td>
    </tr>
    <tr>
      <td><strong>isprintable()</strong></td>
      <td>Returns `True` if the string consists of printable characters.</td>
    </tr>
    <tr>
      <td><strong>isspace()</strong></td>
      <td>Returns `True` if the string contains only whitespace characters.</td>
    </tr>
    <tr>
      <td><strong>istitle()</strong></td>
      <td>Returns `True` if the string is in title case.</td>
    </tr>
    <tr>
      <td><strong>isupper()</strong></td>
      <td>Returns `True` if all characters in the string are uppercase.</td>
    </tr>
    <tr>
      <td><strong>join(iterable)</strong></td>
      <td>Joins elements of an iterable into a single string, separated by the string.</td>
    </tr>
    <tr>
      <td><strong>ljust(width)</strong></td>
      <td>Left-aligns the string within the specified width.</td>
    </tr>
    <tr>
      <td><strong>lower()</strong></td>
      <td>Converts all characters in the string to lowercase.</td>
    </tr>
    <tr>
      <td><strong>lstrip()</strong></td>
      <td>Removes leading whitespace characters.</td>
    </tr>
    <tr>
      <td><strong>replace(old, new)</strong></td>
      <td>Replaces occurrences of a substring with a new string.</td>
    </tr>
    <tr>
      <td><strong>rfind(substring)</strong></td>
      <td>Returns the index of the last occurrence of the substring, or -1 if not found.</td>
    </tr>
    <tr>
      <td><strong>rindex(substring)</strong></td>
      <td>Similar to `rfind()`, but raises a `ValueError` if the substring is not found.</td>
    </tr>
    <tr>
      <td><strong>rjust(width)</strong></td>
      <td>Right-aligns the string within the specified width.</td>
    </tr>
    <tr>
      <td><strong>rstrip()</strong></td>
      <td>Removes trailing whitespace characters.</td>
    </tr>
    <tr>
      <td><strong>split(delimiter)</strong></td>
      <td>Splits the string into a list at each occurrence of the delimiter.</td>
    </tr>
    <tr>
      <td><strong>splitlines()</strong></td>
      <td>Splits the string at line breaks and returns a list of lines.</td>
    </tr>
    <tr>
      <td><strong>startswith(prefix)</strong></td>
      <td>Returns `True` if the string starts with the specified prefix.</td>
    </tr>
    <tr>
      <td><strong>strip()</strong></td>
      <td>Removes leading and trailing whitespace characters.</td>
    </tr>
    <tr>
      <td><strong>swapcase()</strong></td>
      <td>Converts all lowercase characters to uppercase and vice versa.</td>
    </tr>
    <tr>
      <td><strong>title()</strong></td>
      <td>Converts the first character of each word to uppercase.</td>
    </tr>
    <tr>
      <td><strong>upper()</strong></td>
      <td>Converts all characters in the string to uppercase.</td>
    </tr>
    <tr>
      <td><strong>zfill(width)</strong></td>
      <td>Pads the string with zeros on the left, up to the specified width.</td>
    </tr>
  </tbody>
</table>
<br/>
    <h2>Summary</h2>
    <ul>
      <li>Strings are used to represent text and are immutable.</li><br/>
      <li>Python provides various methods and operations to manipulate strings.</li><br/>
      <li>f-Strings make it easy to embed expressions in strings for formatting.</li>
    </ul>
  </div>
)}



          {selectedChapter === 'chapter12' && (
          <div className={style.chaptercontent}>
          <h1 className={style.heading}> Boolean</h1>

    <p>In Python, a <strong>Boolean</strong> is a data type that represents two possible values: <code>True</code> and <code>False</code>. These values are fundamental in controlling the flow of a program, especially in decision-making processes, loops, and conditions.</p>
    <br/>
    <h3 style={{paddingBottom:"6px"}}>Key Points About Python Boolean:</h3>
    <ol>
      <li>
        <strong>Boolean Values:</strong> The Boolean data type in Python only has two values:
        <ul>
          <li><code>True</code>: This represents a condition that is correct or valid.</li><br/>
          <li><code>False</code>: This represents a condition that is incorrect or invalid.</li>
        </ul><br/>
      </li>

      <li>
        <strong>Using Booleans in Conditional Statements:</strong>
        <p>Booleans are often used to control which part of the program runs. For example, in an <code>if</code> statement, the program executes a block of code if a condition evaluates to <code>True</code>:</p>
        <pre>
          <code>
            {`is_raining = True
if is_raining:
    print("Bring an umbrella!")
else:
    print("No rain, no umbrella needed!")`}
          </code>
        </pre>
        <br/>
      </li>

      <li>
        <strong>Boolean Expressions:</strong> You can create Boolean values by comparing two values using comparison operators such as:
        <ul>
          <li><code>==</code>: Checks if two values are equal.</li>
          <li><code>!=</code>: Checks if two values are not equal.</li>
          <li><code>&lt;</code>, <code>&gt;</code>, <code>&lt;=</code>, <code>&gt;=</code>: Used for greater than, less than, etc.</li>
        </ul>
        <p>Example:</p>
        <pre>
          <code>
            {`x = 10
y = 5
print(x > y)  # Output: True (because 10 is greater than 5)`}
          </code>
        </pre>
      </li>
      <br/>
      <li>
        <strong>Logical Operations:</strong> Boolean values can be combined using logical operators:
        <ul>
          <li><code>and</code>: Returns <code>True</code> only if both conditions are <code>True</code>.</li>
          <li><code>or</code>: Returns <code>True</code> if at least one condition is <code>True</code>.</li>
          <li><code>not</code>: Reverses the Boolean value (<code>True</code> becomes <code>False</code> and vice versa).</li>
        </ul>
        <p>Example:</p>
        <pre>
          <code>
            {`x = True
y = False
print(x and y)  # Output: False
print(x or y)   # Output: True
print(not x)    # Output: False`}
          </code>
        </pre>
      </li>
    </ol>
    <br/>
    <h3>Summary:</h3>
    <ul>
      <li>Booleans in Python are used to represent truth values: <code>True</code> and <code>False</code>.</li><br/>
      <li>They are critical for controlling the flow of programs, making decisions, and performing logical operations.</li>
    </ul>
  </div>
)}



          {selectedChapter === 'chapter13' && (
          <div className={style.chaptercontent}>
          <h1 className={style.heading}> Operators</h1>

    <p style={{paddingBottom:"6px"}}>In Python, <strong>operators</strong> are special symbols used to perform operations on variables and values. These operations can range from arithmetic to comparison and logical operations. Python supports several types of operators:</p>
    <h2>1. Arithmetic Operators</h2>
    <p>These operators perform basic mathematical operations such as addition, subtraction, multiplication, etc.</p>
    <ul>
      <li>
        <strong>+</strong> (Addition): Adds two numbers or concatenates strings.
        <pre><code>x = 5<br />y = 3<br />result = x + y  # Output: 8</code></pre>
      </li><br/>
      <li>
        <strong>-</strong> (Subtraction): Subtracts one number from another.
        <pre><code>result = x - y  # Output: 2</code></pre>
      </li><br/>
      <li>
        <strong>*</strong> (Multiplication): Multiplies two numbers.
        <pre><code>result = x * y  # Output: 15</code></pre>
      </li><br/>
      <li>
        <strong>/</strong> (Division): Divides one number by another. The result is always a float.
        <pre><code>result = x / y  # Output: 1.6667</code></pre>
      </li><br/>
      <li>
        <strong>//</strong> (Floor Division): Divides one number by another and returns the integer part of the result.
        <pre><code>result = x // y  # Output: 1</code></pre>
      </li><br/>
      <li>
        <strong>%</strong> (Modulus): Returns the remainder of a division.
        <pre><code>result = x % y  # Output: 2</code></pre>
      </li><br/>
      <li>
        <strong>**</strong> (Exponentiation): Raises the first number to the power of the second.
        <pre><code>result = x ** y  # Output: 125</code></pre>
      </li>
    </ul><br/>

    <h2>2. Comparison Operators</h2>
    <p>These operators compare two values and return a Boolean result (<em>True</em> or <em>False</em>).</p>
    <ul>
      <li>
        <strong>==</strong> (Equal to): Checks if two values are equal.
        <pre><code>result = x == y  # Output: False</code></pre>
      </li><br/>
      <li>
        <strong>!=</strong> (Not equal to): Checks if two values are not equal.
        <pre><code>result = x != y  # Output: True</code></pre>
      </li><br/>
      <li>
        <strong>{">"}</strong> (Greater than): Checks if the left value is greater than the right.
        <pre><code>{`result = x > y  # Output: True`}</code></pre>
      </li><br/>
      <li>
        <strong>{"<"}</strong> (Less than): Checks if the left value is less than the right.
        <pre><code>{`result = x < y  # Output: False`}</code></pre>
      </li><br/>
      <li>
        <strong>{">="}</strong> (Greater than or equal to): Checks if the left value is greater than or equal to the right.
        <pre><code>{`result = x >= y  # Output: True`}</code></pre>
      </li><br/>
      <li>
        <strong>{"<="}</strong> (Less than or equal to): Checks if the left value is less than or equal to the right.
        <pre><code>{`result = x <= y  # Output: False`}</code></pre>
      </li>
    </ul><br/>

    <h2>3. Logical Operators</h2>
    <p>These operators are used to combine multiple Boolean expressions.</p>
    <ul>
      <li>
        <strong>and</strong>: Returns <em>True</em> if both conditions are true.
        <pre><code>{`result = (x > 2) and (y < 5)  # Output: True`}</code></pre>
      </li><br/>
      <li>
        <strong>or</strong>: Returns <em>True</em> if at least one condition is true.
        <pre><code>{`result = (x < 2) or (y > 2)  # Output: True`}</code></pre>
      </li><br/>
      <li>
        <strong>not</strong>: Reverses the Boolean value (i.e., converts <em>True</em> to <em>False</em> and vice versa).
        <pre><code>{`result = not(x > 2)  # Output: False`}</code></pre>
      </li>
    </ul><br/>

    <h2>4. Assignment Operators</h2>
    <p>These operators are used to assign values to variables.</p>
    <ul>
      <li>
        <strong>=</strong> (Simple assignment): Assigns a value to a variable.
        <pre><code>x = 5</code></pre>
      </li><br/>
      <li>
        <strong>+=</strong> (Add and assign): Adds a value to a variable and assigns the result to the same variable.
        <pre><code>x += 3  # Equivalent to x = x + 3</code></pre>
      </li><br/>
      <li>
        <strong>-=</strong> (Subtract and assign): Subtracts a value from a variable and assigns the result to the same variable.
        <pre><code>x -= 2  # Equivalent to x = x - 2</code></pre>
      </li><br/>
      <li>
        <strong>*=</strong> (Multiply and assign): Multiplies a variable by a value and assigns the result.
        <pre><code>x *= 2  # Equivalent to x = x * 2</code></pre>
      </li><br/>
      <li>
        <strong>/=</strong> (Divide and assign): Divides a variable by a value and assigns the result.
        <pre><code>x /= 2  # Equivalent to x = x / 2</code></pre>
      </li><br/>
      <li>
        <strong>%=</strong> (Modulus and assign): Calculates the modulus and assigns the result.
        <pre><code>x %= 2  # Equivalent to x = x % 2</code></pre>
      </li>
    </ul><br/>

    <h2>5. Membership Operators</h2>
    <p>These operators are used to check if a value is present in a sequence (such as a list or string).</p>
    <ul>
      <li>
        <strong>in</strong>: Returns <em>True</em> if a value is found in the sequence.
        <pre><code>x = [1, 2, 3]<br />result = 2 in x  # Output: True</code></pre>
      </li><br/>
      <li>
        <strong>not in</strong>: Returns <em>True</em> if a value is not found in the sequence.
        <pre><code>result = 4 not in x  # Output: True</code></pre>
      </li>
    </ul><br/>

    <h2>6. Identity Operators</h2>
    <p>These operators compare the memory location of two objects.</p>
    <ul>
      <li>
        <strong>is</strong>: Returns <em>True</em> if both variables point to the same object in memory.
        <pre><code>x = [1, 2]<br />y = x<br />result = x is y  # Output: True</code></pre>
      </li><br/>
      <li>
        <strong>is not</strong>: Returns <em>True</em> if both variables do not point to the same object in memory.
        <pre><code>z = [1, 2]<br />result = x is not z  # Output: True</code></pre>
      </li>
    </ul><br/>

    <h2>7. Bitwise Operators</h2>
    <p>These operators perform bit-level operations on integer values.</p>
    <ul>
      <li>
        <strong>&</strong> (Bitwise AND): Performs a bitwise AND operation.
        <pre><code>result = 5 & 3  # Output: 1 (0101 & 0011 = 0001)</code></pre>
      </li><br/>
      <li>
        <strong>|</strong> (Bitwise OR): Performs a bitwise OR operation.
        <pre><code>result = 5 | 3  # Output: 7 (0101 | 0011 = 0111)</code></pre>
      </li><br/>
      <li>
        <strong>^</strong> (Bitwise XOR): Performs a bitwise XOR operation.
        <pre><code>result = 5 ^ 3  # Output: 6 (0101 ^ 0011 = 0110)</code></pre>
      </li><br/>
      <li>
        <strong>~</strong> (Bitwise NOT): Performs a bitwise NOT operation (inverts the bits).
        <pre><code>result = ~5  # Output: -6 (bitwise inversion)</code></pre>
      </li><br/>
      <li>
        <strong>&lt;&lt;</strong> (Bitwise Left Shift): Shifts the bits to the left by the specified number of positions.
        <pre><code>{`result = 5 << 1  # Output: 10 (0101 << 1 = 1010)`}</code></pre>
      </li><br/>
      <li>
        <strong>&gt;&gt;</strong> (Bitwise Right Shift): Shifts the bits to the right by the specified number of positions.
        <pre><code>{`result = 5 >> 1  # Output: 2 (0101 >> 1 = 0010)`}</code></pre>
      </li>
    </ul><br/>

    <h2>Summary</h2>
    <p>Python operators allow you to perform operations on variables and values in various ways. They fall into different categories based on the operation being performed, including arithmetic, comparison, logical, assignment, and more. Understanding these operators is key to writing efficient and readable code.</p>
  </div>
)}




            {selectedChapter === 'chapter14' && (
            <div className={style.chaptercontent}>
            <h1 className={style.heading}>   Python List </h1>

      <p>
        A <strong>list</strong> in Python is a collection of ordered elements that can hold items of different types,
        such as integers, strings, or even other lists. Lists are mutable, meaning you can change their contents after
        they are created (add, remove, or modify items).
      </p><br/>

      <h2>Basic Characteristics of Python Lists:</h2>
      <ul>
        <li><strong>Ordered:</strong> The items in a list have a defined order. Each item has an index (starting from 0 for the first item) that allows you to access or modify it.</li><br/>
        <li><strong>Mutable:</strong> Lists can be modified after they are created. You can add, remove, or change the elements.</li><br/>
        <li><strong>Allow Duplicate Elements:</strong> Lists can contain duplicate values, which means you can have multiple instances of the same value in the same list.</li><br/>
        <li><strong>Heterogeneous:</strong> A list can store different types of elements, such as numbers, strings, or even other lists.</li>
      </ul><br/>

      <h3>Creating a List:</h3>
      <p>You can create a list by placing elements inside square brackets <code>[]</code>, separated by commas:</p>
      <pre><code>{`my_list = [1, 2, 3, 'apple', 3.14]`}</code></pre>
      <br/>
      <h3>Accessing List Elements:</h3>
      <p>You can access the elements in a list using their index:</p>
      <pre><code>{`print(my_list[0])  // Output: 1`}</code></pre>
      <pre><code>{`print(my_list[3])  // Output: 'apple'`}</code></pre>
      <p>Negative indices can be used to access elements from the end of the list:</p>
      <pre><code>{`print(my_list[-1])  // Output: 3.14 (last element)`}</code></pre>
      <br/>
      <h3>Modifying a List:</h3>
      <p>Lists are mutable, meaning you can modify their contents:</p>
      <pre><code>{`my_list[1] = 'orange'  // Changes the second element`}</code></pre>
      <pre><code>{`print(my_list)  // Output: [1, 'orange', 3, 'apple', 3.14]`}</code></pre>
      <br/>
      <h3>Adding Elements:</h3>
      <p>You can add items to the list using the <code>append()</code> method (adds to the end) or the <code>insert()</code> method (adds at a specific position):</p>
      <pre><code>{`my_list.append('banana')  // Adds 'banana' at the end`}</code></pre>
      <pre><code>{`my_list.insert(2, 'grape')  // Adds 'grape' at index 2`}</code></pre>
      <br/>
      <h3>Removing Elements:</h3>
      <p>You can remove elements using methods like <code>remove()</code> (removes the first occurrence of a value), <code>pop()</code> (removes an item at a specific index), or <code>clear()</code> (removes all items):</p>
      <pre><code>{`my_list.remove('apple')  // Removes 'apple'`}</code></pre>
      <pre><code>{`my_list.pop(1)  // Removes the element at index 1`}</code></pre>
      <pre><code>{`my_list.clear()  // Removes all elements`}</code></pre>
      <br/>
      <h3>Slicing a List:</h3>
      <p>You can extract a sublist using slicing, which is a way to create a new list by selecting a range of elements:</p>
      <pre><code>{`my_list = [1, 2, 3, 4, 5]`}</code></pre>
      <pre><code>{`print(my_list[1:4])  // Output: [2, 3, 4] (elements from index 1 to 3)`}</code></pre>
      <br/>
      <h3>Example of List Operations:</h3>
      <pre><code>{`
# Create a list
fruits = ['apple', 'banana', 'cherry']

# Accessing elements
print(fruits[1])  // Output: banana

# Modifying elements
fruits[0] = 'orange'

# Adding an element
fruits.append('grape')

# Removing an element
fruits.remove('banana')

# Slicing a list
print(fruits[1:3])  // Output: ['cherry', 'grape']
      `}</code></pre>
<br/>
      <h3>Summary:</h3>
      <ul>
        <li>Lists are ordered collections of items.</li><br/>
        <li>You can modify, add, or remove elements in a list.</li><br/>
        <li>Lists can store different types of elements.</li><br/>
        <li>They are very useful when you need to store multiple items and work with them in a flexible way.</li>
      </ul>

      <p>This is a brief overview of Python lists and their basic functionality.</p>
    </div>
  )}



          {selectedChapter === 'chapter15' && (
          <div className={style.chaptercontent}>
          <h1 className={style.heading}>Accessing List Items</h1>

    <p>
      In Python, a <strong>list</strong> is an ordered collection of elements, which can be of any data type, such as integers, strings, or even other lists. You access the items of a list using an <strong>index</strong>. Python supports both <strong>positive</strong> and <strong>negative</strong> indexing to access list elements.
    </p>
    <br/>
    <h3>1. Accessing List Items Using Positive Indexes</h3>
    <p>
      Python lists are indexed starting from <code>0</code> for the first element. The index is used to reference each item in the list.
    </p>
    <pre>
      <code>{`my_list = ['apple', 'banana', 'cherry', 'date']

# Accessing the first item (index 0)
print(my_list[0])  # Output: 'apple'

# Accessing the second item (index 1)
print(my_list[1])  # Output: 'banana'

# Accessing the third item (index 2)
print(my_list[2])  # Output: 'cherry'`}</code>
    </pre>
    <br/>
    <h3>2. Accessing List Items Using Negative Indexes</h3>
    <p>
      Python also supports <strong>negative indexing</strong> to access list items starting from the end of the list.
    </p>
    <pre>
      <code>{`my_list = ['apple', 'banana', 'cherry', 'date']

# Accessing the last item using negative indexing
print(my_list[-1])  # Output: 'date'

# Accessing the second-to-last item
print(my_list[-2])  # Output: 'cherry'`}</code>
    </pre>
    <br/>
    <h3>3. Accessing Items with Slicing</h3>
    <p>
      You can access a <strong>range of elements</strong> in the list using slicing. Slicing uses the syntax <code>[start:stop]</code>:
    </p>
    <pre>
      <code>{`my_list = ['apple', 'banana', 'cherry', 'date', 'elderberry']

# Slicing from index 1 to index 3 (does not include index 3)
print(my_list[1:3])  # Output: ['banana', 'cherry']

# Slicing from the beginning to index 2
print(my_list[:3])  # Output: ['apple', 'banana', 'cherry']

# Slicing from index 2 to the end
print(my_list[2:])  # Output: ['cherry', 'date', 'elderberry']

# Slicing the entire list
print(my_list[:])  # Output: ['apple', 'banana', 'cherry', 'date', 'elderberry']`}</code>
    </pre>
    <br/>
    <h3>4. Accessing Items with Out of Range Index</h3>
    <p>
      If you try to access an index that is out of range, Python will raise an <code>IndexError</code>.
    </p>
    <pre>
      <code>{`my_list = ['apple', 'banana', 'cherry']

# Trying to access an out-of-range index
print(my_list[5])  # This will raise IndexError: list index out of range`}</code>
    </pre>
    <br/>
    <h3>5. Using the <code>'in'</code> Keyword for Checking Existence</h3>
    <p>
      Instead of accessing an element by index, you might want to check if a particular item exists in the list. You can use the <code>in</code> keyword to check if an element is present in the list.
    </p>
    <pre>
      <code>{`my_list = ['apple', 'banana', 'cherry']

# Check if 'banana' exists in the list
print('banana' in my_list)  # Output: True

# Check if 'orange' exists in the list
print('orange' in my_list)  # Output: False`}</code>
    </pre>

    <h3>Summary:</h3>
    <ul>
      <li><strong>Positive Indexing</strong>: Starts from 0 and goes up to <code>n-1</code>.</li><br/>
      <li><strong>Negative Indexing</strong>: Starts from <code>-1</code> (last element) and goes backward.</li><br/>
      <li><strong>Slicing</strong>: You can slice lists to get a sublist.</li><br/>
      <li><strong>Out of Range Index</strong>: Trying to access an index outside the list’s range raises an <code>IndexError</code>.</li><br/>
      <li><strong>Existence Check</strong>: The <code>'in'</code> keyword can be used to check if an item exists in the list.</li>
    </ul>

    <p>
      By understanding and using these methods, you can access and manipulate list elements effectively in Python.
    </p>
  </div>
)}



        {selectedChapter === 'chapter16' && (
        <div className={style.chaptercontent}>
        <h1 className={style.heading}>Change List Items </h1>

    <p>
      In Python, lists are <strong>mutable</strong>, which means you can change their contents after creation. This allows you to modify, add, or remove elements from a list. Changing list items is a fundamental operation in Python programming. Let’s look at how you can modify elements in a list in a detailed way.
    </p>
    <br/>
    <h3 style={{paddingBottom:"6px"}}>1. Changing List Items Using Indexing</h3>
    <p>
      To change an item in a list, you use the <strong>index</strong> of the item you want to modify and assign a new value to that index.
      <ul>
        <li><strong>Indexing:</strong> Python lists are indexed starting at 0. The first item is at index 0, the second at index 1, and so on.</li>
      </ul>
      <h4>Example:</h4>
      <pre>
        <code>{`my_list = ['apple', 'banana', 'cherry']`}</code>
        <br />
        <code>{`my_list[1] = 'orange'`}</code>
        <br />
        <code>{`print(my_list)  # Output: ['apple', 'orange', 'cherry']`}</code>
      </pre>
    </p>
    <br/>
    <h3 style={{paddingBottom:"6px"}}>2. Using Negative Indexing to Change Items</h3>
    <p>
      Python also supports <strong>negative indexing</strong> to access list items from the end. Negative indexing starts from `-1` for the last item, `-2` for the second-to-last item, and so on.
    </p>
    <h4>Example:</h4>
    <pre>
      <code>{`my_list = ['apple', 'banana', 'cherry']`}</code>
      <br />
      <code>{`my_list[-1] = 'grape'`}</code>
      <br />
      <code>{`print(my_list)  # Output: ['apple', 'banana', 'grape']`}</code>
    </pre>
    <br/>
    <h3 style={{paddingBottom:"6px"}}>3. Changing Multiple List Items</h3>
    <p>
      You can also change multiple elements in a list at once by using <strong>slicing</strong>. Slicing allows you to access a subset of elements by specifying a range of indexes, and you can modify this subset.
    </p>
    <h4>Example:</h4>
    <pre>
      <code>{`my_list = ['apple', 'banana', 'cherry', 'date', 'elderberry']`}</code>
      <br />
      <code>{`my_list[1:3] = ['orange', 'grape']`}</code>
      <br />
      <code>{`print(my_list)  # Output: ['apple', 'orange', 'grape', 'date', 'elderberry']`}</code>
    </pre>
    <br/>
    <h3 style={{paddingBottom:"6px"}}>4. Using the `append()` Method to Add an Item</h3>
    <p>
      Although <strong>indexing</strong> allows you to modify existing items, the <code>append()</code> method adds new items to the end of the list. This is a way of changing the list by adding an element, rather than replacing an existing one.
    </p>
    <h4>Example:</h4>
    <pre>
      <code>{`my_list = ['apple', 'banana', 'cherry']`}</code>
      <br />
      <code>{`my_list.append('date')`}</code>
      <br />
      <code>{`print(my_list)  # Output: ['apple', 'banana', 'cherry', 'date']`}</code>
    </pre>
    <br/>
    <h3 style={{paddingBottom:"6px"}}>5. Using the `insert()` Method to Add an Item at a Specific Position</h3>
    <p>
      You can also use the <code>insert()</code> method to add an element at a specific index in the list, which can be considered as a form of changing the list's structure.
    </p>
    <h4>Example:</h4>
    <pre>
      <code>{`my_list = ['apple', 'banana', 'cherry']`}</code>
      <br />
      <code>{`my_list.insert(1, 'orange')`}</code>
      <br />
      <code>{`print(my_list)  # Output: ['apple', 'orange', 'banana', 'cherry']`}</code>
    </pre>
    <br/>
    <h3 style={{paddingBottom:"6px"}}>6. Replacing Items with a List</h3>
    <p>
      If you want to replace a part of the list with another list, you can assign a new list to the desired slice.
    </p>
    <h4>Example:</h4>
    <pre>
      <code>{`my_list = ['apple', 'banana', 'cherry']`}</code>
      <br />
      <code>{`my_list[1:2] = ['orange', 'grape']`}</code>
      <br />
      <code>{`print(my_list)  # Output: ['apple', 'orange', 'grape', 'cherry']`}</code>
    </pre>
    <br/>
    <h3 style={{paddingBottom:"6px"}}>7. Modifying List Items Using a Loop</h3>
    <p>
      If you need to modify multiple elements based on certain conditions, you can use a loop to iterate through the list and change items.
    </p>
    <h4>Example:</h4>
    <pre>
      <code>{`my_list = ['apple', 'banana', 'cherry']`}</code>
      <br />
      <code>{`for i in range(len(my_list)): my_list[i] = my_list[i].upper()`}</code>
      <br />
      <code>{`print(my_list)  # Output: ['APPLE', 'BANANA', 'CHERRY']`}</code>
    </pre>
    <br/>
    <h3 style={{paddingBottom:"6px"}}>8. Using `del` to Remove Items</h3>
    <p>
      Although the primary purpose of the <code>del</code> statement is to delete items, you can also use it to change a list by deleting specific items and possibly replacing them with new ones.
    </p>
    <h4>Example:</h4>
    <pre>
      <code>{`my_list = ['apple', 'banana', 'cherry']`}</code>
      <br />
      <code>{`del my_list[1]`}</code>
      <br />
      <code>{`print(my_list)  # Output: ['apple', 'cherry']`}</code>
    </pre>
    <br/>
    <h3>Summary of Methods to Change List Items:</h3>
    <ul>
      <li><strong>Indexing:</strong> Use the index to directly change a list item.</li><br/>
      <li><strong>Negative Indexing:</strong> Access items from the end using negative indexes and modify them.</li><br/>
      <li><strong>Slicing:</strong> Modify multiple items at once by specifying a range of indexes.</li><br/>
      <li><strong>append():</strong> Add an item to the end of the list.</li><br/>
      <li><strong>insert():</strong> Add an item at a specific position in the list.</li><br/>
      <li><strong>Replacing with a List:</strong> Replace a part of the list with a new list.</li><br/>
      <li><strong>Looping:</strong> Use loops to modify elements based on a condition.</li><br/>
      <li><strong>del:</strong> Delete items and change the structure of the list.</li>
    </ul>

    <p>
      Changing list items in Python is versatile and offers various ways to modify lists efficiently, whether you're working with individual items, subsets of the list, or adding/removing items.
    </p>
  </div>
)}





        {selectedChapter === 'chapter17' && (
        <div className={style.chaptercontent}>
        <h1 className={style.heading}>Adding Items to Lists </h1>
    
    <p>
      In Python, lists are <strong>mutable</strong> data structures, which means that you can modify their contents by adding new items. Adding items to a list is one of the most common operations when working with lists in Python. Let's explore in detail how you can add items to a list using different methods.
    </p>
    <br/>
    <h2 style={{paddingBottom:"6px"}}>1. Using the `append()` Method</h2>
    <p>
      The <code>append()</code> method adds an element to the end of a list. It’s one of the simplest ways to extend a list with a new item. The <code>append()</code> method modifies the list in place and does not return a new list.
    </p>
    <pre>
      <code>
        {`list.append(item)`}
      </code>
    </pre>
    <p>
      <strong>item:</strong> The element you want to add to the list. It could be any valid Python object (e.g., integer, string, another list, etc.).
    </p>
    <h3>Example:</h3>
    <pre>
      <code>
        {`my_list = [1, 2, 3]

# Adding an integer to the list
my_list.append(4)

# Adding a string to the list
my_list.append("apple")

print(my_list)  # Output: [1, 2, 3, 4, "apple"]`}
      </code>
    </pre>
    <br/>
    <h2 style={{paddingBottom:"6px"}}>2. Using the `insert()` Method</h2>
    <p>
      The <code>insert()</code> method allows you to add an item to a specific position in the list. This method is more flexible than <code>append()</code> because it allows you to specify where the new element should be placed.
    </p>
    <pre>
      <code>
        {`list.insert(index, item)`}
      </code>
    </pre>
    <p>
      <strong>index:</strong> The position in the list where you want to insert the new item. The list will shift the existing items to make space for the new item.
    </p>
    <h3>Example:</h3>
    <pre>
      <code>
        {`my_list = [1, 2, 3]

# Insert an element at index 1
my_list.insert(1, "banana")

print(my_list)  # Output: [1, "banana", 2, 3]`}
      </code>
    </pre>
    <br/>
    <h2 style={{paddingBottom:"6px"}}>3. Using the `extend()` Method</h2>
    <p>
      The <code>extend()</code> method is used to add all elements from another iterable (e.g., another list, tuple, or string) to the end of the list. This is different from <code>append()</code>, which adds only one item at a time. <code>extend()</code> allows you to concatenate lists by adding multiple items from one list to another.
    </p>
    <pre>
      <code>
        {`list.extend(iterable)`}
      </code>
    </pre>
    <p>
      <strong>iterable:</strong> Any iterable (such as a list, tuple, or string) whose elements will be added to the original list.
    </p>
    <h3>Example:</h3>
    <pre>
      <code>
        {`my_list = [1, 2, 3]
other_list = [4, 5, 6]

# Adding all elements of other_list to my_list
my_list.extend(other_list)

print(my_list)  # Output: [1, 2, 3, 4, 5, 6]`}
      </code>
    </pre>
    <br/>
    <h2 style={{paddingBottom:"6px"}}>4. Using the `+` Operator (List Concatenation)</h2>
    <p>
      The <code>+</code> operator can be used to concatenate two lists, creating a new list that combines the elements of both. It doesn’t modify the original list but returns a new one. This can be a simple and efficient way to add items from another list to an existing one.
    </p>
    <pre>
      <code>
        {`new_list = list1 + list2`}
      </code>
    </pre>
    <p>
      <strong>list1:</strong> The first list. <br />
      <strong>list2:</strong> The second list to be concatenated with <code>list1</code>.
    </p>
    <h3>Example:</h3>
    <pre>
      <code>
        {`my_list = [1, 2, 3]
other_list = [4, 5, 6]

# Concatenating two lists
new_list = my_list + other_list

print(new_list)  # Output: [1, 2, 3, 4, 5, 6]`}
      </code>
    </pre>
    <br/>
    <h2 style={{paddingBottom:"6px"}}>5. Using List Multiplication to Add Items</h2>
    <p>
      List multiplication is a technique in Python that allows you to create a list with repeated elements. While it doesn’t allow you to add arbitrary elements, it can be useful for adding multiple copies of a single element to a list.
    </p>
    <pre>
      <code>
        {`list = [item] * n`}
      </code>
    </pre>
    <p>
      <strong>item:</strong> The item you want to add multiple times. <br />
      <strong>n:</strong> The number of times you want the item to appear in the list.
    </p>
    <h3>Example:</h3>
    <pre>
      <code>
        {`my_list = [1, 2, 3]

# Adding 3 copies of the number 0 to the list
my_list = my_list + [0] * 3

print(my_list)  # Output: [1, 2, 3, 0, 0, 0]`}
      </code>
    </pre>
    <br/>
    <h2 style={{paddingBottom:"6px"}}>6. Using the `*` Operator to Unpack Elements</h2>
    <p>
      In Python 3.5 and later, the <code>*</code> operator can be used for unpacking the elements of one list and adding them to another. This is useful for merging lists or inserting elements at specific positions in a list.
    </p>
    <pre>
      <code>
        {`list1 = [*list1, item]`}
      </code>
    </pre>
    <p>
      This will append <code>item</code> to <code>list1</code>. The unpacking can also be used with more complex structures to manipulate and add elements to the list.
    </p>
    <h3>Example:</h3>
    <pre>
      <code>
        {`my_list = [1, 2, 3]

# Unpacking and adding an element at the end
my_list = [*my_list, 4]

print(my_list)  # Output: [1, 2, 3, 4]`}
      </code>
    </pre>
    <br/>
    <h2 style={{paddingBottom:"6px"}}>Summary of Methods to Add Items to a List:</h2>
    <ul>
      <li><strong>append()</strong>: Adds a single item to the end of the list.</li><br/>
      <li><strong>insert()</strong>: Adds an item at a specific index in the list.</li><br/>
      <li><strong>extend()</strong>: Adds all elements of an iterable to the end of the list.</li><br/>
      <li><strong>+ Operator</strong>: Concatenates two lists and returns a new list.</li><br/>
      <li><strong>List Multiplication</strong>: Adds multiple copies of an item to the list.</li><br/>
      <li><strong>Unpacking (<code>*</code>)</strong>: Used for adding or merging elements to a list in a more flexible manner.</li>
    </ul>
    <br/>
    <h2 style={{paddingBottom:"6px"}}>Conclusion:</h2>
    <p>
      Adding items to a list in Python is a versatile process that offers multiple options. Whether you're adding a single element, multiple elements, or even concatenating entire lists, Python provides efficient and flexible methods to accomplish this. By using the appropriate method for your use case, you can effectively manage and modify lists in Python.
    </p>
  </div>
)}




            {selectedChapter === 'chapter18' && (
            <div className={style.chaptercontent}>
              <h1 className={style.heading}>Remove List Items </h1>        
        <p>
          In Python, lists are a type of mutable data structure, which means you can modify their contents by adding, changing, or removing items. Removing items from a list is one of the most common operations when working with lists. There are several ways to remove elements, and the method you choose depends on your use case. Let's explore how you can remove items from a list in Python in detail.
        </p>
        <br/>
        <h2 style={{paddingBottom:"6px"}}>1. Using the <code>remove()</code> Method</h2>
        <p>
          The <code>remove()</code> method is used to remove the first occurrence of a specific item from a list. It searches for the item, removes it from the list, and shifts the remaining elements to fill the gap. If the item is not found, Python raises a <code>ValueError</code>.
        </p>

        <h3>Syntax:</h3>
        <pre>
          <code>
            list.remove(item)
          </code>
        </pre>

        <p><strong>item</strong>: The element you want to remove. If the element appears multiple times in the list, only the first occurrence will be removed.</p>

        <h3>Example:</h3>
        <pre>
          <code>
            my_list = [1, 2, 3, 4, 2, 5] <br />
            my_list.remove(2) <br />
            print(my_list)  # Output: [1, 3, 4, 2, 5]
          </code>
        </pre>

        <p>
          In this example, the <code>remove()</code> method searches for the first occurrence of <code>2</code> and removes it from the list. The remaining elements are shifted accordingly. If you try to remove an item that doesn't exist in the list, you will get a <code>ValueError</code>.
        </p>
        <br/>
        <h2 style={{paddingBottom:"6px"}}>2. Using the <code>pop()</code> Method</h2>
        <p>
          The <code>pop()</code> method removes an item from a specific index in the list and returns the value of the removed item. This method is useful when you want to remove an item and use it later, such as when implementing a stack-like structure (Last In, First Out). If you don't specify an index, the <code>pop()</code> method removes and returns the last item of the list.
        </p>

        <h3>Syntax:</h3>
        <pre>
          <code>
            list.pop(index)
          </code>
        </pre>

        <p><strong>index</strong>: The position in the list of the item to be removed. If not provided, the last item is removed.</p>

        <h3>Example:</h3>
        <pre>
          <code>
            my_list = [1, 2, 3, 4] <br />
            removed_item = my_list.pop(2) <br />
            print(my_list)  # Output: [1, 2, 4] <br />
            print(removed_item)  # Output: 3
          </code>
        </pre>

        <p>
          In this case, the <code>pop()</code> method removes the item at index <code>2</code> (the value <code>3</code>) and returns it. The list is modified, and the removed item is stored in the <code>removed_item</code> variable. If you don't provide an index, it removes and returns the last item.
        </p>
        <br/>
        <h2 style={{paddingBottom:"6px"}}>3. Using the <code>del</code> Statement</h2>
        <p>
          The <code>del</code> statement is a general Python statement used to delete variables, entire lists, or specific items in a list. You can use <code>del</code> to remove an item at a specific index or slice elements from a list. The <code>del</code> statement does not return the removed item, unlike <code>pop()</code>.
        </p>

        <h3>Syntax:</h3>
        <pre>
          <code>
            del list[index]
          </code>
        </pre>

        <p><strong>index</strong>: The position in the list of the item to be deleted.</p>

        <h3>Example:</h3>
        <pre>
          <code>
            my_list = [1, 2, 3, 4] <br />
            del my_list[1] <br />
            print(my_list)  # Output: [1, 3, 4]
          </code>
        </pre>

        <p>
          In this case, <code>del</code> removes the item at index <code>1</code> (the value <code>2</code>). After removal, the list is modified, and no value is returned. You can also use <code>del</code> to remove slices of the list:
        </p>

        <pre>
          <code>
            my_list = [1, 2, 3, 4, 5] <br />
            del my_list[1:4] <br />
            print(my_list)  # Output: [1, 5]
          </code>
        </pre>
        <br/>
        <h2 style={{paddingBottom:"6px"}}>4. Using List Comprehension</h2>
        <p>
          If you want to remove items from a list based on a condition, list comprehension can be very useful. You can use this method to create a new list that excludes certain items based on a condition, without modifying the original list in place.
        </p>

        <h3>Syntax:</h3>
        <pre>
          <code>
            new_list = [item for item in list if condition]
          </code>
        </pre>

        <p><strong>item</strong>: The element in the list. <strong>condition</strong>: The condition used to filter the list (e.g., excluding certain values).</p>

        <h3>Example:</h3>
        <pre>
          <code>
            my_list = [1, 2, 3, 4, 5] <br />
            new_list = [item for item in my_list if item % 2 != 0] <br />
            print(new_list)  # Output: [1, 3, 5]
          </code>
        </pre>
        <br/>
        <h2 style={{paddingBottom:"6px"}}>5. Using the <code>clear()</code> Method</h2>
        <p>
          If you want to remove all items from a list, you can use the <code>clear()</code> method. This method empties the list entirely, leaving it with zero elements.
        </p>

        <h3>Syntax:</h3>
        <pre>
          <code>
            list.clear()
          </code>
        </pre>

        <h3>Example:</h3>
        <pre>
          <code>
            my_list = [1, 2, 3, 4, 5] <br />
            my_list.clear() <br />
            print(my_list)  # Output: []
          </code>
        </pre>
        <br/>
        <h2 style={{paddingBottom:"6px"}}>6. Using the <code>remove()</code> in a Loop for Multiple Items</h2>
        <p>
          If you need to remove multiple occurrences of the same item from a list, you can use a loop to repeatedly call the <code>remove()</code> method. However, be careful when modifying the list while iterating through it, as it may lead to unexpected behavior if you're not careful. A safer way is to loop through the list in reverse or use a list comprehension.
        </p>

        <h3>Example:</h3>
        <pre>
          <code>
            my_list = [1, 2, 3, 2, 4, 2, 5] <br />
            while 2 in my_list: <br />
            &nbsp;&nbsp;&nbsp;&nbsp;my_list.remove(2) <br />
            print(my_list)  # Output: [1, 3, 4, 5]
          </code>
        </pre>
        <br/>
        <h2 style={{paddingBottom:"6px"}}>Summary of Methods to Remove Items from a List:</h2>
        <ul>
          <li><strong>remove()</strong>: Removes the first occurrence of an item from the list.</li><br/>
          <li><strong>pop()</strong>: Removes an item at a specific index and returns the value of the removed item.</li><br/>
          <li><strong>del</strong>: Deletes an item at a specific index or can remove slices of the list.</li><br/>
          <li><strong>List Comprehension</strong>: Creates a new list by filtering out unwanted items.</li><br/>
          <li><strong>clear()</strong>: Removes all items from the list, leaving it empty.</li><br/>
          <li><strong>Looping with remove()</strong>: Removes multiple occurrences of an item.</li>
        </ul>
        <br/>
        <h2 style={{paddingBottom:"6px"}}>Conclusion:</h2>
        <p>
          Removing items from a list in Python is a fundamental operation that can be done in several ways depending on your needs. Whether you're removing specific items, multiple occurrences, or clearing the entire list, Python provides several methods that offer flexibility and efficiency. By choosing the right method for your situation, you can effectively manage and manipulate lists in your programs.
        </p>
      </div>
    
  )}



        {selectedChapter === 'chapter19' && (
        <div className={style.chaptercontent}>
        <h1 className={style.heading}>Looping Through Lists </h1>

    <p>
      In Python, a <strong>loop list</strong> typically refers to iterating over a list using a loop. You can use loops like <code>for</code> or <code>while</code> to go through each item in a list. Here's a brief overview of how loops are used with lists:
    </p> <br/>

    <h2 style={{paddingBottom:"6px"}}>1. Using the <code>for</code> Loop</h2>
    <p>
      The <code>for</code> loop allows you to iterate over each item in the list and perform operations on each element.
    </p>

    <h3>Syntax:</h3>
    <pre>
      <code>
        {`for item in list:
  # Perform action with item`}
      </code>
    </pre>

    <h3>Example:</h3>
    <pre>
      <code>
        {`my_list = [1, 2, 3, 4, 5]

# Print each item in the list
for item in my_list:
    print(item)`}
      </code>
    </pre>

    <p>Output:</p>
    <pre><code>1
2
3
4
5</code></pre>

    <p>
      In this example, the <code>for</code> loop iterates over the list <code>my_list</code> and prints each element.
    </p>
    <br/>
    <h2 style={{paddingBottom:"6px"}}>2. Using the <code>while</code> Loop</h2>
    <p>
      You can also use a <code>while</code> loop to iterate through a list. This is less common but can be useful in certain situations where you need more control over the loop condition.
    </p>

    <h3>Syntax:</h3>
    <pre>
      <code>
        {`index = 0
while index < len(list):
    # Perform action with list[index]
    index += 1`}
      </code>
    </pre>

    <h3>Example:</h3>
    <pre>
      <code>
        {`my_list = [1, 2, 3, 4, 5]

# Print each item in the list
index = 0
while index < len(my_list):
    print(my_list[index])
    index += 1`}
      </code>
    </pre>

    <p>Output:</p>
    <pre><code>1
2
3
4
5</code></pre>
<br/>
    <h2 style={{paddingBottom:"6px"}}>Summary:</h2>
    <ul>
      <li><strong><code>for</code> loop:</strong> The most common way to loop through a list in Python, as it is simple and easy to use.</li><br/>
      <li><strong><code>while</code> loop:</strong> Can be used if you need to track the index manually, giving you more flexibility in some cases.</li>
    </ul>

    <p>
      Both loops help you process or manipulate each item in the list efficiently.
    </p>
  </div>
)}




        {selectedChapter === 'chapter20' && (
        <div className={style.chaptercontent}>
        <h1 className={style.heading}> List Comprehension: </h1>
    
    <p>
      List comprehension is a concise and efficient way to create a new list by applying an expression to each item in an existing iterable, like a list or a range, with an optional condition. It allows you to perform operations like transformations or filtering in a single line of code.
    </p>
    <br/>
    <h3>Basic Syntax:</h3>
    <pre><code>{`new_list = [expression for item in iterable if condition]`}</code></pre>
    <ul>
      <li><strong>expression</strong>: The value you want to include in the new list.</li><br/>
      <li><strong>item</strong>: The current element from the iterable that you're iterating over.</li><br/>
      <li><strong>iterable</strong>: The sequence (like a list, string, or range) you're iterating through.</li><br/>
      <li><strong>condition (optional)</strong>: A filter that decides which items to include in the new list.</li>
    </ul><br/>

    <h3 style={{paddingBottom:"6px"}}>Examples:</h3>

    <h4 style={{paddingBottom:"6px"}}>1. Basic List Comprehension (Squaring Numbers)</h4>
    <pre><code>{`numbers = [1, 2, 3, 4, 5]
squares = [x ** 2 for x in numbers]
print(squares)`}</code></pre>
    <p><strong>Output:</strong></p>
    <pre><code>[1, 4, 9, 16, 25]</code></pre>
    <p><strong>Explanation:</strong> This comprehension squares each number in the list <code>numbers</code> and stores it in the new list <code>squares</code>.</p>
    <br/>
    <h4 style={{paddingBottom:"6px"}}>2. Adding a Condition (Filtering Even Numbers)</h4>
    <pre><code>{`numbers = [1, 2, 3, 4, 5]
even_numbers = [x for x in numbers if x % 2 == 0]
print(even_numbers)`}</code></pre>
    <p><strong>Output:</strong></p>
    <pre><code>[2, 4]</code></pre>
    <p><strong>Explanation:</strong> Here, the comprehension filters out the even numbers from the <code>numbers</code> list and creates a new list containing only the even numbers.</p>
    <br/>
    <h4 style={{paddingBottom:"6px"}}>3. Modifying Items (Adding 10 to Each Number)</h4>
    <pre><code>{`numbers = [1, 2, 3, 4, 5]
modified_numbers = [x + 10 for x in numbers]
print(modified_numbers)`}</code></pre>
    <p><strong>Output:</strong></p>
    <pre><code>[11, 12, 13, 14, 15]</code></pre>
    <p><strong>Explanation:</strong> This comprehension adds 10 to each number in the list <code>numbers</code> and stores the result in <code>modified_numbers</code>.</p>
    <br/>
    <h4 style={{paddingBottom:"6px"}}>4. Nested List Comprehension (Flattening a List of Lists)</h4>
    <pre><code>{`matrix = [[1, 2], [3, 4], [5, 6]]
flattened = [item for row in matrix for item in row]
print(flattened)`}</code></pre>
    <p><strong>Output:</strong></p>
    <pre><code>[1, 2, 3, 4, 5, 6]</code></pre>
    <p><strong>Explanation:</strong> This is a nested list comprehension that iterates through each row of the <code>matrix</code> and then through each item within the row, flattening the matrix into a single list.</p>
    <br/>
    <h4 style={{paddingBottom:"6px"}}>5. List Comprehension with String Operations</h4>
    <pre><code>{`string = "hello"
uppercase_letters = [char.upper() for char in string]
print(uppercase_letters)`}</code></pre>
    <p><strong>Output:</strong></p>
    <pre><code>['H', 'E', 'L', 'L', 'O']</code></pre>
    <p><strong>Explanation:</strong> This comprehension converts each character in the string <code>hello</code> to uppercase and stores the results in a list.</p>
    <br/>
    <h3>Advantages of List Comprehension:</h3>
    <ul>
      <li><strong>Concise:</strong> It allows you to write shorter code.</li><br/>
      <li><strong>Readable:</strong> It's often more readable and expressive than using loops.</li><br/>
      <li><strong>Efficient:</strong> List comprehensions are generally faster than using traditional loops for creating lists.</li>
    </ul>
    <br/>
    <h3>When to Use:</h3>
    <ul>
      <li>When you want to filter or transform items in a list or iterable in a single line.</li><br/>
      <li>When the logic is simple and can be expressed clearly in one line. For complex logic, traditional loops might be better.</li>
    </ul>

    <p>
      List comprehension is a powerful tool in Python, making code more readable and often more efficient, especially for common tasks like transformations or filtering data.
    </p>
  </div>
)}



        {selectedChapter === 'chapter21' && (
        <div className={style.chaptercontent}>
        <h1 className={style.heading}>Sort List </h1>

    <p>
      In Python, you can sort a list using the <code>sort()</code> method or the <code>sorted()</code> function. 
      Both are used to arrange the items in the list in a specific order (ascending or descending). Here’s a brief explanation of each approach:
    </p>
    <br/>
    <h2>1. Using <code>sort()</code> Method</h2>
    <p>
      The <code>sort()</code> method sorts a list <strong>in place</strong>, meaning it modifies the original list directly.
    </p>
    <h3>Syntax:</h3>
    <pre>
      <code>
        list.sort(reverse=False)
      </code>
    </pre>
    <ul>
      <li><strong>reverse (optional)</strong>: If set to <code>True</code>, the list will be sorted in descending order. By default, it is <code>False</code>, which sorts in ascending order.</li>
    </ul>

    <h3>Example:</h3>
    <pre>
      <code>
        {`numbers = [5, 2, 8, 1, 4]\nnumbers.sort()  # Sorts in ascending order\nprint(numbers)  # Output: [1, 2, 4, 5, 8]\n\nnumbers.sort(reverse=True)  # Sorts in descending order\nprint(numbers)  # Output: [8, 5, 4, 2, 1]`}
      </code>
    </pre>
    <br/>
    <h2>2. Using <code>sorted()</code> Function</h2>
    <p>
      The <code>sorted()</code> function returns a new list that is sorted, leaving the original list unchanged. You can use this if you want to keep the original list intact.
    </p>
    <h3>Syntax:</h3>
    <pre>
      <code>
        new_list = sorted(list, reverse=False)
      </code>
    </pre>

    <h3>Example:</h3>
    <pre>
      <code>
        {`numbers = [5, 2, 8, 1, 4]\nsorted_list = sorted(numbers)  # Sorts in ascending order\nprint(sorted_list)  # Output: [1, 2, 4, 5, 8]\nprint(numbers)  # Original list remains unchanged: [5, 2, 8, 1, 4]\n\nsorted_list_desc = sorted(numbers, reverse=True)  # Sorts in descending order\nprint(sorted_list_desc)  # Output: [8, 5, 4, 2, 1]`}
      </code>
    </pre><br/>

    <h2>Summary:</h2>
    <ul>
      <li><strong><code>sort()</code></strong>: Sorts the list in place and modifies the original list.</li><br/>
      <li><strong><code>sorted()</code></strong>: Returns a new sorted list, leaving the original list unchanged.</li>
    </ul>
    <br/>
    <h2>Sorting Strings and Other Data Types:</h2>
    <p>
      You can also use <code>sort()</code> and <code>sorted()</code> to sort lists of strings or other data types. For example, sorting alphabetically for strings:
    </p>
    <pre>
      <code>
        {`words = ["banana", "apple", "cherry"]\nwords.sort()  # Sorts alphabetically\nprint(words)  # Output: ['apple', 'banana', 'cherry']`}
      </code>
    </pre>
    <br/>
    <p>
      Note: Both methods allow you to customize sorting with a <strong>key</strong> parameter, which can be used to sort based on a specific condition (e.g., sorting by string length or using custom comparison functions).
    </p>
  </div>
)}



        {selectedChapter === 'chapter22' && (
        <div className={style.chaptercontent}>
        <h1 className={style.heading}>Copy List </h1>

    <p>
      In Python, copying a list means creating a new list that contains the same elements as the original list. You can do this in several ways depending on the situation. Here's a brief explanation of the common methods:
    </p>
    <br/>
    <h2 style={{paddingBottom:"6px"}}>1. Using the <code>copy()</code> Method</h2>
    <p>
      The <code>copy()</code> method creates a shallow copy of the list, meaning it creates a new list with the same elements, but it does not copy the nested objects (if any). Modifications to the new list do not affect the original list.
    </p>
    <h4>Syntax:</h4>
    <pre><code>new_list = original_list.copy()</code></pre>

    <h4>Example:</h4>
    <pre>
      {`original_list = [1, 2, 3, 4]\nnew_list = original_list.copy()\nprint(new_list)  # Output: [1, 2, 3, 4]`}
    </pre>
    <br/>
    <h2 style={{paddingBottom:"6px"}}>2. Using Slicing</h2>
    <p>
      You can use slicing to create a shallow copy of a list. This is another simple and commonly used method.
    </p>
    <h4>Syntax:</h4>
    <pre><code>new_list = original_list[:]</code></pre>

    <h4>Example:</h4>
    <pre>
      {`original_list = [1, 2, 3, 4]\nnew_list = original_list[:]\nprint(new_list)  # Output: [1, 2, 3, 4]`}
    </pre>
    <br/>
    <h2 style={{paddingBottom:"6px"}}>3. Using the <code>list()</code> Constructor</h2>
    <p>
      You can also use the <code>list()</code> constructor to create a new list from the original list.
    </p>
    <h4>Syntax:</h4>
    <pre><code>new_list = list(original_list)</code></pre>

    <h4>Example:</h4>
    <pre>
      {`original_list = [1, 2, 3, 4]\nnew_list = list(original_list)\nprint(new_list)  # Output: [1, 2, 3, 4]`}
    </pre>
    <br/>
    <h2 style={{paddingBottom:"6px"}}>4. Using the <code>copy</code> Module (Deep Copy for Nested Lists)</h2>
    <p>
      If your list contains nested lists (or other mutable objects), the <code>copy()</code> method or slicing only creates a shallow copy. To create a deep copy (where all nested objects are copied too), you can use the <code>deepcopy()</code> function from the <code>copy</code> module.
    </p>
    <h4>Syntax:</h4>
    <pre><code>import copy\nnew_list = copy.deepcopy(original_list)</code></pre>

    <h4>Example:</h4>
    <pre>
      {`import copy\noriginal_list = [[1, 2], [3, 4]]\nnew_list = copy.deepcopy(original_list)\nnew_list[0][0] = 10\nprint(original_list)  # Output: [[1, 2], [3, 4]]\nprint(new_list)       # Output: [[10, 2], [3, 4]]`}
    </pre>
    <br/>
    <h2>Summary:</h2>
    <ul>
      <li><strong>Shallow Copy:</strong> Methods like <code>copy()</code>, slicing <code>[:]</code>, or <code>list()</code> create shallow copies.</li><br/>
      <li><strong>Deep Copy:</strong> Use <code>copy.deepcopy()</code> for nested lists or more complex structures.</li>
    </ul>

    <p>
      Note: These methods allow you to copy lists in Python, either shallowly or deeply, depending on the requirement.
    </p>
  </div>
)}



        {selectedChapter === 'chapter23' && (
        <div className={style.chaptercontent}>
        <h1 className={style.heading}>Join List </h1>

    <p>
      In Python, joining a list refers to combining the elements of a list into a single string. This is typically done using the <code>join()</code> method, which is available for string objects. It allows you to concatenate all the elements in a list into one string, with a specified separator between each element.
    </p>
    <br/>
    <h3>Using the <code>join()</code> Method</h3>
    <p>
      The <code>join()</code> method is called on a string separator and is used to join the elements of an iterable (like a list) into a single string.
    </p>

    <h4>Syntax:</h4>
    <pre><code>separator.join(iterable)</code></pre>
    <ul>
      <li><strong>separator</strong>: The string that you want to insert between the elements. It can be any string, such as a space, comma, or even an empty string.</li>
      <li><strong>iterable</strong>: The list (or any iterable) whose elements you want to join.</li>
    </ul>
    <br/>
    <h3 style={{paddingBottom:"6px"}}>Examples:</h3>

    <h4>1. Joining a List of Strings with a Space</h4>
    <pre><code>
      words = ["Hello", "world", "from", "Python"]<br />
      sentence = " ".join(words)<br />
      print(sentence)
    </code></pre>
    <p><strong>Output:</strong><br />
      <code>Hello world from Python</code>
    </p>
    <p>
      The <code>" ".join(words)</code> joins each word in the list with a space between them.
    </p>
    <br/>
    <h4>2. Joining a List of Strings with a Comma</h4>
    <pre><code>
      fruits = ["apple", "banana", "cherry"]<br />
      result = ", ".join(fruits)<br />
      print(result)
    </code></pre>
    <p><strong>Output:</strong><br />
      <code>apple, banana, cherry</code>
    </p>
    <br/>
    <h4>3. Joining a List of Characters</h4>
    <pre><code>
      chars = ['P', 'y', 't', 'h', 'o', 'n']<br />
      joined_string = "".join(chars)<br />
      print(joined_string)
    </code></pre>
    <p><strong>Output:</strong><br />
      <code>Python</code>
    </p>
    <br/>
    <h4>4. Joining Non-String Elements</h4>
    <pre><code>
      numbers = [1, 2, 3, 4]<br />
      result = "-".join(map(str, numbers))<br />
      print(result)
    </code></pre>
    <p><strong>Output:</strong><br />
      <code>1-2-3-4</code>
    </p>
    <p>
      The <code>map(str, numbers)</code> converts the integers in the list to strings before joining them with a hyphen ("-").
    </p>
    <br/>
    <h3>Summary:</h3>
    <ul>
      <li>The <code>join()</code> method is used to concatenate the elements of a list into a single string with a specified separator.</li><br/>
      <li>It is most useful for joining lists of strings, but you can join non-string elements by converting them to strings first.</li><br/>
      <li>The method does not modify the original list and returns a new string.</li>
    </ul>

      </div>
)}




        {selectedChapter === 'chapter24' && (
        <div className={style.chaptercontent}>
        <h1 className={style.heading}>  List Methods </h1>

      <p>In Python, lists come with a variety of built-in methods that allow you to manipulate, access, and modify them efficiently. Here's a summary of the most commonly used built-in methods for lists in Python:</p>

      <h2>1. append()</h2>
      <p>Adds an element to the end of the list.</p>
      <pre><code>list.append(element)</code></pre>
      <p>Example:</p>
      <pre><code>fruits = ['apple', 'banana']<br/>fruits.append('cherry')<br/>print(fruits)  # Output: ['apple', 'banana', 'cherry']</code></pre>
      <br/>
      <h2>2. extend()</h2>
      <p>Adds all elements of an iterable (e.g., another list) to the end of the list.</p>
      <pre><code>list.extend(iterable)</code></pre>
      <p>Example:</p>
      <pre><code>fruits = ['apple', 'banana']<br/>fruits.extend(['cherry', 'date'])<br/>print(fruits)  # Output: ['apple', 'banana', 'cherry', 'date']</code></pre>
      <br/>
      <h2>3. insert()</h2>
      <p>Inserts an element at a specified index.</p>
      <pre><code>list.insert(index, element)</code></pre>
      <p>Example:</p>
      <pre><code>fruits = ['apple', 'banana']<br/>fruits.insert(1, 'cherry')  // Insert 'cherry' at index 1<br/>print(fruits)  // Output: ['apple', 'cherry', 'banana']</code></pre>
      <br/>
      <h2>4. remove()</h2>
      <p>Removes the first occurrence of a specified element from the list.</p>
      <pre><code>list.remove(element)</code></pre>
      <p>Example:</p>
      <pre><code>fruits = ['apple', 'banana', 'cherry']<br/>fruits.remove('banana')<br/>print(fruits)  // Output: ['apple', 'cherry']</code></pre>
      <br/>
      <h2>5. pop()</h2>
      <p>Removes and returns the element at the specified index (or the last element if no index is provided).</p>
      <pre><code>list.pop(index)</code></pre>
      <p>Example:</p>
      <pre><code>fruits = ['apple', 'banana', 'cherry']<br/>removed_item = fruits.pop(1)  // Removes the element at index 1<br/>print(fruits)  // Output: ['apple', 'cherry']<br/>print(removed_item)  // Output: 'banana'</code></pre>
      <br/>
      <h2>6. clear()</h2>
      <p>Removes all elements from the list, resulting in an empty list.</p>
      <pre><code>list.clear()</code></pre>
      <p>Example:</p>
      <pre><code>fruits = ['apple', 'banana', 'cherry']<br/>fruits.clear()<br/>print(fruits)  // Output: []</code></pre>
      <br/>
      <h2>7. index()</h2>
      <p>Returns the index of the first occurrence of a specified element.</p>
      <pre><code>list.index(element)</code></pre>
      <p>Example:</p>
      <pre><code>fruits = ['apple', 'banana', 'cherry']<br/>index_of_banana = fruits.index('banana')<br/>print(index_of_banana)  // Output: 1</code></pre>
      <br/>
      <h2>8. count()</h2>
      <p>Returns the number of occurrences of a specified element in the list.</p>
      <pre><code>list.count(element)</code></pre>
      <p>Example:</p>
      <pre><code>fruits = ['apple', 'banana', 'cherry', 'banana']<br/>count_of_bananas = fruits.count('banana')<br/>print(count_of_bananas)  // Output: 2</code></pre>
      <br/>
      <h2>9. sort</h2>
      <p>Sorts the list in ascending order by default. You can use the <code>reverse=True</code> argument to sort in descending order.</p>
      <pre><code>list.sort(reverse=False)</code></pre>
      <p>Example:</p>
      <pre><code>fruits = ['banana', 'cherry', 'apple']<br/>fruits.sort()<br/>print(fruits)  // Output: ['apple', 'banana', 'cherry']</code></pre>
      <br/>
      <h2>10. reverse</h2>
      <p>Reverses the elements of the list in place.</p>
      <pre><code>list.reverse()</code></pre>
      <p>Example:</p>
      <pre><code>fruits = ['apple', 'banana', 'cherry']<br/>fruits.reverse()<br/>print(fruits)  // Output: ['cherry', 'banana', 'apple']</code></pre>
      <br/>
      <h2>11.copy(</h2>
      <p>Returns a shallow copy of the list (a new list with the same elements, but not the same object).</p>
      <pre><code>new_list = list.copy()</code></pre>
      <p>Example:</p>
      <pre><code>fruits = ['apple', 'banana', 'cherry']<br/>fruits_copy = fruits.copy()<br/>print(fruits_copy)  // Output: ['apple', 'banana', 'cherry']</code></pre>
      <br/>
      <h2>12.sort( (used for sorting)</h2>
      <p>Sorts the list in place.</p>
      <pre><code>numbers = [4, 3, 1, 2]<br/>numbers.sort()<br/>print(numbers)  // Output: [1, 2, 3, 4]</code></pre>
      <br/>
      <h2>13. del statement</h2>
      <p>Although not technically a list method, <code>del</code> can be used to remove an element by index or to delete the entire list.</p>
      <pre><code>del list[index]</code></pre>
      <p>Example:</p>
      <pre><code>fruits = ['apple', 'banana', 'cherry']<br/>del fruits[1]<br/>print(fruits)  // Output: ['apple', 'cherry']</code></pre>
      <br/>
      <h2>Summary of List Methods:</h2>
      <ul>
        <li><code>append()</code> – Add a single element to the end of the list.</li><br/>
        <li><code>extend()</code> – Add elements from an iterable to the end of the list.</li><br/>
        <li><code>insert()</code> – Insert an element at a specified index.</li><br/>
        <li><code>remove()</code> – Remove the first occurrence of an element.</li><br/>
        <li><code>pop()</code> – Remove and return an element at a specific index.</li><br/>
        <li><code>clear()</code> – Remove all elements from the list.</li><br/>
        <li><code>index()</code> – Get the index of the first occurrence of an element.</li><br/>
        <li><code>count()</code> – Get the count of an element in the list.</li><br/>
        <li><code>sort()</code> – Sort the list in ascending or descending order.</li><br/>
        <li><code>reverse()</code> – Reverse the order of elements in the list.</li><br/>
        <li><code>copy()</code> – Create a shallow copy of the list.</li>
      </ul><br/>

      <p>These list methods provide flexibility for manipulating lists in Python. Each of these methods can be used depending on the situation to modify, access, or retrieve data from a list.</p>
    </div>
  )}



      {selectedChapter === 'chapter25' && (
      <div className={style.chaptercontent}>
      <h1 className={style.heading}>Tuples in Python</h1>
    
    <p>
      A <strong>tuple</strong> in Python is an <strong>ordered</strong> collection of elements, similar to a list, but with a key difference: <strong>tuples are immutable</strong>, meaning their contents cannot be changed after they are created. Tuples can contain elements of different data types, and they are commonly used when you want to store a collection of values that should not be modified.
    </p>
    <br/>
    <h2>Key Features of Tuples:</h2>
    <ul>
      <li><strong>Ordered</strong>: The elements have a defined order, which means the order of elements is preserved.</li><br/>
      <li><strong>Immutable</strong>: Once a tuple is created, its contents cannot be modified (i.e., you cannot add, remove, or change elements).</li><br/>
      <li><strong>Heterogeneous</strong>: A tuple can contain elements of different data types (integers, strings, lists, etc.).</li><br/>
      <li><strong>Indexing</strong>: Tuples support indexing, so you can access elements using their position.</li><br/>
      <li><strong>Supports Duplication</strong>: Tuples can contain multiple instances of the same value.</li>
    </ul><br/>

    <h2>Creating a Tuple:</h2>
    <p>Tuples are created by placing elements inside <code>parentheses ()</code>, separated by commas.</p>
    <pre>
      <code>
{`# Creating a tuple with mixed data types
my_tuple = (1, 2, 3, "apple", 4.5)

# Creating a tuple with a single element (Note the comma)
single_element_tuple = (5,)

# Creating an empty tuple
empty_tuple = ()`}
      </code>
    </pre>
    <br/>
    <h2>Tuple Data Type:</h2>
    <p>A tuple is an <strong>object</strong> in Python, and it has the type <code>&lt;class 'tuple'&gt;</code>. You can check the type of a tuple using the <code>type()</code> function.</p>
    <pre>
      <code>
{`# Checking the data type of a tuple
print(type(my_tuple))  # Output: <class 'tuple'>`}
      </code>
    </pre>
    <br/>
    <h2>Accessing Elements in a Tuple (Indexing):</h2>
    <p>You can access individual elements of a tuple using <strong>indexing</strong>. Indexing starts from 0.</p>
    <pre>
      <code>
{`# Accessing tuple elements
print(my_tuple[0])  # Output: 1
print(my_tuple[3])  # Output: 'apple'

# Negative indexing (accessing elements from the end)
print(my_tuple[-1])  # Output: 4.5 (last element)
print(my_tuple[-2])  # Output: 'apple' (second to last element)`}
      </code>
    </pre>
    <br/>
    <h2>Tuple Length: <code>len()</code></h2>
    <p>The <code>len()</code> function returns the number of elements in a tuple. It can be used to find the length (number of elements) of the tuple.</p>
    <pre>
      <code>
{`# Getting the length of a tuple
tuple_length = len(my_tuple)
print(tuple_length)  # Output: 5 (the number of elements in the tuple)`}
      </code>
    </pre>
    <br/>
    <h2>Tuple Index: <code>index()</code></h2>
    <p>The <code>index()</code> method returns the index of the <strong>first occurrence</strong> of a specified element in the tuple. If the element is not found, it raises a <code>ValueError</code>.</p>
    <pre>
      <code>
{`# Finding the index of an element in a tuple
index_of_apple = my_tuple.index("apple")
print(index_of_apple)  # Output: 3 (index of 'apple' in the tuple)`}
      </code>
    </pre>
    <br/>
    <h2>Tuple Count: <code>count()</code></h2>
    <p>The <code>count()</code> method returns the <strong>number of occurrences</strong> of a specified element in the tuple.</p>
    <pre>
      <code>
{`# Counting occurrences of an element
count_of_1 = my_tuple.count(1)
print(count_of_1)  # Output: 1 (since 1 appears once in the tuple)`}
      </code>
    </pre>
    <br/>
    <h2>Tuple Operations:</h2>
    <ol>
      <li><strong>Concatenation (+)</strong>: You can join two tuples together.</li><br/>
      <li><strong>Repetition (*)</strong>: You can repeat the tuple elements multiple times.</li>
    </ol>
    <pre>
      <code>
{`# Concatenating tuples
tuple1 = (1, 2)
tuple2 = (3, 4)
combined_tuple = tuple1 + tuple2
print(combined_tuple)  # Output: (1, 2, 3, 4)

# Repeating a tuple
repeated_tuple = tuple1 * 3
print(repeated_tuple)  # Output: (1, 2, 1, 2, 1, 2)`}
      </code>
    </pre>
    <br/>
    <h2>Why Use Tuples:</h2>
    <ul>
      <li><strong>Immutability</strong>: Useful when you need a constant collection of data.</li><br/>
      <li><strong>Performance</strong>: Tuples are generally more memory-efficient and faster for iteration than lists.</li><br/>
      <li><strong>Used as Dictionary Keys</strong>: Since tuples are immutable, they can be used as keys in dictionaries (unlike lists).</li>
    </ul>
    <br/>
    <h2>Summary:</h2>
    <ul>
      <li><strong>Tuples</strong> are ordered, immutable collections in Python that can store elements of any data type.</li><br/>
      <li>They support basic operations like indexing, slicing, and counting elements.</li><br/>
      <li>The <code>len()</code> function gives the number of elements in a tuple, and the <code>index()</code> and <code>count()</code> methods help find the position and count of elements, respectively.</li>
    </ul>
  </div>
)}



      {selectedChapter === 'chapter26' && (
      <div className={style.chaptercontent}>
      <h1 className={style.heading}>Accessing Tuples </h1>

    <p>In Python, you can access the elements of a tuple using <strong>indexing</strong> and <strong>slicing</strong>. Here's a detailed explanation of how to access items in a tuple:</p>
    <br/>
    <h2>1. Accessing Tuple Items Using Indexing</h2>
    <p>Tuples are <strong>ordered</strong> collections, which means each element has a specific position, and you can access the elements by referring to their index.</p>
    <ul>
      <li><strong>Indexing</strong> starts at <code>0</code> for the first element.</li>
      <li>Negative indexing allows you to access elements from the end of the tuple, starting from <code>-1</code> for the last element.</li>
    </ul>

    <h3 style={{paddingBottom:"6px"}}>Example of Indexing:</h3>
    <pre>
      <code>
        {`my_tuple = (10, 20, 30, 40, 50)\n\n# Accessing elements using positive indexing\nprint(my_tuple[0])  # Output: 10\nprint(my_tuple[3])  # Output: 40\n\n# Accessing elements using negative indexing\nprint(my_tuple[-1])  # Output: 50\nprint(my_tuple[-2])  # Output: 40`}
      </code>
    </pre>
    <br/>
    <h2>2. Accessing Tuple Items Using Slicing</h2>
    <p>You can use <strong>slicing</strong> to access a range of elements from a tuple, which allows you to specify a start, stop, and step.</p>
    <ul>
      <li><strong>Syntax</strong>: <code>tuple[start:end:step]</code></li>
      <li><strong>start</strong>: The index where the slice begins (inclusive).</li>
      <li><strong>end</strong>: The index where the slice ends (exclusive).</li>
      <li><strong>step</strong>: The step (or stride) between elements to include.</li>
    </ul>

    <h3 style={{paddingBottom:"6px"}}>Example of Slicing:</h3>
    <pre>
      <code>
        {`my_tuple = (10, 20, 30, 40, 50, 60)\n\n# Slicing a tuple (from index 1 to index 4)\nprint(my_tuple[1:4])  # Output: (20, 30, 40)\n\n# Slicing with a step of 2\nprint(my_tuple[::2])  # Output: (10, 30, 50)\n\n# Slicing with negative indices (from second to last element to the first element)\nprint(my_tuple[-3:-1])  # Output: (40, 50)`}
      </code>
    </pre>
    <br/>
    <h2>3. Accessing Tuple Items Using Looping</h2>
    <p>You can loop through a tuple using a <strong>for</strong> loop to access each element.</p>

    <h3 style={{paddingBottom:"6px"}}>Example of Looping Through a Tuple:</h3>
    <pre>
      <code>
        {`my_tuple = (10, 20, 30, 40)\n\n# Looping through the tuple\nfor item in my_tuple:\n    print(item)\n\n# Output:\n# 10\n# 20\n# 30\n# 40`}
      </code>
    </pre>
    <br/>
    <h2>4. Using <code>index()</code> Method to Find the Index of an Element</h2>
    <p>The <code>index()</code> method can be used to find the index of the first occurrence of a specified element in the tuple.</p>

    <h3 style={{paddingBottom:"6px"}}>Example of Using <code>index()</code> Method:</h3>
    <pre>
      <code>
        {`my_tuple = (10, 20, 30, 40, 30)\n\n# Finding the index of the first occurrence of '30'\nindex_of_30 = my_tuple.index(30)\nprint(index_of_30)  # Output: 2`}
      </code>
    </pre>
    <br/>
    <h2>5. Using <code>count()</code> Method to Count Occurrences of an Element</h2>
    <p>The <code>count()</code> method returns the number of times an element appears in the tuple.</p>

    <h3 style={{paddingBottom:"6px"}}>Example of Using <code>count()</code> Method:</h3>
    <pre>
      <code>
        {`my_tuple = (10, 20, 30, 40, 30)\n\n# Counting the occurrences of 30\ncount_of_30 = my_tuple.count(30)\nprint(count_of_30)  # Output: 2`}
      </code>
    </pre>
    <br/>
    <h2>Key Points:</h2>
    <ul>
      <li><strong>Indexing</strong> starts from <code>0</code>, and you can access elements using both positive and negative indices.</li><br/>
      <li><strong>Slicing</strong> allows you to access a range of elements with the ability to specify start, end, and step.</li><br/>
      <li>You can <strong>loop</strong> through the tuple to access each element.</li><br/>
      <li>The <code>index()</code> method finds the index of the first occurrence of an element.</li><br/>
      <li>The <code>count()</code> method counts the occurrences of an element in the tuple.</li>
    </ul><br/>

    <p>Note: Tuples, like lists, are ordered, and these various ways of accessing their items make it flexible for different use cases.</p>
  </div>
)}



        {selectedChapter === 'chapter27' && (
        <div className={style.chaptercontent}>
        <h1 className={style.heading}>Update Tuples</h1>

    <p>
      In Python, <strong>tuples</strong> are immutable, which means once a tuple is created, you cannot modify its elements directly.
      You cannot add, remove, or change the values of the elements in a tuple. However, you can work around this limitation by
      converting the tuple into a list (which is mutable), making changes, and then converting it back to a tuple if needed.
    </p>
    <br/>
    <h2>How to "Update" Tuples:</h2>
    <ol>
      <li><strong>Changing Tuple Elements</strong>: You cannot change the elements of a tuple directly.</li>
      <li><strong>Adding Elements</strong>: You can't add elements to an existing tuple, but you can concatenate another tuple to the original one.</li>
      <li><strong>Removing Elements</strong>: Similar to adding, you cannot remove elements directly, but you can create a new tuple that excludes specific elements.</li>
    </ol>
    <br/>
    <h3>Example 1: Converting a Tuple to a List, Modifying, and Converting Back</h3>
    <pre><code>{`
# Initial tuple
my_tuple = (10, 20, 30, 40, 50)

# Convert tuple to a list
temp_list = list(my_tuple)

# Modify the list (e.g., changing the second element)
temp_list[1] = 25

# Convert the list back to a tuple
updated_tuple = tuple(temp_list)

print(updated_tuple)  # Output: (10, 25, 30, 40, 50)
    `}</code></pre>
<br/>
    <h3>Example 2: Concatenating Tuples (Adding Elements)</h3>
    <pre><code>{`
# Initial tuple
my_tuple = (10, 20, 30)

# Concatenate another tuple
new_tuple = my_tuple + (40, 50)

print(new_tuple)  # Output: (10, 20, 30, 40, 50)
    `}</code></pre>
<br/>
    <h3>Example 3: Removing Elements from a Tuple</h3>
    <pre><code>{`
# Initial tuple
my_tuple = (10, 20, 30, 40, 50)

# Remove an element by creating a new tuple (exclude the element you want to remove)
new_tuple = my_tuple[:2] + my_tuple[3:]

print(new_tuple)  # Output: (10, 20, 40, 50)
    `}</code></pre>
<br/>
    <h2>Key Points:</h2>
    <ul>
      <li><strong>Immutability</strong>: Once a tuple is created, you cannot modify it directly.</li><br/>
      <li><strong>Workaround with Lists</strong>: You can convert the tuple into a list, modify the list, and convert it back to a tuple.</li><br/>
      <li><strong>Concatenation and Slicing</strong>: You can add elements by concatenating another tuple, and remove elements by slicing and creating a new tuple.</li>
    </ul><br/>

    <p>
      In Python, if you need a mutable collection, consider using a <strong>list</strong> instead of a tuple.
    </p>
  </div>
)}




        {selectedChapter === 'chapter28' && (
        <div className={style.chaptercontent}>
        <h1 className={style.heading}>Tuple Unpacking </h1>

    <p>
      In Python, <strong>tuple unpacking</strong> refers to the process of assigning the values of a tuple to multiple variables in a single statement. This is possible because tuples are ordered collections, and you can directly extract individual elements from a tuple and assign them to variables based on their position.
    </p>
    <br/>
    <h3>Tuple Unpacking Syntax</h3>
    <p>
      To unpack a tuple, you place the variables inside parentheses on the left side of an assignment statement, with each variable corresponding to an element of the tuple.
    </p>
    <pre>
      <code>
{`tuple_name = (value1, value2, value3)
var1, var2, var3 = tuple_name`}
      </code>
    </pre>
    <br/>
    <h3>Example of Tuple Unpacking</h3>
    <pre>
      <code>
{`my_tuple = (10, 20, 30)

# Unpacking the tuple into individual variables
a, b, c = my_tuple

# Output the unpacked variables
print(a)  # Output: 10
print(b)  # Output: 20
print(c)  # Output: 30`}
      </code>
    </pre>
    <br/>
    <p>
      In the example above:
      <ul>
        <li><strong>a</strong> receives the first element of the tuple (<code>10</code>),</li><br/>
        <li><strong>b</strong> receives the second element (<code>20</code>),</li><br/>
        <li><strong>c</strong> receives the third element (<code>30</code>).</li>
      </ul><br/>
    </p>

    <h3>Important Points</h3>
    <ul>
      <li>
        <strong>Number of Variables Must Match:</strong> The number of variables on the left-hand side must match the number of elements in the tuple, otherwise, you'll get a <code>ValueError</code>.
        <pre>
          <code>
{`my_tuple = (10, 20)
a, b, c = my_tuple  # This will raise a ValueError because the tuple has only 2 elements`}
          </code>
        </pre>
      </li><br/>
      <li>
        <strong>Ignoring Unwanted Values with an Underscore:</strong> If you want to unpack only some values and ignore others, you can use an underscore (<code>_</code>) as a placeholder.
        <pre>
          <code>
{`my_tuple = (10, 20, 30, 40)

# Only unpack the first two values and ignore the rest
a, b, _ = my_tuple

print(a)  # Output: 10
print(b)  # Output: 20`}
          </code>
        </pre>
      </li><br/>
      <li>
        <strong>Using Extended Unpacking:</strong> Python 3 allows you to use the <code>*</code> operator to unpack multiple elements into a list, which is useful when you don’t know how many elements are in the tuple.
        <pre>
          <code>
{`my_tuple = (10, 20, 30, 40, 50)

# Unpacking with extended unpacking (the * operator)
a, b, *rest = my_tuple

print(a)      # Output: 10
print(b)      # Output: 20
print(rest)   # Output: [30, 40, 50] (the remaining elements)`}
          </code>
        </pre>
      </li><br/>
      <li>
        Similarly, you can place the <code>*</code> operator in the middle to collect elements from the middle of the tuple:
        <pre>
          <code>
{`my_tuple = (10, 20, 30, 40, 50)

# Unpacking with * in the middle
a, *middle, c = my_tuple

print(a)      # Output: 10
print(middle) # Output: [20, 30, 40]
print(c)      # Output: 50`}
          </code>
        </pre>
      </li>
    </ul><br/>

    <h3>Tuple Unpacking with Functions</h3>
    <p>
      You can also use tuple unpacking when passing values to functions.
    </p>
    <pre>
      <code>
{`def sum_and_diff(a, b):
    return a + b, a - b

result = sum_and_diff(10, 5)

# Unpacking the result of the function
sum_result, diff_result = result

print(sum_result)  # Output: 15
print(diff_result)  # Output: 5`}
      </code>
    </pre>

    <h3>Key Points:</h3>
    <ul>
      <li>Tuple unpacking allows you to assign the elements of a tuple to variables in a concise way.</li><br/>
      <li>The number of variables must match the number of elements in the tuple, unless you're using the <code>*</code> operator for extended unpacking.</li><br/>
      <li>Tuple unpacking is often used for readability and in functions that return multiple values.</li>
    </ul>
    <br/>
    <p>
      Unpacking makes code cleaner, especially when dealing with functions or methods that return tuples with multiple values.
    </p>
  </div>
)}




            {selectedChapter === 'chapter29' && (
            <div className={style.chaptercontent}>
            <h1 className={style.heading}>Looping in Tuple</h1>

          <p>
            In Python, you can loop through a tuple to access its elements using different types of loops, such as a <code>for</code> loop. Since tuples are ordered collections, looping through them allows you to access each element one by one. Here's an explanation of how to loop through tuples in Python:
          </p>
          <br/>
          <h2>Looping Through a Tuple with a <code>for</code> Loop</h2>
          <p>
            The most common way to loop through a tuple is by using a <code>for</code> loop. This method iterates over the elements of the tuple one by one.
          </p>

          <h3>Example 1: Basic Looping through a Tuple</h3>
          <pre>
            <code>
              {`
my_tuple = (10, 20, 30, 40)

# Looping through the tuple using a for loop
for item in my_tuple:
    print(item)
              `}
            </code>
          </pre>
          <p><strong>Output:</strong></p>
          <pre>
            <code>
{`
10
20
30
40
            `}
            </code>
          </pre>

          <p>
            In this example:
            <ul>
              <li>The <code>for</code> loop iterates over each element of <code>my_tuple</code>.</li><br/>
              <li>Each element is assigned to the variable <code>item</code> during each iteration.</li><br/>
              <li>The <code>print(item)</code> statement prints each element of the tuple.</li>
            </ul>
          </p>
          <br/>
          <h2>Looping Through Tuple with Indexes</h2>
          <p>
            If you need both the index and the value of each element, you can use the <code>enumerate()</code> function, which provides both the index and the value of each element in the tuple.
          </p>

          <h3>Example 2: Looping with Indexes Using <code>enumerate()</code></h3>
          <pre>
            <code>
              {`
my_tuple = (10, 20, 30, 40)

# Looping through the tuple with index and value using enumerate
for index, value in enumerate(my_tuple):
    print(f"Index {index}: Value {value}")
              `}
            </code>
          </pre>
          <p><strong>Output:</strong></p>
          <pre>
            <code>
{`
Index 0: Value 10
Index 1: Value 20
Index 2: Value 30
Index 3: Value 40
            `}
            </code>
          </pre>

          <p>
            In this example:
            <ul>
              <li><code>enumerate(my_tuple)</code> returns each element along with its index.</li><br/>
              <li><code>index</code> gets the index of the element, and <code>value</code> gets the element itself.</li><br/>
              <li>The <code>{`print(f"Index {index}: Value {value}")`}</code> prints both the index and the value.</li>
            </ul>
          </p>
          <br/>
          <h2>Looping Through a Tuple with a <code>while</code> Loop</h2>
          <p>
            You can also use a <code>while</code> loop to iterate over a tuple, though it's less common than the <code>for</code> loop. This method requires manually handling the index.
          </p>

          <h3>Example 3: Looping with a <code>while</code> Loop</h3>
          <pre>
            <code>
              {`
my_tuple = (10, 20, 30, 40)
index = 0

# Looping through the tuple using a while loop
while index < len(my_tuple):
    print(my_tuple[index])
    index += 1
              `}
            </code>
          </pre>
          <p><strong>Output:</strong></p>
          <pre>
            <code>
{`
10
20
30
40
            `}
            </code>
          </pre>

          <p>
            In this example:
            <ul>
              <li>A <code>while</code> loop is used to loop over the tuple.</li><br/>
              <li>The <code>index</code> is incremented manually during each iteration to access the next element.</li>
            </ul>
          </p>
          <br/>
          <h2>Key Points:</h2>
          <ul>
            <li><strong><code>for</code> Loop</strong>: The most common way to loop through a tuple. It iterates through each element without needing an index.</li><br/>
            <li><strong><code>enumerate()</code></strong>: Use this to get both the index and the value of each element during the loop.</li><br/>
            <li><strong><code>while</code> Loop</strong>: Allows manual control over the loop but is less common than the <code>for</code> loop for simple tuple iteration.</li>
          </ul>
          <br/>
          <p>
            Looping through tuples is useful when you need to perform operations on each element of the tuple or when you want to access them in a specific order.
          </p>
        </div>
      )}
    
  


    {selectedChapter === 'chapter30' && (
  <div className={style.chaptercontent}>
    <h1 className={style.heading}>Join Tuples</h1>

    <p>In Python, you can <strong>join tuples</strong> by concatenating them. Tuples are immutable, so you can't modify them directly, but you can combine multiple tuples into one new tuple by using the <code>+</code> operator. This process of joining tuples is similar to adding elements to a list, but in the case of tuples, a new tuple is created rather than modifying an existing one.</p>
    <br/>
    <h3>Joining Tuples in Python</h3>

    <h4>Syntax:</h4>
    <p>To join two or more tuples, simply use the <code>+</code> operator:</p>
    <pre>
      <code>
        {`tuple1 + tuple2`}
      </code>
    </pre>
    <p>This will concatenate <code>tuple1</code> and <code>tuple2</code> into a new tuple.</p>

    <h4>Example of Joining Tuples:</h4>
    <pre>
      <code>
        {`tuple1 = (1, 2, 3)\ntuple2 = (4, 5, 6)\n\n# Joining two tuples\njoined_tuple = tuple1 + tuple2\n\nprint(joined_tuple)`}
      </code>
    </pre>
    <p><strong>Output:</strong></p>
    <pre>
      <code>
        (1, 2, 3, 4, 5, 6)
      </code>
    </pre>

    <p>In this example:</p>
    <ul>
      <li><code>tuple1</code> contains <code>(1, 2, 3)</code></li><br/>
      <li><code>tuple2</code> contains <code>(4, 5, 6)</code></li><br/>
      <li>By using the <code>+</code> operator, both tuples are joined into a new tuple: <code>(1, 2, 3, 4, 5, 6)</code>.</li>
    </ul>
    <br/>
    <h4>Joining Multiple Tuples:</h4>
    <pre>
      <code>
        {`tuple1 = (1, 2)\ntuple2 = (3, 4)\ntuple3 = (5, 6)\n\n# Joining three tuples\njoined_tuple = tuple1 + tuple2 + tuple3\n\nprint(joined_tuple)`}
      </code>
    </pre>
    <p><strong>Output:</strong></p>
    <pre>
      <code>
        (1, 2, 3, 4, 5, 6)
      </code>
    </pre>

    <h4>Key Points:</h4>
    <ul>
      <li><strong>Immutability:</strong> Tuples cannot be modified after creation, so the <code>+</code> operator creates a new tuple.</li><br/>
      <li><strong>Concatenation:</strong> You can concatenate any number of tuples by chaining the <code>+</code> operator.</li><br/>
      <li><strong>Efficiency:</strong> Joining tuples is simple and effective, but keep in mind that a new tuple is created, which could be less memory-efficient if you're joining very large tuples repeatedly in a loop.</li>
    </ul>
    <br/>
    <h4>Alternative: Using <code>*</code> Operator for Unpacking (Python 3.5+)</h4>
    <p>In Python 3.5 and later, you can use the <code>*</code> operator to unpack and join multiple tuples in a more concise way:</p>
    <pre>
      <code>
        {`tuple1 = (1, 2)\ntuple2 = (3, 4)\ntuple3 = (5, 6)\n\n# Using * to unpack and join tuples\njoined_tuple = (*tuple1, *tuple2, *tuple3)\n\nprint(joined_tuple)`}
      </code>
    </pre>
    <p><strong>Output:</strong></p>
    <pre>
      <code>
        (1, 2, 3, 4, 5, 6)
      </code>
    </pre>
    <p>This approach is especially useful when you need to join many tuples in one line, and it maintains code readability.</p>
  </div>
)}





        {selectedChapter === 'chapter31' && (
        <div className={style.chaptercontent}>
        <h1 className={style.heading}>Tuple Methods </h1>

    <p>
      In Python, tuples are immutable, meaning you can't modify their elements directly after creation. However, there are several built-in methods that allow you to work with tuples, such as counting occurrences or finding the index of an element. Here’s an overview of the common tuple methods:
    </p>
    <br/>
    <h2>1. count()</h2>
    <p>
      This method returns the number of occurrences of a specified element in the tuple.
    </p>
    <pre><code>{`tuple.count(element)`}</code></pre>

    <h3>Example:</h3>
    <pre><code>{`my_tuple = (10, 20, 30, 20, 40, 20)\nprint(my_tuple.count(20))  # Output: 3`}</code></pre>
    <p>
      In this example, the element <code>20</code> appears 3 times in the tuple.
    </p>
    <br/>
    <h2>2. index()</h2>
    <p>
      This method returns the index of the first occurrence of a specified element in the tuple. If the element is not found, it raises a <code>ValueError</code>.
    </p>
    <pre><code>{`tuple.index(element)`}</code></pre>

    <h3>Example:</h3>
    <pre><code>{`my_tuple = (10, 20, 30, 40, 20)\nprint(my_tuple.index(20))  # Output: 1`}</code></pre>
    <p>
      In this example, the first occurrence of <code>20</code> is at index <code>1</code>.
    </p>
    <br/>
    <h2>Important Notes:</h2>
    <ul>
      <li>Since tuples are immutable, methods like <code>append()</code>, <code>remove()</code>, or <code>pop()</code> which modify the tuple are not available.</li><br/>
      <li>You can, however, perform operations like concatenation, slicing, and joining to create new tuples.</li>
    </ul>
    <br/>
    <h2>Key Points:</h2>
    <ul>
      <li><strong>count()</strong>: Counts how many times an element appears in the tuple.</li><br/>
      <li><strong>index()</strong>: Returns the index of the first occurrence of an element in the tuple.</li>
    </ul>
    <br/>
    <p>
      These methods are useful for extracting information from a tuple without modifying its structure.
    </p>
  </div>
)}



        {selectedChapter === 'chapter32' && (
        <div className={style.chaptercontent}>
        <h1 className={style.heading}>Sets in Python</h1>

    <p>
      In Python, a <strong>set</strong> is an unordered collection of unique elements. Sets are similar to lists or tuples, but they have a few key differences:
    </p>
    <br/>
    <h3 style={{paddingBottom:"6px"}}>Key Characteristics of Sets:</h3>
    <ul>
      <li><strong>Unordered:</strong> The elements in a set do not have a specific order, meaning the order of elements is not maintained.</li><br/>
      <li><strong>Unique:</strong> A set only allows unique elements. If you try to add a duplicate element, it will not be added to the set.</li><br/>
      <li><strong>Mutable:</strong> You can add or remove elements from a set, but the set itself is unordered, and it does not support indexing, slicing, or other sequence-like behavior.</li><br/>
      <li><strong>No Duplicate Elements:</strong> Sets automatically eliminate duplicate values when elements are added.</li>
    </ul>
    <br/>
    <h3>Creating a Set:</h3>
    <p>You can create a set by placing elements inside curly braces <code>{`{}`}</code> or by using the <code>set()</code> function.</p>

    <pre>
      <code>
        {`
# Creating a set using curly braces
my_set = {1, 2, 3, 4, 5}

# Creating a set using the set() function
my_set = set([1, 2, 3, 4, 5])
        `}
      </code>
    </pre>

    <h3>Example of Set:</h3>
    <pre>
      <code>
        {`
my_set = {1, 2, 3, 4, 5}
print(my_set)
        `}
      </code>
    </pre>

    <p><strong>Output:</strong></p>
    <pre>{`{1, 2, 3, 4, 5}`}</pre>
    <br/>
    <p>Even if you add duplicate elements, only the unique ones will remain:</p>

    <pre>
      <code>
        {`
my_set = {1, 2, 3, 3, 4}
print(my_set)
        `}
      </code>
    </pre>

    <p><strong>Output:</strong></p>
    <pre>{`{1, 2, 3, 4}`}</pre>
    <br/>
    <h3>Common Operations with Sets:</h3>
    <h4>1. Adding Elements:</h4>
    <pre>
      <code>
        {`
my_set.add(6)
print(my_set)  # Output: {1, 2, 3, 4, 6}
        `}
      </code>
    </pre>
    <br/>
    <h4>2. Removing Elements:</h4>
    <p>You can remove elements using <code>remove()</code> or <code>discard()</code>.</p>
    <ul>
      <li><code>remove()</code> will raise an error if the element is not present.</li>
      <li><code>discard()</code> will not raise an error if the element is not present.</li>
    </ul>

    <pre>
      <code>
        {`
my_set.remove(3)  # Removes 3 from the set
my_set.discard(7)  # Does nothing because 7 is not in the set
        `}
      </code>
    </pre>
    <br/>
    <h4>3. Set Operations:</h4>
    <p>Sets support various mathematical set operations like union, intersection, and difference.</p>
    <ul>
      <li><strong>Union</strong> (<code>|</code> or <code>union()</code>): Combines two sets.</li><br/>
      <li><strong>Intersection</strong> (<code>&</code> or <code>intersection()</code>): Returns common elements between two sets.</li><br/>
      <li><strong>Difference</strong> (<code>-</code> or <code>difference()</code>): Returns elements that are in one set but not the other.</li>
    </ul>

    <pre>
      <code>
        {`
set1 = {1, 2, 3}
set2 = {3, 4, 5}

# Union
print(set1 | set2)  # Output: {1, 2, 3, 4, 5}

# Intersection
print(set1 & set2)  # Output: {3}

# Difference
print(set1 - set2)  # Output: {1, 2}
        `}
      </code>
    </pre>
    <br/>
    <h3 style={{paddingBottom:"6px"}}>Important Points:</h3>
    <ul>
      <li><strong>Unordered:</strong> Sets do not maintain any order, so when you iterate through a set, the order may not be the same as how it was added.</li><br/>
      <li><strong>No Indexing:</strong> Unlike lists, you cannot access individual elements of a set by index. However, you can iterate over the set or convert it to a list if you need to access elements by index.</li><br/>
      <li><strong>Supports Mathematical Operations:</strong> Sets allow operations like union, intersection, and difference, making them useful for problems related to collections of unique items.</li>
    </ul>
    <br/>
    <h3>Example of Set Use Case:</h3>
    <p>You might use sets when you need to eliminate duplicate items from a collection or when you're working with set theory operations like finding common elements between two lists.</p>

    <pre>
      <code>
        {`
list1 = [1, 2, 2, 3, 4]
list2 = [3, 4, 4, 5, 6]

# Convert lists to sets and find common elements
set1 = set(list1)
set2 = set(list2)

# Intersection (common elements)
common_elements = set1 & set2
print(common_elements)  # Output: {3, 4}
        `}
      </code>
    </pre>

    <p>Sets are great when you need to work with collections of unique items and when order does not matter.</p>
  </div>
)}




        {selectedChapter === 'chapter33' && (
        <div className={style.chaptercontent}>
        <h1 className={style.heading}>Access Sets Items</h1>

    <p>
      In Python, sets are unordered collections of unique elements. Unlike lists or tuples, sets do not support indexing, slicing, or accessing individual elements by position. However, there are ways to access and work with items in a set.
    </p>
    <br/>
    <h3 style={{paddingBottom:"6px"}}>Ways to Access Set Items:</h3>

    <h4>1. Iterating Through a Set:</h4>
    <p>
      Since you can't directly access items by index, the most common way to work with elements in a set is by iterating through it using a <code>for</code> loop.
    </p>
    <pre>
      <code>
        {`my_set = {1, 2, 3, 4, 5}\n\n# Iterating through the set\nfor item in my_set:\n    print(item)`}
      </code>
    </pre>
    <p><strong>Output:</strong></p>
    <pre>
      <code>
        {`1\n2\n3\n4\n5`}
      </code>
    </pre>
    <p>
      (The order may vary since sets are unordered.)
    </p>
    <br/>
    <h4>2. Using <code>in</code> to Check Membership:</h4>
    <p>
      You can check if an element exists in a set using the <code>in</code> keyword.
    </p>
    <pre>
      <code>
        {`my_set = {1, 2, 3, 4, 5}\n\n# Check if an element is in the set\nprint(3 in my_set)  # Output: True\nprint(6 in my_set)  # Output: False`}
      </code>
    </pre>
    <br/>
    <h4>3. Converting a Set to a List (if Indexing is Needed):</h4>
    <p>
      If you need to access elements by index (for example, to get the first element), you can convert the set to a list. However, keep in mind that sets do not maintain the order of elements.
    </p>
    <pre>
      <code>
        {`my_set = {1, 2, 3, 4, 5}\n\n# Convert the set to a list\nmy_list = list(my_set)\n\n# Access by index\nprint(my_list[0])  # Output: This could be any element from the set`}
      </code>
    </pre>
    <p>
      <strong>Note:</strong> The order is not guaranteed in a set, so accessing the list after conversion may not return the same results each time.
    </p>
    <br/>
    <h4>4. Using <code>pop()</code>:</h4>
    <p>
      The <code>pop()</code> method removes and returns an arbitrary element from the set. Since sets are unordered, you can’t predict which element will be removed.
    </p>
    <pre>
      <code>
        {`my_set = {1, 2, 3, 4, 5}\n\n# Pop an element from the set\npopped_item = my_set.pop()\nprint(f"Popped item: {popped_item}")\nprint(f"Remaining set: {my_set}")`}
      </code>
    </pre>
    <p><strong>Output (example):</strong></p>
    <pre>
      <code>
        {`Popped item: 1\nRemaining set: {2, 3, 4, 5}`}
      </code>
    </pre>
    <br/>
    <h3>Summary of Accessing Set Items:</h3>
    <ul>
      <li><strong>Iteration</strong>: The most common way to work with set items.</li><br/>
      <li><strong>Membership Check</strong>: Use <code>in</code> to check if an element exists.</li><br/>
      <li><strong>Convert to List</strong>: If you need indexing, convert the set to a list.</li><br/>
      <li><strong>Pop</strong>: Removes and returns an arbitrary element.</li>
    </ul><br/>
    <p>
      Since sets are unordered, the key point is that you cannot directly access items by position like you can in a list or tuple. You can only check membership or iterate through the elements.
    </p>
  </div>
)}




        {selectedChapter === 'chapter34' && (
        <div className={style.chaptercontent}>
        <h1 className={style.heading}>Add Set Items </h1>

    <p>
      In Python, you can add items to a set using the <code>add()</code> method, which allows you to insert a single element, or the <code>update()</code> method, which allows you to add multiple elements at once. Here’s an explanation of both methods:
    </p><br/>

    <h3>1. Using <code>add()</code> Method</h3>
    <p>
      The <code>add()</code> method adds a single element to a set. If the element already exists in the set, it will not be added again since sets do not allow duplicate elements.
    </p>
    <h4>Syntax:</h4>
    <pre><code>set.add(element)</code></pre>

    <h4>Example:</h4>
    <pre><code>
{`my_set = {1, 2, 3}
my_set.add(4)

print(my_set)  # Output: {1, 2, 3, 4}`}
    </code></pre>
    <p>
      In this example, the element <code>4</code> is added to the set.
    </p>
    <p>
      If you try to add an existing element, the set will remain unchanged:
    </p>
    <pre><code>
{`my_set.add(2)
print(my_set)  # Output: {1, 2, 3, 4} (No duplicate element added)`}
    </code></pre>
    <br/>
    <h3>2. Using <code>update()</code> Method</h3>
    <p>
      The <code>update()</code> method is used to add multiple elements (from another set, list, tuple, or any iterable) to the set. If the elements already exist in the set, they will be ignored.
    </p>
    <h4>Syntax:</h4>
    <pre><code>set.update(iterable)</code></pre>

    <h4>Example:</h4>
    <pre><code>
{`my_set = {1, 2, 3}
my_set.update([4, 5, 6])

print(my_set)  # Output: {1, 2, 3, 4, 5, 6}`}
    </code></pre>
    <p>
      You can also add elements from another set:
    </p>
    <pre><code>
{`another_set = {7, 8}
my_set.update(another_set)

print(my_set)  # Output: {1, 2, 3, 4, 5, 6, 7, 8}`}
    </code></pre>
    <br/>
    <h3>3. Adding Elements from Different Iterables</h3>
    <p>
      You can add items from different types of iterables, such as lists or tuples:
    </p>
    <pre><code>
{`my_set = {1, 2, 3}
my_set.update([4, 5], (6, 7))

print(my_set)  # Output: {1, 2, 3, 4, 5, 6, 7}`}
    </code></pre>
    <br/>
    <h3>Summary:</h3>
    <ul>
      <li><strong><code>add()</code></strong>: Adds a single element to the set.</li><br/>
      <li><strong><code>update()</code></strong>: Adds multiple elements from an iterable (list, set, tuple, etc.).</li>
    </ul><br/>
    <p>
      Sets automatically remove duplicates, so if you try to add an item that already exists, it won’t be added again.
    </p>
  </div>
)}



        {selectedChapter === 'chapter35' && (
        <div className={style.chaptercontent}>
        <h1 className={style.heading}>Remove Set Items </h1>

    <p>In Python, you can remove items from a set using several methods. Below are the most common ways to remove elements from a set:</p>
    <br/>
    <h3>1. Using <code>remove()</code> Method</h3>
    <p>
      The <code>remove()</code> method removes a specific element from a set. If the element is not found, it raises a <code>KeyError</code>.
    </p>
    <pre><code>
      set.remove(element)
    </code></pre>
    <p>Example:</p>
    <pre><code>{`
      my_set = {1, 2, 3, 4, 5}
      my_set.remove(3)

      print(my_set)  # Output: {1, 2, 4, 5}
    `}</code></pre>
    <p>If you try to remove an element that does not exist, Python will raise an error:</p>
    <pre><code>{`
      my_set.remove(10)  # KeyError: 10
    `}</code></pre>
    <br/>
    <h3>2. Using <code>discard()</code> Method</h3>
    <p>
      The <code>discard()</code> method also removes a specific element from a set, but if the element does not exist in the set, it does <strong>not</strong> raise an error. It simply does nothing.
    </p>
    <pre><code>
      set.discard(element)
    </code></pre>
    <p>Example:</p>
    <pre><code>{`
      my_set = {1, 2, 3, 4, 5}
      my_set.discard(4)

      print(my_set)  # Output: {1, 2, 3, 5}
     `} </code></pre>
    <p>If the element does not exist, the set remains unchanged without raising an error:</p>
    <pre><code>{`
      my_set.discard(10)  # Does nothing
      print(my_set)  # Output: {1, 2, 3, 5}
    `}</code></pre>
    <br/>
    <h3>3. Using <code>pop()</code> Method</h3>
    <p>
      The <code>pop()</code> method removes and returns an arbitrary element from the set. Since sets are unordered, you cannot predict which element will be removed.
    </p>
    <pre><code>
      set.pop()
    </code></pre>
    <p>Example:</p>
    <pre><code>{`
      my_set = {1, 2, 3, 4, 5}
      popped_item = my_set.pop()

      print(f"Popped item: {popped_item}")
      print(f"Remaining set: {my_set} ")
    </code></pre>
    <p>Example Output (may vary):</p>
    <pre><code>
      Popped item: 1
      Remaining set: {2, 3, 4, 5}
    `}</code></pre>
    <br/>
    <h3>4. Using <code>clear()</code> Method</h3>
    <p>
      The <code>clear()</code> method removes all items from a set, leaving it empty.
    </p>
    <pre><code>
      set.clear()
    </code></pre>
    <p>Example:</p>
    <pre><code>{`
      my_set = {1, 2, 3, 4, 5}
      my_set.clear()

      print(my_set)  # Output: set()
    `}</code></pre>
    <br/>
    <h3>Summary:</h3>
    <ul>
      <li><code>remove()</code>: Removes an element from the set. Raises <code>KeyError</code> if the element is not found.</li><br/>
      <li><code>discard()</code>: Removes an element from the set. Does not raise an error if the element is not found.</li><br/>
      <li><code>pop()</code>: Removes and returns an arbitrary element from the set (set is unordered).</li><br/>
      <li><code>clear()</code>: Removes all elements from the set, leaving it empty.</li>
    </ul><br/>

    <p>These methods are useful for removing elements from sets depending on the specific needs of your program.</p>
  </div>
)}



          {selectedChapter === 'chapter36' && (
          <div className={style.chaptercontent}>
          <h1 className={style.heading}>Loops  Sets </h1>

    <p>
      In Python, <strong>loops</strong> are commonly used to iterate over a collection of items. Since a set is an unordered collection of unique elements, you can use loops to iterate through its elements. The most common type of loop used with sets is the <code>for</code> loop. Here’s an explanation of how to use loops with sets:
    </p><br/>

    <h3>Iterating Over a Set with a <code>for</code> Loop:</h3>
    <p>
      A <code>for</code> loop allows you to iterate over each element of a set one by one. Since sets are unordered, the order in which elements are iterated over is not guaranteed to be the same each time.
    </p>
    
    <h4>Syntax:</h4>
    <pre>
      <code>
        for item in my_set:
          {'// Perform some action with the item'}
      </code>
    </pre>

    <h4>Example:</h4>
    <pre>
      <code>
          {`my_set = {1, 2, 3, 4, 5}
for item in my_set:
          print(item)  `}
      </code>
    </pre>
    <p><strong>Output:</strong></p>
    <pre>
      <code>
        1
        2
        3
        4
        5
      </code>
    </pre>

    <p><strong>Note:</strong> The output order may vary each time you run the program because sets do not maintain a specific order.</p>
    <br/>

    <h3>Looping with <code>for</code> and Conditions:</h3>
    <p>
      You can use conditions inside the loop to perform specific actions depending on the value of the element being iterated over.
    </p>
    
    <h4>Example:</h4>
    <pre>
      <code>
        {`my_set = {1, 2, 3, 4, 5}
for item in my_set:
  if item % 2 == 0:
     print(f"{item} is even")
  else:
     print(f"{item} is odd")  `}
      </code>
    </pre>
    <p><strong>Output:</strong></p>
    <pre>
      <code>
        1 is odd
        2 is even
        3 is odd
        4 is even
        5 is odd
      </code>
    </pre>

    <br/>
    <h3 style={{paddingBottom:"6px"}}>Looping with <code>while</code> Loop:</h3>
    <p>
      Although <code>while</code> loops are less common with sets (since <code>for</code> loops are simpler for this purpose), you can still use a <code>while</code> loop by converting the set to a list, or by using an iterator.
    </p>

    <h4>Example using an iterator:</h4>
    <pre>
      <code>
        {`my_set = {1, 2, 3, 4, 5}
iterator = iter(my_set)
while True:
    try:
      item = next(iterator)
      print(item)
    except StopIteration:
      break  `}
      </code>
    </pre>
    <p><strong>Output:</strong></p>
    <pre>
      <code>
        1
        2
        3
        4
        5
      </code>
    </pre>

    <br/>
    <h3 style={{paddingBottom:"6px"}}>Breaking and Continuing in Loops:</h3>
    <p>
      You can also use <code>break</code> and <code>continue</code> statements within the loop to control its flow.
    </p>
    <ul>
      <li><strong><code>break</code></strong>: Stops the loop completely.</li>
      <li><strong><code>continue</code></strong>: Skips the current iteration and moves to the next one.</li>
    </ul>

    <h4>Example with <code>break</code>:</h4>
    <pre>
      <code>
      {`my_set = {1, 2, 3, 4, 5}
for item in my_set:
    if item == 3:
      break  # Stop the loop when we reach the element 3
    print(item) `}
      </code>
    </pre>
    <p><strong>Output:</strong></p>
    <pre>
      <code>
        1
        2
      </code>
    </pre>

    <br/>
    <h4>Example with <code>continue</code>:</h4>
    <pre>
      <code>
       {`my_set = {1, 2, 3, 4, 5}
for item in my_set:
    if item == 3:
      continue  # Skip the iteration when the element is 3
    print(item)  `}
      </code>
    </pre>
    <p><strong>Output:</strong></p>
    <pre>
      <code>
        1
        2
        4
        5
      </code>
    </pre>

    <br/>
    <h3>Summary:</h3>
    <ul>
      <li><strong><code>for</code> loop</strong>: The most common way to iterate over sets.</li><br/>
      <li><strong><code>while</code> loop</strong>: Can be used, but typically requires an iterator or conversion to a list.</li><br/>
      <li><strong>Conditions</strong>: You can add conditional statements within the loop to filter or modify behavior based on the set elements.</li><br/>
      <li><strong><code>break</code> and <code>continue</code></strong>: Control the flow of the loop to stop or skip iterations.</li>
    </ul><br/>

    <h3>Example Use Case for Sets with Loops:</h3>
    <p>
      Imagine you have a set of unique student IDs and you want to check if a student has completed their assignments. You could iterate over the set of IDs and apply some logic for each one.
    </p>

    <pre>
      <code>
       {`completed_assignments = {101, 102, 103, 105}

# Checking which students have completed their assignments
students = {101, 102, 103, 104, 105, 106}

for student in students:
    if student in completed_assignments:
      print(f"Student {student} has completed their assignment.")
    else:
      print(f"Student {student} has not completed their assignment.")   `}
      </code>
    </pre>
    <p>
      This will iterate over all students and check if their ID is in the set of completed assignments.
    </p>

  </div>
)}


        {selectedChapter === 'chapter113' && (
        <div className={style.chaptercontent}>
        <h1 className={style.heading}>Join Sets</h1>

    <p>
      In Python, you can <strong>join sets</strong> using several methods, with the most common being the <code>union()</code> method or the <code>|</code> (pipe) operator. These methods combine two or more sets into one, and they automatically handle duplicates (sets only contain unique elements).
    </p>
    <br/>
    <h2>1.Using <code>union()</code> Method</h2>
    <p>
      The <code>union()</code> method returns a new set that contains all elements from the original set and the other sets being combined. Duplicate elements are removed automatically.
    </p>
    <pre>
      <code>{`set1.union(set2, set3, ...)`}</code>
    </pre>
    <h3>Example:</h3>
    <pre>
      <code>{`set1 = {1, 2, 3}
set2 = {3, 4, 5}
set3 = {5, 6, 7}

result_set = set1.union(set2, set3)

print(result_set)  # Output: {1, 2, 3, 4, 5, 6, 7}`}</code>
    </pre>
    <p>
      In this example, the union of <code>set1</code>, <code>set2</code>, and <code>set3</code> is computed, and the result is a set with all unique elements from the three sets.
    </p><br/>

    <h2>2. Using <code>|</code> (Pipe) Operator</h2>
    <p>
      The <code>|</code> operator is a shorthand for <code>union()</code>. It combines the sets similarly, resulting in a set with unique elements.
    </p>
    <pre>
      <code>{`set1 | set2 | set3`}</code>
    </pre>
    <h3>Example:</h3>
    <pre>
      <code>{`set1 = {1, 2, 3}
set2 = {3, 4, 5}
set3 = {5, 6, 7}

result_set = set1 | set2 | set3

print(result_set)  # Output: {1, 2, 3, 4, 5, 6, 7}`}</code>
    </pre><br/>

    <h2>3. Using <code>update()</code> Method</h2>
    <p>
      The <code>update()</code> method can be used to add elements from another set (or any iterable) to the existing set. This modifies the original set in place (it does not create a new set).
    </p>
    <pre>
      <code>{`set1.update(set2, set3, ...)`}</code>
    </pre>
    <h3>Example:</h3>
    <pre>
      <code>{`set1 = {1, 2, 3}
set2 = {3, 4, 5}
set3 = {5, 6, 7}

set1.update(set2, set3)

print(set1)  # Output: {1, 2, 3, 4, 5, 6, 7}`}</code>
    </pre>
    <p>
      In this example, <code>set1</code> is updated to include the elements from <code>set2</code> and <code>set3</code>. The result is stored in <code>set1</code>, and the original set is modified.
    </p>
    <br/>
    <h2>Summary:</h2>
    <ul>
      <li><strong><code>union()</code></strong>: Returns a new set with elements from multiple sets, handling duplicates.</li><br/>
      <li><strong><code>|</code> (pipe operator)</strong>: Shorthand for <code>union()</code>, combining sets and removing duplicates.</li><br/>
      <li><strong><code>update()</code></strong>: Modifies the original set by adding elements from other sets.</li>
    </ul><br/>

    <p>
      Note: These methods help you easily combine sets and manage unique elements. Let me know if you'd like to see more examples or details!
    </p>
  </div>
)}


        {selectedChapter === 'chapter37' && (
        <div className={style.chaptercontent}>
        <h1 className={style.heading}>   Set Methods    </h1>

      <p>
        In Python, <strong>sets</strong> are unordered collections of unique elements. Python provides various methods to manipulate sets, allowing you to add, remove, and combine elements. Here is a detailed explanation of the commonly used set methods in Python:
      </p><br/>

      <h2>1. <code>add()</code> Method</h2>
      <p>
        <strong>Purpose</strong>: Adds a single element to the set. If the element already exists in the set, it will not be added again.
      </p>
      <p><strong>Syntax</strong>: <code>set.add(element)</code></p>
      <pre><code>
        {`my_set = {1, 2, 3}
my_set.add(4)
print(my_set)  # Output: {1, 2, 3, 4}`}
      </code></pre><br/>

      <h2>2. <code>update()</code> Method</h2>
      <p>
        <strong>Purpose</strong>: Adds multiple elements from an iterable (like a list, tuple, or another set) to the set. This method modifies the original set.
      </p>
      <p><strong>Syntax</strong>: <code>set.update(iterable)</code></p>
      <pre><code>
        {`my_set = {1, 2, 3}
my_set.update([4, 5], (6, 7))
print(my_set)  # Output: {1, 2, 3, 4, 5, 6, 7}`}
      </code></pre><br/>

      <h2>3. <code>remove()</code> Method</h2>
      <p>
        <strong>Purpose</strong>: Removes a specific element from the set. If the element is not found, it raises a <code>KeyError</code>.
      </p>
      <p><strong>Syntax</strong>: <code>set.remove(element)</code></p>
      <pre><code>
        {`my_set = {1, 2, 3, 4}
my_set.remove(3)
print(my_set)  # Output: {1, 2, 4}`}
      </code></pre><br/>

      <h2>4. <code>discard()</code> Method</h2>
      <p>
        <strong>Purpose</strong>: Removes an element from the set. Unlike <code>remove()</code>, it does not raise an error if the element is not found.
      </p>
      <p><strong>Syntax</strong>: <code>set.discard(element)</code></p>
      <pre><code>
        {`my_set = {1, 2, 3, 4}
my_set.discard(3)
print(my_set)  # Output: {1, 2, 4}
        
# Does nothing if element is not in the set
my_set.discard(5)
print(my_set)  # Output: {1, 2, 4}`}
      </code></pre><br/>

      <h2>5. <code>pop()</code> Method</h2>
      <p>
        <strong>Purpose</strong>: Removes and returns an arbitrary element from the set. Since sets are unordered, you cannot predict which element will be popped.
      </p>
      <p><strong>Syntax</strong>: <code>element = set.pop()</code></p>
      <pre><code>
        {`my_set = {1, 2, 3}
popped_item = my_set.pop()
print(popped_item)  # Output: 1 (could be any element)
print(my_set)       # Output: {2, 3}`}
      </code></pre><br/>

      <h2>6. <code>clear()</code> Method</h2>
      <p>
        <strong>Purpose</strong>: Removes all elements from the set, making it empty.
      </p>
      <p><strong>Syntax</strong>: <code>set.clear()</code></p>
      <pre><code>
        {`my_set = {1, 2, 3}
my_set.clear()
print(my_set)  # Output: set()`}
      </code></pre><br/>

      <h2>7. <code>copy()</code> Method</h2>
      <p>
        <strong>Purpose</strong>: Returns a shallow copy of the set. Changes made to the copied set will not affect the original set.
      </p>
      <p><strong>Syntax</strong>: <code>new_set = set.copy()</code></p>
      <pre><code>
        {`my_set = {1, 2, 3}
new_set = my_set.copy()
new_set.add(4)
print(my_set)   # Output: {1, 2, 3}
print(new_set)  # Output: {1, 2, 3, 4}`}
      </code></pre><br/>

      <h2>8. <code>union()</code> Method</h2>
      <p>
        <strong>Purpose</strong>: Returns a new set that is the union of two or more sets. It combines all unique elements from the sets.
      </p>
      <p><strong>Syntax</strong>: <code>new_set = set.union(set2, set3, ...)</code></p>
      <pre><code>
        {`set1 = {1, 2, 3}
set2 = {3, 4, 5}
result = set1.union(set2)
print(result)  # Output: {1, 2, 3, 4, 5}`}
      </code></pre><br/>

      <h2>9. <code>intersection()</code> Method</h2>
      <p>
        <strong>Purpose</strong>: Returns a new set containing only the elements common to all sets.
      </p>
      <p><strong>Syntax</strong>: <code>new_set = set.intersection(set2, set3, ...)</code></p>
      <pre><code>
        {`set1 = {1, 2, 3, 4}
set2 = {3, 4, 5, 6}
result = set1.intersection(set2)
print(result)  # Output: {3, 4}`}
      </code></pre><br/>

      <h2>10. <code>difference()</code> Method</h2>
      <p>
        <strong>Purpose</strong>: Returns a new set containing the elements in the first set that are not present in the other sets.
      </p>
      <p><strong>Syntax</strong>: <code>new_set = set.difference(set2, set3, ...)</code></p>
      <pre><code>
        {`set1 = {1, 2, 3, 4}
set2 = {3, 4, 5, 6}
result = set1.difference(set2)
print(result)  # Output: {1, 2}`}
      </code></pre><br/>

      <h2>11. <code>symmetric_difference()</code> Method</h2>
      <p>
        <strong>Purpose</strong>: Returns a new set containing elements that are in either of the sets, but not in both.
      </p>
      <p><strong>Syntax</strong>: <code>new_set = set.symmetric_difference(set2)</code></p>
      <pre><code>
        {`set1 = {1, 2, 3, 4}
set2 = {3, 4, 5, 6}
result = set1.symmetric_difference(set2)
print(result)  # Output: {1, 2, 5, 6}`}
      </code></pre><br/>

      <h2>12. <code>issubset()</code> Method</h2>
      <p>
        <strong>Purpose</strong>: Checks if the set is a subset of another set, i.e., all elements of the set are contained in the other set.
      </p>
      <p><strong>Syntax</strong>: <code>set.issubset(other_set)</code></p>
      <pre><code>
        {`set1 = {1, 2, 3}
set2 = {1, 2, 3, 4, 5}
print(set1.issubset(set2))  # Output: True`}
      </code></pre><br/>

      <h2>13. <code>issuperset()</code> Method</h2>
      <p>
        <strong>Purpose</strong>: Checks if the set is a superset of another set, i.e., the set contains all elements of the other set.
      </p>
      <p><strong>Syntax</strong>: <code>set.issuperset(other_set)</code></p>
      <pre><code>
        {`set1 = {1, 2, 3, 4, 5}
set2 = {1, 2, 3}
print(set1.issuperset(set2))  # Output: True`}
      </code></pre><br/>

      <h2>14. <code>isdisjoint()</code> Method</h2>
      <p>
        <strong>Purpose</strong>: Checks if two sets have no elements in common.
      </p>
      <p><strong>Syntax</strong>: <code>set.isdisjoint(other_set)</code></p>
      <pre><code>
        {`set1 = {1, 2, 3}
set2 = {4, 5, 6}
print(set1.isdisjoint(set2))  # Output: True`}
      </code></pre><br/>

      <h2 style={{paddingBottom:"6px"}}>Summary of Common Set Methods:</h2>
      <ul>
        <li><code>add()</code>: Adds a single element to the set.</li><br/>
        <li><code>update()</code>: Adds multiple elements from an iterable to the set.</li><br/>
        <li><code>remove()</code>: Removes a specific element (raises <code>KeyError</code> if the element is not found).</li><br/>
        <li><code>discard()</code>: Removes an element (does nothing if the element is not found).</li><br/>
        <li><code>pop()</code>: Removes and returns an arbitrary element.</li><br/>
        <li><code>clear()</code>: Clears all elements from the set.</li><br/>
        <li><code>copy()</code>: Returns a shallow copy of the set.</li><br/>
        <li><code>union()</code>: Combines multiple sets into one, removing duplicates.</li><br/>
        <li><code>intersection()</code>: Returns the common elements from multiple sets.</li><br/>
        <li><code>difference()</code>: Returns elements in the first set but not in the other sets.</li><br/>
        <li><code>symmetric_difference()</code>: Returns elements that are in either set but not both.</li><br/>
        <li><code>issubset()</code>: Checks if the set is a subset of another set.</li><br/>
        <li><code>issuperset()</code>: Checks if the set is a superset of another set.</li><br/>
        <li><code>isdisjoint()</code>: Checks if two sets have no elements in common.</li>
      </ul>
      <br/>
      <p>
        These methods help efficiently manage and manipulate sets in Python, providing powerful tools for tasks involving uniqueness, comparisons, and set operations. 
      </p>
    </div>
  )}



        {selectedChapter === 'chapter38' && (
        <div className={style.chaptercontent}>
        <h1 className={style.heading}>  Python Dictionaries  </h1>
          <p>
            In Python, a <strong>dictionary</strong> is an unordered collection of items. Each item is stored as a key-value pair, where each key must be unique, and each key is associated with a value. Dictionaries are versatile and powerful data structures used for efficient lookups, organizing data, and implementing key-based indexing.
          </p>
          <br/>
          <h2>Key Characteristics of Dictionaries:</h2>
          <ol>
            <li><strong>Unordered</strong>: The elements in a dictionary are not stored in any specific order (although in Python 3.7 and later, dictionaries maintain the insertion order).</li><br/>
            <li><strong>Key-Value Pairs</strong>: A dictionary consists of key-value pairs, where:
              <ul>
                <li>The <strong>key</strong> is a unique identifier (can be a string, number, or tuple).</li><br/>
                <li>The <strong>value</strong> can be any data type (strings, lists, other dictionaries, etc.).</li>
              </ul>
            </li><br/>
            <li><strong>Mutable</strong>: Dictionaries are mutable, meaning you can modify them after creation (add, remove, or change elements).</li><br/>
            <li><strong>No Duplicate Keys</strong>: A dictionary cannot have duplicate keys. If you try to insert a key that already exists, the old value will be overwritten.</li>
          </ol><br/>

          <h3>Dictionary Syntax:</h3>
          <pre>
            <code>
{`# Example of a dictionary
my_dict = {
  "name": "Alice",
  "age": 25,
  "city": "New York"
}`}
            </code>
          </pre><br/>

          <h3>Common Dictionary Operations:</h3>

          <h4>1. Accessing Values:</h4>
          <pre>
            <code>
{`# Access values by key
print(my_dict["name"])  # Output: Alice
print(my_dict["age"])   # Output: 25`}
            </code>
          </pre><br/>

          <h4>2. Adding or Updating Items:</h4>
          <pre>
            <code>
{`# Add or update key-value pairs
my_dict["email"] = "alice@example.com"  # Adding a new key-value pair
my_dict["age"] = 26  # Updating the value of the existing key "age"
print(my_dict)`}
            </code>
          </pre><br/>

          <h4>3. Removing Items:</h4>
          <pre>
            <code>
{`# Use del or pop to remove items
del my_dict["city"]  # Removes the key "city"
print(my_dict)

# Using pop() to remove a specific key-value pair and return the value
age = my_dict.pop("age")
print(age)  # Output: 26
print(my_dict)`}
            </code>
          </pre><br/>

          <h4>4. Checking if a Key Exists:</h4>
          <pre>
            <code>
{`if "name" in my_dict:
    print("Name exists")`}
            </code>
          </pre><br/>

          <h4>5. Getting All Keys or Values:</h4>
          <pre>
            <code>
{`print(my_dict.keys())   # Output: dict_keys(['name', 'email'])
print(my_dict.values()) # Output: dict_values(['Alice', 'alice@example.com'])`}
            </code>
          </pre><br/>

          <h4>6. Iterating Through a Dictionary:</h4>
          <pre>
            <code>
{`for key, value in my_dict.items():
    print(key, ":", value)`}
            </code>
          </pre><br/>

          <h4>7. Copying a Dictionary:</h4>
          <pre>
            <code>
{`new_dict = my_dict.copy()`}
            </code>
          </pre><br/>

          <h4>8. Clearing a Dictionary:</h4>
          <pre>
            <code>
{`my_dict.clear()  # Removes all items
print(my_dict)  # Output: {}`}
            </code>
          </pre><br/>

          <h3>Example:</h3>
          <pre>
            <code>
{`# Creating a dictionary
student = {
  "name": "John",
  "age": 20,
  "subjects": ["Math", "Science"],
  "grades": {"Math": 90, "Science": 85}
}

# Accessing values
print(student["name"])  # Output: John
print(student["grades"]["Math"])  # Output: 90

# Adding a new key-value pair
student["email"] = "john@example.com"

# Updating an existing value
student["age"] = 21

# Removing a key-value pair
del student["subjects"]

# Iterating through keys and values
for key, value in student.items():
    print(key, ":", value)`}
            </code>
          </pre><br/>

          <h3>Useful Dictionary Methods:</h3>

          <h4>1. `get()`:</h4>
          <pre>
            <code>
{`# Returns value if key exists, otherwise returns default value
print(student.get("name"))  # Output: John
print(student.get("address", "Not Available"))  # Output: Not Available`}
            </code>
          </pre><br/>

          <h4>2. `setdefault()`:</h4>
          <pre>
            <code>
{`# Returns value if key exists, otherwise inserts the key with default value
print(student.setdefault("address", "Unknown"))  # Output: Unknown`}
            </code>
          </pre><br/>

          <h4>3. `update()`:</h4>
          <pre>
            <code>
{`# Updates dictionary with another dictionary or key-value pairs
student.update({"age": 22, "phone": "123-456-7890"})
print(student)`}
            </code>
          </pre><br/>

          <h3>Summary:</h3>
          <ul>
            <li>Dictionaries are essential in Python for storing and retrieving data using unique keys.</li><br/>
            <li>They are widely used for tasks that require fast access to data and can hold any data type as values.</li><br/>
            <li>With built-in methods like <code>get()</code>, <code>keys()</code>, and <code>update()</code>, Python provides flexibility in manipulating and working with dictionaries.</li>
          </ul>
        </div>
)}
   



          {selectedChapter === 'chapter39' && (
          <div className={style.chaptercontent}>
          <h1 className={style.heading}> Access Dictionary Items   </h1>

          <p>
            In Python, you can access the values of a dictionary using their corresponding keys. Since a dictionary
            consists of key-value pairs, each key is associated with a value. There are several ways to access the items
            in a dictionary, depending on your requirements.
          </p><br/>

          <h2>1. Accessing Values Using Keys</h2>
          <p>You can access the value of a dictionary by using its key inside square brackets <code>[]</code>.</p>
          <pre>
            <code>
              {`
my_dict = {
  "name": "Alice",
  "age": 25,
  "city": "New York"
}

# Accessing values by key
print(my_dict["name"])  # Output: Alice
print(my_dict["age"])   # Output: 25
              `}
            </code>
          </pre>
          <p>
            If the key exists in the dictionary, this will return the corresponding value. However, if the key does not
            exist, Python will raise a <code>KeyError</code>.
          </p><br/>

          <h2>2. Using the <code>get()</code> Method</h2>
          <p>
            The <code>get()</code> method allows you to access a dictionary's value without causing an error if the key
            does not exist. It returns <code>None</code> (or a default value you specify) when the key is not found.
          </p>
          <pre>
            <code>
              {`
# Accessing values using the get() method
print(my_dict.get("name"))  # Output: Alice
print(my_dict.get("address"))  # Output: None
print(my_dict.get("address", "Not Found"))  # Output: Not Found
              `}
            </code>
          </pre><br/>

          <h2>3. Accessing Multiple Values (Using Loops)</h2>
          <p>You can iterate over the dictionary to access all the keys and values.</p>

          <h3>Accessing keys:</h3>
          <pre>
            <code>
              {`
for key in my_dict.keys():
  print(key)
              `}
            </code>
          </pre>
          <p>Output:</p>
          <pre>
            <code>name</code>
            <br />
            <code>age</code>
            <br />
            <code>city</code>
          </pre><br/>

          <h3>Accessing values:</h3>
          <pre>
            <code>
              {`
for value in my_dict.values():
  print(value)
              `}
            </code>
          </pre>
          <p>Output:</p>
          <pre>
            <code>Alice</code>
            <br />
            <code>25</code>
            <br />
            <code>New York</code>
          </pre><br/>

          <h3>Accessing key-value pairs:</h3>
          <pre>
            <code>
              {`
for key, value in my_dict.items():
  print(f"{key}: {value}")
              `}
            </code>
          </pre>
          <p>Output:</p>
          <pre>
            <code>name: Alice</code>
            <br />
            <code>age: 25</code>
            <br />
            <code>city: New York</code>
          </pre><br/>

          <h2>4. Accessing Nested Dictionaries</h2>
          <p>
            Dictionaries can also contain other dictionaries as values, which are called <strong>nested dictionaries</strong>.
            To access values inside a nested dictionary, you can chain keys.
          </p>
          <pre>
            <code>
              {`
my_dict = {
  "name": "Alice",
  "address": {
    "city": "New York",
    "state": "NY"
  }
}

# Accessing nested dictionary values
print(my_dict["address"]["city"])  # Output: New York
print(my_dict["address"]["state"])  # Output: NY
              `}
            </code>
          </pre><br/>

          <h2>5. Using <code>setdefault()</code> Method</h2>
          <p>
            The <code>setdefault()</code> method checks if a key is present in the dictionary. If the key is not found,
            it inserts the key with a specified default value. It returns the value associated with the key if it exists
            or the default value if it does not.
          </p>
          <pre>
            <code>
              {`
# Using setdefault() to access or set a default value
print(my_dict.setdefault("age", 30))  # Output: 30 (since "age" is not in my_dict, it sets it to 30)
print(my_dict)  # The dictionary now includes "age": 30

print(my_dict.setdefault("name", "Bob"))  # Output: Alice (no change since "name" exists)
              `}
            </code>
          </pre><br/>

          <h2>Summary</h2>
          <ul>
            <li><strong>Using keys</strong>: Access values directly with <code>my_dict[key]</code>.</li><br/>
            <li><strong>Using <code>get()</code></strong>: A safer way to access values, avoiding <code>KeyError</code> if the key doesn't exist.</li><br/>
            <li><strong>Iterating through dictionary</strong>: Use <code>keys()</code>, <code>values()</code>, or <code>items()</code> to access multiple values.</li><br/>
            <li><strong>Nested dictionaries</strong>: Access values inside nested dictionaries by chaining keys.</li><br/>
            <li><strong><code>setdefault()</code></strong>: Retrieve or set a default value for a key.</li>
          </ul><br/>

          <p>
            Each of these methods helps you access values in a Python dictionary, depending on whether you need a direct
            access or a safer, more flexible way to handle missing keys.
          </p>
        </div>
      )}
    



          {selectedChapter === 'chapter40' && (
          <div className={style.chaptercontent}>
          <h1 className={style.heading}>Changing Dictionary Items </h1>

    <p>In Python, dictionaries are mutable, which means you can modify, add, or remove items after the dictionary has been created. Here's a detailed explanation of how to change items in a dictionary:</p>
    <br/>
    <h3>1. Updating Values</h3>
    <p>You can update the value of an existing key by assigning a new value to it. If the key doesn't exist, a new key-value pair will be added to the dictionary.</p>
    <pre>
      <code>
        {`# Original dictionary
my_dict = {
  "name": "Alice",
  "age": 25,
  "city": "New York"
}

# Update the value of the "age" key
my_dict["age"] = 26

# Add a new key-value pair
my_dict["email"] = "alice@example.com"

# Output the updated dictionary
print(my_dict)`}
      </code>
    </pre>
    <p><strong>Output:</strong></p>
    <pre>
      <code>
        {`{
  "name": "Alice",
  "age": 26,
  "city": "New York",
  "email": "alice@example.com"
}`}
      </code>
    </pre>
    <br/>
    <h3>2. Adding New Items</h3>
    <p>You can add new key-value pairs to an existing dictionary by simply assigning a value to a new key.</p>
    <pre>
      <code>
        {`my_dict["gender"] = "Female"
print(my_dict)`}
      </code>
    </pre>
    <p><strong>Output:</strong></p>
    <pre>
      <code>
        {`{
  "name": "Alice",
  "age": 25,
  "city": "New York",
  "gender": "Female"
}`}
      </code>
    </pre><br/>

    <h3>3. Removing Items</h3>
    <p>You can remove items from a dictionary using the following methods:</p>
    <ul>
      <li><strong><code>del</code></strong> Statement: Removes a key-value pair by specifying the key.</li><br/>
      <li><strong><code>pop()</code></strong> Method: Removes a key-value pair by key and returns the value of the removed item.</li><br/>
      <li><strong><code>popitem()</code></strong> Method: Removes and returns the last key-value pair in the dictionary (Python 3.7+ maintains insertion order).</li><br/>
      <li><strong><code>clear()</code></strong> Method: Removes all items from the dictionary.</li>
    </ul><br/>
    
    <h4>Example: Using <code>del</code> to remove a key-value pair:</h4>
    <pre>
      <code>
        {`# Using del to remove a key-value pair
del my_dict["city"]
print(my_dict)`}
      </code>
    </pre>
    <p><strong>Output:</strong></p>
    <pre>
      <code>
        {`{
  "name": "Alice",
  "age": 25
}`}
      </code>
    </pre><br/>

    <h4>Example: Using <code>pop()</code> to remove a key and get its value:</h4>
    <pre>
      <code>
        {`# Using pop to remove a key-value pair and get the value
age = my_dict.pop("age")
print(age)  # Output: 25
print(my_dict)  # Output: {"name": "Alice"}`}
      </code>
    </pre><br/>

    <h3>4. Using <code>update()</code> Method</h3>
    <p>The <code>update()</code> method allows you to update the dictionary with elements from another dictionary or from an iterable of key-value pairs. It can add new items or modify existing ones.</p>
    <pre>
      <code>
        {`# Updating using the update() method
my_dict.update({"city": "Los Angeles", "email": "alice@newdomain.com"})
print(my_dict)`}
      </code>
    </pre>
    <p><strong>Output:</strong></p>
    <pre>
      <code>
        {`{
  "name": "Alice",
  "city": "Los Angeles",
  "email": "alice@newdomain.com"
}`}
      </code>
    </pre><br/>

    <h3>5. Using <code>setdefault()</code> Method</h3>
    <p>The <code>setdefault()</code> method is useful for setting a default value for a key. If the key exists, it returns the value. If it doesn't exist, it inserts the key with the default value and returns that value.</p>
    <pre>
      <code>
        {`# Using setdefault() to set a default value for a key
my_dict.setdefault("age", 30)  # "age" key already exists, so no change
my_dict.setdefault("country", "USA")  # "country" doesn't exist, so it's added
print(my_dict)`}
      </code>
    </pre>
    <p><strong>Output:</strong></p>
    <pre>
      <code>
        {`{
  "name": "Alice",
  "age": 25,
  "city": "New York",
  "country": "USA"
}`}
      </code>
    </pre><br/>

    <h3>6. Nested Dictionaries</h3>
    <p>You can also change values in nested dictionaries (dictionaries within dictionaries) by accessing the nested dictionary and modifying its values.</p>
    <pre>
      <code>
        {`# Nested dictionary
my_dict = {
  "name": "Alice",
  "address": {
    "city": "New York",
    "state": "NY"
  }
}

# Change a value inside the nested dictionary
my_dict["address"]["city"] = "Los Angeles"
print(my_dict)`}
      </code>
    </pre>
    <p><strong>Output:</strong></p>
    <pre>
      <code>
        {`{
  "name": "Alice",
  "address": {
    "city": "Los Angeles",
    "state": "NY"
  }
}`}
      </code>
    </pre><br/>

    <h3>Summary:</h3>
    <ul>
      <li><strong>Updating values:</strong> Directly assign a new value to an existing key.</li><br/>
      <li><strong>Adding new items:</strong> Add new key-value pairs using assignment.</li><br/>
      <li><strong>Removing items:</strong> Use <code>del</code>, <code>pop()</code>, or <code>popitem()</code> to remove key-value pairs.</li><br/>
      <li><strong><code>update()</code> method:</strong> Update or add key-value pairs from another dictionary.</li><br/>
      <li><strong><code>setdefault()</code> method:</strong> Set a default value for a key if it does not exist.</li><br/>
      <li><strong>Nested dictionaries:</strong> Modify values within nested dictionaries using the key chain.</li>
    </ul><br/>
    <p>By using these methods, you can effectively change the contents of a dictionary in Python.</p>
  </div>
)}



        {selectedChapter === 'chapter41' && (
         <div className={style.chaptercontent}>
           <h1 className={style.heading}>Adding Items to a Dictionary </h1>

    <p>
      To add items to a dictionary in Python, you can simply assign a value to a new or existing key. Here’s a detailed explanation of how to add items to dictionaries:
    </p>
    <br/>
    <h3 style={{paddingBottom:"6px"}}>1. Adding a New Key-Value Pair</h3>
    <p>
      You can add a new key-value pair to an existing dictionary by assigning a value to a new key. If the key already exists, it will update the value associated with that key.
    </p>

    <pre>
      <code>
{`# Original dictionary
my_dict = {
    "name": "Alice",
    "age": 25
}

# Adding a new key-value pair
my_dict["city"] = "New York"

# Output the updated dictionary
print(my_dict)
`}
      </code>
    </pre>
    <p><strong>Output:</strong></p>
    <pre>
{`{
  "name": "Alice",
  "age": 25,
  "city": "New York"
}`}
    </pre><br/>

    <h3 style={{paddingBottom:"6px"}}>2. Adding Multiple Key-Value Pairs Using update() Method</h3>
    <p>
      You can add multiple key-value pairs at once by using the <code>update()</code> method. This method allows you to update the dictionary with another dictionary or an iterable of key-value pairs (such as a list of tuples).
    </p>

    <pre>
      <code>
{`# Original dictionary
my_dict = {
    "name": "Alice",
    "age": 25
}

# Adding multiple key-value pairs
my_dict.update({"city": "New York", "email": "alice@example.com"})

# Output the updated dictionary
print(my_dict)
`}
      </code>
    </pre>
    <p><strong>Output:</strong></p>
    <pre>
{`{
  "name": "Alice",
  "age": 25,
  "city": "New York",
  "email": "alice@example.com"
}`}
    </pre><br/>

    <h3 style={{paddingBottom:"6px"}}>3. Adding Items Using setdefault() Method</h3>
    <p>
      The <code>setdefault()</code> method is useful when you want to add a key with a default value if the key does not exist. If the key already exists, it will return the existing value.
    </p>

    <pre>
      <code>
{`# Original dictionary
my_dict = {
    "name": "Alice",
    "age": 25
}

# Using setdefault to add a key with a default value
my_dict.setdefault("city", "New York")  # Adds "city" key if it doesn't exist

# Output the updated dictionary
print(my_dict)
`}
      </code>
    </pre>
    <p><strong>Output:</strong></p>
    <pre>
{`{
  "name": "Alice",
  "age": 25,
  "city": "New York"
}`}
    </pre><br/>

    <h3 style={{paddingBottom:"6px"}}>4. Adding Items to Nested Dictionaries</h3>
    <p>
      Dictionaries can also contain other dictionaries as values. You can add items to these nested dictionaries by accessing the nested dictionary and adding new key-value pairs.
    </p>

    <pre>
      <code>
{`# Original dictionary with a nested dictionary
my_dict = {
    "name": "Alice",
    "address": {
        "city": "New York",
        "state": "NY"
    }
}

# Adding an item to the nested dictionary
my_dict["address"]["zip"] = "10001"

# Output the updated dictionary
print(my_dict)
`}
      </code>
    </pre>
    <p><strong>Output:</strong></p>
    <pre>
{`{
  "name": "Alice",
  "address": {
    "city": "New York",
    "state": "NY",
    "zip": "10001"
  }
}`}
    </pre><br/>

    <h3>Summary of Ways to Add Items:</h3>
    <ul>
      <li><strong>Direct assignment:</strong> Add a single key-value pair by assigning a value to a new key.</li><br/><br/>
      <li><strong>update() method:</strong> Add multiple key-value pairs at once from another dictionary or iterable.</li><br/>
      <li><strong>setdefault() method:</strong> Adds a key with a default value if the key does not already exist.</li><br/>
      <li><strong>Nested dictionaries:</strong> Add items to nested dictionaries by accessing the nested structure and adding key-value pairs.</li>
    </ul><br/>

    <p>
      By using these methods, you can easily add items to dictionaries in Python, whether you’re adding one item or multiple items at once, including when working with nested dictionaries.
    </p>
  </div>
)}




        {selectedChapter === 'chapter42' && (
        <div className={style.chaptercontent}>
        <h1 className={style.heading}>Removing Items ( from a  Dictionary )</h1>

        <p>In Python, you can remove items from a dictionary using several methods, depending on your needs. Here's a detailed explanation of the different ways to remove items from a dictionary:</p>
        <br/>
        <h3 style={{paddingBottom:"6px"}}>1. Using <code>del</code> Statement</h3>
        <p>The <code>del</code> statement removes a key-value pair from the dictionary by specifying the key. If the key doesn't exist, a <code>KeyError</code> is raised.</p>

        <pre>
          <code>{`
# Original dictionary
my_dict = {
    "name": "Alice",
    "age": 25,
    "city": "New York"
}

# Using del to remove a key-value pair
del my_dict["city"]

# Output the updated dictionary
print(my_dict)
          `}</code>
        </pre>
        
        <p><strong>Output:</strong></p>
        <pre>
          <code>{`
{
  "name": "Alice",
  "age": 25
}
          `}</code>
        </pre><br/>

        <h3 style={{paddingBottom:"6px"}}>2. Using <code>pop()</code> Method</h3>
        <p>The <code>pop()</code> method removes a key-value pair from the dictionary and returns the value associated with the key. If the key doesn't exist, it raises a <code>KeyError</code>, unless you specify a default value.</p>

        <pre>
          <code>{`
# Original dictionary
my_dict = {
    "name": "Alice",
    "age": 25,
    "city": "New York"
}

# Using pop to remove a key-value pair and get its value
removed_value = my_dict.pop("age")

# Output the updated dictionary and the removed value
print(my_dict)  # Output: {"name": "Alice", "city": "New York"}
print(removed_value)  # Output: 25
          `}</code>
        </pre><br/>

        <h3 style={{paddingBottom:"6px"}}>3. Using <code>popitem()</code> Method</h3>
        <p>The <code>popitem()</code> method removes and returns the last key-value pair from the dictionary (in the case of Python 3.7+ where dictionaries maintain insertion order). If the dictionary is empty, it raises a <code>KeyError</code>.</p>

        <pre>
          <code>{`
# Original dictionary
my_dict = {
    "name": "Alice",
    "age": 25,
    "city": "New York"
}

# Using popitem to remove and return the last key-value pair
removed_item = my_dict.popitem()

# Output the updated dictionary and the removed item
print(my_dict)  # Output: {"name": "Alice", "age": 25}
print(removed_item)  # Output: ("city", "New York")
          `}</code>
        </pre><br/>

        <h3 style={{paddingBottom:"6px"}}>4. Using <code>clear()</code> Method</h3>
        <p>The <code>clear()</code> method removes all the items from the dictionary, making it empty.</p>

        <pre>
          <code>{`
# Original dictionary
my_dict = {
    "name": "Alice",
    "age": 25,
    "city": "New York"
}

# Using clear to remove all items
my_dict.clear()

# Output the updated dictionary (which is now empty)
print(my_dict)  # Output: {}
          `}</code>
        </pre><br/>

        <h3 style={{paddingBottom:"6px"}}>5. Using <code>del</code> with Nested Dictionaries</h3>
        <p>You can also use <code>del</code> to remove items from nested dictionaries. To do this, you need to specify the key of the nested dictionary first.</p>

        <pre>
          <code>{`
# Original dictionary with a nested dictionary
my_dict = {
    "name": "Alice",
    "address": {
        "city": "New York",
        "state": "NY"
    }
}

# Using del to remove a key from the nested dictionary
del my_dict["address"]["city"]

# Output the updated dictionary
print(my_dict)
          `}</code>
        </pre>

        <p><strong>Output:</strong></p>
        <pre>
          <code>{`
{
  "name": "Alice",
  "address": {
    "state": "NY"
  }
}
          `}</code>
        </pre><br/>

        <h3>Summary of Methods to Remove Items:</h3>
        <ul>
            <li><code>del</code>: Removes a key-value pair from the dictionary.</li><br/>
            <li><code>pop()</code>: Removes a key-value pair and returns the value.</li><br/>
            <li><code>popitem()</code>: Removes and returns the last key-value pair (Python 3.7+).</li><br/>
            <li><code>clear()</code>: Removes all items from the dictionary.</li><br/>
            <li><code>del</code> with nested dictionaries: Removes a key from a nested dictionary.</li>
        </ul><br/>

        <p>By using these methods, you can effectively remove items from a Python dictionary.</p>
    </div>
)}




     {selectedChapter === 'chapter43' && (
     <div className={style.chaptercontent}>
     <h1 className={style.heading}>Looping Through Dictionaries </h1>

    <p>In Python, you can loop through a dictionary to access its keys, values, or both keys and values simultaneously. Here’s an overview of the different ways to loop through a dictionary:</p>
    <br/>
    <h3>1. Looping Through Keys</h3>
    <p>You can loop through just the keys of the dictionary by default, or by using the <code>.keys()</code> method. This is helpful if you only need to access or perform operations on the keys.</p>

    <pre>
      <code>
        {`# Dictionary
my_dict = {
    "name": "Alice",
    "age": 25,
    "city": "New York"
}

# Looping through keys
for key in my_dict:
    print(key)`}
      </code>
    </pre>

    <strong>Output:</strong>
    <pre>
      <code>
        {`name
age
city`}
      </code>
    </pre>

    <p>Alternatively, you can use the <code>.keys()</code> method:</p>
    <pre>
      <code>
        {`for key in my_dict.keys():
    print(key)`}
      </code>
    </pre><br/>

    <h3>2. Looping Through Values</h3>
    <p>To loop through only the values in the dictionary, use the <code>.values()</code> method. This is useful when you only need the values and not the keys.</p>
    <pre>
      <code>
        {`# Looping through values
for value in my_dict.values():
    print(value)`}
      </code>
    </pre>

    <strong>Output:</strong>
    <pre>
      <code>
        {`Alice
25
New York`}
      </code>
    </pre><br/>

    <h3>3. Looping Through Key-Value Pairs</h3>
    <p>If you need both keys and values, use the <code>.items()</code> method, which returns each key-value pair as a tuple.</p>
    <pre>
      <code>
        {`# Looping through key-value pairs
for key, value in my_dict.items():
    print(f"{key}: {value}")`}
      </code>
    </pre>

    <strong>Output:</strong>
    <pre>
      <code>
        {`name: Alice
age: 25
city: New York`}
      </code>
    </pre><br/>

    <h3>4. Looping Through a Nested Dictionary</h3>
    <p>If you have a dictionary within a dictionary, you can use nested loops to access items at different levels.</p>
    <pre>
      <code>
        {`# Nested dictionary
my_dict = {
    "name": "Alice",
    "address": {
        "city": "New York",
        "state": "NY"
    }
}

# Looping through a nested dictionary
for key, value in my_dict.items():
    if isinstance(value, dict):
        print(f"{key}:")
        for sub_key, sub_value in value.items():
            print(f"  {sub_key}: {sub_value}")
    else:
        print(f"{key}: {value}")`}
      </code>
    </pre>

    <strong>Output:</strong>
    <pre>
      <code>
        {`name: Alice
address:
  city: New York
  state: NY`}
      </code>
    </pre><br/>

    <h3>5. Using Dictionary Comprehensions</h3>
    <p>You can also use dictionary comprehensions to create a new dictionary by transforming items from the original dictionary.</p>
    <pre>
      <code>
        {`# Original dictionary
my_dict = {
    "name": "Alice",
    "age": 25,
    "city": "New York"
}

# Dictionary comprehension to create a new dictionary with uppercase keys
new_dict = {key.upper(): value for key, value in my_dict.items()}
print(new_dict)`}
      </code>
    </pre>

    <strong>Output:</strong>
    <pre>
      <code>
        {`{
  "NAME": "Alice",
  "AGE": 25,
  "CITY": "New York"
}`}
      </code>
    </pre><br/>

    <h3>Summary</h3>
    <ul>
      <li><strong>Loop through keys:</strong> <code>for key in my_dict</code> or <code>for key in my_dict.keys()</code></li><br/>
      <li><strong>Loop through values:</strong> <code>for value in my_dict.values()</code></li><br/>
      <li><strong>Loop through key-value pairs:</strong> <code>for key, value in my_dict.items()</code></li><br/>
      <li><strong>Nested dictionary:</strong> Use nested loops with <code>isinstance()</code> to handle sub-dictionaries.</li><br/>
      <li><strong>Dictionary comprehension:</strong> Efficiently transform or filter items in a dictionary.</li>
    </ul><br/>

    <p>Using these methods, you can efficiently loop through dictionaries in Python to access, modify, or transform their data.</p>
  </div>
)}



        {selectedChapter === 'chapter44' && (
         <div className={style.chaptercontent}>
            <h1 className={style.heading}>  Copy Dictionaries  </h1>

          <p>
            In Python, dictionaries are mutable, meaning you can change their contents. If you want to create a copy of a dictionary, you have a few options to make a separate copy. Here’s an overview of the different ways to copy dictionaries:
          </p><br/>

          <h2 style={{paddingBottom:"6px"}}>1. Using the <code>copy()</code> Method</h2>
          <p>
            The <code>copy()</code> method creates a shallow copy of the dictionary. This means it copies the dictionary itself but does not copy nested objects, so any nested dictionaries or lists will still be referenced to the original.
          </p>

          <pre>
            <code>
              {`# Original dictionary
my_dict = {
    "name": "Alice",
    "age": 25,
    "city": "New York"
}

# Shallow copy of the dictionary
copy_dict = my_dict.copy()

# Modifying the copy does not affect the original
copy_dict["name"] = "Bob"
print(my_dict)      # Output: {'name': 'Alice', 'age': 25, 'city': 'New York'}
print(copy_dict)    # Output: {'name': 'Bob', 'age': 25, 'city': 'New York'}`}
            </code>
          </pre><br/>

          <h2 style={{paddingBottom:"6px"}}>2. Using <code>dict()</code> Constructor</h2>
          <p>
            You can also use the <code>dict()</code> constructor to create a shallow copy of a dictionary. This works the same as <code>copy()</code>.
          </p>

          <pre>
            <code>
              {`# Shallow copy using dict()
copy_dict = dict(my_dict)

# Modifying the copy does not affect the original
copy_dict["city"] = "Boston"
print(my_dict)      # Output: {'name': 'Alice', 'age': 25, 'city': 'New York'}
print(copy_dict)    # Output: {'name': 'Alice', 'age': 25, 'city': 'Boston'}`}
            </code>
          </pre><br/>

          <h2 style={{paddingBottom:"6px"}}>3. Using Dictionary Comprehension</h2>
          <p>
            Dictionary comprehension can also be used to create a shallow copy by copying each key-value pair.
          </p>

          <pre>
            <code>
              {`# Shallow copy using dictionary comprehension
copy_dict = {key: value for key, value in my_dict.items()}

# Modifying the copy does not affect the original
copy_dict["age"] = 30
print(my_dict)      # Output: {'name': 'Alice', 'age': 25, 'city': 'New York'}
print(copy_dict)    # Output: {'name': 'Alice', 'age': 30, 'city': 'New York'}`}
            </code>
          </pre><br/>

          <h2 style={{paddingBottom:"6px"}}>4. Using <code>copy.deepcopy()</code> for a Deep Copy</h2>
          <p>
            If your dictionary contains nested dictionaries (or other mutable objects), use the <code>copy</code> module’s <code>deepcopy()</code> function to make a deep copy. This copies all levels of nested structures, ensuring that changes in the copy do not affect the original.
          </p>

          <pre>
            <code>
              {`import copy

# Original dictionary with a nested dictionary
my_dict = {
    "name": "Alice",
    "address": {
        "city": "New York",
        "state": "NY"
    }
}

# Deep copy of the dictionary
deep_copy_dict = copy.deepcopy(my_dict)

# Modifying the nested dictionary in the copy does not affect the original
deep_copy_dict["address"]["city"] = "Boston"
print(my_dict)           # Output: {'name': 'Alice', 'address': {'city': 'New York', 'state': 'NY'}}
print(deep_copy_dict)    # Output: {'name': 'Alice', 'address': {'city': 'Boston', 'state': 'NY'}}`}
            </code>
          </pre><br/>

          <h3>Summary:</h3>
          <ul>
            <li><code>copy()</code> method: Creates a shallow copy (original dictionary and references to nested objects).</li><br/>
            <li><code>dict()</code> constructor: Creates a shallow copy, similar to <code>copy()</code>.</li><br/>
            <li>Dictionary comprehension: Creates a shallow copy by copying each item individually.</li><br/>
            <li><code>copy.deepcopy()</code>: Creates a deep copy, duplicating all levels, including nested dictionaries.</li>
          </ul><br/>

          <p>
            By choosing the appropriate method based on whether your dictionary is nested, you can create either a shallow or deep copy in Python.
          </p>
        </div>
)}





{selectedChapter === 'chapter45' && (
  <div className={style.chaptercontent}>
    <h1 className={style.heading}>Nested Dictionaries </h1>

    <p>
      In Python, a <strong>nested dictionary</strong> is a dictionary within another dictionary. This allows you to store complex data structures, where each key can have another dictionary as its value. Nested dictionaries are useful when you need to organize data in a hierarchy, like representing data about multiple objects with additional details for each object.
    </p><br/>

    <h3 style={{paddingBottom:"6px"}}>1. Creating a Nested Dictionary</h3>
    <p>You can create a nested dictionary by assigning another dictionary as the value of a key.</p>

    <pre>
      <code>
{`# Nested dictionary
person = {
    "name": "Alice",
    "age": 30,
    "address": {
        "city": "New York",
        "zip": "10001"
    }
}`}
      </code>
    </pre>

    <p>
      In this example:
      <ul>
        <li><code>person</code> is the main dictionary.</li>
        <li><code>address</code> is a nested dictionary inside <code>person</code> with keys <code>"city"</code> and <code>"zip"</code>.</li>
      </ul>
    </p><br/>

    <h3 style={{paddingBottom:"6px"}}>2. Accessing Items in a Nested Dictionary</h3>
    <p>To access values in a nested dictionary, chain the keys. Use the outer key to access the nested dictionary, then the inner key for its value.</p>

    <pre>
      <code>
{`# Access the nested dictionary's items
print(person["name"])           # Output: Alice
print(person["address"]["city"])  # Output: New York`}
      </code>
    </pre><br/>

    <h3>3. Modifying Items in a Nested Dictionary</h3>
    <p>You can modify items by directly assigning new values to keys, just like with a regular dictionary.</p>

    <pre>
      <code>
{`# Modify an item in the nested dictionary
person["address"]["zip"] = "10002"
print(person["address"]["zip"])  # Output: 10002`}
      </code>
    </pre><br/>

    <h3 style={{paddingBottom:"6px"}}>4. Adding or Removing Items in a Nested Dictionary</h3>
    <p>You can add or remove items from a nested dictionary using standard dictionary methods.</p>

    <p><strong>Adding a New Key-Value Pair:</strong></p>
    <pre>
      <code>
{`# Adding a new key-value pair in the nested dictionary
person["address"]["country"] = "USA"
print(person["address"])  
# Output: {'city': 'New York', 'zip': '10002', 'country': 'USA'}`}
      </code>
    </pre>

    <p><strong>Removing an Item:</strong></p>
    <pre>
      <code>
{`# Removing a key-value pair from the nested dictionary
del person["address"]["zip"]
print(person["address"])  
# Output: {'city': 'New York', 'country': 'USA'}`}
      </code>
    </pre><br/>

    <h3 style={{paddingBottom:"6px"}}>5. Looping Through a Nested Dictionary</h3>
    <p>To loop through a nested dictionary, use a loop for the outer dictionary, then add another loop for the inner dictionary if needed.</p>

    <pre>
      <code>
{`# Loop through the nested dictionary
for key, value in person.items():
    if isinstance(value, dict):  # Check if the value is a nested dictionary
        print(f"{key}:")
        for sub_key, sub_value in value.items():
            print(f"  {sub_key}: {sub_value}")
    else:
        print(f"{key}: {value}")`}
      </code>
    </pre><br/>

    <h3 style={{paddingBottom:"6px"}}>6. Working with Deeply Nested Dictionaries</h3>
    <p>For dictionaries nested multiple levels deep, you may need to chain keys further, or use recursion if accessing dynamically.</p>

    <pre>
      <code>
{`# Deeply nested dictionary
data = {
    "student": {
        "name": "John",
        "subjects": {
            "math": {
                "score": 95,
                "teacher": "Mr. Smith"
            }
        }
    }
}

# Access deeply nested value
print(data["student"]["subjects"]["math"]["score"])  # Output: 95`}
      </code>
    </pre><br/>

    <h3 style={{paddingBottom:"6px"}}>7. Using the <code>get()</code> Method with Nested Dictionaries</h3>
    <p>The <code>get()</code> method can be used to access nested dictionaries safely, avoiding errors if a key is missing.</p>

    <pre>
      <code>
{`# Using get with nested dictionaries
city = person.get("address", {}).get("city", "Unknown")
print(city)  # Output: New York`}
      </code>
    </pre><br/>

    <h3>8. Summary</h3>
    <ul>
      <li><strong>Creating</strong>: Define a dictionary within another dictionary.</li><br/>
      <li><strong>Accessing</strong>: Chain keys to access items at each level.</li><br/>
      <li><strong>Modifying</strong>: Directly update or delete nested items.</li><br/>
      <li><strong>Looping</strong>: Use nested loops to iterate through each dictionary level.</li><br/>
      <li><strong>Deep Nesting</strong>: Chain further or use recursion.</li><br/>
      <li><strong><code>get()</code></strong>: Access items safely in nested dictionaries.</li>
    </ul><br/>

    <p>Nested dictionaries provide a powerful way to structure data, especially useful for complex applications like configurations, structured data storage, or APIs.</p>
  </div>
)}



      {selectedChapter === 'chapter46' && (
       <div className={style.chaptercontent}>
          <h1 className={style.heading}> Dictionary Methods</h1>

    <p>Here’s a breakdown of some commonly used dictionary methods in Python, each with examples to illustrate its functionality.</p>

    <br/>

    <h3>1. <code>.get()</code></h3>
    <p>
      The <code>.get()</code> method retrieves the value associated with a specified key. If the key doesn’t exist, it returns a default value instead of raising a <code>KeyError</code>.
    </p>
    <pre>
      <code>
{`# Dictionary
person = {"name": "Alice", "age": 25}

# Get value for an existing key
print(person.get("name"))  # Output: Alice

# Get value for a non-existing key, with a default
print(person.get("city", "Not Found"))  # Output: Not Found`}
      </code>
    </pre>

    <br/>

    <h3>2. <code>.keys()</code></h3>
    <p>
      The <code>.keys()</code> method returns a view object containing all keys in the dictionary.
    </p>
    <pre>
      <code>
{`person = {"name": "Alice", "age": 25}
print(person.keys())  # Output: dict_keys(['name', 'age'])`}
      </code>
    </pre>

    <br/>

    <h3>3. <code>.values()</code></h3>
    <p>
      The <code>.values()</code> method returns a view object containing all values in the dictionary.
    </p>
    <pre>
      <code>
{`person = {"name": "Alice", "age": 25}
print(person.values())  # Output: dict_values(['Alice', 25])`}
      </code>
    </pre>

    <br/>

    <h3>4. <code>.items()</code></h3>
    <p>
      The <code>.items()</code> method returns a view object containing key-value pairs as tuples, allowing you to iterate over them.
    </p>
    <pre>
      <code>
{`person = {"name": "Alice", "age": 25}
for key, value in person.items():
    print(key, value)
# Output:
# name Alice
# age 25`}
      </code>
    </pre>

    <br/>

    <h3>5. <code>.pop()</code></h3>
    <p>
      The <code>.pop()</code> method removes a specified key and returns its value. If the key is not found, it raises a <code>KeyError</code> unless you provide a default value.
    </p>
    <pre>
      <code>
{`person = {"name": "Alice", "age": 25}
age = person.pop("age")
print(age)         # Output: 25
print(person)      # Output: {'name': 'Alice'}`}
      </code>
    </pre>

    <br/>

    <h3>6. <code>.popitem()</code></h3>
    <p>
      The <code>.popitem()</code> method removes and returns the last key-value pair as a tuple. In Python 3.7+, dictionaries maintain insertion order, so <code>.popitem()</code> removes the most recently added item.
    </p>
    <pre>
      <code>
{`person = {"name": "Alice", "age": 25}
item = person.popitem()
print(item)        # Output: ('age', 25)
print(person)      # Output: {'name': 'Alice'}`}
      </code>
    </pre>

    <br/>

    <h3>7. <code>.update()</code></h3>
    <p>
      The <code>.update()</code> method updates the dictionary with key-value pairs from another dictionary or an iterable of key-value pairs.
    </p>
    <pre>
      <code>
{`person = {"name": "Alice"}
person.update({"age": 25, "city": "New York"})
print(person)  # Output: {'name': 'Alice', 'age': 25, 'city': 'New York'}`}
      </code>
    </pre>

    <br/>

    <h3>8. <code>.clear()</code></h3>
    <p>
      The <code>.clear()</code> method removes all items from the dictionary, making it empty.
    </p>
    <pre>
      <code>
{`person = {"name": "Alice", "age": 25}
person.clear()
print(person)  # Output: {}`}
      </code>
    </pre>

    <br/>

    <h3>9. <code>.copy()</code></h3>
    <p>
      The <code>.copy()</code> method returns a shallow copy of the dictionary, meaning that it only copies the top-level items.
    </p>
    <pre>
      <code>
{`person = {"name": "Alice", "age": 25}
person_copy = person.copy()
print(person_copy)  # Output: {'name': 'Alice', 'age': 25}`}
      </code>
    </pre>
    <br/>
    

    <h3>10. <code>fromkeys()</code></h3>
    <p>
      The <code>fromkeys()</code> method creates a new dictionary from a given sequence of keys, all set to a specified value (or <code>None</code> by default).
    </p>
    <pre>
      <code>
{`keys = ["name", "age", "city"]
default_value = "unknown"
new_dict = dict.fromkeys(keys, default_value)
print(new_dict)  # Output: {'name': 'unknown', 'age': 'unknown', 'city': 'unknown'}`}
      </code>
    </pre>

    <br/>

    <h3 style={{paddingBottom:"6px"}}>Summary Table</h3>
    <table>
      <thead>
        <tr>
          <th>Method</th>
          <th>Description</th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td><code>.get()</code></td>
          <td>Retrieves the value for a specified key, with an optional default if the key doesn’t exist.</td>
        </tr>
        <tr>
          <td><code>.keys()</code></td>
          <td>Returns all keys in the dictionary as a view object.</td>
        </tr>
        <tr>
          <td><code>.values()</code></td>
          <td>Returns all values in the dictionary as a view object.</td>
        </tr>
        <tr>
          <td><code>.items()</code></td>
          <td>Returns key-value pairs as tuples in a view object.</td>
        </tr>
        <tr>
          <td><code>.pop()</code></td>
          <td>Removes a specified key and returns its value.</td>
        </tr>
        <tr>
          <td><code>.popitem()</code></td>
          <td>Removes and returns the last key-value pair as a tuple.</td>
        </tr>
        <tr>
          <td><code>.update()</code></td>
          <td>Updates the dictionary with key-value pairs from another dictionary or iterable.</td>
        </tr>
        <tr>
          <td><code>.clear()</code></td>
          <td>Removes all items from the dictionary.</td>
        </tr>
        <tr>
          <td><code>.copy()</code></td>
          <td>Creates a shallow copy of the dictionary.</td>
        </tr>
        <tr>
          <td><code>fromkeys()</code></td>
          <td>Creates a new dictionary with specified keys, all set to the same value.</td>
        </tr>
      </tbody>
    </table><br/>

    <p>
      These methods provide a variety of ways to interact with dictionaries in Python, making them versatile tools for data manipulation and management.
    </p>

  </div>
)}




        {selectedChapter === 'chapter47' && (
        <div className={style.chaptercontent}>
        <h1 className={style.heading}> Conditional Statement if.....else and elif  </h1>

          <p>
            Conditional statements in Python are used to control the flow of execution based on certain conditions. They allow a program to execute specific blocks of code depending on whether a condition evaluates to <code>True</code> or <code>False</code>. These statements are essential for decision-making in programming, enabling more dynamic and interactive code.
          </p><br/>

          <h2 style={{paddingBottom:"6px"}}>1. The <code>if</code> Statement</h2>
          <p>
            The <code>if</code> statement is the simplest form of conditional statement. It evaluates a condition, and if the condition is <code>True</code>, the code block inside the <code>if</code> is executed.
          </p>
          <pre>
            <code>
              {`if condition:
  # Block of code executed if condition is true`}
            </code>
          </pre>
          <p>
            In this example, since <code>x</code> is 10 and the condition <code>x &gt; 5</code> is true, the output will be <code>"x is greater than 5"</code>.
          </p>
          <br/>
          <h2 style={{paddingBottom:"6px"}}>2. The <code>else</code> Statement</h2>
          <p>
            The <code>else</code> statement can be used after an <code>if</code> statement to provide an alternative block of code that will execute if the condition is <code>False</code>.
          </p>
          <pre>
            <code>
              {`if condition:
  # Code executed if condition is true
else:
  # Code executed if condition is false`}
            </code>
          </pre>
          <p>
            If the condition evaluates to <code>False</code>, the code inside the <code>else</code> block is executed.
          </p><br/>

          <h2 style={{paddingBottom:"6px"}}>3. The <code>elif</code> Statement</h2>
          <p>
            The <code>elif</code> (short for "else if") statement is used to check multiple conditions sequentially. It provides an alternative condition to check if the previous <code>if</code> or <code>elif</code> conditions were <code>False</code>. Once a true condition is found, the corresponding block is executed, and the rest are skipped.
          </p>
          <pre>
            <code>
              {`if condition1:
  # Code executed if condition1 is true
elif condition2:
  # Code executed if condition1 is false and condition2 is true
else:
  # Code executed if none of the conditions are true`}
            </code>
          </pre><br/>

          <h2>4. Nested Conditional Statements</h2>
          <p>
            You can place conditional statements inside other conditional statements, which is called <strong>nesting</strong>. This allows for more complex decision-making.
          </p>
          <pre>
            <code>
              {`if condition1:
    if condition2:
        # Code executed if both condition1 and condition2 are true
    else:
        # Code executed if condition1 is true and condition2 is false
else:
    # Code executed if condition1 is false`}
            </code>
          </pre><br/>

          <h2>5. Conditional Expressions (Ternary Operator)</h2>
          <p>
            Python supports a shorthand form of the <code>if-else</code> statement known as a <strong>conditional expression</strong> (or ternary operator). This allows you to choose between two values based on a condition, all in a single line.
          </p>
          <pre>
            <code>
              {`value_if_true if condition else value_if_false`}
            </code>
          </pre><br/>

          <h2>6. Logical Operators in Conditional Statements</h2>
          <p>
            Python allows you to combine multiple conditions using logical operators. The most common logical operators are:
          </p>
          <ul>
            <li><code>and</code>: Returns <code>True</code> if both conditions are true.</li><br/>
            <li><code>or</code>: Returns <code>True</code> if at least one condition is true.</li><br/>
            <li><code>not</code>: Reverses the truth value of the condition.</li>
          </ul><br/>

          <h2>7. Comparison Operators in Conditional Statements</h2>
          <p>
            You can use various comparison operators to compare values:
          </p>
          <ul>
            <li><code>==</code>: Equal to</li><br/>
            <li><code>!=</code>: Not equal to</li><br/>
            <li><code>&gt;</code>: Greater than</li><br/>
            <li><code>&lt;</code>: Less than</li><br/>
            <li><code>&gt;=</code>: Greater than or equal to</li><br/>
            <li><code>&lt;=</code>: Less than or equal to</li>
          </ul><br/>

          <h2>8. Truthiness and Falsiness</h2>
          <p>
            In Python, certain values are considered "truthy" or "falsy". Here's how it works:
          </p>
          <ul>
            <li><strong>Truthy</strong> values: Non-zero numbers, non-empty strings, lists, and other objects.</li><br/>
            <li><strong>Falsy</strong> values: <code>False</code>, <code>None</code>, <code>0</code>, empty strings, empty lists, etc.</li>
          </ul><br/>

          <h2>Conclusion</h2>
          <p>
            Conditional statements are a fundamental concept in Python that allow your program to make decisions. By using <code>if</code>, <code>else</code>, <code>elif</code>, and logical and comparison operators, you can control the flow of execution in your programs. Understanding how to use these statements effectively is essential for writing dynamic and interactive code.
          </p>
        </div>
)}




        {selectedChapter === 'chapter48' && (
          <div className={style.chaptercontent}>
            <h1 className={style.heading}>While Loop </h1>

    <p>
      The <code>while</code> loop in Python is one of the two primary types of loops (the other being the <code>for</code> loop). It allows you to repeatedly execute a block of code as long as a specified condition is true. The <code>while</code> loop is generally used when you don't know in advance how many times the loop will execute, but you want to continue looping until a certain condition is met.
    </p><br/>

    <h2 style={{paddingBottom:"6px"}}>Syntax of the <code>while</code> loop:</h2>
    <pre><code>{`while condition:
    # Block of code to be executed`}</code></pre>

    <p>
      - <code>condition</code>: This is an expression that is evaluated before each iteration of the loop. If the condition evaluates to <code>True</code>, the code inside the loop is executed. If it evaluates to <code>False</code>, the loop terminates, and the program continues with the next part of the code after the loop.
      - The block of code inside the <code>while</code> loop is indented. This indentation is required in Python to indicate that these lines are part of the loop.
    </p><br/>

    <h2>How It Works:</h2>
    <ol>
      <li><strong>Check the condition:</strong> Before each iteration, the loop checks the condition.</li><br/>
      <li><strong>If the condition is <code>True</code>:</strong> The block of code inside the loop is executed.</li><br/>
      <li><strong>Reevaluate the condition:</strong> After executing the code inside the loop, the condition is checked again.</li><br/>
      <li><strong>Loop ends when the condition is <code>False</code>:</strong> When the condition evaluates to <code>False</code>, the loop terminates, and the program moves on to the next part of the code after the loop.</li>
    </ol><br/>

    <h2>Basic Example:</h2>
    <pre><code>{`x = 0
while x < 5:
    print(x)
    x += 1  # Increment x by 1`}</code></pre>
    <p><strong>Output:</strong></p>
    <pre><code>0
1
2
3
4</code></pre>

    <h2>Explanation:</h2>
    <ul>
      <li>Initially, <code>x</code> is set to 0.</li>
      <li>The <code>while</code> loop checks if <code>x</code> is less than 5. Since <code>x</code> is 0, which is less than 5, the condition evaluates to <code>True</code>.</li>
      <li>The value of <code>x</code> is printed, and <code>x</code> is incremented by 1.</li>
      <li>The loop repeats, now with <code>x</code> as 1, and continues until <code>x</code> becomes 5.</li>
      <li>When <code>x</code> becomes 5, the condition <code>x &lt; 5</code> evaluates to <code>False</code>, and the loop terminates.</li>
    </ul><br/>

    <h2>Infinite Loop:</h2>
    <p>A <code>while</code> loop can also create an <strong>infinite loop</strong> if the condition always remains <code>True</code>. This happens when the condition never becomes <code>False</code>, causing the loop to run indefinitely. This is generally something you want to avoid, as it can cause your program to freeze or become unresponsive.</p>

    <h3>Example of an infinite loop:</h3>
    <pre><code>{`while True:
    print("This loop will run forever!")`}</code></pre>
    <p><strong>Note:</strong> This loop will keep running indefinitely unless you manually stop the program.</p><br/>

    <h2 style={{paddingBottom:"6px"}}>Breaking out of a <code>while</code> loop:</h2>
    <p>You can use the <code>break</code> statement to exit the <code>while</code> loop prematurely, regardless of whether the condition is <code>True</code> or not.</p>

    <h3>Example with <code>break</code>:</h3>
    <pre><code>{`x = 0
while x < 10:
    if x == 5:
        break  # Exit the loop when x reaches 5
    print(x)
    x += 1`}</code></pre>
    <p><strong>Output:</strong></p>
    <pre><code>0
1
2
3
4</code></pre><br/>

    <h2 style={{paddingBottom:"6px"}}>Skipping an iteration with <code>continue</code>:</h2>
    <p>You can use the <code>continue</code> statement inside a <code>while</code> loop to skip the current iteration and move to the next iteration of the loop.</p>

    <h3>Example with <code>continue</code>:</h3>
    <pre><code>{`x = 0
while x < 5:
    x += 1
    if x == 3:
        continue  # Skip printing when x is 3
    print(x)`}</code></pre>
    <p><strong>Output:</strong></p>
    <pre><code>1
2
4
5</code></pre><br/>

    <h2 style={{paddingBottom:"6px"}}><code>else</code> Clause with <code>while</code> Loop:</h2>
    <p>In Python, a <code>while</code> loop can optionally have an <code>else</code> clause, which will be executed after the loop terminates (when the condition becomes <code>False</code>). The <code>else</code> block is not executed if the loop is terminated using <code>break</code>.</p>

    <h3>Example with <code>else</code>:</h3>
    <pre><code>{`x = 0
while x < 5:
    print(x)
    x += 1
else:
    print("The loop has finished.")`}</code></pre>
    <p><strong>Output:</strong></p>
    <pre><code>0
1
2
3
4
The loop has finished.</code></pre><br/>

    <h2>Summary of Key Points:</h2>
    <ul>
      <li><strong>Basic Structure:</strong> The <code>while</code> loop executes a block of code as long as the given condition is <code>True</code>.</li><br/>
      <li><strong>Important Statements Inside <code>while</code>:</strong>
        <ul><br/>
          <li><code>break</code>: Exits the loop immediately, regardless of the condition.</li><br/>
          <li><code>continue</code>: Skips the current iteration and moves to the next iteration.</li><br/>
          <li><code>else</code>: Executes after the loop completes, unless it is terminated by <code>break</code>.</li>
        </ul><br/>
      </li>
      <li><strong>Avoid Infinite Loops:</strong> Ensure the condition will eventually evaluate to <code>False</code> to avoid infinite loops.</li><br/>
      <li><strong>Common Use Case:</strong> The <code>while</code> loop is often used when you don't know the number of iterations in advance but have a condition that must be satisfied to stop the loop.</li>
    </ul><br/>

    <h2>Practical Example:</h2>
    <h3>Example of Input Validation:</h3>
    <pre><code>{`password = ""
while password != "secret":
    password = input("Enter the password: ")
    if password != "secret":
        print("Incorrect password, try again.")
print("Access granted!")`}</code></pre>
    <p>In this example:</p>
    <ul>
      <li>The loop continues to ask the user for the password until they enter the correct one (<code>"secret"</code>).</li><br/>
      <li>Once the correct password is entered, the loop exits, and <code>"Access granted!"</code> is printed.</li>
    </ul><br/>

    <h2>Conclusion:</h2>
    <p>The <code>while</code> loop is a powerful control structure in Python that enables repeating a block of code as long as a specified condition is <code>True</code>. It's especially useful when the number of iterations is not predetermined, but the condition to continue looping is clear.</p>
  </div>
)}



            {selectedChapter === 'chapter49' && (
            <div className={style.chaptercontent}>
            <h1 className={style.heading}> For Loop </h1>

          <p>
            The <code>for</code> loop in Python is one of the most commonly used control structures for iterating over a sequence of items. This sequence can be a list, tuple, string, dictionary, or any other iterable object. It provides a convenient way to execute a block of code multiple times, once for each item in the sequence.
          </p><br/>

          <h2>Syntax of the <code>for</code> loop:</h2>
          <pre>
            <code>{`for variable in iterable:\n    # Block of code to be executed`}</code>
          </pre>
          <ul>
            <li><strong>variable</strong>: This is a temporary name for each item in the iterable. In each iteration, this variable takes the value of the next element in the iterable.</li><br/>
            <li><strong>iterable</strong>: This is the sequence or collection of items that the loop will iterate over. Common examples of iterables include lists, strings, ranges, dictionaries, etc.</li><br/>
            <li>The block of code inside the <code>for</code> loop is indented. This indentation is crucial because it tells Python that these lines are part of the loop.</li>
          </ul><br/>

          <h2>How It Works:</h2>
          <ol>
            <li><strong>Initialization</strong>: The loop starts by initializing the loop variable with the first item in the iterable.</li><br/>
            <li><strong>Execution</strong>: The block of code inside the loop is executed for each item in the iterable. After each iteration, the loop variable is updated to the next item in the iterable.</li><br/>
            <li><strong>Termination</strong>: The loop terminates when all items in the iterable have been processed.</li>
          </ol><br/>

          <h2>Basic Example:</h2>
          <pre>
            <code>{`fruits = ["apple", "banana", "cherry"]\nfor fruit in fruits:\n    print(fruit)`}</code>
          </pre>
          <p><strong>Output:</strong></p>
          <pre>
            <code>
              apple<br />
              banana<br />
              cherry
            </code>
          </pre>
          <p>In this example:</p>
          <ul>
            <li>The list <code>fruits</code> contains three items: <code>"apple"</code>, <code>"banana"</code>, and <code>"cherry"</code>.</li><br/>
            <li>The <code>for</code> loop iterates over the list, and in each iteration, the variable <code>fruit</code> is assigned one item from the list.</li><br/>
            <li>The <code>print(fruit)</code> statement is executed three times, once for each fruit in the list.</li>
          </ul><br/>  

          <h2>Using <code>range()</code> with <code>for</code> loop:</h2>
          <pre>
            <code>{`for i in range(5):\n    print(i)`}</code>
          </pre>
          <p><strong>Output:</strong></p>
          <pre>
            <code>
              0<br />
              1<br />
              2<br />
              3<br />
              4
            </code>
          </pre>
          <p>In this example:</p>
          <ul>
            <li>The <code>range(5)</code> generates the numbers from <code>0</code> to <code>4</code> (5 is excluded).</li><br/>
            <li>The <code>for</code> loop iterates through these numbers, and the variable <code>i</code> takes each value from <code>0</code> to <code>4</code> during the loop.</li>
          </ul><br/>

          <h2>Looping through a String:</h2>
          <pre>
            <code>{`word = "hello"\nfor char in word:\n    print(char)`}</code>
          </pre>
          <p><strong>Output:</strong></p>
          <pre>
            <code>
              h<br />
              e<br />
              l<br />
              l<br />
              o
            </code>
          </pre>
          <p>Here:</p>
          <ul>
            <li>The string <code>word</code> is treated as an iterable, where each character in the string is accessed in each iteration of the loop.</li>
          </ul><br/>

          <h2>Looping through a Dictionary:</h2>
          <h3>Iterating over the keys:</h3>
          <pre>
            <code>{`person = {"name": "John", "age": 30, "city": "New York"}\nfor key in person:\n    print(key)`}</code>
          </pre>
          <p><strong>Output:</strong></p>
          <pre>
            <code>
              name<br />
              age<br />
              city
            </code>
          </pre><br/>

          <h3>Iterating over keys and values:</h3>
          <pre>
            <code>{`for key, value in person.items():\n    print(key, ":", value)`}</code>
          </pre>
          <p><strong>Output:</strong></p>
          <pre>
            <code>
              name : John<br />
              age : 30<br />
              city : New York
            </code>
          </pre><br/>        

          <h2>Using <code>else</code> with <code>for</code> loop:</h2>
          <pre>
            <code>{`for i in range(3):\n    print(i)\nelse:\n    print("Loop finished.")`}</code>
          </pre>
          <p><strong>Output:</strong></p>
          <pre>
            <code>
              0<br />
              1<br />
              2<br />
              Loop finished.
            </code>
          </pre><br/>

          <h2>Using <code>break</code> and <code>continue</code> in a <code>for</code> loop:</h2>
          <h3>Example with <code>break</code>:</h3>
          <pre>
            <code>{`for i in range(10):\n    if i == 5:\n        break  # Exit the loop when i is 5\n    print(i)`}</code>
          </pre>
          <p><strong>Output:</strong></p>
          <pre>
            <code>
              0<br />
              1<br />
              2<br />
              3<br />
              4
            </code>
          </pre><br/>

          <h3>Example with <code>continue</code>:</h3>
          <pre>
            <code>{`for i in range(5):\n    if i == 2:\n        continue  # Skip printing when i is 2\n    print(i)`}</code>
          </pre>
          <p><strong>Output:</strong></p>
          <pre>
            <code>
              0<br />
              1<br />
              3<br />
              4
            </code>
          </pre><br/>

          <h2>Nested <code>for</code> loops:</h2>
          <pre>
            <code>{`for i in range(3):\n    for j in range(3):\n        print(f"({i}, {j})")`}</code>
          </pre>
          <p><strong>Output:</strong></p>
          <pre>
            <code>
              (0, 0)<br />
              (0, 1)<br />
              (0, 2)<br />
              (1, 0)<br />
              (1, 1)<br />
              (1, 2)<br />
              (2, 0)<br />
              (2, 1)<br />
              (2, 2)
            </code>
          </pre><br/>

          <h2>Summary of Key Points:</h2>
          <ul>
            <li><strong>Basic Structure:</strong> The <code>for</code> loop iterates over an iterable, executing the block of code for each item in the iterable.</li><br/>
            <li><strong>Common Iterables:</strong> You can use the <code>for</code> loop with various iterables such as lists, strings, dictionaries, and more.</li><br/>
            <li><strong>Using <code>range()</code>:</strong> The <code>range()</code> function is commonly used to iterate over a sequence of numbers.</li><br/>
            <li><strong><code>else</code> Clause:</strong> An optional <code>else</code> block can be used in a <code>for</code> loop, which executes when the loop completes normally.</li><br/>
            <li><strong>Control Statements:</strong> <code>break</code>: Exits the loop early. <code>continue</code>: Skips the current iteration and moves to the next one.</li><br/>
            <li><strong>Nested Loops:</strong> <code>for</code> loops can be nested inside each other to handle more complex structures, like matrices or multidimensional arrays.</li>
          </ul><br/>

          <h2>Conclusion:</h2>
          <p>The <code>for</code> loop is a fundamental and flexible construct in Python that makes it easy to iterate over sequences and perform repetitive tasks. By using it with different data structures, you can automate and simplify tasks involving lists, strings, numbers, and other iterables.</p>
        </div>
      )}




        {selectedChapter === 'chapter50' && (
        <div className={style.chaptercontent}>
        <h1 className={style.heading}>  Functions  </h1>

          <h2>Understanding Functions in Python</h2>
          <p>
            Functions in Python are fundamental tools for organizing and structuring code. A function is essentially a block of reusable code designed to perform a specific task. By using functions, you can break down complex tasks into smaller, more manageable pieces, which enhances code readability and maintainability. Functions can accept inputs, process them, and return outputs. This modularity allows for easy code reuse, reducing redundancy and making programs more concise and efficient.
          </p><br/>

          <h3>What Is a Function in Python?</h3>
          <p>
            A function is a block of code that performs a specific task, typically designed to execute a set of instructions whenever it's called. Functions allow you to group related operations together, making your code more organized and readable. Functions can take inputs (parameters), perform calculations or actions, and return a result.
          </p><br/>

          <h3>Syntax of a Function</h3>
          <pre>
            <code>
              {`def function_name(parameters):\n  # Code block\n  return result`}
            </code>
          </pre>
          <ul>
            <li><strong>`def`</strong>: This keyword tells Python that you are defining a function.</li><br/>
            <li><strong>`function_name`</strong>: The name you assign to the function. It must follow the same naming conventions as variables.</li><br/>
            <li><strong>`parameters`</strong>: These are optional inputs the function can accept. They are used to pass data into the function.</li><br/>
            <li><strong>`return`</strong>: This keyword is used to send a result back from the function. If no return statement is provided, the function returns <code>None</code> by default.</li>
          </ul><br/>

          <h3>Creating a Simple Function</h3>
          <pre>
            <code>{`def greet():\n  print("Hello, World!")\ngreet()`}</code>
          </pre>
          <p>Output:</p>
          <pre><code>Hello, World!</code></pre><br/>

          <h3>Functions with Parameters</h3>
          <pre>
            <code>{`def greet(name):\n  print(f"Hello, {name}!")\ngreet("Alice")`}</code>
          </pre>
          <p>Output:</p>
          <pre><code>Hello, Alice!</code></pre><br/>

          <h3>Returning Values from Functions</h3>
          <pre>
            <code>{`def add(a, b):\n  return a + b\nresult = add(5, 3)\nprint(result)`}</code>
          </pre>
          <p>Output:</p>
          <pre><code>8</code></pre><br/>

          <h3>Default Parameters</h3>
          <pre>
            <code>{`def greet(name="Guest"):\n  print(f"Hello, {name}!")\ngreet()\ngreet("Alice")`}</code>
          </pre>
          <p>Output:</p>
          <pre><code>Hello, Guest!\nHello, Alice!</code></pre><br/>

          <h3>Keyword Arguments</h3>
          <pre>
            <code>{`def describe_pet(name, animal_type="dog"):\n  print(f"My {animal_type} is named {name}.")\ndescribe_pet(name="Rex", animal_type="cat")\ndescribe_pet(name="Fluffy")`}</code>
          </pre>
          <p>Output:</p>
          <pre><code>My cat is named Rex.\nMy dog is named Fluffy.</code></pre><br/>

          <h3>Arbitrary Arguments (`*args` and `**kwargs`)</h3>
          <h4>Using `*args` for Variable Positional Arguments</h4>
          <pre>
            <code>{`def print_numbers(*args):\n  for num in args:\n    print(num)\nprint_numbers(1, 2, 3, 4)`}</code>
          </pre>
          <p>Output:</p>
          <pre><code>1\n2\n3\n4</code></pre><br/>

          <h4>Using `**kwargs` for Variable Keyword Arguments</h4>
          <pre>
            <code>{`def describe_pet(**kwargs):\n  for key, value in kwargs.items():\n    print(f"{key}: {value}")\ndescribe_pet(name="Rex", animal_type="dog", age=5)`}</code>
          </pre>
          <p>Output:</p>
          <pre><code>name: Rex\nanimal_type: dog\nage: 5</code></pre><br/>

          <h3>Lambda Functions</h3>
          <pre>
            <code>{`add = lambda x, y: x + y\nprint(add(5, 3))`}</code>
          </pre>
          <p>Output:</p>
          <pre><code>8</code></pre><br/>

          <h3>Recursion</h3>
          <pre>
            <code>{`def factorial(n):\n  if n == 0:\n    return 1\n  else:\n    return n * factorial(n - 1)\nprint(factorial(5))`}</code>
          </pre>
          <p>Output:</p>
          <pre><code>120</code></pre><br/>

          <h3>Function Scope</h3>
          <pre>
            <code>{`def my_function():\n  x = 10  # Local variable\n  print(x)\n\nmy_function()\n# print(x)  # This will result in an error because x is not defined outside the function.`}</code>
          </pre><br/>

          <h3>Function Overloading</h3>
          <p>Python doesn't support traditional function overloading, but you can achieve similar behavior using default arguments or variable-length arguments (`*args` and `**kwargs`).</p>
          <br/>
          <h3>Summary of Key Concepts</h3>
          <ul>
            <li>Function Definition: Functions are defined using the <code>def</code> keyword.</li><br/>
            <li>Parameters and Arguments: Functions can accept inputs, allowing them to work with different data each time they are called.</li><br/>
            <li>Return Statement: Functions can return a result, which can be captured and used in the rest of the program.</li><br/>
            <li>Default Parameters: You can provide default values for parameters that are used when no argument is passed.</li><br/>
            <li>Variable-length Arguments: Use <code>*args</code> for a variable number of positional arguments and <code>**kwargs</code> for keyword arguments.</li><br/>
            <li>Lambda Functions: Small anonymous functions that can perform a single operation.</li><br/>
            <li>Recursion: Functions can call themselves to solve problems recursively.</li><br/>
            <li>Scope: Variables can either be local (inside functions) or global (outside functions).</li>
          </ul><br/>

          <h3>Conclusion</h3>
          <p>
            Functions are a powerful feature in Python that help make code more organized, reusable, and maintainable. They allow you to break down complex tasks into smaller, manageable parts. With the ability to accept parameters, return values, and handle various types of arguments (like default, keyword, or variable-length), functions provide a lot of flexibility and power. By mastering functions, you can significantly improve the structure and quality of your Python programs.
          </p>
        </div>
)} 
 




        {selectedChapter === 'chapter51' && (
        <div className={style.chaptercontent}>
        <h1 className={style.heading}> Lambda Functions</h1>

        <p>
          A <strong>lambda function</strong> in Python is a small anonymous function
          that is defined using the <code>lambda</code> keyword. It allows you to define
          functions in a concise way, especially for short, simple tasks. These functions
          are useful when you need a simple function for a short duration, without the need
          to formally define it with the <code>def</code> keyword.
        </p><br/>

        <h3>Syntax of Lambda Function</h3>
        <pre>
          <code>
            lambda arguments: expression
          </code>
        </pre>

        <ul>
          <li><strong>lambda</strong>: The keyword used to create the function.</li><br/>
          <li><strong>arguments</strong>: The input values (like parameters) that the function takes.</li><br/>
          <li><strong>expression</strong>: A single expression that is evaluated and returned by the function. It cannot contain multiple statements.</li>
        </ul><br/>

        <h3>Key Features of Lambda Functions</h3>
        <ul>
          <li>They are anonymous (do not need a name).</li><br/>
          <li>They can have any number of arguments, but only one expression.</li><br/>
          <li>The expression is evaluated and returned when the function is called.</li>
        </ul><br/>

        <h3>Examples</h3>

        <h4>Example 1: Simple Lambda Function</h4>
        <pre>
          <code>
            {`add = lambda x, y: x + y`}
          </code>
        </pre>
        <p>
          The lambda function takes two parameters <code>x</code> and <code>y</code>, and returns their sum.
        </p><br/>

        <h4>Example 2: Lambda Function for Squaring a Number</h4>
        <pre>
          <code>
            {`square = lambda x: x ** 2`}
          </code>
        </pre>
        <p>This function takes one parameter <code>x</code> and returns <code>x</code> squared.</p><br/>

        <h4>Example 3: Lambda Function with No Parameters</h4>
        <pre>
          <code>
            {`greet = lambda: "Hello, World!"`}
          </code>
        </pre>
        <p>This lambda function doesn't take any arguments but returns a simple string.</p><br/>

        <h4>Example 4: Using Lambda with map()</h4>
        <pre>
          <code>
            {`numbers = [1, 2, 3, 4]`}
            <br />
            {`squared = list(map(lambda x: x ** 2, numbers))`}
          </code>
        </pre>
        <p>
          The <code>map()</code> function applies the lambda function to each element of the list <code>numbers</code>.
        </p><br/>

        <h4>Example 5: Using Lambda with filter()</h4>
        <pre>
          <code>
            {`numbers = [1, 2, 3, 4, 5, 6]`}
            <br />
            {`even_numbers = list(filter(lambda x: x % 2 == 0, numbers))`}
          </code>
        </pre>
        <p>
          The <code>filter()</code> function uses the lambda function to test if each element is even.
        </p><br/>

        <h3>When to Use Lambda Functions</h3>
        <ul>
          <li>You need a quick, simple function.</li><br/>
          <li>You don’t want to define a full function with the <code>def</code> keyword.</li><br/>
          <li>You need a function for short-term use, especially as an argument to functions like <code>map()</code>, <code>filter()</code>, or <code>sorted()</code>.</li>
        </ul><br/>

        <h3>Conclusion</h3>
        <p>
          Lambda functions in Python provide a compact and efficient way to define simple functions.
          They can take multiple arguments but only evaluate one expression. They are particularly
          useful in functional programming scenarios where you want to apply functions on the fly
          without defining them separately.
        </p>
      </div>
)}



        {selectedChapter === 'chapter52' && (
        <div className={style.chaptercontent}>
        <h1 className={style.heading}>  Classes and Objects  </h1>

      <h3>What are Classes and Objects?</h3>
      <p><strong>Class</strong>: A class in Python is like a blueprint for creating objects. It defines the attributes (characteristics) and methods (functions) that the objects will have.</p>
      <p><strong>Object</strong>: An object is an instance of a class. It is the actual entity that is created from the class blueprint. Each object can have its own unique data (attributes) but will share the same behavior (methods) defined in the class.</p>
      <br/>
      <h3>How to Define a Class and Create Objects?</h3>
      <p>Let’s create a simple <code>Dog</code> class and explain the concepts of attributes and methods:</p>
      <pre>
        <code>
          {`# Define a class called Dog
class Dog:
    # Constructor to initialize object attributes
    def __init__(self, name, breed, age):
        self.name = name  # The dog's name
        self.breed = breed  # The dog's breed
        self.age = age  # The dog's age
    
    # Method to display information about the dog
    def display_info(self):
        return f"{self.name} is a {self.age}-year-old {self.breed}."`}
        </code>
      </pre><br/>

      <h3>Creating Objects (Instances)</h3>
      <p>Now that we have the <code>Dog</code> class, we can create multiple <strong>objects</strong> (individual dogs) based on the class:</p>
      <pre>
        <code>
          {`# Create objects (instances) of the Dog class
dog1 = Dog("Buddy", "Golden Retriever", 3)
dog2 = Dog("Max", "Bulldog", 5)

# Accessing methods and attributes
print(dog1.display_info())  # Output: Buddy is a 3-year-old Golden Retriever.
print(dog2.display_info())  # Output: Max is a 5-year-old Bulldog.`}
        </code>
      </pre><br/>

      <h3>Explanation of the Code</h3>
      <p>- <strong>Class Definition</strong>: We defined a <code>Dog</code> class with:</p>
      <ul>
        <li><strong>Attributes</strong> (<code>name</code>, <code>breed</code>, <code>age</code>) to store information about the dog.</li>
        <li><strong>Method</strong> (<code>display_info()</code>) to display the dog's details.</li>
      </ul>
      <p>- <strong>Object Creation</strong>: We created two objects: <code>dog1</code> and <code>dog2</code>, each with its own data.</p><br/>

      <h3>What is the <code>__init__()</code> Method?</h3>
      <p>The <code>__init__()</code> method in Python is a special method (also called a <strong>constructor</strong>) used to initialize the attributes of an object when it is created. It runs automatically when an object is instantiated from the class.</p>
      <p><strong>Purpose:</strong> It’s used to set up the initial state of an object.</p>
      <p><strong>Syntax:</strong></p>
      <pre>
        <code>
          {`def __init__(self, parameters):
    # Initialization code`}
        </code>
      </pre><br/>

      <p>In the example above, the <code>__init__()</code> method is used to set the initial values for <code>name</code>, <code>breed</code>, and <code>age</code> when we create a new <code>Dog</code> object.</p>

      <h3>Example of <code>__init__()</code> Method</h3>
      <pre>
        <code>
          {`class Dog:
    def __init__(self, name, breed, age):
        self.name = name
        self.breed = breed
        self.age = age

# Creating an object
dog1 = Dog("Buddy", "Golden Retriever", 3)

# Accessing the attributes
print(dog1.name)  # Output: Buddy
print(dog1.breed)  # Output: Golden Retriever
print(dog1.age)  # Output: 3`}
        </code>
      </pre><br/>

      <h3>What is the <code>__str__()</code> Method?</h3>
      <p>The <code>__str__()</code> method is another special method that defines the string representation of an object. It’s called when you print an object or when the object is converted to a string.</p>
      <p><strong>Purpose:</strong> It provides a user-friendly or readable string description of an object.</p>
      <p><strong>Syntax:</strong></p>
      <pre>
        <code>
          {`def __str__(self):
    return "String representation of the object"`}
        </code>
      </pre>

      <p>Let’s add the <code>__str__()</code> method to our <code>Dog</code> class for a better string representation:</p><br/>

      <h3>Example of <code>__str__()</code> Method</h3>
      <pre>
        <code>
          {`class Dog:
    def __init__(self, name, breed, age):
        self.name = name
        self.breed = breed
        self.age = age

    # __str__ method to define a string representation of the object
    def __str__(self):
        return f"{self.name} is a {self.age}-year-old {self.breed}."

# Creating an object
dog1 = Dog("Buddy", "Golden Retriever", 3)

# Printing the object will now call the __str__ method
print(dog1)  # Output: Buddy is a 3-year-old Golden Retriever.`}
        </code>
      </pre><br/>

      <h3>Modifying and Deleting Objects</h3>

      <h4>Modifying Object Attributes</h4>
      <p>You can modify an object’s attributes directly by assigning new values to them:</p>
      <pre>
        <code>
          {`# Modifying the dog's age
dog1.age = 4
print(dog1.display_info())  # Output: Buddy is a 4-year-old Golden Retriever.`}
        </code>
      </pre><br/>

      <h4>Deleting Object Attributes</h4>
      <p>You can delete an object’s attribute using the <code>del</code> keyword:</p>
      <pre>
        <code>
          {`# Deleting the 'age' attribute of dog1
del dog1.age`}
        </code>
      </pre><br/>

      <h4>Deleting an Entire Object</h4>
      <p>You can delete an entire object using the <code>del</code> keyword. This removes the object from memory:</p>
      <pre>
        <code>
          {`# Deleting the dog1 object
del dog1

# Trying to print dog1 now will raise an error since it no longer exists
# print(dog1)  # This will raise a NameError`}
        </code>
      </pre><br/>

      <h3>Full Example: Combining Everything</h3>
      <pre>
        <code>
          {`class Dog:
    # Constructor to initialize the object attributes
    def __init__(self, name, breed, age):
        self.name = name
        self.breed = breed
        self.age = age

    # Method to display information about the dog
    def display_info(self):
        return f"{self.name} is a {self.age}-year-old {self.breed}."

    # String representation of the dog object
    def __str__(self):
        return f"{self.name} is a {self.age}-year-old {self.breed}."

# Create objects
dog1 = Dog("Buddy", "Golden Retriever", 3)
dog2 = Dog("Max", "Bulldog", 5)

# Access methods
print(dog1.display_info())  # Output: Buddy is a 3-year-old Golden Retriever.

# Modify attributes
dog1.age = 4
print(dog1.display_info())  # Output: Buddy is a 4-year-old Golden Retriever.

# Delete an attribute
del dog1.age

# Try printing after deletion (will raise an error)
# print(dog1.display_info())  # Will raise an error because 'age' is deleted

# Delete the entire object
del dog1

# Try accessing dog1 after deletion (will raise an error)
# print(dog1)  # Will raise NameError since dog1 is deleted`}
        </code>
      </pre><br/>

      <h3>Conclusion</h3>
      <ul>
        <li><strong>Classes</strong> define the structure and behavior of objects.</li><br/>
        <li><strong>Objects</strong> are instances of classes, with their own data.</li><br/>
        <li><strong>__init__()</strong> initializes the attributes of an object when it is created.</li><br/>
        <li><strong>__str__()</strong> provides a user-friendly string representation of an object.</li><br/>
        <li>You can <strong>modify</strong> attributes, <strong>delete</strong> attributes, or even <strong>delete objects</strong> entirely.</li>
      </ul><br/>

      <p>This should give you a good understanding of how to use classes, objects, and special methods in Python!</p>
    </div>
  )}





      {selectedChapter === 'chapter53' && (
        <div className={style.chapterContent}>
          <h1 className={style.heading}>Polymorphism in Python</h1>

          <p>
            <strong>Polymorphism</strong> is a concept in object-oriented programming (OOP) that means "many forms."
            It allows objects of different classes to be treated as objects of a common superclass. Essentially,
            polymorphism lets us use the same method or function name in different ways depending on the object
            it is acting upon.
          </p>

          <p>
            Polymorphism is particularly useful when we need to perform similar operations on different types of objects
            without worrying about the specific class they belong to.
          </p>

          <h2>Types of Polymorphism in Python</h2>
          <ol>
            <li>Method Overloading (Python does not support this natively, but we can achieve similar behavior)</li><br/>
            <li>Method Overriding</li><br/>
            <li>Operator Overloading</li>
          </ol><br/>

          <h3>1. Method Overloading in Python (Achieving Similar Behavior)</h3>
          <p>
            In some languages, <strong>method overloading</strong> allows the same method name to be used with different
            arguments. However, Python does not support true method overloading because it doesn’t have a way to
            distinguish between methods based on argument types or numbers.
          </p>

          <p>We can create similar behavior by using default values or handling variable arguments with <code>*args</code> and <code>**kwargs</code>.</p>

          <pre>
            <code>
              {`class MathOperations:
    def add(self, a, b, c=0):
        return a + b + c

# Create an object of MathOperations
math_op = MathOperations()

# Call add method with 2 arguments
print(math_op.add(5, 10))  # Output: 15

# Call add method with 3 arguments
print(math_op.add(5, 10, 15))  # Output: 30`}
            </code>
          </pre><br/>

          <h3>2. Method Overriding</h3>
          <p>
            <strong>Method overriding</strong> allows a subclass to provide a specific implementation of a method that
            is already defined in its superclass. This is useful when we want a subclass to behave differently for a
            method that is shared with the parent class.
          </p>

          <pre>
            <code>
              {`class Animal:
    def speak(self):
        return "Animal speaks in some way."

class Dog(Animal):
    def speak(self):
        return "Woof!"

class Cat(Animal):
    def speak(self):
        return "Meow!"

# Create objects of Dog and Cat
dog = Dog()
cat = Cat()

print(dog.speak())  # Output: Woof!
print(cat.speak())  # Output: Meow!`}
            </code>
          </pre><br/>

          <h3>3. Operator Overloading</h3>
          <p>
            <strong>Operator overloading</strong> allows us to define the behavior of operators (<code>+</code>, <code>-</code>,
            <code>*</code>, etc.) for our own classes. In Python, operators like <code>+</code> and <code>*</code> can
            be overloaded by defining special methods in classes.
          </p>

          <pre>
            <code>
              {`class Book:
    def __init__(self, title, pages):
        self.title = title
        self.pages = pages

    # Overloading the + operator
    def __add__(self, other):
        return self.pages + other.pages

# Create two Book objects
book1 = Book("Book One", 300)
book2 = Book("Book Two", 200)

# Use the + operator to add pages of two books
total_pages = book1 + book2
print(f"Total pages: {total_pages}")  # Output: Total pages: 500`}
            </code>
          </pre><br/>

          <h3>Polymorphism with Functions and Methods</h3>
          <p>
            Polymorphism in Python can also be achieved by defining functions or methods that work with different types
            of objects. As long as these objects implement certain methods, they can be passed to the same function,
            showcasing polymorphism.
          </p>

          <pre>
            <code>
              {`class Dog:
    def sound(self):
        return "Woof!"

class Cat:
    def sound(self):
        return "Meow!"

class Cow:
    def sound(self):
        return "Moo!"

# A function that accepts any object with a sound method
def animal_sound(animal):
    return animal.sound()

# Using the function with different types of objects
dog = Dog()
cat = Cat()
cow = Cow()

print(animal_sound(dog))  # Output: Woof!
print(animal_sound(cat))  # Output: Meow!
print(animal_sound(cow))  # Output: Moo!`}
            </code>
          </pre><br/>

          <h3>Polymorphism with Class Methods</h3>
          <p>
            A similar approach can be used within classes to support polymorphism by defining common methods that subclasses
            override.
          </p>

          <pre>
            <code>
              {`class Shape:
    def area(self):
        pass

class Rectangle(Shape):
    def __init__(self, length, width):
        self.length = length
        self.width = width

    def area(self):
        return self.length * self.width

class Circle(Shape):
    def __init__(self, radius):
        self.radius = radius

    def area(self):
        return 3.14 * self.radius ** 2

# Create objects of Rectangle and Circle
rectangle = Rectangle(5, 3)
circle = Circle(4)

# Use the area method polymorphically
print(f"Rectangle area: {rectangle.area()}")  # Output: Rectangle area: 15
print(f"Circle area: {circle.area()}")        # Output: Circle area: 50.24`}
            </code>
          </pre><br/>

          <h3>Key Takeaways</h3>
          <ul>
            <li><strong>Polymorphism</strong> allows a single interface to be used with different types of objects, making code more flexible and easier to extend.</li><br/>
            <li><strong>Method Overloading</strong> in Python isn’t directly supported, but similar behavior can be achieved using default parameters or <code>*args</code>.</li><br/>
            <li><strong>Method Overriding</strong> allows subclasses to provide specific implementations of methods defined in a superclass.</li><br/>
            <li><strong>Operator Overloading</strong> uses special methods (like <code>__add__</code> and <code>__mul__</code>) to allow operators to work with user-defined classes.</li><br/>
            <li><strong>Polymorphic Functions</strong> and <strong>Class Methods</strong> can work with any objects that share common methods, regardless of the actual class they belong to.</li>
          </ul><br/>

          <p>
            This concept is very powerful in Python as it enables you to write more generic and reusable code. By understanding polymorphism,
            you can make your classes and functions more flexible to accommodate different data types and behaviors.
          </p>
        </div>
      )}
    



      
        {selectedChapter === 'chapter54' && (
        <div className={style.chaptercontent}>
        <h1 className={style.heading}>Encapsulation in Python</h1>

          <h3>Encapsulation in Python</h3>
          <p>
            <strong>Encapsulation</strong> is a core concept in object-oriented programming (OOP) that focuses on bundling data
            (attributes) and methods (functions) that operate on that data within a single unit, called a class. This keeps
            data safe from direct access and modification by outside code, promoting better control and security.
          </p>
          <p>
            In Python, encapsulation is often achieved by making certain attributes or methods <strong>private</strong> or
            <strong>protected</strong>. This prevents unintended access or changes from outside the class, allowing controlled
            interaction with data.
          </p><br/>

          <h4>Why Encapsulation is Important</h4>
          <ul>
            <li><strong>Data Protection:</strong> It prevents external interference with internal data.</li>
            <li><strong>Controlled Access:</strong> You can control how data is accessed or modified.</li>
            <li><strong>Code Organization:</strong> It keeps related attributes and methods together, making code easier to understand and maintain.</li>
          </ul><br/>

          <h4>Implementing Encapsulation in Python</h4>
          <p>
            Python doesn’t have strict access modifiers like some other languages. However, we can still control access to class attributes and methods using naming conventions.
          </p>
          <ul>
            <li><strong>Public Attributes:</strong> Accessible from outside the class. Defined with a regular name (e.g., <code>self.name</code>).</li><br/>
            <li><strong>Protected Attributes:</strong> Meant to be used within the class and subclasses. Defined with a single underscore (e.g., <code>self._balance</code>).</li><br/>
            <li><strong>Private Attributes:</strong> Restricted to the class itself. Defined with a double underscore (e.g., <code>self.__salary</code>).</li>
          </ul><br/>

          <h4>Examples</h4>
          <h5>Public and Private Attributes</h5>
          <p>In the following example, we’ll see how encapsulation works to manage access to data.</p>

          <pre className={style.code}>
            <code>{`
class BankAccount:
    def __init__(self, account_holder, balance):
        self.account_holder = account_holder  # Public attribute
        self.__balance = balance  # Private attribute

    # Public method to access the private balance attribute
    def get_balance(self):
        return self.__balance

    # Public method to update the balance in a controlled way
    def deposit(self, amount):
        if amount > 0:
            self.__balance += amount
            print(f"Deposited {amount}. New balance: {self.__balance}")
        else:
            print("Amount must be positive.")

# Creating an object of BankAccount
account = BankAccount("John Doe", 1000)

# Accessing public attribute
print(account.account_holder)  # Output: John Doe

# Accessing private attribute (will raise an error if accessed directly)
# print(account.__balance)  # Raises AttributeError

# Accessing private attribute through a public method
print(account.get_balance())  # Output: 1000

# Modifying the balance using a public method
account.deposit(500)  # Output: Deposited 500. New balance: 1500
            `}</code>
          </pre>

          <p>
            In this example:
            <ul>
              <li><code>account_holder</code> is a public attribute, accessible from outside the class.</li>
              <li><code>__balance</code> is a private attribute, hidden from direct access. It can only be accessed or modified through public methods (<code>get_balance()</code> and <code>deposit()</code>), ensuring controlled interaction.</li>
            </ul>
          </p><br/>

          <h5>Protected Attributes</h5>
          <p>Protected attributes (e.g., <code>_balance</code>) are accessible within the class and any subclasses but are generally not meant to be accessed directly from outside.</p>

          <pre className={style.code}>
            <code>{`
class Employee:
    def __init__(self, name, salary):
        self.name = name  # Public attribute
        self._salary = salary  # Protected attribute

class Manager(Employee):
    def show_salary(self):
        print(f"{self.name}'s salary is {self._salary}")

manager = Manager("Alice", 5000)
manager.show_salary()  # Output: Alice's salary is 5000
            `}</code>
          </pre>

          <p>
            In this case, <code>_salary</code> is a protected attribute, meaning it can be accessed by subclasses like <code>Manager</code>, but it’s not intended to be accessed directly from outside.
          </p><br/>

          <h4>Summary</h4>
          <ul>
            <li><strong>Encapsulation</strong> helps to protect and control access to class data.</li><br/>
            <li>In Python, private attributes are prefixed with <code>__</code> and protected ones with <code>_</code>.</li><br/>
            <li>Access and modifications to private attributes are managed through <strong>public methods</strong> to maintain control over data.</li>
          </ul><br/>

          <p>This approach helps make classes more robust, secure, and easier to maintain.</p>
        </div>
      )}
   




   
         {selectedChapter === 'chapter55' && (
         <div className={style.chaptercontent}>
         <h1 className={style.heading}>  Inheritance  </h1>

        <p>
          Inheritance is a fundamental concept in object-oriented programming (OOP) that allows one class to inherit attributes and methods from another class.
          This concept is particularly useful in Python and other OOP languages because it helps reduce code repetition and allows for better organization and reuse of code. Let’s break it down in a simple and detailed way.
        </p><br/>

        <h3>What is Inheritance?</h3>
        <p>
          In Python, inheritance allows a new class (known as the <strong>child class</strong> or <strong>subclass</strong>) to inherit properties (attributes and methods) from an existing class
          (known as the <strong>parent class</strong> or <strong>superclass</strong>). This means that the child class can use, extend, or modify the functionality of the parent class without having to write all the code from scratch.
        </p><br/>

        <h3>Why Use Inheritance?</h3>
        <ul>
          <li><strong>Reusability:</strong> You can reuse code from existing classes, which makes your programs shorter and easier to read.</li><br/>
          <li><strong>Organized Code:</strong> Inheritance structures code in a hierarchy, making it clear which classes serve as "base" classes and which build upon them.</li><br/>
          <li><strong>Ease of Modification:</strong> Changes made in the parent class are automatically available in the child class, which makes updating code more efficient.</li><br/>
          <li><strong>Extendability:</strong> You can add new features to the child class while maintaining the core structure inherited from the parent.</li>
        </ul><br/>

        <h3>How Inheritance Works in Python</h3>
        <p>
          In Python, to create a child class that inherits from a parent class, you place the parent class name in parentheses after the child class name. Here’s a basic structure of how it works:
        </p>

        <pre>
          <code>
            {`class ParentClass:\n  # Attributes and methods of the parent class\n  pass\n\nclass ChildClass(ParentClass):\n  # Additional attributes and methods for the child class\n  pass`}
          </code>
        </pre>

        <ul>
          <li><strong>ParentClass:</strong> The class that contains attributes and methods you want to share with other classes.</li><br/>
          <li><strong>ChildClass(ParentClass):</strong> This class inherits from <code>ParentClass</code>. It can access and use everything in <code>ParentClass</code>, and you can also add new attributes and methods unique to <code>ChildClass</code>.</li>
        </ul><br/>

        <h3>Example of Inheritance in Python</h3>
        <p>Here’s an example to illustrate inheritance with a <code>Person</code> parent class and a <code>Student</code> child class.</p>

        <pre>
          <code>
            {`# Parent Class\nclass Person:\n  def __init__(self, name, age):\n    self.name = name\n    self.age = age\n\n  def introduce(self):\n    return f"My name is {self.name} and I am {self.age} years old."\n\n# Child Class inheriting from Person\nclass Student(Person):\n  def __init__(self, name, age, student_id):\n    super().__init__(name, age)\n    self.student_id = student_id\n\n  def study(self):\n    return f"{self.name} is studying with student ID {self.student_id}."\n\n# Create a Student object\nstudent = Student("Alice", 20, "S12345")\n\nprint(student.introduce())  # Output: My name is Alice and I am 20 years old.\nprint(student.study())  # Output: Alice is studying with student ID S12345.`}
          </code>
        </pre><br/>

        <h3>Explanation of the Code</h3>
        <ul>
          <li><strong>Person Class (Parent):</strong> This is the parent class with two attributes, <code>name</code> and <code>age</code>, and a method <code>introduce()</code> that describes the person.</li><br/>
          <li><strong>Student Class (Child):</strong> This child class inherits from <code>Person</code> and uses <code>super()</code> to call the parent class's <code>__init__</code> method. <code>Student</code> adds its own attribute, <code>student_id</code>, and a new method, <code>study()</code>.</li><br/>
          <li><strong>Using <code>super()</code>:</strong> The <code>super()</code> function lets us call methods or access attributes from the parent class, allowing the child class to extend or modify them if needed.</li>
        </ul><br/>

        <h3>Types of Inheritance in Python</h3>
        <ul>
          <li><strong>Single Inheritance:</strong> A child class inherits from only one parent class.</li><br/>
          <li><strong>Multiple Inheritance:</strong> A child class inherits from multiple parent classes.</li><br/>
          <li><strong>Multilevel Inheritance:</strong> A child class inherits from a parent class, and another class can inherit from this child class.</li><br/>
          <li><strong>Hierarchical Inheritance:</strong> Multiple child classes inherit from a single parent class.</li><br/>
          <li><strong>Hybrid Inheritance:</strong> A mix of two or more types of inheritance.</li>
        </ul><br/>

        <h3>Summary of Key Points</h3>
        <ul>
          <li><strong>Inheritance</strong> allows child classes to inherit properties and methods from parent classes.</li><br/>
          <li>It’s useful for reusing code, organizing it in a hierarchy, and making future modifications easier.</li><br/>
          <li>In Python, you use inheritance by defining the child class with the parent class in parentheses.</li><br/>
          <li><strong>super()</strong> is a special function to call the parent class’s methods, often used in initializers.</li>
        </ul><br/>

        <h3>Example Recap</h3>
        <p>
          With inheritance, we’re able to build the <code>Student</code> class upon the <code>Person</code> class, reusing and extending the functionality of <code>Person</code> instead of starting from scratch. This provides a cleaner, more organized code structure that can be expanded upon easily.
        </p>
      </div>
)}






      {selectedChapter === 'chapter56' && (
      <div className={style.chaptercontent}>
      <h1 className={style.heading}>Data Abstraction in Python</h1>

          <p>
            <strong>Data Abstraction</strong> is a fundamental concept in object-oriented programming (OOP) that allows the user to interact with an object without needing to know its internal workings. In simple terms, <strong>abstraction</strong> involves hiding the complexity of the system and only exposing the necessary details. The main goal of data abstraction is to reduce complexity and improve efficiency by showing only relevant information to the user.
          </p><br/>

          <h3>Key Concepts of Data Abstraction</h3>
          <ul>
            <li><strong>Hiding Implementation Details</strong>: Abstraction hides unnecessary details and only shows the essential features.</li><br/>
            <li><strong>Public Interface</strong>: The user interacts with an object using its public interface, which is a set of methods or functions that allow access to the object’s data or functionality.</li><br/>
            <li><strong>Encapsulation</strong>: This is closely related to abstraction. While abstraction hides complexity, encapsulation binds data and the methods that operate on the data together.</li>
          </ul><br/>

          <h3>Benefits of Data Abstraction</h3>
          <ul>
            <li><strong>Simplifies the Complex System</strong>: By hiding the inner workings, abstraction makes the code simpler to understand and use.</li><br/>
            <li><strong>Improves Security</strong>: Internal object details are hidden, preventing unauthorized access or modification.</li><br/>
            <li><strong>Reduces Redundancy</strong>: Abstraction allows code reuse by providing generalized operations that can be applied to different classes.</li>
          </ul><br/>

          <h3>How Data Abstraction Works in Python</h3>
          <p>
            In Python, we can achieve data abstraction through the use of abstract classes and abstract methods. An <strong>abstract class</strong> is a class that cannot be instantiated directly and must be subclassed by other classes. <strong>Abstract methods</strong> are methods that are declared in the abstract class but don’t have a defined implementation. These methods must be overridden in any subclass.
          </p>
          <p>Python provides the <code>abc</code> (Abstract Base Class) module to define abstract classes and methods.</p><br/>

          <h3>Example of Data Abstraction in Python</h3>
          <pre><code>{`
from abc import ABC, abstractmethod

# Abstract class
class Animal(ABC):
    @abstractmethod
    def sound(self):
        pass
    
    @abstractmethod
    def move(self):
        pass

# Child class 1
class Dog(Animal):
    def sound(self):
        return "Bark"
    
    def move(self):
        return "Run"

# Child class 2
class Bird(Animal):
    def sound(self):
        return "Chirp"
    
    def move(self):
        return "Fly"

# Creating instances of child classes
dog = Dog()
bird = Bird()

# Accessing methods
print(f"Dog sound: {dog.sound()} and Dog moves by: {dog.move()}")
print(f"Bird sound: {bird.sound()} and Bird moves by: {bird.move()}")
          `}</code></pre><br/>

          <h3>Explanation of the Example</h3>
          <p>1. <strong>Abstract Class (<code>Animal</code>)</strong>: The <code>Animal</code> class is an abstract class because it inherits from <code>ABC</code> (Abstract Base Class). It contains two abstract methods, <code>sound()</code> and <code>move()</code>. These methods are not implemented in the <code>Animal</code> class and must be implemented by any subclass. The <code>@abstractmethod</code> decorator is used to define abstract methods.</p>
          <p>2. <strong>Child Classes (<code>Dog</code> and <code>Bird</code>)</strong>: Both the <code>Dog</code> and <code>Bird</code> classes inherit from the <code>Animal</code> class and implement the <code>sound()</code> and <code>move()</code> methods. The <code>Dog</code> class defines that a dog barks and runs, while the <code>Bird</code> class defines that a bird chirps and flies.</p>
          <p>3. <strong>Creating Objects</strong>: We create objects of the <code>Dog</code> and <code>Bird</code> classes and call their <code>sound()</code> and <code>move()</code> methods, which return the respective behaviors of the animals.</p>

          <h3>Output:</h3>
          <pre><code>
Dog sound: Bark and Dog moves by: Run
Bird sound: Chirp and Bird moves by: Fly
          </code></pre><br/>

          <h3>Explanation of the Code</h3>
          <p><strong>Abstraction in Action</strong>: The <code>Animal</code> class does not specify how <code>sound()</code> and <code>move()</code> should behave. It simply defines the <strong>interface</strong> (what the methods should do). The actual implementation of these methods is provided by the subclasses, <code>Dog</code> and <code>Bird</code>.</p>
          <p><strong>Flexibility</strong>: The user can now work with the <code>Animal</code> class in a more abstract manner without worrying about how the sound or movement is implemented. The classes <code>Dog</code> and <code>Bird</code> have their own specific implementations of these methods.</p>
          <br/>
          <h3>More Detailed Explanation</h3>
          <p>In the example above:</p>
          <ol>
            <li><strong>Abstract Base Class (ABC)</strong>: We use Python’s <code>abc</code> module to create an abstract class. The abstract class provides the blueprint for other classes. An abstract class cannot be instantiated directly, which is why trying to create an instance of <code>Animal</code> would result in an error.</li><br/>
            <li><strong>Abstract Methods</strong>: Abstract methods are methods that are defined in the abstract class but do not have a body (implementation). They only specify what the method should do, leaving it up to the child class to define how it should be done.</li><br/>
            <li><strong>Overriding Methods</strong>: In the <code>Dog</code> and <code>Bird</code> classes, we override the abstract methods. This is where we provide the actual implementation of the methods that were defined in the abstract base class.</li><br/>
            <li><strong>Polymorphism</strong>: Notice that both <code>Dog</code> and <code>Bird</code> objects can be treated as <code>Animal</code> objects because they share the same interface (the <code>sound()</code> and <code>move()</code> methods). This is an example of <strong>polymorphism</strong>—the ability to treat objects of different classes in a uniform way.</li>
          </ol><br/>

          <h3>Real-Life Example of Data Abstraction</h3>
          <pre><code>{`
from abc import ABC, abstractmethod

class Car(ABC):
    @abstractmethod
    def start_engine(self):
        pass
    
    @abstractmethod
    def drive(self):
        pass
    
    @abstractmethod
    def stop_engine(self):
        pass

class Sedan(Car):
    def start_engine(self):
        return "Sedan engine started"
    
    def drive(self):
        return "Sedan is driving"
    
    def stop_engine(self):
        return "Sedan engine stopped"

class SUV(Car):
    def start_engine(self):
        return "SUV engine started"
    
    def drive(self):
        return "SUV is driving"
    
    def stop_engine(self):
        return "SUV engine stopped"

# Creating objects
sedan = Sedan()
suv = SUV()

print(sedan.start_engine())
print(suv.drive())
          `}</code></pre><br/>

          <h3 style={{paddingBottom:"6px"}}>Advantages of Data Abstraction</h3>
          <ul>
            <li><strong>Simplified Interface</strong>: Users can interact with the class through a simplified interface without knowing the details of its implementation.</li><br/>
            <li><strong>Security</strong>: Hiding the internal implementation helps protect sensitive data from being directly accessed or modified.</li><br/>
            <li><strong>Maintainability</strong>: Since the internal implementation is abstracted, changes to the underlying implementation won’t affect the way the user interacts with the object.</li>
          </ul><br/>

          <h3>Conclusion</h3>
          <p>Data abstraction in Python allows you to hide the complexity of the underlying system and provide only the necessary details to the user. By using abstract classes and methods, Python allows you to define a clear and simple interface while allowing subclasses to handle specific implementations. This improves code organization, reusability, and security.</p>
        </div>
      )}




              {selectedChapter === 'chapter57' && (
              <div className={style.chaptercontent}>
              <h1 className={style.heading}> Python Iterators  </h1>
          <p>
            In Python, <strong>iterators</strong> are objects that allow you to iterate over a sequence (like lists, tuples, dictionaries, sets, etc.) one element at a time. Iterators are used in loops and other structures that require sequential access to data.
          </p><br/>

          <h3 style={{paddingBottom:"6px"}}>Key Concepts of Iterators</h3>
          <ul>
            <li><strong>Iterator Object</strong>: An object is called an iterator if it implements two methods:
              <ul><br/>
                <li><code>__iter__()</code>: This method returns the iterator object itself. It is required for an object to be an iterator.</li><br/>
                <li><code>__next__()</code>: This method returns the next item in the sequence. If there are no more items, it raises the <code>StopIteration</code> exception.</li>
              </ul><br/>
            </li>
            <li><strong>Iterable</strong>: An iterable is any object that can return an iterator. Examples include lists, tuples, dictionaries, and strings. You can convert any iterable into an iterator using the <code>iter()</code> function.</li><br/>
            <li><strong><code>StopIteration</code></strong>: This exception is raised when there are no more items to return, signaling the end of the iteration.</li>
          </ul><br/>

          <h3>Example of an Iterator in Python</h3>
          <pre><code>{`
# Creating an iterator from a list
numbers = [1, 2, 3, 4]
iterator = iter(numbers)  # 'iter()' converts an iterable to an iterator

# Using the iterator
print(next(iterator))  # 1
print(next(iterator))  # 2
print(next(iterator))  # 3
print(next(iterator))  # 4
# The next call will raise StopIteration
# print(next(iterator))  # Uncommenting this will raise StopIteration
          `}</code></pre><br/>

          <h3>Custom Iterator Example</h3>
          <p>You can also create your own iterator by defining a class with <code>__iter__()</code> and <code>__next__()</code> methods.</p>
          <pre><code>{`
class Countdown:
    def __init__(self, start):
        self.start = start

    def __iter__(self):
        self.current = self.start
        return self

    def __next__(self):
        if self.current <= 0:
            raise StopIteration
        else:
            self.current -= 1
            return self.current

# Using the custom iterator
countdown = Countdown(5)
for number in countdown:
    print(number)
          `}</code></pre>

          <h3>Output:</h3>
          <pre><code>
4
3
2
1
0
          </code></pre><br/>

          <h3>Iterators in Loops</h3>
          <p>You can directly use iterators in loops such as <code>for</code> loops, which internally handle the <code>StopIteration</code> exception:</p>
          <pre><code>{`
for number in Countdown(5):
    print(number)
          `}</code></pre><br/>

          <h3>Advantages of Iterators</h3>
          <ul>
            <li><strong>Memory Efficient</strong>: Iterators don’t require storing all elements in memory. They generate values one by one when needed, making them efficient for working with large datasets.</li><br/>
            <li><strong>Lazy Evaluation</strong>: Values are produced only when requested (on-demand), which helps in optimizing performance.</li>
          </ul><br/>

          <h3>Conclusion</h3>
          <p>In Python, iterators provide a way to access elements of a collection one at a time, allowing efficient traversal of large data sets. By implementing the <code>__iter__()</code> and <code>__next__()</code> methods, you can create custom iterators, and Python’s built-in <code>for</code> loop and functions like <code>iter()</code> and <code>next()</code> make using iterators easy.</p>
        </div>
)}




      {selectedChapter === 'chapter58' && (
         <div className={style.chaptercontent}>
          <h1 className={style.heading}>Python Scope</h1>

    <p>
      In Python, <strong>scope</strong> refers to the region of a program where a particular variable can be accessed or modified. There are different types of scopes based on where variables are defined, and Python follows the LEGB rule for variable resolution.
    </p><br/>

    <h3>Types of Scope</h3>
    <ol>
      <li><strong>Local Scope</strong>: This is the scope inside a function or block. Variables defined within a function are accessible only within that function.</li><br/>
      <li><strong>Enclosing Scope</strong>: This refers to the scope of any enclosing functions. It is relevant for nested functions.</li><br/>
      <li><strong>Global Scope</strong>: Variables defined at the top level of a script or module are in the global scope. They are accessible throughout the program.</li><br/>
      <li><strong>Built-in Scope</strong>: This scope contains all built-in names in Python, like <code>print()</code>, <code>len()</code>, and others.</li>
    </ol><br/>

    <h3>LEGB Rule</h3>
    <p>Python follows the LEGB rule to resolve names:</p>
    <ol>
      <li><strong>Local</strong>: Looks in the local scope first (inside the function).</li><br/>
      <li><strong>Enclosing</strong>: Looks in the enclosing scope (if there's a nested function).</li><br/>
      <li><strong>Global</strong>: Then looks in the global scope (top-level of the script).</li><br/>
      <li><strong>Built-in</strong>: Finally, looks in the built-in scope.</li>
    </ol><br/>

    <h3>Example 1: Local Scope</h3>
    <pre>
      <code>{`
def example_function():
    x = 10  # Local variable
    print(x)

example_function()  # Output: 10
# print(x)  # This would cause an error, as x is not defined in the global scope.
      `}</code>
    </pre>
    <p>In this example, the variable <code>x</code> is defined within the function <code>example_function()</code>, so it's only accessible inside the function (local scope).</p>
    <br/>
    <h3>Example 2: Global Scope</h3>
    <pre>
      <code>{`
x = 20  # Global variable

def example_function():
    print(x)  # Accessing the global variable

example_function()  # Output: 20
print(x)  # Output: 20 (x is accessible globally)
      `}</code>
    </pre>
    <p>Here, <code>x</code> is defined in the global scope, so it can be accessed both inside and outside the function.</p><br/>

    <h3>Example 3: Enclosing Scope (Nested Functions)</h3>
    <pre>
      <code>{`
def outer_function():
    y = 30  # Enclosing variable
    
    def inner_function():
        print(y)  # Accessing the enclosing variable
        
    inner_function()

outer_function()  # Output: 30
      `}</code>
    </pre>
    <p>In this case, the variable <code>y</code> is defined in the outer function and is accessible within the inner function. This is an example of <strong>enclosing scope</strong>.</p>
    <br/>
    <h3>Example 4: Built-in Scope</h3>
    <pre>
      <code>{`
print(len([1, 2, 3]))  # Output: 3
      `}</code>
    </pre>
    <p>Here, <code>len()</code> is a built-in function in Python, and it's accessible anywhere in your code, as it's in the <strong>built-in scope</strong>.</p>
    <br/>
    <h3>Example 5: Modifying Global Variables (Global Scope)</h3>
    <pre>
      <code>{`
x = 50  # Global variable

def change_global():
    global x  # Declare x as global to modify it
    x = 100  # Modifies the global x

change_global()
print(x)  # Output: 100
      `}</code>
    </pre>
    <p>The <code>global</code> keyword is used to modify a global variable from within a function. Without it, the function would create a new local variable <code>x</code>.</p>
    <br/>
    <h3>Conclusion</h3>
    <ul>
      <li><strong>Local variables</strong> are defined inside functions and can only be accessed within those functions.</li><br/>
      <li><strong>Global variables</strong> are defined outside of functions and can be accessed anywhere in the program.</li><br/>
      <li><strong>Enclosing scopes</strong> occur in nested functions, where the inner function can access variables from the outer function.</li><br/>
      <li>Python resolves variable names using the <strong>LEGB</strong> (Local, Enclosing, Global, Built-in) rule, prioritizing local scopes and moving outward.</li>
    </ul><br/>

    <p>This hierarchical structure ensures that Python correctly identifies the variable based on the scope it is called from.</p>
  </div>
)}




        {selectedChapter === 'chapter59' && (
         <div className={style.chaptercontent}>
           <h1 className={style.heading}>Python Module </h1>
    <p>
      A <strong>Python module</strong> is simply a file containing Python code that can define functions, classes, and variables, as well as include runnable code. A module allows you to organize your code into separate files, making it easier to manage and reuse.
    </p><br/>

    <h3>Key Concepts:</h3>
    <ul>
      <li>
        A <strong>module</strong> is just a Python file (.py) that contains Python code.
      </li><br/>
      <li>
        You can create your own modules and import them into other Python files.
      </li><br/>
      <li>
        Python has many <strong>built-in modules</strong> that provide useful functionality like math operations, system operations, file handling, etc.
      </li>
    </ul><br/>

    <h3 style={{paddingBottom:"6px"}}>How to Create and Use a Python Module</h3>

    <ol>
      <li>
        <strong>Creating a Python Module</strong>:  
        To create a module, simply write a Python file (e.g., <code>mymodule.py</code>) with some code in it.
        <pre>
          <code>{`
            # This is a simple module
            def greet(name):
                return f"Hello, {name}!"

            pi = 3.14159`}
          </code>
        </pre>
      </li><br/>

      <li>
        <strong>Using (Importing) a Module</strong>:  
        To use a module in another Python script, you need to import it using the <code>import</code> statement.
        <pre>
          <code>{`
            # Importing the 'mymodule' module
            import mymodule

            # Using the function from the module
            print(mymodule.greet("Alice"))

            # Accessing the variable from the module
            print("Value of pi:", mymodule.pi)
          </code>
        </pre>
        <p><strong>Output:</strong></p>
        <pre>
          <code>
            Hello, Alice!
            Value of pi: 3.14159`}
          </code>
        </pre>
      </li><br/>

      <li>
        <strong>Using <code>from</code> to Import Specific Elements</strong>:  
        If you only need a specific function or variable from a module, you can import it directly using <code>from</code>.
        <pre>
          <code>{`
            # Importing specific function and variable from mymodule
            from mymodule import greet, pi

            print(greet("Bob"))
            print("Value of pi:", pi)
          </code>
        </pre>
        <p><strong>Output:</strong></p>
        <pre>
          <code>
            Hello, Bob!
            Value of pi: 3.14159`}
          </code>
        </pre>
      </li><br/>

      <li>
        <strong>Built-in Modules</strong>:  
        Python comes with many built-in modules that you can use without needing to install anything extra. For example, the <code>math</code> module provides mathematical functions.
        <pre>
          <code>{`
            import math

            print(math.sqrt(16))  # Output: 4.0
            print(math.factorial(5))  # Output: 120`}
          </code>
        </pre>
      </li>
    </ol><br/>

    <h3>Recap</h3>
    <ul>
      <li>A module is a Python file with functions, classes, and variables.</li><br/>
      <li>You can create your own module or use built-in modules.</li><br/>
      <li>Use <code>import</code> to bring modules into your code.</li><br/>
      <li>Use <code>from</code> to import specific items from a module.</li>
    </ul><br/>

    <p>
      This basic structure helps you organize your code and reuse functionality across different Python scripts.
    </p>
  </div>
)}




            {selectedChapter === 'chapter60' && (
            <div className={style.chaptercontent}>
            <h1 className={style.heading}>  Python Dates  </h1>

      <p>
        In Python, working with dates and times is done using the <code>datetime</code> module, which provides various classes to handle dates, times, and both together.
      </p><br/>

      <h2>Key Classes in <code>datetime</code> Module:</h2>
      <ul>
        <li><strong><code>date</code></strong>: Handles just the date (year, month, day).</li><br/>
        <li><strong><code>time</code></strong>: Handles just the time (hours, minutes, seconds).</li><br/>
        <li><strong><code>datetime</code></strong>: Combines both date and time.</li><br/>
        <li><strong><code>timedelta</code></strong>: Represents the difference between two dates or times.</li>
      </ul><br/>

      <h3>Example 1: Getting the Current Date and Time</h3>
      <pre>
        <code>
          {`from datetime import datetime

# Get current date and time
current_datetime = datetime.now()
print("Current date and time:", current_datetime)`}
        </code>
      </pre>
      <p><strong>Output:</strong> Current date and time: 2024-11-15 10:30:45.123456</p>
      <br/>
      <h3>Example 2: Accessing Date and Time Components</h3>
      <pre>
        <code>
          {`from datetime import datetime

# Get current date and time
current_datetime = datetime.now()

# Access date and time components
print("Year:", current_datetime.year)
print("Month:", current_datetime.month)
print("Day:", current_datetime.day)
print("Hour:", current_datetime.hour)
print("Minute:", current_datetime.minute)
print("Second:", current_datetime.second)`}
        </code>
      </pre>
      <p><strong>Output:</strong></p>
      <pre>
        <code>
          {`Year: 2024
Month: 11
Day: 15
Hour: 10
Minute: 30
Second: 45`}
        </code>
      </pre><br/>

      <h3>Example 3: Creating a Specific Date</h3>
      <pre>
        <code>
          {`from datetime import date

# Create a specific date
specific_date = date(2024, 11, 15)
print("Specific date:", specific_date)`}
        </code>
      </pre>
      <p><strong>Output:</strong> Specific date: 2024-11-15</p><br/>

      <h3>Example 4: Date Arithmetic (Using <code>timedelta</code>)</h3>
      <pre>
        <code>
          {`from datetime import datetime, timedelta

# Get current date
current_date = datetime.now()

# Add 10 days to the current date
new_date = current_date + timedelta(days=10)
print("Date after 10 days:", new_date)

# Subtract 5 days from the current date
new_date2 = current_date - timedelta(days=5)
print("Date 5 days ago:", new_date2)`}
        </code>
      </pre>
      <p><strong>Output:</strong> Date after 10 days: 2024-11-25 10:30:45.123456</p>
      <p><strong>Output:</strong> Date 5 days ago: 2024-11-10 10:30:45.123456</p><br/>

      <h3>Example 5: Formatting Dates</h3>
      <pre>
        <code>
          {`from datetime import datetime

# Get current date and time
current_datetime = datetime.now()

# Format date and time
formatted_datetime = current_datetime.strftime("%Y-%m-%d %H:%M:%S")
print("Formatted date and time:", formatted_datetime)`}
        </code>
      </pre>
      <p><strong>Output:</strong> Formatted date and time: 2024-11-15 10:30:45</p><br/>

      <h3>Summary:</h3>
      <ul>
        <li><code>datetime.now()</code>: Gets the current date and time.</li><br/>
        <li><code>date()</code>: Represents just a date.</li><br/>
        <li><code>timedelta</code>: Used for adding or subtracting time from dates.</li><br/>
        <li><code>strftime()</code>: Formats a <code>datetime</code> object into a string.</li>
      </ul><br/>

      <p>These tools help you manipulate and format dates and times in Python efficiently!</p>
    </div>
  )}






            {selectedChapter === 'chapter61' && (
            <div className={style.chaptercontent}>
            <h1 className={style.heading}> Python Math </h1>

      <p>
        In Python, the <code>math</code> module provides a variety of mathematical functions that can help with mathematical operations like square roots, trigonometry, logarithms, and more.
      </p><br/>

      <h2>Key Functions in the <code>math</code> Module:</h2>
      <ul>
        <li><strong>math.sqrt(x)</strong>: Returns the square root of a number <code>x</code>.</li><br/>
        <li><strong>math.pow(x, y)</strong>: Returns <code>x</code> raised to the power of <code>y</code> (equivalent to <code>x ** y</code>).</li><br/>
        <li><strong>math.factorial(x)</strong>: Returns the factorial of a number <code>x</code>, which is the product of all positive integers less than or equal to <code>x</code>.</li><br/>
        <li><strong>math.sin(x)</strong>: Returns the sine of <code>x</code> (where <code>x</code> is in radians).</li><br/>
        <li><strong>math.cos(x)</strong>: Returns the cosine of <code>x</code> (where <code>x</code> is in radians).</li><br/>
        <li><strong>math.log(x, base)</strong>: Returns the logarithm of <code>x</code> to the specified <code>base</code>. If no base is provided, it defaults to the natural logarithm (base <code>e</code>).</li><br/>
        <li><strong>math.pi</strong>: Provides the mathematical constant <code>π</code> (approximately 3.14159).</li><br/>
        <li><strong>math.e</strong>: Provides the mathematical constant <code>e</code> (Euler’s number, approximately 2.71828).</li>
      </ul><br/>

      <h3>Example 1: Using <code>math.sqrt()</code> to Find Square Root</h3>
      <pre>
        {`
import math

number = 16
result = math.sqrt(number)
print("Square root of", number, "is", result)
        `}
      </pre>
      <p>Output: <code>Square root of 16 is 4.0</code></p><br/>

      <h3>Example 2: Using <code>math.pow()</code> for Power Calculations</h3>
      <pre>
        {`
import math

base = 2
exponent = 3
result = math.pow(base, exponent)
print(base, "raised to the power of", exponent, "is", result)
        `}
      </pre>
      <p>Output: <code>2 raised to the power of 3 is 8.0</code></p><br/>

      <h3>Example 3: Using <code>math.factorial()</code> to Calculate Factorial</h3>
      <pre>
        {`
import math

number = 5
result = math.factorial(number)
print("Factorial of", number, "is", result)
        `}
      </pre>
      <p>Output: <code>Factorial of 5 is 120</code></p><br/>

      <h3>Example 4: Using <code>math.sin()</code> and <code>math.cos()</code> for Trigonometry</h3>
      <pre>
        {`
import math

angle = math.radians(30)  # Convert 30 degrees to radians

sin_value = math.sin(angle)
cos_value = math.cos(angle)

print("Sin(30°):", sin_value)
print("Cos(30°):", cos_value)
        `}
      </pre>
      <p>Output: <code>Sin(30°): 0.5</code></p>
      <p>Output: <code>Cos(30°): 0.8660254037844387</code></p><br/>

      <h3>Example 5: Using <code>math.log()</code> for Logarithms</h3>
      <pre>
        {`
import math

number = 100
result = math.log(number, 10)  # Logarithm base 10
print("Logarithm of", number, "is", result)
        `}
      </pre>
      <p>Output: <code>Logarithm of 100 is 2.0</code></p><br/>

      <h3>Example 6: Using <code>math.pi</code> for π</h3>
      <pre>
        {`
import math

print("Value of pi:", math.pi)
        `}
      </pre>
      <p>Output: <code>Value of pi: 3.141592653589793</code></p><br/>

      <h3>Conclusion:</h3>
      <ul>
        <li>The <code>math</code> module makes it easy to perform various mathematical operations like finding square roots, calculating factorials, trigonometry, logarithms, and more.</li><br/>
        <li>You can import the <code>math</code> module and use these functions to simplify mathematical tasks in your Python code.</li>
      </ul><br/>

      <p>By using the <code>math</code> module, Python provides built-in functions to handle complex mathematical calculations with ease.</p>
    </div>
  )}




{selectedChapter === 'chapter62' && (
  <div className={style.chaptercontent}>
    <h1 className={style.heading}>Python Regular Expressions (RegEx)</h1>

    <p>
      Regular expressions (RegEx) are a powerful tool in Python for matching patterns in strings, validating inputs, extracting data, and performing complex text manipulation.
    </p>
    
    <p>
      Python provides the <code>re</code> module to work with regular expressions. This module allows you to search for patterns in text, replace text, and split text based on patterns.
    </p><br/>

    <h3>Key Concepts of Python Regular Expressions:</h3>
    <ol>
      <li><strong>Pattern Matching</strong>: Searching for specific patterns (like a phone number, email, etc.) in a string.</li><br/>
      <li><strong>Metacharacters</strong>: Special characters used to define patterns.</li><br/>
      <li><strong>Quantifiers</strong>: Define how many times an element in the pattern can repeat.</li><br/>
      <li><strong>Grouping</strong>: Group parts of patterns to treat them as a single unit.</li><br/>
      <li><strong>Anchors</strong>: Specify the position of the pattern in the string (e.g., start, end).</li>
    </ol><br/>

    <h3>Basic Syntax of Regular Expressions</h3>

    <h4>1. Basic Metacharacters:</h4>
    <ul>
      <li><code>.</code> (dot): Matches any character except a newline.</li><br/>
      <li><code>^</code>: Matches the beginning of the string.</li><br/>
      <li><code>$</code>: Matches the end of the string.</li><br/>
      <li><code>[]</code>: Matches any single character within the brackets.</li><br/>
      <li><code>|</code>: Acts as an OR operator (e.g., <code>a|b</code> matches "a" or "b").</li>
    </ul><br/>

    <h4>2. Quantifiers:</h4>
    <ul>
      <li><code>*</code>: Matches 0 or more repetitions of the preceding pattern.</li><br/>
      <li><code>+</code>: Matches 1 or more repetitions of the preceding pattern.</li><br/>
      <li><code>?</code>: Matches 0 or 1 repetition of the preceding pattern.</li><br/>
      <li><code>{`{n}`}</code>: Matches exactly <code>n</code> repetitions.</li><br/>
      <li><code>{`{n,}`}</code>: Matches <code>n</code> or more repetitions.</li><br/>
      <li><code>{`{n,m}`}</code>: Matches between <code>n</code> and <code>m</code> repetitions.</li>
    </ul><br/>

    <h4>3. Character Classes:</h4>
    <ul>
      <li><code>\d</code>: Matches any digit (equivalent to <code>[0-9]</code>).</li><br/>
      <li><code>\D</code>: Matches any non-digit character.</li><br/>
      <li><code>\w</code>: Matches any word character (alphanumeric + underscore).</li><br/>
      <li><code>\W</code>: Matches any non-word character.</li><br/>
      <li><code>\s</code>: Matches any whitespace character (space, tab, newline).</li><br/>
      <li><code>\S</code>: Matches any non-whitespace character.</li>
    </ul><br/>

    <h4>4. Escape Sequences:</h4>
    <ul>
      <li><code>\</code>: Used to escape special characters (e.g., <code>\.</code> to match a literal dot).</li>
    </ul><br/>

    <h3>Example of Using Regular Expressions in Python:</h3>

    <h4>1. Searching for a Pattern:</h4>
    <pre><code>{`
import re

# Example string
text = "The price is $50."

# Search for a pattern
match = re.search(r"\d+", text)  # \d+ matches one or more digits

if match:
    print("Found:", match.group())
else:
    print("No match found")`}
    </code></pre>
    <p><strong>Output:</strong><br/>Found: 50</p><br/>

    <h4>2. Finding All Matches:</h4>
    <pre><code>{`
import re

text = "I have 2 apples and 3 bananas."

# Find all digits in the string
numbers = re.findall(r"\d+", text)
print(numbers)`}
    </code></pre>
    <p><strong>Output:</strong><br/>['2', '3']</p><br/>

    <h4>3. Replacing Text:</h4>
    <pre><code>{`
import re

text = "My email is user@example.com."

# Replace the email with a placeholder
modified_text = re.sub(r"\S+@\S+", "[REDACTED]", text)
print(modified_text)`}
    </code></pre>
    <p><strong>Output:</strong><br/>My email is [REDACTED].</p><br/>

    <h4>4. Splitting a String:</h4>
    <pre><code>{`
import re

text = "apple, orange, banana, grape"

# Split the string by commas
fruits = re.split(r",\s*", text)  # \s* allows for optional spaces after the comma
print(fruits)`}
    </code></pre>
    <p><strong>Output:</strong><br/>['apple', 'orange', 'banana', 'grape']</p><br/>

    <h4>5. Matching Start and End of String:</h4>
    <pre><code>{`
import re

text = "Hello World"

# Check if the string starts with "Hello"
if re.match(r"^Hello", text):
    print("String starts with 'Hello'")

# Check if the string ends with "World"
if re.match(r"World$", text):
    print("String ends with 'World'")`}
    </code></pre>
    <p><strong>Output:</strong><br/>String starts with 'Hello' <br/>String ends with 'World'</p><br/>

    <h3>Conclusion:</h3>
    <ul>
      <li>The <code>re</code> module in Python is used to handle regular expressions.</li><br/>
      <li>It helps in searching, matching, replacing, and splitting strings based on patterns.</li><br/>
      <li>Commonly used functions include <code>re.search()</code>, <code>re.findall()</code>, <code>re.sub()</code>, and <code>re.split()</code>.</li><br/>
      <li><strong>Metacharacters</strong> like <code>.</code> (dot), <code>*</code>, <code>+</code>, and <code>[]</code> are used to define patterns.</li><br/>
      <li><strong>Escape sequences</strong> (like <code>\d</code> for digits) are used for matching specific character types.</li>
    </ul><br/>

    <p>
      Regular expressions are a powerful tool for text processing, but they can also be complex. Understanding their syntax and how to use them effectively will make working with strings in Python much easier.
    </p>
  </div>
)}




      {selectedChapter === 'chapter63' && (
      <div className={style.chaptercontent}>
      <h1 className={style.heading}>Python JSON (JavaScript Object Notation)</h1>

          <p>
            In Python, JSON (JavaScript Object Notation) is a lightweight data-interchange format that is easy for humans to read and write, and easy for machines to parse and generate. Python has a built-in module called <code>json</code> that allows you to work with JSON data easily. The <code>json</code> module can be used to convert Python objects (like dictionaries, lists, etc.) into JSON strings and vice versa.
          </p><br/>

          <h2>Key Functions in the <code>json</code> module:</h2>
          <ul>
            <li><strong>json.dumps()</strong>: Converts a Python object to a JSON string.</li><br/>
            <li><strong>json.loads()</strong>: Converts a JSON string to a Python object.</li><br/>
            <li><strong>json.dump()</strong>: Writes a Python object as a JSON string to a file.</li><br/>
            <li><strong>json.load()</strong>: Reads a JSON string from a file and converts it into a Python object.</li>
          </ul><br/>

          <h3>Example 1: Converting Python Object to JSON String (using <code>json.dumps()</code>)</h3>
          <pre>
            <code>
              {`import json\n\n// Python dictionary\nconst data = {\n  "name": "John",\n  "age": 30,\n  "city": "New York"\n}\n\n// Convert Python object (dictionary) to JSON string\nconst jsonString = json.dumps(data);\nconsole.log(jsonString);`}
            </code>
          </pre>
          <p><strong>Output:</strong><br />
            {"{"} "name": "John", "age": 30, "city": "New York" {"}"}
          </p><br/>

          <h3>Example 2: Converting JSON String to Python Object (using <code>json.loads()</code>)</h3>
          <pre>
            <code>
              {`import json\n\n// JSON string\nconst jsonString = '{"name": "John", "age": 30, "city": "New York"}';\n\n// Convert JSON string to Python object (dictionary)\nconst pythonDict = json.loads(jsonString);\nconsole.log(pythonDict);`}
            </code>
          </pre>
          <p><strong>Output:</strong><br />
            {"{"} 'name': 'John', 'age': 30, 'city': 'New York' {"}"}
          </p><br/>

          <h3>Example 3: Writing Python Object to a JSON File (using <code>json.dump()</code>)</h3>
          <pre>
            <code>
              {`import json\n\n// Python dictionary\nconst data = {\n  "name": "John",\n  "age": 30,\n  "city": "New York"\n}\n\n// Open a file and write the Python dictionary as JSON\nwith open("data.json", "w") as jsonFile:\n  json.dump(data, jsonFile);`}
            </code>
          </pre>
          <p>This code will create a <code>data.json</code> file with the following content:</p>
          <pre>
            <code>
              {`{"name": "John", "age": 30, "city": "New York"}`}
            </code>
          </pre><br/>

          <h3>Example 4: Reading JSON from a File and Converting it to a Python Object (using <code>json.load()</code>)</h3>
          <pre>
            <code>
              {`import json\n\n// Open the JSON file and read the content\nwith open("data.json", "r") as jsonFile:\n  data = json.load(jsonFile);\n  print(data);`}
            </code>
          </pre>
          <p><strong>Output:</strong><br />
            {"{"} 'name': 'John', 'age': 30, 'city': 'New York' {"}"}
          </p><br/>

          <h3>Key Points to Remember:</h3>
          <ul>
            <li><strong>JSON Syntax:</strong><br />
              - JSON objects are written in key/value pairs.<br />
              - JSON strings must be enclosed in double quotes (<code>"</code>), whereas Python allows single or double quotes for strings.<br />
              - JSON supports primitive data types like <code>strings</code>, <code>numbers</code>, <code>booleans</code>, <code>arrays</code>, and <code>objects</code>.
            </li><br/>
            <li><strong>Python Data Types to JSON Mapping:</strong><br />
              - <code>dict</code> {"->"} JSON Object<br />
              - <code>list</code>{"->"}  JSON Array<br />
              - <code>str</code> {"->"}  JSON String<br />
              - <code>int</code>, <code>float</code> {"->"}  JSON Number<br />
              - <code>True</code> {"->"}  <code>true</code> (JSON Boolean)<br />
              - <code>False</code>{"->"} <code>false</code> (JSON Boolean)<br />
              - <code>None</code> {"->"}  <code>null</code> (JSON Null)
            </li><br/>
            <li><strong>Indenting and Formatting JSON:</strong><br />
              You can format the JSON output to make it more readable by adding the <code>indent</code> argument to <code>json.dumps()</code>:
            </li>
          </ul><br/>

          <pre>
            <code>
              {`import json\n\nconst data = {\n  "name": "John",\n  "age": 30,\n  "city": "New York"\n}\n\n// Convert to JSON string with indentation for readability\nconst jsonString = json.dumps(data, indent=4);\nconsole.log(jsonString);`}
            </code>
          </pre>
          <p><strong>Output:</strong><br />
            {`{
    "name": "John",
    "age": 30,
    "city": "New York"
}`}
          </p><br/>

          <h3>Conclusion:</h3>
          <ul>
            <li>The <code>json</code> module in Python allows easy conversion between JSON data and Python objects.</li><br/>
            <li>You can use <code>json.dumps()</code> and <code>json.loads()</code> to work with strings, and <code>json.dump()</code> and <code>json.load()</code> for file operations.</li><br/>
            <li>JSON is widely used for data exchange between web services and is a commonly supported format across different programming languages.</li>
          </ul>
        </div>
      )}
  




  {selectedChapter === 'chapter64' && (
  <div className={style.chaptercontent}>
    <h1 className={style.heading}>Python pip </h1>

    <p>
      `pip` is the package installer for Python, and it is used to install and manage additional Python packages that are not part of the Python standard library. It is one of the most important tools for Python developers because it allows easy access to third-party libraries and packages.
    </p><br/>

    <h3>Key Features of `pip`:</h3>
    <ul>
      <li><strong>Installing packages</strong>: Install packages from the Python Package Index (PyPI) or other repositories.</li><br/>
      <li><strong>Upgrading packages</strong>: Upgrade installed packages to their latest versions.</li><br/>
      <li><strong>Uninstalling packages</strong>: Remove packages from your Python environment.</li><br/>
      <li><strong>Listing installed packages</strong>: Display installed packages and their versions.</li>
    </ul><br/>

    <h3 style={{paddingBottom:"6px"}}>Basic `pip` Commands:</h3>

    <h4>1. Installing a package:</h4>
    <p>To install a package, simply use the command:</p>
    <pre><code>pip install &lt;package_name&gt;</code></pre>
    <p>Example:</p>
    <pre><code>pip install requests</code></pre>
    <p>This will install the `requests` library, which is used to make HTTP requests.</p><br/>

    <h4>2. Upgrading a package:</h4>
    <p>To upgrade a package to the latest version:</p>
    <pre><code>pip install --upgrade &lt;package_name&gt;</code></pre>
    <p>Example:</p>
    <pre><code>pip install --upgrade requests</code></pre><br/>

    <h4>3. Uninstalling a package:</h4>
    <p>To uninstall a package:</p>
    <pre><code>pip uninstall &lt;package_name&gt;</code></pre>
    <p>Example:</p>
    <pre><code>pip uninstall requests</code></pre><br/>

    <h4>4. Listing installed packages:</h4>
    <p>To list all installed packages in the current environment:</p>
    <pre><code>pip list</code></pre><br/>

    <h4>5. Checking for outdated packages:</h4>
    <p>To check which packages are outdated:</p>
    <pre><code>pip list --outdated</code></pre><br/>

    <h4>6. Search for a package:</h4>
    <p>To search for a package by name:</p>
    <pre><code>pip search &lt;package_name&gt;</code></pre>
    <p>Example:</p>
    <pre><code>pip search requests</code></pre>
    <p><i>(Note: As of `pip` version 21.0, this command is deprecated.)</i></p><br/>

    <h4>7. Installing from a requirements file:</h4>
    <p>A `requirements.txt` file lists all the dependencies for a Python project. You can install all packages listed in the file using:</p>
    <pre><code>pip install -r requirements.txt</code></pre><br/>

    <h4>8. Freezing package versions:</h4>
    <p>To generate a `requirements.txt` file with all the currently installed packages and their versions:</p>
    <pre><code>pip freeze &gt; requirements.txt</code></pre><br/>

    <h3>Example Usage:</h3>
    <ul>
      <li><strong>Installing a package:</strong> <code>pip install numpy</code></li><br/>
      <li><strong>Upgrading a package:</strong> <code>pip install --upgrade numpy</code></li><br/>
      <li><strong>Uninstalling a package:</strong> <code>pip uninstall numpy</code></li><br/>
      <li><strong>Listing installed packages:</strong> <code>pip list</code></li>
    </ul><br/>

    <h3>Conclusion:</h3>
    <p>
      `pip` is an essential tool for Python developers, enabling them to easily install and manage third-party libraries and packages. It simplifies the process of working with external dependencies, ensuring that Python projects can leverage a vast ecosystem of packages available on PyPI.
    </p>
  </div>
)}




{selectedChapter === 'chapter65' && (
  <div className={style.chaptercontent}>
    <h1 className={style.heading}>Python try except</h1>
    
    <p>
      In Python, exception handling is done using the <code>try</code> and <code>except</code> blocks.
      It allows you to handle errors gracefully and continue the execution of the program without it crashing.
    </p>

    <ul>
      <li><strong>try block</strong>: The code that might raise an exception is written inside the <code>try</code> block.</li><br/>
      <li><strong>except block</strong>: The code to handle the exception is written inside the <code>except</code> block.</li><br/>
      <li><strong>else block</strong>: If no exception occurs in the <code>try</code> block, the code in the <code>else</code> block will execute.</li><br/>
      <li><strong>finally block</strong>: The code in the <code>finally</code> block will execute no matter what, whether an exception occurred or not. It is generally used for clean-up actions.</li>
    </ul><br/>

    <h2>Syntax:</h2>
    <pre>
      <code>
        {`try:
    # Code that might raise an exception
except SomeException:
    # Code that handles the exception
else:
    # Code that runs if no exception occurred
finally:
    # Code that runs no matter what`}
      </code>
    </pre><br/>

    <h2>Example 1: Basic <code>try</code> and <code>except</code></h2>
    <pre>
      <code>
        {`try:
    num = int(input("Enter a number: "))
    print(f"The number you entered is {num}")
except ValueError:
    print("Oops! That wasn't a valid number.")`}
      </code>
    </pre>
    <p><strong>Explanation:</strong> If the user enters a non-integer value, a <code>ValueError</code> will be raised, and the program will print an error message instead of crashing.</p>
    <br/>
    <h2>Example 2: Using <code>else</code> with <code>try...except</code></h2>
    <pre>
      <code>
        {`try:
    num1 = int(input("Enter the first number: "))
    num2 = int(input("Enter the second number: "))
    result = num1 / num2
except ZeroDivisionError:
    print("Error! Cannot divide by zero.")
except ValueError:
    print("Oops! Please enter valid numbers.")
else:
    print(f"The result of the division is {result}")`}
      </code>
    </pre>
    <p><strong>Explanation:</strong> 
      If the user enters valid numbers and doesn't attempt division by zero, the <code>else</code> block will execute and print the result of the division.
      If any exception occurs, the respective <code>except</code> block will handle it.
    </p><br/>

    <h2>Example 3: Using <code>finally</code> for Clean-up Actions</h2>
    <pre>
      <code>
        {`try:
    file = open("sample.txt", "r")
    content = file.read()
    print(content)
except FileNotFoundError:
    print("The file does not exist.")
finally:
    print("Execution completed.")
    if 'file' in locals():
        file.close()  # Ensure file is closed even if an exception occurs`}
      </code>
    </pre>
    <p><strong>Explanation:</strong> 
      The <code>finally</code> block will always execute, whether or not an exception occurred.
      This is useful for clean-up tasks like closing files or releasing resources.
    </p><br/>

    <h2>Example 4: Using All Together</h2>
    <pre>
      <code>
        {`try:
    num = int(input("Enter a number: "))
    result = 100 / num
except ZeroDivisionError:
    print("Cannot divide by zero.")
except ValueError:
    print("Invalid input. Please enter a valid number.")
else:
    print(f"Success! The result is {result}")
finally:
    print("Execution finished.")`}
      </code>
    </pre>
    <p><strong>Explanation:</strong> 
      If the user enters a valid number and it is not zero, the division is performed, and the <code>else</code> block executes.
      If there's a <code>ZeroDivisionError</code> or <code>ValueError</code>, the respective <code>except</code> block handles it.
      The <code>finally</code> block ensures that "Execution finished." is always printed, regardless of any exceptions.
    </p><br/>

    <h2>Key Points:</h2>
    <ul>
      <li>The <code>else</code> block executes only if the <code>try</code> block does <strong>not</strong> raise an exception.</li><br/>
      <li>The <code>finally</code> block is always executed, no matter what, and is often used for clean-up tasks like closing files or network connections.</li>
    </ul>
  </div>
)}




      {selectedChapter === 'chapter66' && (
      <div className={style.chaptercontent}>
      <h1 className={style.heading}>User Input in Python</h1>

    <p>
      In Python, user input is handled using the built-in <code>input()</code> function. 
      This function allows the program to take input from the user through the console or terminal.
    </p><br/>

    <h3>How <code>input()</code> works:</h3>
    <ul>
      <li>The <code>input()</code> function displays a prompt (optional message) and waits for the user to type something.</li><br/>
      <li>The function then returns the input as a string (text).</li><br/>
      <li>If you need to convert the input to a different data type (like an integer or float), you can do so by using type conversion functions.</li>
    </ul><br/>

    <h3>Basic Usage:</h3>

    <h4>1. Getting input from the user:</h4>
    <pre>
      <code>
{`user_input = input("Enter something: ")
print("You entered:", user_input)`}
      </code>
    </pre>
    <p>
      <strong>Explanation:</strong> 
      The <code>input()</code> function shows the prompt <code>"Enter something: "</code>.
      Whatever the user types is captured as a string and stored in <code>user_input</code>.
      The program prints out what the user entered.
    </p>
    <pre>
      <code>
{`Example Output:
Enter something: Hello
You entered: Hello`}
      </code>
    </pre><br/>

    <h4>2. Converting input to an integer:</h4>
    <pre>
      <code>
{`age = input("Enter your age: ")
age = int(age)  # Convert the string to an integer
print("Your age is:", age)`}
      </code>
    </pre>
    <p>
      <strong>Explanation:</strong>
      The user inputs a value (e.g., <code>"25"</code>).
      The <code>int()</code> function converts the string <code>"25"</code> to an integer <code>25</code>.
    </p>
    <pre>
      <code>
{`Example Output:
Enter your age: 25
Your age is: 25`}
      </code>
    </pre><br/>

    <h4>3. Converting input to a float:</h4>
    <pre>
      <code>
{`price = input("Enter the price: ")
price = float(price)  # Convert the string to a float
print("The price is:", price)`}
      </code>
    </pre>
    <p>
      <strong>Explanation:</strong> 
      The user inputs a value (e.g., <code>"19.99"</code>).
      The <code>float()</code> function converts the string <code>"19.99"</code> to a float <code>19.99</code>.
    </p>
    <pre>
      <code>
{`Example Output:
Enter the price: 19.99
The price is: 19.99`}
      </code>
    </pre><br/>

    <h3>Multiple Inputs:</h3>
    <h4>4. Getting multiple inputs on the same line:</h4>
    <pre>
      <code>
{`name, age = input("Enter your name and age: ").split()
age = int(age)  # Convert age to integer
print(f"Hello, {name}. You are {age} years old.")`}
      </code>
    </pre>
    <p>
      <strong>Explanation:</strong> 
      The <code>split()</code> method splits the input string at spaces and stores the parts in a list.
      We unpack the list into two variables (<code>name</code> and <code>age</code>).
      The <code>int()</code> function converts <code>age</code> to an integer.
    </p>
    <pre>
      <code>
{`Example Output:
Enter your name and age: Alice 30
Hello, Alice. You are 30 years old.`}
      </code>
    </pre><br/>

    <h4>5. Handling invalid input with a <code>try...except</code> block:</h4>
    <pre>
      <code>
{`try:
    age = int(input("Enter your age: "))
    print("Your age is:", age)
except ValueError:
    print("That's not a valid age!")`}
      </code>
    </pre>
    <p>
      <strong>Explanation:</strong> 
      If the user doesn't enter a valid integer, a <code>ValueError</code> will occur.
      The <code>except</code> block catches the error and prints an error message.
    </p>
    <pre>
      <code>
{`Example Output:
Enter your age: abc
That's not a valid age!`}
      </code>
    </pre><br/>

    <h3>Summary of Key Points:</h3>
    <ul>
      <li><code>input()</code>: Captures user input as a string.</li><br/>
      <li>Converting input: Use <code>int()</code> or <code>float()</code> to convert the input to the desired type.</li><br/>
      <li>Handling multiple inputs: Use <code>split()</code> to separate inputs.</li><br/>
      <li>Error handling: Use <code>try...except</code> to handle invalid inputs.</li>
    </ul><br/>

    <p>
      This should give you a basic understanding of handling user input in Python!
    </p>

  </div>
)}





      {selectedChapter === 'chapter67' && (
      <div className={style.chaptercontent}>
      <h1 className={style.heading}>String Formatting in Python</h1>

    <p>
      In Python, <strong>string formatting</strong> is used to embed variables and expressions within strings in a flexible and readable way. Python offers multiple methods to format strings, including the older `%` formatting, `str.format()`, and the newer f-string formatting introduced in Python 3.6.
    </p><br/>

    <h3>1.% Formatting (Old Style)</h3>
    <p>
      This is the oldest way of formatting strings in Python, similar to printf-style formatting in C. You use `%` to insert values into a string.
    </p>

    <h4>Example:</h4>
    <pre>
      {`name = "Alice"\nage = 25\nformatted_string = "My name is %s and I am %d years old." % (name, age)\nprint(formatted_string)`}
    </pre>
    <p><strong>Explanation:</strong></p>
    <ul>
      <li><code>%s</code> is a placeholder for a string.</li>
      <li><code>%d</code> is a placeholder for an integer.</li>
    </ul>
    <p><strong>Output:</strong></p>
    <pre>{`My name is Alice and I am 25 years old.`}</pre><br/>

    <h3>2.str.format() (New Style)</h3>
    <p>
      This method is more versatile and allows you to use placeholders in curly braces <code>{}</code>. You can pass the values to <code>str.format()</code> either positionally or by keyword.
    </p>

    <h4>Example (Positional):</h4>
    <pre>
      {`name = "Bob"\nage = 30\nformatted_string = "My name is {} and I am {} years old.".format(name, age)\nprint(formatted_string)`}
    </pre>

    <h4>Example (Keyword):</h4>
    <pre>
      {`name = "Bob"\nage = 30\nformatted_string = "My name is {name} and I am {age} years old.".format(name=name, age=age)\nprint(formatted_string)`}
    </pre>

    <p><strong>Explanation:</strong></p>
    <ul>
      <li><code>{}</code> are placeholders where values will be inserted.</li>
      <li><code>.format()</code> is used to replace these placeholders with the values provided in the function call.</li>
    </ul>
    <p><strong>Output:</strong></p>
    <pre>{`My name is Bob and I am 30 years old.`}</pre><br/>

    <h3>3. f-Strings (Formatted String Literals)</h3>
    <p>
      Introduced in Python 3.6, f-strings are the most modern and efficient way to format strings. You simply prefix the string with <code>f</code> and insert expressions inside curly braces <code>{}</code>.
    </p>

    <h4>Example:</h4>
    <pre>
      {`name = "Charlie"\nage = 35\nformatted_string = f"My name is {name} and I am {age} years old."\nprint(formatted_string)`}
    </pre>
    <p><strong>Explanation:</strong></p>
    <ul>
      <li>The <code>f</code> before the string indicates an f-string.</li>
      <li>Expressions inside <code>{}</code> are evaluated at runtime.</li>
    </ul>
    <p><strong>Output:</strong></p>
    <pre>{`My name is Charlie and I am 35 years old.`}</pre><br/>

    <h3>4. Formatting Numbers and Precision</h3>
    <p>
      You can also format numbers and control their precision using all three methods.
    </p>

    <h4>Example (Using str.format()):</h4>
    <pre>
      {`pi = 3.14159\nformatted_string = "The value of pi is {:.2f}".format(pi)  # 2 decimal places\nprint(formatted_string)`}
    </pre>

    <h4>Example (Using f-strings):</h4>
    <pre>
      {`pi = 3.14159\nformatted_string = f"The value of pi is {pi:.2f}"  # 2 decimal places\nprint(formatted_string)`}
    </pre>
    <p><strong>Explanation:</strong></p>
    <ul>
      <li><code>{`{:.2f}`}</code> formats the floating-point number <code>pi</code> to 2 decimal places.</li>
    </ul>
    <p><strong>Output:</strong></p>
    <pre>{`The value of pi is 3.14`}</pre><br/>

    <h3><strong>Summary of Key Points:</strong></h3>
    <ul>
      <li><strong>% Formatting:</strong> Old style, less flexible.</li><br/>
      <li><strong>str.format():</strong> More versatile, allows positional and keyword arguments.</li><br/>
      <li><strong>f-Strings:</strong> The most modern and efficient way, introduced in Python 3.6, for inline variable interpolation and expression evaluation.</li><br/>
      <li><strong>Precision:</strong> You can format numbers to control decimal places using <code>:.2f</code> or similar.</li>
    </ul><br/>
    <p>
      F-strings are generally preferred for their readability and performance, especially in Python 3.6 and beyond.
    </p>
  </div>
)}




{selectedChapter === 'chapter68' && (
  <div className={style.chaptercontent}>
    <h1 className={style.heading}>File Handling </h1>

    <p>File handling in Python is used to work with files, such as opening, reading, writing, and closing them. Python provides built-in functions to perform these operations. Here's a brief explanation of file handling in Python with examples:</p>
    <br/>
    <h3>Opening a File</h3>
    <p>To open a file, we use the built-in <code>open()</code> function. This function requires the name of the file and an optional mode that specifies how the file should be opened (e.g., for reading, writing, etc.).</p>

    <h4>Syntax:</h4>
    <pre>
      <code>file = open('filename', 'mode')</code>
    </pre>
    <ul>
      <li><code>'r'</code>: Read (default mode). Opens the file for reading.</li><br/>
      <li><code>'w'</code>: Write. Opens the file for writing, creates a new file if it doesn't exist, or truncates it if it does.</li><br/>
      <li><code>'a'</code>: Append. Opens the file for appending (creates a new file if it doesn't exist).</li><br/>
      <li><code>'b'</code>: Binary mode. Used to read/write binary files.</li>
    </ul>

    <h4>Example: Opening a file for reading:</h4>
    <pre>
      <code>file = open('example.txt', 'r')</code>
    </pre><br/>

    <h3>Reading from a File</h3>
    <p>You can read the contents of a file using methods like <code>.read()</code>, <code>.readline()</code>, and <code>.readlines()</code>.</p>
    <ul>
      <li><code>.read()</code>: Reads the entire file.</li>
      <li><code>.readline()</code>: Reads one line at a time.</li>
      <li><code>.readlines()</code>: Reads all lines into a list.</li>
    </ul>

    <h4>Example: Reading the entire file</h4>
    <pre>
      <code>
        file = open('example.txt', 'r')<br/>
        content = file.read()<br/>
        print(content)<br/>
        file.close()
      </code>
    </pre>

    <h4>Example: Reading line by line</h4>
    <pre>
      <code>
        file = open('example.txt', 'r')<br/>
        for line in file:<br/>
        &nbsp;&nbsp;&nbsp;&nbsp;print(line)<br/>
        file.close()
      </code>
    </pre><br/>

    <h3>Writing to a File</h3>
    <p>You can write to a file using the <code>.write()</code> or <code>.writelines()</code> methods.</p>
    <ul>
      <li><code>.write()</code>: Writes a string to the file.</li>
      <li><code>.writelines()</code>: Writes a list of strings to the file.</li>
    </ul>

    <h4>Example: Writing to a file</h4>
    <pre>
      <code>
        file = open('example.txt', 'w')<br/>
        file.write("Hello, world!")<br/>
        file.close()
      </code>
    </pre>

    <h4>Example: Appending to a file</h4>
    <pre>
      <code>
        file = open('example.txt', 'a')<br/>
        file.write("Appended text.\n")<br/>
        file.close()
      </code>
    </pre><br/>

    <h3>Closing a File</h3>
    <p>After completing file operations, you should always close the file to free up system resources. You can do this using the <code>.close()</code> method.</p>

    <pre>
      <code>file = open('example.txt', 'r')<br/>
      content = file.read()<br/>
      file.close()</code>
    </pre>

    <h3>Using <code>with</code> Statement (Recommended)</h3>
    <p>To handle files more efficiently and safely (ensuring the file is always closed), use the <code>with</code> statement. It automatically closes the file when the block of code is done.</p>

    <h4>Example with <code>with</code>:</h4>
    <pre>
      <code>
        with open('example.txt', 'r') as file:<br/>
        &nbsp;&nbsp;&nbsp;&nbsp;content = file.read()<br/>
        &nbsp;&nbsp;&nbsp;&nbsp;print(content)
      </code>
    </pre><br/>

    <h3>File Modes Summary:</h3>
    <ul>
      <li><code>'r'</code>: Read (default).</li><br/>
      <li><code>'w'</code>: Write (creates or truncates file).</li><br/>
      <li><code>'a'</code>: Append (adds to the file).</li><br/>
      <li><code>'b'</code>: Binary mode (for non-text files).</li><br/>
      <li><code>'rb'</code>, <code>'wb'</code>, etc.: For reading/writing binary files.</li>
    </ul><br/>

    <h3>Example of Complete File Handling:</h3>
    <pre>
      <code>
        # Writing to a file<br/>
        with open('example.txt', 'w') as file:<br/>
        &nbsp;&nbsp;&nbsp;&nbsp;file.write("Hello, world!\\n")<br/>
        &nbsp;&nbsp;&nbsp;&nbsp;file.write("This is a test.")<br/><br/>
        # Reading from a file<br/>
        with open('example.txt', 'r') as file:<br/>
        &nbsp;&nbsp;&nbsp;&nbsp;content = file.read()<br/>
        &nbsp;&nbsp;&nbsp;&nbsp;print(content)
      </code>
    </pre><br/>

    <h3>Summary of Key Points:</h3>
    <ul>
      <li><strong>Opening</strong>: Use <code>open()</code> with the filename and mode.</li><br/>
      <li><strong>Reading</strong>: Use <code>.read()</code>, <code>.readline()</code>, or <code>.readlines()</code>.</li><br/>
      <li><strong>Writing</strong>: Use <code>.write()</code> or <code>.writelines()</code>.</li><br/>
      <li><strong>Closing</strong>: Always close the file with <code>.close()</code> or use the <code>with</code> statement for automatic closure.</li><br/>
    </ul>

    <p>This should give you a clear understanding of how file handling works in Python!</p>
  </div>
)}





      {selectedChapter === 'chapter69' && (
        <div className={style.chaptercontent}>
          <h1 className={style.heading}>Reading Files </h1>

          <p>
            In Python, reading files is a common task, and Python provides several ways to read data from a file. The basic approach is to use the built-in <code>open()</code> function to open a file and then use methods like <code>.read()</code>, <code>.readline()</code>, or <code>.readlines()</code> to read the contents. Here's a brief explanation with examples:
          </p><br/>

          <h2>1. <code>open()</code> to Open a File</h2>
          <p>
            The first step is to open the file using the <code>open()</code> function. The <code>open()</code> function requires the filename and an optional mode (default is read mode <code>'r'</code>).
          </p>
          <pre>
            <code>file = open('filename', 'r')</code>  // <code>'r'</code> stands for read mode
          </pre><br/>

          <h2>2. Reading the Entire File with <code>.read()</code></h2>
          <p>The <code>.read()</code> method reads the entire content of the file as a single string.</p>
          <pre>
            <code>
              # Open the file in read mode <br />
              file = open('example.txt', 'r') <br />
              # Read the entire file content <br />
              content = file.read() <br />
              print(content) <br />
              file.close()
            </code>
          </pre>
          <p>**Example Output**:</p>
          <pre>
            This is a sample text file.
            It contains multiple lines.
            This is the third line.
          </pre><br/>

          <h2>3. Reading One Line at a Time with <code>.readline()</code></h2>
          <p>The <code>.readline()</code> method reads one line at a time from the file. You can call <code>.readline()</code> multiple times to read all lines in the file.</p>
          <pre>
            <code>
              file = open('example.txt', 'r') <br />
              line1 = file.readline() <br />
              print(line1) <br />
              line2 = file.readline() <br />
              print(line2) <br />
              file.close()
            </code>
          </pre>
          <p>**Example Output**:</p>
          <pre>
            This is a sample text file.
            It contains multiple lines.
          </pre><br/>

          <h2>4. Reading All Lines as a List with <code>.readlines()</code></h2>
          <p>The <code>.readlines()</code> method reads all lines from the file and returns them as a list of strings. Each element of the list represents a line in the file.</p>
          <pre>
            <code>
              file = open('example.txt', 'r') <br />
              lines = file.readlines() <br />
              for line in lines: <br />
                print(line) <br />
              file.close()
            </code>
          </pre>
          <p>**Example Output**:</p>
          <pre>
            This is a sample text file.
            It contains multiple lines.
            This is the third line.
          </pre><br/>

          <h2>5. Using <code>with</code> Statement (Recommended)</h2>
          <p>Using the <code>with</code> statement is the recommended way to work with files in Python. It automatically takes care of closing the file once the operations are done, even if an error occurs.</p>
          <pre>
            <code>
              with open('example.txt', 'r') as file: <br />
              content = file.read() <br />
              # The file is automatically closed after the block <br />
              print(content)
            </code>
          </pre>
          <p>**Example Output**:</p>
          <pre>
            This is a sample text file.
            It contains multiple lines.
            This is the third line.
          </pre><br/>

          <h2>Summary of File Reading Methods:</h2>
          <ul>
            <li><code>.read()</code>: Reads the entire file at once.</li><br/>
            <li><code>.readline()</code>: Reads one line at a time.</li><br/>
            <li><code>.readlines()</code>: Reads all lines and returns them as a list.</li><br/>
            <li><code>with</code> statement: Ensures the file is automatically closed after the block is executed.</li>
          </ul><br/>

          <p>Using the <code>with</code> statement is generally considered best practice because it manages file resources efficiently.</p>
        </div>
      )}
   




   {selectedChapter === 'chapter70' && (
  <div className={style.chaptercontent}>
    <h1 className={style.heading}>Write and Create Files</h1>

    <p>
      In Python, you can create and write to files using built-in functions. This is essential for saving data, creating logs, or storing results. Here’s a brief overview of how to create and write to files in Python:
    </p><br/>

    <h2>1. Creating and Writing to Files with <code>open()</code></h2>
    <p>
      You can create and write to files using the <code>open()</code> function in write (<code>'w'</code>) or append (<code>'a'</code>) mode. If the file does not exist, Python will create it. If the file already exists and you open it in write mode (<code>'w'</code>), it will be overwritten. In append mode (<code>'a'</code>), the data will be added to the end of the file without overwriting its contents.
    </p>

    <h3>Example 1: Writing to a New File</h3>
    <pre>
      <code>
        {`# Creating and writing to a new file
file = open('example.txt', 'w')
file.write("Hello, this is a new file!\\n")
file.write("This is the second line.\\n")
file.close()`}
      </code>
    </pre>
    <p>
      The file <code>'example.txt'</code> is created, and the text "Hello, this is a new file!" is written to it. The file is closed after writing.
    </p>
    <p><strong>Output:</strong> A new file <code>'example.txt'</code> is created with the following content:</p>
    <pre>
      <code>
        {`Hello, this is a new file!
This is the second line.`}
      </code>
    </pre><br/>

    <h3>Example 2: Appending to an Existing File</h3>
    <pre>
      <code>
        {`# Opening the file in append mode and adding more content
file = open('example.txt', 'a')
file.write("This line is appended to the file.\\n")
file.close()`}
      </code>
    </pre>
    <p>
      The file <code>'example.txt'</code> is opened in append mode (<code>'a'</code>), which means new content will be added without overwriting the existing content.
    </p>
    <p><strong>Output:</strong> The file <code>'example.txt'</code> now contains:</p>
    <pre>
      <code>
        {`Hello, this is a new file!
This is the second line.
This line is appended to the file.`}
      </code>
    </pre><br/>

    <h2>2. Using the <code>with</code> Statement (Recommended)</h2>
    <p>
      The <code>with</code> statement is the preferred way to handle files because it ensures that the file is automatically closed after the block of code is executed, even if an error occurs.
    </p>
    <h3>Example 3: Writing to a File Using <code>with</code>:</h3>
    <pre>
      <code>
        {`# Using 'with' to write to a file
with open('example.txt', 'w') as file:
    file.write("This content is written using the 'with' statement.\\n")`}
      </code>
    </pre>
    <p>
      The <code>with</code> statement automatically handles closing the file after the block completes. It creates or overwrites the file <code>'example.txt'</code> and writes the content.
    </p>
    <p><strong>Output:</strong> The file <code>'example.txt'</code> contains:</p>
    <pre>
      <code>
        {`This content is written using the 'with' statement.`}
      </code>
    </pre><br/>

    <h2>3. Writing Multiple Lines with <code>writelines()</code></h2>
    <p>
      If you want to write multiple lines to a file at once, you can use the <code>writelines()</code> method, which accepts a list of strings.
    </p>

    <h3>Example 4: Writing Multiple Lines</h3>
    <pre>
      <code>
        {`lines = ["First line\\n", "Second line\\n", "Third line\\n"]
with open('example.txt', 'w') as file:
    file.writelines(lines)`}
      </code>
    </pre>
    <p>
      A list of strings is provided, each representing a line. The <code>writelines()</code> method writes each line to the file.
    </p>
    <p><strong>Output:</strong> The file <code>'example.txt'</code> will contain:</p>
    <pre>
      <code>
        {`First line
Second line
Third line`}
      </code>
    </pre><br/>

    <h2>4. File Modes Summary:</h2>
    <ul>
      <li><code>'w'</code>: Write mode. Creates a new file or overwrites an existing file.</li><br/>
      <li><code>'a'</code>: Append mode. Adds content to the end of an existing file without overwriting it.</li><br/>
      <li><code>'x'</code>: Exclusive creation mode. Creates a new file, but fails if the file already exists.</li>
    </ul><br/>

    <h2>Conclusion:</h2>
    <ul>
      <li>To create and write to files in Python, you use the <code>open()</code> function.</li><br/>
      <li>The <code>w</code> mode creates or overwrites the file, and the <code>a</code> mode appends content to the file.</li><br/>
      <li>It's recommended to use the <code>with</code> statement, as it handles file closing automatically and is more efficient.</li>
    </ul>
  </div>
)}






          {selectedChapter === 'chapter71' && (
            <div className={style.chaptercontent}>
              <h1 className={style.heading}>  Python File Deletion  </h1>

      <p>
        In Python, you can delete files using the <code>os</code> module. The <code>os.remove()</code> function is used to delete a file. If you want to check whether a file exists before trying to delete it, you can use <code>os.path.exists()</code> to avoid errors.
      </p><br/>

      <h2>1. Deleting a File Using <code>os.remove()</code></h2>
      <p>
        The <code>os.remove()</code> function is used to delete a specific file.
      </p>
      <pre>
        <code>{`import os\nos.remove('filename')`}</code>
      </pre>
      <h3>Example 1: Deleting a File</h3>
      <pre>
        <code>{`import os\n\n# Delete a file\nos.remove('example.txt')`}</code>
      </pre>
      <p>
        <strong>Explanation:</strong> This will delete the file <code>example.txt</code> from the current working directory. If the file doesn't exist, it will raise a <code>FileNotFoundError</code>.
      </p><br/>

      <h2>2. Checking if a File Exists Before Deleting</h2>
      <p>
        It’s good practice to check if the file exists before attempting to delete it to avoid errors. You can use <code>os.path.exists()</code> to check whether the file exists.
      </p>
      <pre>
        <code>{`import os\n\n# Check if the file exists\nif os.path.exists('example.txt'):\n  os.remove('example.txt')\n  print("File deleted successfully")\nelse:\n  print("The file does not exist")`}</code>
      </pre>
      <p>
        <strong>Explanation:</strong> This code checks whether <code>example.txt</code> exists before trying to delete it. If the file is found, it is deleted; otherwise, a message is printed stating that the file does not exist.
      </p><br/>

      <h2>3. Deleting Multiple Files in a Directory</h2>
      <p>
        You can use the <code>os</code> module along with a loop to delete multiple files in a directory.
      </p>
      <pre>
        <code>{`import os\n\n# List all files in the directory\nfiles = os.listdir('/path/to/directory')\n\n# Loop through and remove each file\nfor file in files:\n  file_path = os.path.join('/path/to/directory', file)\n  if os.path.isfile(file_path):  # Check if it is a file (not a directory)\n    os.remove(file_path)\n    print(f"Deleted {file}")`}</code>
      </pre>
      <p>
        <strong>Explanation:</strong> This code will list all files in the specified directory and delete them one by one. It checks whether the item is a file using <code>os.path.isfile()</code> before attempting to delete it.
      </p><br/>

      <h2>4. Using <code>os.rmdir()</code> to Remove an Empty Directory</h2>
      <p>
        If you need to remove an empty directory, you can use <code>os.rmdir()</code>.
      </p>
      <pre>
        <code>{`import os\n\n# Remove an empty directory\nos.rmdir('empty_directory')`}</code>
      </pre>
      <p>
        <strong>Explanation:</strong> The <code>os.rmdir()</code> function deletes an empty directory. If the directory contains files, it will raise a <code>OSError</code>.
      </p><br/>

      <h2>5. Using <code>shutil.rmtree()</code> to Remove a Non-Empty Directory</h2>
      <p>
        If you need to delete a directory and all its contents (including subdirectories and files), you can use the <code>shutil.rmtree()</code> function from the <code>shutil</code> module.
      </p>
      <pre>
        <code>{`import shutil\n\n# Remove a non-empty directory and all its contents\nshutil.rmtree('non_empty_directory')`}</code>
      </pre>
      <p>
        <strong>Explanation:</strong> The <code>shutil.rmtree()</code> function removes a directory and all its contents. Be cautious when using this function as it permanently deletes the directory and everything inside it.
      </p><br/>

      <h2>Summary:</h2>
      <ul>
        <li><code>os.remove()</code>: Deletes a single file.</li><br/>
        <li><code>os.path.exists()</code>: Check if a file exists before deleting.</li><br/>
        <li><code>os.rmdir()</code>: Deletes an empty directory.</li><br/>
        <li><code>shutil.rmtree()</code>: Deletes a directory and all its contents.</li>
      </ul><br/>
      <p>
        Deleting files and directories should be done with caution, especially if you're dealing with important data. Always make sure you are deleting the correct files, and consider adding safeguards to your code when performing these operations.
      </p>
    </div>
  )}





          {selectedChapter === 'chapter72' && (
            <div className={style.chaptercontent}>
              <h1 className={style.heading}>       Introduction to NumPy        </h1>

      <p>
        NumPy is a powerful library in Python used for numerical and scientific computing. It provides support for large, multi-dimensional arrays and matrices, along with a collection of high-level mathematical functions to operate on these arrays. NumPy is the foundation for most scientific computing in Python and is widely used in data analysis, machine learning, and artificial intelligence.
      </p><br/>

      <h2>1. Importing NumPy</h2>
      <p>To use NumPy, you first need to import it into your Python script. It's commonly imported as `np` for convenience.</p>
      <pre>
        <code>
          {`import numpy as np`}
        </code>
      </pre><br/>

      <h2>2. Creating Arrays</h2>
      <p>NumPy provides several ways to create arrays, which are similar to lists but more efficient for numerical operations.</p>

      <h3 style={{paddingBottom:"6px"}}>a) Creating a 1D array</h3>
      <pre>
        <code>
          {`arr = np.array([1, 2, 3, 4])`}
        </code>
      </pre>
      <p>Output:</p>
      <pre>
        <code>
          {`[1 2 3 4]`}
        </code>
      </pre>

      <h3 style={{paddingBottom:"6px"}}>b) Creating a 2D array (matrix)</h3>
      <pre>
        <code>
          {`arr_2d = np.array([[1, 2], [3, 4]])`}
        </code>
      </pre>
      <p>Output:</p>
      <pre>
        <code>
          {`[[1 2]
           [3 4]]`}
        </code>
      </pre>

      <h3 style={{paddingBottom:"6px"}}>c) Using built-in functions to create arrays</h3>
      <p>Here are some useful built-in functions for creating arrays:</p>

      <ul>
        <li><code>np.zeros((2, 3))</code> - Creates a 2x3 array of zeros</li><br/>
        <li><code>np.ones((3, 2))</code> - Creates a 3x2 array of ones</li><br/>
        <li><code>np.arange(0, 10, 2)</code> - Creates an array with values from 0 to 10 with a step of 2</li><br/>
        <li><code>np.linspace(0, 1, 5)</code> - Creates an array of 5 evenly spaced values between 0 and 1</li>
      </ul><br/>

      <h2>3. Array Operations</h2>
      <p>NumPy supports element-wise operations and mathematical functions on arrays.</p>

      <h3 style={{paddingBottom:"6px"}}>a) Arithmetic operations</h3>
      <pre>
        <code>
          {`arr1 = np.array([1, 2, 3])
arr2 = np.array([4, 5, 6])
sum_arr = arr1 + arr2
prod_arr = arr1 * arr2`}
        </code>
      </pre>
      <p>Output for addition:</p>
      <pre>
        <code>
          {`[5 7 9]`}
        </code>
      </pre>
      <p>Output for multiplication:</p>
      <pre>
        <code>
          {`[4 10 18]`}
        </code>
      </pre>

      <h3 style={{paddingBottom:"6px"}}>b) Statistical functions</h3>
      <pre>
        <code>
          {`arr = np.array([1, 2, 3, 4, 5])
print(np.mean(arr))   # Mean: 3.0
print(np.median(arr)) # Median: 3.0
print(np.std(arr))    # Standard deviation: 1.414`}
        </code>
      </pre><br/>

      <h2>4. Array Indexing and Slicing</h2>
      <p>You can access elements of NumPy arrays using indexing and slicing, similar to Python lists.</p>

      <h3 style={{paddingBottom:"6px"}}>a) Indexing</h3>
      <pre>
        <code>
          {`arr = np.array([1, 2, 3, 4, 5])
print(arr[0])  # Output: 1`}
        </code>
      </pre>

      <h3 style={{paddingBottom:"6px"}}>b) Slicing</h3>
      <pre>
        <code>
          {`arr = np.array([1, 2, 3, 4, 5])
print(arr[1:4])  # Output: [2 3 4]`}
        </code>
      </pre><br/>

      <h2>5. Matrix Operations</h2>
      <h3 style={{paddingBottom:"6px"}}>a) Dot Product</h3>
      <pre>
        <code>
          {`arr1 = np.array([1, 2])
arr2 = np.array([3, 4])
dot_product = np.dot(arr1, arr2)
print(dot_product)  # Output: 11`}
        </code>
      </pre>

      <h3 style={{paddingBottom:"6px"}}>b) Matrix Transpose</h3>
      <pre>
        <code>
          {`matrix = np.array([[1, 2], [3, 4]])
transposed = np.transpose(matrix)
print(transposed)  # Output: [[1 3] [2 4]]`}
        </code>
      </pre><br/>

      <h2>6. Reshaping Arrays</h2>
      <pre>
        <code>
          {`arr = np.array([1, 2, 3, 4, 5, 6])
reshaped_arr = arr.reshape(2, 3)  # Reshape to 2x3 matrix`}
        </code>
      </pre>
      <p>Output:</p>
      <pre>
        <code>
          {`[[1 2 3]
 [4 5 6]]`}
        </code>
      </pre><br/>

      <h2>7. Broadcasting</h2>
      <pre>
        <code>
          {`arr = np.array([1, 2, 3])
result = arr + 5  # Broadcasting the scalar 5 to all elements of arr`}
        </code>
      </pre>
      <p>Output:</p>
      <pre>
        <code>
          {`[6 7 8]`}
        </code>
      </pre><br/>

      <h2>8. Random Numbers</h2>
      <pre>
        <code>
          {`# Generate random numbers from a uniform distribution
random_arr = np.random.rand(2, 3)  # 2x3 matrix of random numbers between 0 and 1`}
        </code>
      </pre>
      <p>Output:</p>
      <pre>
        <code>
          {`[[0.22924958 0.90664393 0.82707475]
 [0.59953933 0.10958572 0.47606553]]`}
        </code>
      </pre><br/>

      <h2>Summary</h2>
      <p>
        NumPy provides an efficient way to work with arrays, including multi-dimensional arrays (matrices). It supports element-wise operations, matrix operations, and statistical functions. You can reshape arrays, broadcast them for operations of different shapes, and even generate random numbers for simulations or testing.
      </p>
    </div>
  )}





      {selectedChapter === 'chapter73' && (
        <div className={style.chaptercontent}>
          <h1 className={style.heading}>Pandas </h1>

          <p>
            Pandas is a powerful and widely-used library in Python for data manipulation and analysis. It provides data structures like <code>DataFrame</code> and <code>Series</code> that make it easier to handle and analyze large datasets. With Pandas, you can perform tasks such as reading and writing data, cleaning data, filtering, grouping, merging, and performing statistical analysis.
          </p><br/>

          <h2>1. Importing Pandas</h2>
          <p>Before using Pandas, you need to import it into your script. It's usually imported as <code>pd</code>.</p>
          <pre><code>import pandas as pd</code></pre><br/>

          <h2>2. Creating DataFrames</h2>
          <p>The core data structure in Pandas is the <code>DataFrame</code>, which is similar to a table (like a spreadsheet or SQL table). It can be created from various data sources, such as lists, dictionaries, or external files (CSV, Excel, etc.).</p>

          <h3>a) Creating a DataFrame from a Dictionary</h3>
          <pre>
            <code>
              {`data = {'Name': ['Alice', 'Bob', 'Charlie'],
                      'Age': [24, 27, 22],
                      'City': ['New York', 'Los Angeles', 'Chicago']}

              df = pd.DataFrame(data)
              print(df)`}
            </code>
          </pre>
          <p>Output:</p>
          <pre>
            <code>
              {`      Name  Age         City
              0    Alice   24     New York
              1      Bob   27  Los Angeles
              2  Charlie   22      Chicago`}
            </code>
          </pre><br/>

          <h2>3. Reading Data</h2>
          <p>Pandas provides several functions to read data from different file formats, such as CSV, Excel, and SQL databases.</p>
          
          <h3>a) Reading a CSV File</h3>
          <pre><code>df = pd.read_csv('data.csv')</code></pre>
          
          <h3>b) Reading an Excel File</h3>
          <pre><code>df = pd.read_excel('data.xlsx', sheet_name='Sheet1')</code></pre>
          <br/>
          <h2>4. Exploring Data</h2>
          <h3>a) Viewing the First Few Rows</h3>
          <pre><code>print(df.head())</code></pre>
          
          <h3>b) Summary of Data</h3>
          <pre><code>print(df.info())</code></pre>
          <pre><code>print(df.describe())</code></pre>
          <br/>
          <h2>5. Selecting Data</h2>
          <h3>a) Selecting a Column</h3>
          <pre><code>age_column = df['Age']</code></pre>
          
          <h3>b) Selecting Multiple Columns</h3>
          <pre><code>columns = df[['Name', 'City']]</code></pre>
          
          <h3>c) Selecting Rows by Index</h3>
          <pre><code>row = df.iloc[1]</code></pre>
          
          <h3>d) Selecting Rows Based on Conditions</h3>
          <pre><code>{`young_people = df[df['Age'] < 25]`}</code></pre>
          <br/>
          <h2>6. Modifying Data</h2>
          <h3>a) Adding a New Column</h3>
          <pre><code>df['Country'] = ['USA', 'USA', 'USA']</code></pre>
          
          <h3>b) Updating an Existing Column</h3>
          <pre><code>df['Age'] = df['Age'] + 1</code></pre>
         
          <h3>c) Deleting a Column</h3>
          <pre><code>df = df.drop('Country', axis=1)</code></pre>
          <br/>
          <h2>7. Data Cleaning</h2>
          <h3>a) Handling Missing Data</h3>
          <pre><code>df = df.dropna()</code></pre>
          <pre><code>df = df.fillna('Unknown')</code></pre>
          
          <h3>b) Changing Data Types</h3>
          <pre><code>df['Age'] = df['Age'].astype(float)</code></pre>
          <br/>
          <h2>8. Grouping Data</h2>
          <h3>a) Group by a Column</h3>
          <pre><code>grouped = df.groupby('City')['Age'].mean()</code></pre>
          <br/>
          <h2>9. Merging and Joining Data</h2>
          <h3>a) Merging DataFrames</h3>
          <pre>
            <code>
              {`df1 = pd.DataFrame({'Name': ['Alice', 'Bob'], 'Age': [24, 27]})
              df2 = pd.DataFrame({'Name': ['Alice', 'Bob'], 'City': ['New York', 'Los Angeles']})

              merged_df = pd.merge(df1, df2, on='Name')
              print(merged_df)`}
            </code>
          </pre>
          <p>Output:</p>
          <pre>
            <code>
              {`    Name  Age         City
              0  Alice   24     New York
              1    Bob   27  Los Angeles`}
            </code>
          </pre><br/>

          <h2>10. Sorting Data</h2>
          <pre><code>df_sorted = df.sort_values(by='Age', ascending=False)</code></pre>
          <br/>
          <h2>11. Writing Data</h2>
          <h3>a) Writing to a CSV File</h3>
          <pre><code>df.to_csv('output.csv', index=False)</code></pre>

          <h3>b) Writing to an Excel File</h3>
          <pre><code>df.to_excel('output.xlsx', index=False)</code></pre>
          <br/>
          <h2>Summary of Key Functions in Pandas:</h2>
          <ul>
            <li><code>pd.DataFrame()</code>: Create a DataFrame from various data sources.</li><br/>
            <li><code>pd.read_csv()</code> and <code>pd.read_excel()</code>: Read data from CSV or Excel files.</li><br/>
            <li><code>df.head()</code>, <code>df.tail()</code>: View the first and last few rows of the DataFrame.</li><br/>
            <li><code>df.info()</code> and <code>df.describe()</code>: Get summary information about the data.</li><br/>
            <li><code>df['Column']</code>: Select a column.</li><br/>
            <li><code>df.iloc[]</code>: Select rows by index.</li><br/>
            <li><code>df.groupby()</code>: Group data for aggregation.</li><br/>
            <li><code>df.merge()</code>: Merge DataFrames.</li><br/>
            <li><code>df.to_csv()</code> and <code>df.to_excel()</code>: Write data back to files.</li>
          </ul><br/>

          <h2>Conclusion:</h2>
          <p>
            Pandas is a versatile and powerful library for data manipulation, making it easy to work with large datasets. It provides a wide range of functions for importing, cleaning, transforming, and analyzing data, and is widely used in data science, machine learning, and data analysis tasks.
          </p>
        </div>
      )}
    




    {selectedChapter === 'chapter74' && (
            <div className={style.chaptercontent}>
              <h1 className={style.heading}>  SciPy Module   </h1>

        
        <p>SciPy is an open-source Python library used for scientific and technical computing. It builds on NumPy and provides a collection of mathematical algorithms and functions that operate on NumPy arrays. SciPy is particularly useful for tasks such as optimization, integration, interpolation, eigenvalue problems, and more.</p>
        <br/>
        <h2>Key Features of SciPy:</h2>
        <ul>
          <li><strong>Optimization:</strong> Functions to minimize or maximize scalar or vector functions.</li><br/>
          <li><strong>Integration:</strong> Numerical integration of functions (e.g., solving differential equations).</li><br/>
          <li><strong>Interpolation:</strong> Tools for interpolating data points.</li><br/>
          <li><strong>Linear Algebra:</strong> Solvers for linear systems, eigenvalues, and other linear algebra tasks.</li><br/>
          <li><strong>Statistics:</strong> Functions for statistical distributions and hypothesis testing.</li>
        </ul><br/>

        <h2>Example of Using SciPy:</h2>
        
        <h3>1. Installation:</h3>
        <p>You can install SciPy using pip:</p>
        <pre><code>pip install scipy</code></pre><br/>

        <h3>2. Basic Example:</h3>
        <p>Let’s look at an example of using SciPy for optimization and integration.</p>

        <h4>a) Optimization:</h4>
        <p>SciPy provides optimization algorithms to find the minimum or maximum of a function. For example, let's minimize a simple quadratic function.</p>
        
        <pre><code>{`
          import scipy.optimize as opt

          # Define a function
          def func(x):
              return x**2 + 3*x + 2

          # Find the minimum of the function
          result = opt.minimize(func, 0)  # Starting guess at x=0
          print("Minimization result:", result)`}
        </code></pre>

        <p><strong>Output:</strong></p>
        <pre><code>{`
          Minimization result:   message: Optimization terminated successfully
             success: True
              status: 0
                 fun: 2.0
                   x: -1.5
                 nit: 2
                 jac: array([0.])
                nfev: 3
                njev: 1  `}
        </code></pre>

        <p>In this example, the function <code>f(x) = x^2 + 3x + 2</code> is minimized, and SciPy finds the value of <code>x</code> that minimizes the function (which is <code>x = -1.5</code>).</p>
        <br/>
        <h4>b) Integration:</h4>
        <p>SciPy provides numerical integration functions, such as <code>quad</code> for integrating a function over a specific interval.</p>

        <pre><code>{`
          import scipy.integrate as integrate

          # Define a function to integrate
          def integrand(x):
              return x**2

          # Perform the integration of x^2 from 0 to 1
          result, error = integrate.quad(integrand, 0, 1)
          print("Integration result:", result)  `}
        </code></pre>

        <p><strong>Output:</strong></p>
        <pre><code>
          Integration result: 0.33333333333333337
        </code></pre>

        <p>Here, we integrate the function <code>f(x) = x^2</code> from 0 to 1, and SciPy calculates the result as approximately <code>0.333</code>.</p>
        <br/>
        <h3>3. Other Common Use Cases:</h3>
        <ul>
          <li><strong>Interpolation:</strong> SciPy provides interpolation tools to estimate values between discrete data points. For example, using <code>scipy.interpolate.interp1d()</code> to create an interpolating function.</li><br/>
          <li><strong>Linear Algebra:</strong> SciPy has functions for solving linear systems of equations, computing eigenvalues, and more (using <code>scipy.linalg</code>).</li><br/>
          <li><strong>Signal Processing:</strong> Functions for working with signals (e.g., Fourier transforms, filtering, etc.).</li>
        </ul><br/>
        <br/>
        <h2>Conclusion:</h2>
        <p>SciPy is a powerful tool for scientific computing in Python, offering a wide range of functions for optimization, integration, linear algebra, statistics, and more. It works seamlessly with NumPy arrays and provides a high-level interface for performing complex mathematical tasks with just a few lines of code.</p>
      </div>
    )}






        {selectedChapter === 'chapter75' && (
            <div className={style.chaptercontent}>
              <h1 className={style.heading}> Django Framework  </h1>

        <p>
          Django is a high-level, open-source web framework for Python that allows developers to build robust and scalable web applications quickly. It follows the "Don't Repeat Yourself" (DRY) principle and emphasizes the reusability of components, making it an efficient tool for web development. Django is based on the model-template-views (MTV) architecture pattern, which is similar to the popular model-view-controller (MVC) pattern.
        </p><br/>

        <h3>Key Features of Django:</h3>
        <ul>
          <li><strong>Fast Development:</strong> Django allows for rapid development with built-in features, so you can focus more on writing the application logic rather than worrying about basic functionality like authentication, database access, etc.</li><br/>
          <li><strong>ORM (Object-Relational Mapping):</strong> Django includes a built-in ORM, which allows developers to interact with the database using Python code, rather than writing raw SQL queries. It provides a high-level interface for defining models and manipulating database records.</li><br/>
          <li><strong>Security:</strong> Django provides several built-in security features, such as protection against SQL injection, cross-site scripting (XSS), cross-site request forgery (CSRF), and clickjacking.</li><br/>
          <li><strong>Admin Interface:</strong> One of Django's most powerful features is the built-in admin interface that allows developers and administrators to manage database content easily. It is auto-generated from your models, saving time when creating CRUD (Create, Read, Update, Delete) interfaces.</li><br/>
          <li><strong>URL Routing:</strong> Django uses a URL dispatcher to map user requests to specific views, making it easy to manage URLs and handle different types of requests in a clean way.</li><br/>
          <li><strong>Templates:</strong> Django includes a powerful templating engine that allows you to generate dynamic HTML pages. It supports inheritance, includes, and loops, which makes rendering data to the front-end very flexible.</li><br/>
          <li><strong>Scalability:</strong> Django’s structure allows for scaling applications easily. It is capable of handling high traffic and can be used in complex, large-scale applications.</li><br/>
          <li><strong>Built-in Tools:</strong> Django comes with several built-in tools, such as:
            <ul><br/>
              <li>Authentication and Authorization</li><br/>
              <li>URL routing</li><br/>
              <li>Form handling</li><br/>
              <li>Caching</li><br/>
              <li>Middleware for request processing</li>
            </ul>
          </li>
        </ul><br/>

        <h3>Example of a Simple Django Application:</h3>
        
        <h4>1. Installation:</h4>
        <p>You can install Django using pip:</p>
        <pre><code>pip install django</code></pre><br/>

        <h4>2. Creating a New Django Project:</h4>
        <p>Once Django is installed, you can create a new project by running:</p>
        <pre><code>django-admin startproject myproject</code></pre>
        <pre><code>cd myproject</code></pre><br/>

        <h4>3. Creating a Django App:</h4>
        <p>A Django project consists of one or more apps. You can create an app by running:</p>
        <pre><code>python manage.py startapp myapp</code></pre><br/>

        <h4>4. Defining Models:</h4>
        <p>In your <code>models.py</code> file, you can define the database structure using Django's ORM:</p>
        <pre><code>{`
from django.db import models

class Book(models.Model):
    title = models.CharField(max_length=100)
    author = models.CharField(max_length=100)
    published_date = models.DateField()

    def __str__(self):
        return self.title  `}
        </code></pre><br/>

        <h4>5. Running Migrations:</h4>
        <p>After defining models, you can generate the database schema with migrations and apply them:</p>
        <pre><code>python manage.py makemigrations</code></pre>
        <pre><code>python manage.py migrate</code></pre><br/>

        <h4>6. Creating Views:</h4>
        <p>In the <code>views.py</code> file, you can create functions or classes to handle requests and return responses:</p>
        <pre><code>{`
from django.http import HttpResponse

def home(request):
    return HttpResponse("Hello, Django!")
        </code></pre>

        <h4>7. Configuring URLs:</h4>
        <p>In the <code>urls.py</code> file, you define the URL patterns that link to your views:</p>
        <pre><code>
from django.urls import path
from . import views

urlpatterns = [
    path('', views.home, name='home'),
]
       `} </code></pre><br/>

        <h4>7. Running the Server:</h4>
        <p>You can run the development server to test your application:</p>
        <pre><code>python manage.py runserver</code></pre>

        <p>After running the server, you can access the app in your browser at <code>http://127.0.0.1:8000/</code>.</p>
        <br/>
        <h3>Conclusion:</h3>
        <p>Django is a powerful and flexible framework that allows developers to quickly build secure, scalable web applications. It provides everything you need to build a web application, including ORM, routing, templating, and much more, making it one of the most popular Python web frameworks. Its community-driven development ensures that Django continues to be a reliable and effective solution for both small and large-scale projects.</p>
      </div>
    
  )}




          {selectedChapter === 'chapter76' && (
            <div className={style.chaptercontent}>
              <h1 className={style.heading}>  Introduction to Matplotlib  </h1>



      <p>
        <strong>Matplotlib</strong> is one of the most popular and widely used plotting libraries in Python. It allows you to create a wide variety of static, animated, and interactive plots and visualizations, such as line plots, bar charts, histograms, scatter plots, 3D plots, and more. Matplotlib is highly customizable and provides flexibility to create complex plots with fine control over styling.
      </p>
      <p>
        Matplotlib works well with <strong>NumPy</strong> for data handling and can be used to plot data from other libraries such as <strong>Pandas</strong> as well.
      </p>

      <h2 style={{paddingBottom:"6px"}}>Key Features of Matplotlib:</h2>
      <ul>
        <li><strong>High-level plotting</strong>: Create complex plots with a few lines of code.</li><br/>
        <li><strong>Customization</strong>: Control over every aspect of the plot, from colors and lines to axes and labels.</li><br/>
        <li><strong>Compatibility</strong>: Works seamlessly with NumPy, Pandas, and other Python libraries.</li><br/>
        <li><strong>Interactive plots</strong>: Can be used to create interactive plots when integrated with tools like Jupyter Notebooks.</li><br/>
        <li><strong>Export</strong>: Save plots in a variety of formats like PNG, PDF, SVG, and more.</li>
      </ul><br/>

      <h2>Installation</h2>
      <p>To use Matplotlib in your Python environment, you need to install it first. You can do this using <code>pip</code>:</p>
      <pre><code>pip install matplotlib</code></pre><br/>

      <h2 style={{paddingBottom:"6px"}}>Basic Example of Plotting with Matplotlib</h2>
      <h3>1. Importing Matplotlib:</h3>
      <p>Typically, you'll use <code>matplotlib.pyplot</code> for plotting.</p>
      <pre><code>import matplotlib.pyplot as plt</code></pre><br/>

      <h3>2. Creating a Simple Line Plot:</h3>
      <p>Here’s a simple example of how to create a line plot:</p>
      <pre><code>
{`import matplotlib.pyplot as plt

# Data to plot
x = [1, 2, 3, 4, 5]
y = [1, 4, 9, 16, 25]

# Create a line plot
plt.plot(x, y)

# Add labels and title
plt.xlabel('X-axis')
plt.ylabel('Y-axis')
plt.title('Simple Line Plot')

# Display the plot
plt.show()`}
      </code></pre>

      <p><strong>Explanation:</strong></p>
      <ul>
        <li><code>plt.plot(x, y)</code>: This creates a line plot of <code>y</code> against <code>x</code>.</li><br/>
        <li><code>plt.xlabel()</code> and <code>plt.ylabel()</code>: These set the labels for the X and Y axes.</li><br/>
        <li><code>plt.title()</code>: Sets the title of the plot.</li><br/>
        <li><code>plt.show()</code>: Displays the plot in the output.</li>
      </ul><br/>

      <h2 style={{paddingBottom:"6px"}}>Common Types of Plots</h2>
      <h3>1. Line Plot (Most basic plot type):</h3>
      <p>Line plots are used to represent data points connected by straight lines. The example above shows how to plot a simple line chart.</p>
      <br/>
      <h3>2. Bar Plot:</h3>
      <pre><code>
{`# Bar plot
categories = ['A', 'B', 'C', 'D']
values = [5, 7, 3, 4]

plt.bar(categories, values)
plt.title('Simple Bar Plot')
plt.show()`}
      </code></pre><br/>

      <h3>3. Histogram:</h3>
      <pre><code>
{`import numpy as np

# Random data
data = np.random.randn(1000)

# Create a histogram
plt.hist(data, bins=30, alpha=0.7, color='blue')
plt.title('Histogram')
plt.show()`}
      </code></pre><br/>

      <h3>4. Scatter Plot:</h3>
      <pre><code>
{`x = [1, 2, 3, 4, 5]
y = [5, 4, 3, 2, 1]

# Scatter plot
plt.scatter(x, y)
plt.title('Scatter Plot')
plt.show()`}
      </code></pre><br/>

      <h3>5. Pie Chart:</h3>
      <pre><code>
{`sizes = [15, 30, 45, 10]
labels = ['A', 'B', 'C', 'D']

# Pie chart
plt.pie(sizes, labels=labels, autopct='%1.1f%%')
plt.title('Pie Chart')
plt.show()`}
      </code></pre><br/>

      <h2>Customizing Plots</h2>
      <p>Matplotlib provides numerous customization options, such as:</p><br/>
      <ul>
        <li><strong>Line styles, colors, and markers</strong> in line plots.</li><br/>
        <li><strong>Adding legends</strong>, grid lines, and more.</li>
      </ul>

      <pre><code>
{`x = [1, 2, 3, 4, 5]
y = [1, 4, 9, 16, 25]

# Customizing the line plot
plt.plot(x, y, color='green', linestyle='--', marker='o')

# Adding labels and title
plt.xlabel('X-axis')
plt.ylabel('Y-axis')
plt.title('Customized Line Plot')

# Display the plot
plt.show()`}
      </code></pre><br/>

      <h2>Saving Plots</h2>
      <p>You can save plots as images (e.g., PNG, JPG, PDF, etc.) using <code>plt.savefig()</code>.</p>
      <pre><code>
{`plt.plot(x, y)
plt.title('Save Plot Example')

# Save the plot as a PNG image
plt.savefig('line_plot.png')`}
      </code></pre><br/>

      <h2>Conclusion</h2>
      <p>
        Matplotlib is a powerful and flexible plotting library that provides a wide range of plotting options for creating static, animated, and interactive plots. It's a great choice for anyone looking to visualize data in Python. Once you are comfortable with basic plots, you can explore more advanced features such as 3D plotting and animations to create more dynamic visualizations.
      </p><br/>

      <h2>Example Summary:</h2>
      <pre><code>
{`import matplotlib.pyplot as plt

# Line Plot Example
x = [1, 2, 3, 4, 5]
y = [1, 4, 9, 16, 25]

plt.plot(x, y)
plt.xlabel('X-axis')
plt.ylabel('Y-axis')
plt.title('Line Plot')
plt.show()

# Save the plot
plt.savefig('line_plot.png')`}
      </code></pre>

    </div>
  )}





          {selectedChapter === 'chapter77' && (
            <div className={style.chaptercontent}>
              <h1 className={style.heading}>  Matplotlib Pyplot </h1>


      <p><strong>Matplotlib</strong> is a widely used plotting library in Python that helps to create static, animated, and interactive plots and visualizations. One of the most important modules in Matplotlib is <strong>Pyplot</strong>, which provides a MATLAB-like interface for creating plots and visualizations.</p>
      
      <p>Pyplot allows you to create various types of plots such as line plots, bar plots, histograms, scatter plots, pie charts, etc., with minimal code. It is an essential tool for data visualization in Python.</p>
      <br/>
      <h2 style={{paddingBottom:"6px"}}>Key Features of <code>matplotlib.pyplot</code>:</h2>
      <ul>
        <li><strong>Simple Interface</strong>: It provides a simple interface for creating plots with functions like <code>plot()</code>, <code>scatter()</code>, <code>bar()</code>, <code>hist()</code>, etc.</li><br/>
        <li><strong>Interactive</strong>: Works well with Jupyter notebooks to provide interactive plotting.</li><br/>
        <li><strong>Customization</strong>: Offers detailed control over plot elements such as axes, labels, titles, grid lines, legends, and more.</li><br/>
        <li><strong>Compatibility</strong>: Can be used with libraries like NumPy, Pandas, and others for handling and visualizing data.</li>
      </ul><br/>

      <h2>How to Use <code>matplotlib.pyplot</code>?</h2>
      <p>First, to use Pyplot, you need to import it:</p>
      <pre><code>import matplotlib.pyplot as plt</code></pre><br/>

      <h2 style={{paddingBottom:"6px"}}> Basic Plotting</h2>

      <h3>1. Line Plot</h3>
      <p>A simple plot where data points are connected by lines:</p>
      <pre><code>
{`import matplotlib.pyplot as plt

# Data to plot
x = [1, 2, 3, 4, 5]
y = [1, 4, 9, 16, 25]

# Create a line plot
plt.plot(x, y)

# Add labels and title
plt.xlabel('X-axis')
plt.ylabel('Y-axis')
plt.title('Simple Line Plot')

# Display the plot
plt.show()`}</code></pre><br/>

      <p><strong>Explanation</strong>:</p>
      <ul>
        <li><code>plt.plot(x, y)</code>: Plots the data points <code>(x, y)</code> as a line plot.</li><br/>
        <li><code>plt.xlabel()</code>, <code>plt.ylabel()</code>: Add labels to the X and Y axes.</li><br/>
        <li><code>plt.title()</code>: Adds a title to the plot.</li><br/>
        <li><code>plt.show()</code>: Displays the plot.</li>
      </ul><br/>

      <h3>2. Bar Plot</h3>
      <p>A bar plot is useful to compare values across categories:</p>
      <pre><code>
{`categories = ['A', 'B', 'C', 'D']
values = [5, 7, 3, 4]

plt.bar(categories, values)
plt.title('Simple Bar Plot')
plt.show()`}</code></pre><br/>

      <h3>3. Histogram</h3>
      <p>Histograms are used to show the distribution of numerical data:</p>
      <pre><code>
{`import numpy as np

# Random data
data = np.random.randn(1000)

# Create a histogram
plt.hist(data, bins=30, alpha=0.7, color='blue')
plt.title('Histogram')
plt.show()`}</code></pre><br/>

      <h3>4. Scatter Plot</h3>
      <p>Scatter plots show the relationship between two variables using individual points:</p>
      <pre><code>
{`x = [1, 2, 3, 4, 5]
y = [5, 4, 3, 2, 1]

plt.scatter(x, y)
plt.title('Scatter Plot')
plt.show()`}</code></pre><br/>

      <h3>5. Pie Chart</h3>
      <p>Pie charts are used to show proportions of a whole:</p>
      <pre><code>
{`sizes = [15, 30, 45, 10]
labels = ['A', 'B', 'C', 'D']

plt.pie(sizes, labels=labels, autopct='%1.1f%%')
plt.title('Pie Chart')
plt.show()`}</code></pre><br/>

      <h2>Customizing Plots</h2>
      <p>Matplotlib allows for extensive customization. You can change the line styles, add markers, adjust colors, set axis limits, and more.</p>

      <p>For example, here’s a customized line plot:</p>
      <pre><code>
{`x = [1, 2, 3, 4, 5]
y = [1, 4, 9, 16, 25]

# Customizing the line plot
plt.plot(x, y, color='green', linestyle='--', marker='o')

# Adding labels and title
plt.xlabel('X-axis')
plt.ylabel('Y-axis')
plt.title('Customized Line Plot')

# Display the plot
plt.show()`}</code></pre><br/>

      <h2>Adding Legends and Grid Lines</h2>
      <p>You can add legends and grid lines to your plots for better understanding:</p>
      <pre><code>
{`# Line plot with legend and grid
plt.plot(x, y, label='Data Points', color='blue')
plt.xlabel('X-axis')
plt.ylabel('Y-axis')
plt.title('Line Plot with Legend and Grid')

# Adding grid lines and legend
plt.grid(True)
plt.legend()

# Display the plot
plt.show()`}</code></pre><br/>

      <h2>Saving Plots</h2>
      <p>You can save the plot to a file (such as PNG, JPG, PDF, etc.) using <code>plt.savefig()</code>:</p>
      <pre><code>
{`# Save the plot as a PNG image
plt.plot(x, y)
plt.title('Save Plot Example')
plt.savefig('line_plot.png')`}</code></pre><br/>

      <h2>Conclusion</h2>
      <p><code>matplotlib.pyplot</code> is a powerful and flexible plotting library in Python. It provides an easy-to-use interface to create a wide range of static and interactive plots. With <code>pyplot</code>, you can visualize data effectively, making it a crucial tool for data scientists, analysts, and engineers working with Python.</p>

      <p>Once you are comfortable with basic plotting, you can explore advanced features like 3D plotting, animations, and customization options to create more dynamic and interactive visualizations.</p>
    </div>
  )}



          {selectedChapter === 'chapter78' && (
            <div className={style.chaptercontent}>
              <h1 className={style.heading}>  Matplotlib Plotting   </h1>

      <p>
        <strong>Matplotlib</strong> is a powerful plotting library in Python that allows you to create a wide variety of static, animated, and interactive plots. It is the most commonly used library for data visualization in Python and provides an easy-to-use interface for generating plots, charts, and graphs. The core module for plotting in Matplotlib is <strong>pyplot</strong>, which is often imported as <strong>plt</strong>.
      </p><br/>

      <h3 style={{paddingBottom:"6px"}}>Key Features of Matplotlib:</h3>
      <ul>
        <li><strong>Wide Variety of Plots</strong>: You can create line plots, bar plots, histograms, scatter plots, pie charts, etc.</li><br/>
        <li><strong>Customization</strong>: Provides fine control over every element of a plot including axes, titles, labels, grid lines, and legends.</li><br/>
        <li><strong>Compatibility</strong>: Works seamlessly with NumPy and Pandas for data handling and manipulation.</li><br/>
        <li><strong>Interactive</strong>: Supports interactive plotting, especially useful in Jupyter Notebooks.</li><br/>
        <li><strong>Export</strong>: Allows saving plots in various formats such as PNG, JPG, PDF, and SVG.</li>
      </ul><br/>

     

      <h3>Basic Steps for Plotting in Matplotlib:</h3>
      <ol>
        <li><strong>Import Matplotlib</strong>: Typically, you'll import the <strong>pyplot</strong> module from <strong>matplotlib</strong> as <strong>plt</strong>.</li>
        <pre><code>{`import matplotlib.pyplot as plt`}</code></pre><br/>

        <li><strong>Create Data</strong>: Create data points that you want to plot. For example, you can use lists, NumPy arrays, or Pandas dataframes to hold your data.</li>
        <pre><code>{`x = [1, 2, 3, 4, 5]\ny = [1, 4, 9, 16, 25]`}</code></pre><br/>

        <li><strong>Plot Data</strong>: The primary function to plot data is <strong>plt.plot()</strong>. This can create a line plot by default.</li>
        <pre><code>{`plt.plot(x, y)`}</code></pre><br/>

        <li><strong>Customize the Plot</strong>: You can add labels, titles, and customize the appearance (line style, markers, colors, etc.).</li>
        <pre><code>{`plt.xlabel('X-axis')\nplt.ylabel('Y-axis')\nplt.title('Simple Line Plot')`}</code></pre><br/>

        <li><strong>Display the Plot</strong>: Use <strong>plt.show()</strong> to display the plot in your environment (works well in Jupyter Notebooks).</li>
        <pre><code>{`plt.show()`}</code></pre>
      </ol><br/>

    

      <h3 style={{paddingBottom:"6px"}}>Example: Simple Line Plot</h3>
      <pre><code>
        {`import matplotlib.pyplot as plt

# Data to plot
x = [1, 2, 3, 4, 5]
y = [1, 4, 9, 16, 25]

# Create a line plot
plt.plot(x, y)

# Add labels and title
plt.xlabel('X-axis')
plt.ylabel('Y-axis')
plt.title('Simple Line Plot')

# Display the plot
plt.show()`}
      </code></pre><br/>

      <h4>Explanation:</h4>
      <ul>
        <li><strong>plt.plot(x, y)</strong>: Creates a line plot where <strong>x</strong> is on the horizontal axis and <strong>y</strong> is on the vertical axis.</li>
        <li><strong>plt.xlabel()</strong>, <strong>plt.ylabel()</strong>: Sets labels for the X and Y axes.</li>
        <li><strong>plt.title()</strong>: Adds a title to the plot.</li>
        <li><strong>plt.show()</strong>: Displays the plot.</li>
      </ul><br/>

      

      <h3 style={{paddingBottom:"6px"}}>Types of Plots in Matplotlib</h3>

      <h4>1. Line Plot</h4>
      <p>Line plots are useful to display trends over time or continuous data. They are created with <code>plt.plot()</code>.</p>
      <pre><code>{`plt.plot(x, y)`}</code></pre><br/>

      <h4>2. Bar Plot</h4>
      <p>Bar plots are used to display data with rectangular bars. The length of the bars corresponds to the value of the data.</p>
      <pre><code>{`categories = ['A', 'B', 'C', 'D']\nvalues = [5, 7, 3, 4]\nplt.bar(categories, values)\nplt.title('Simple Bar Plot')\nplt.show()`}</code></pre>
      <br/>
      <h4>3. Histogram</h4>
      <p>Histograms show the frequency distribution of a dataset by dividing the data into bins.</p>
      <pre><code>{`import numpy as np
data = np.random.randn(1000)
plt.hist(data, bins=30, alpha=0.7, color='blue')
plt.title('Histogram')
plt.show()`}</code></pre><br/>

      <h4>4. Scatter Plot</h4>
      <p>Scatter plots show the relationship between two variables using individual points.</p>
      <pre><code>{`x = [1, 2, 3, 4, 5]\ny = [5, 4, 3, 2, 1]\nplt.scatter(x, y)\nplt.title('Scatter Plot')\nplt.show()`}</code></pre>
      <br/>
      <h4>5. Pie Chart</h4>
      <p>Pie charts display proportions of a whole. Each slice of the pie represents a category.</p>
      <pre><code>{`sizes = [15, 30, 45, 10]
labels = ['A', 'B', 'C', 'D']
plt.pie(sizes, labels=labels, autopct='%1.1f%%')
plt.title('Pie Chart')
plt.show()`}</code></pre><br/>

    

      <h3 style={{paddingBottom:"6px"}}>Customizing Plots</h3>
      <p>You can customize various aspects of a plot using Matplotlib:</p>

      <h4>Line Style</h4>
      <p>Change the color, style, or markers of a line plot.</p>
      <pre><code>{`plt.plot(x, y, color='green', linestyle='--', marker='o')`}</code></pre><br/>

      <h4>Legends</h4>
      <p>Add a legend to describe the data.</p>
      <pre><code>{`plt.plot(x, y, label='Data')\nplt.legend()`}</code></pre><br/>

      <h4>Grid</h4>
      <p>Add gridlines to the plot for better readability.</p>
      <pre><code>{`plt.grid(True)`}</code></pre><br/>

      <h4>Subplots</h4>
      <p>Create multiple plots in a single figure using <code>plt.subplot()</code>.</p>
      <pre><code>{`plt.subplot(1, 2, 1)  # One row, two columns, first subplot
plt.plot(x, y)
plt.title('First Plot')

plt.subplot(1, 2, 2)  # One row, two columns, second subplot
plt.bar(categories, values)
plt.title('Second Plot')

plt.show()`}</code></pre><br/>

     

      <h3>Saving Plots</h3>
      <p>You can save your plots to files like PNG, JPG, PDF, etc., using <code>plt.savefig()</code>.</p>
      <pre><code>{`plt.plot(x, y)
plt.title('Save Plot Example')
plt.savefig('line_plot.png')  # Save as PNG image`}</code></pre><br/>

     

      <h3>Conclusion</h3>
      <p>
        <strong>Matplotlib</strong> is a versatile plotting library that allows you to create a wide range of static and interactive visualizations. It is highly customizable and integrates well with other data analysis libraries like NumPy and Pandas. Whether you need to create simple line plots or complex visualizations with multiple subplots, Matplotlib provides the tools and flexibility to make it easy.
      </p>

      <p>Once you're comfortable with basic plots, you can explore more advanced features like 3D plotting, animations, and interactive visualizations.</p>
    </div>
  )}





        {selectedChapter === 'chapter79' && (
            <div className={style.chaptercontent}>
              <h1 className={style.heading}> Matplotlib Markers  </h1>
      <p>
        In <strong>Matplotlib</strong>, markers are used to highlight individual
        data points in a plot, especially when you're visualizing line plots,
        scatter plots, or any other plot that involves data points. Markers help
        make the data more visually distinct, and they can be customized in
        various ways, including size, shape, and color.
      </p><br/>

      <h3>Marker in Matplotlib</h3>
      <p>
        A <strong>marker</strong> is a symbol (like a circle, square, diamond,
        etc.) that is drawn at each data point in a plot. You can specify markers
        for different plot types (like lines, scatter plots, etc.), and you can
        customize their appearance.
      </p><br/>

      <h3>Key Marker Styles:</h3>
      <ol>
        <li>
          <strong>Default Marker:</strong> When you plot a line, the data points
          are connected with a line, but you can add markers at the data points
          as well.
        </li>
        <pre>
          <code>plt.plot(x, y, marker='o')  # 'o' is the marker symbol for circle</code>
        </pre><br/>

        <li>
          <strong>Marker Shapes:</strong>
          <ul>
            <li>'o': Circle</li><br/>
            <li>'s': Square</li><br/>
            <li>'^': Triangle up</li><br/>
            <li>'v': Triangle down</li><br/>
            <li>'D': Diamond</li><br/>
            <li>'P': Pentagon</li><br/>
            <li>'*': Star</li><br/>
            <li>'X': X shape</li><br/>
            <li>'+': Plus sign</li><br/>
            <li>'_': Horizontal line</li>
          </ul>
          <p>Example of using a different marker shape:</p>
          <pre>
            <code>plt.plot(x, y, marker='s')  # Square marker</code>
          </pre>
        </li><br/>

        <li>
          <strong>Marker Size and Color:</strong> You can customize the size and
          color of the markers. The <strong>markersize</strong> parameter
          controls the size, and you can specify{" "}
          <strong>markerfacecolor</strong> and <strong>markeredgecolor</strong>{" "}
          for coloring the interior and edges of the marker.
        </li><br/>
        <pre>
          <code>
            plt.plot(x, y, marker='o', markersize=10, markerfacecolor='red', markeredgecolor='black')
          </code>
        </pre><br/>

        <li>
          <strong>Line Style and Markers Together:</strong> You can combine line
          styles (solid, dashed, etc.) and markers.
        </li>
        <pre><br/>
          <code>
            plt.plot(x, y, linestyle='-', marker='o', color='blue')
          </code>
        </pre><br/>

        <li>
          <strong>Customizing Marker Edge Width:</strong> The{" "}
          <strong>markeredgewidth</strong> parameter controls the thickness of
          the marker's border.
        </li>
        <pre>
          <code>
            plt.plot(x, y, marker='D', markersize=10, markeredgewidth=2)
          </code>
        </pre><br/>

        <li>
          <strong>Marker Fill Styles:</strong> The <strong>fillstyle</strong>{" "}
          parameter allows you to control whether the marker is filled or not.
          <ul>
            <li>'full': Completely filled (default).</li><br/>
            <li>'none': Not filled.</li><br/>
            <li>'left': Filled on the left side.</li><br/>
            <li>'right': Filled on the right side.</li>
          </ul>
          <pre>
            <code>
              plt.plot(x, y, marker='D', markersize=8, fillstyle='left')
            </code>
          </pre>
        </li>
      </ol><br/>

      <h3>Example Usage:</h3>
      <p>Here’s an example that demonstrates various markers and customizations:</p>
      <pre>
        <code>
          {`import matplotlib.pyplot as plt

# Data for plotting
x = [1, 2, 3, 4, 5]
y = [1, 4, 9, 16, 25]

# Plot with different markers
plt.plot(x, y, marker='o', markersize=10, markerfacecolor='red', markeredgecolor='black', linestyle='-', color='blue')
plt.title('Line Plot with Circle Markers')
plt.xlabel('X-axis')
plt.ylabel('Y-axis')
plt.show()

# Plot with square markers
plt.plot(x, y, marker='s', markersize=8, color='green')
plt.title('Line Plot with Square Markers')
plt.xlabel('X-axis')
plt.ylabel('Y-axis')
plt.show()

# Plot with custom markers (Triangle)
plt.plot(x, y, marker='^', markersize=12, markerfacecolor='yellow', markeredgecolor='purple', linestyle='--')
plt.title('Line Plot with Triangle Markers')
plt.xlabel('X-axis')
plt.ylabel('Y-axis')
plt.show()`}
        </code>
      </pre><br/>

      <h3>Summary of Common Marker Parameters:</h3>
      <ul>
        <li>
          <strong>marker</strong>: Shape of the marker (e.g., 'o', 's', '^',
          'D').
        </li><br/>
        <li>
          <strong>markersize</strong>: Size of the marker (integer or float).
        </li><br/>
        <li>
          <strong>markeredgecolor</strong>: Color of the marker edge (e.g.,
          'red', 'black').
        </li><br/>
        <li>
          <strong>markerfacecolor</strong>: Color of the marker’s interior (e.g.,
          'yellow').
        </li><br/>
        <li>
          <strong>markeredgewidth</strong>: Width of the marker's border.
        </li><br/>
        <li>
          <strong>fillstyle</strong>: How the marker is filled ('full', 'none',
          'left', 'right').
        </li>
      </ul><br/>

      <p>
        Using markers in your plots makes the data points more visible and
        allows you to highlight specific points with different styles, enhancing
        the visual appeal and clarity of your plots.
      </p>
    </div>
  )}




        {selectedChapter === 'chapter80' && (
            <div className={style.chaptercontent}>
              <h1 className={style.heading}> Matplotlib Line Plot   </h1>

        <p>
          In <strong>Matplotlib</strong>, a <strong>line plot</strong> is one of the most common types of visualizations used to represent data points along a continuous axis. The line plot connects individual data points with a straight line, which is helpful for showing trends or relationships between variables over time or across some other variable.
        </p>
        <br/>
        <h2>Line Plot in Matplotlib:</h2>
        <p>
          A <strong>line</strong> in Matplotlib represents data points that are connected by a line. You can customize the appearance of the line, its markers, colors, and more to improve the clarity or aesthetics of the plot.
        </p>

        <h3 style={{paddingBottom:"6px"}}>Creating a Basic Line Plot:</h3>
        <pre>
          <code>
{`import matplotlib.pyplot as plt

# Sample data
x = [1, 2, 3, 4, 5]
y = [2, 4, 6, 8, 10]

# Create a basic line plot
plt.plot(x, y)
plt.show()`}
          </code>
        </pre><br/>

        <h3>Line Styles in Matplotlib:</h3>
        <p>In addition to the basic line plot, you can specify different <strong>line styles</strong> for the plot to change how the lines are displayed.</p>
        <ul>
          <li><code>'-'</code>: Solid line (default)</li><br/>
          <li><code>'--'</code>: Dashed line</li><br/>
          <li><code>':'</code>: Dotted line</li><br/>
          <li><code>'-. '</code>: Dash-dot line</li>
        </ul>
        <pre>
          <code>
{`plt.plot(x, y, linestyle='--')  # Dashed line
plt.show()`}
          </code>
        </pre><br/>

        <h3>Line Color:</h3>
        <p>
          You can change the color of the line using the <code>color</code> parameter. The color can be specified using:
          <ul>
            <li>Color names: <code>'red'</code>, <code>'blue'</code>, <code>'green'</code>, etc.</li><br/>
            <li>RGB tuples: <code>(0.1, 0.2, 0.5)</code></li><br/>
            <li>Hexadecimal color codes: <code>'#FF5733'</code></li>
          </ul>
        </p>
        <pre>
          <code>
{`plt.plot(x, y, color='purple')  # Line color is purple
plt.show()`}
          </code>
        </pre><br/>

        <h3>Line Width:</h3>
        <p>The <code>linewidth</code> parameter controls the thickness of the line. It takes a positive integer or float value to define the thickness.</p>
        <pre>
          <code>
{`plt.plot(x, y, linewidth=2)  # Thicker line
plt.show()`}
          </code>
        </pre><br/>

        <h3>Markers in Line Plots:</h3>
        <p>You can also add markers at each data point to highlight individual points in the line plot. The <code>marker</code> parameter allows you to specify different marker shapes such as:</p>
        <ul>
          <li><code>'o'</code>: Circle</li><br/>
          <li><code>'s'</code>: Square</li><br/>
          <li><code>'^'</code>: Triangle up</li><br/>
          <li><code>'v'</code>: Triangle down</li><br/>
          <li><code>'D'</code>: Diamond</li><br/>
          <li><code>'x'</code>: X shape</li>
        </ul>
        <pre>
          <code>
{`plt.plot(x, y, marker='o', markersize=8)  # Circle markers at data points
plt.show()`}
          </code>
        </pre><br/>

        <h3>Combining Line Styles and Markers:</h3>
        <p>You can combine line styles with markers to create more complex visualizations. For example:</p>
        <pre>
          <code>
{`plt.plot(x, y, linestyle='-', marker='s', color='green', markersize=10)
plt.show()`}
          </code>
        </pre><br/>

        <h3>Multiple Lines on the Same Plot:</h3>
        <p>You can plot multiple lines in the same figure by calling <code>plt.plot()</code> multiple times. Each line can have its own style, color, and markers.</p>
        <pre>
          <code>
{`x2 = [1, 2, 3, 4, 5]
y2 = [3, 6, 9, 12, 15]

plt.plot(x, y, label='Line 1', color='blue', linestyle='--')
plt.plot(x2, y2, label='Line 2', color='red', linestyle='-')
plt.legend()
plt.show()`}
          </code>
        </pre><br/>

        <h3>Labeling the Axes and Title:</h3>
        <p>For clarity, it’s always good to label the axes and give the plot a title.</p>
        <pre>
          <code>
{`plt.plot(x, y)
plt.title('Line Plot Example')
plt.xlabel('X-axis')
plt.ylabel('Y-axis')
plt.show()`}
          </code>
        </pre><br/>

        <h3>Additional Customizations:</h3>
        <ul>
          <li><strong>Gridlines:</strong> You can add gridlines to the plot using <code>plt.grid()</code>.</li><br/>
          <li><strong>Legends:</strong> You can add legends to label the lines with <code>plt.legend()</code>.</li><br/>
          <li><strong>Markersize:</strong> The <code>markersize</code> parameter allows you to control the size of the markers.</li>
        </ul><br/>

        <h3>Example Code:</h3>
        <pre>
          <code>
{`import matplotlib.pyplot as plt

# Data for plotting
x = [1, 2, 3, 4, 5]
y = [2, 4, 6, 8, 10]
y2 = [1, 3, 5, 7, 9]

# Plot with different customizations
plt.plot(x, y, marker='o', color='blue', linestyle='-', linewidth=2, markersize=8, label='Line 1')
plt.plot(x, y2, marker='s', color='red', linestyle='--', linewidth=2, markersize=8, label='Line 2')

# Add title and labels
plt.title('Customized Line Plot')
plt.xlabel('X-axis')
plt.ylabel('Y-axis')

# Add grid and legend
plt.grid(True)
plt.legend()

# Show plot
plt.show()`}
          </code>
        </pre><br/>

        <h3>Summary of Line Plot Parameters in Matplotlib:</h3>
        <ul>
          <li><code>linestyle</code>: Specifies the line style (e.g., <code>'-'</code>, <code>'--'</code>, <code>':'</code>).</li><br/>
          <li><code>color</code>: Defines the color of the line (e.g., <code>'red'</code>, <code>'#FF5733'</code>).</li><br/>
          <li><code>linewidth</code>: Adjusts the thickness of the line (e.g., <code>2</code>).</li><br/>
          <li><code>marker</code>: Specifies the shape of the marker at each data point (e.g., <code>'o'</code>, <code>'s'</code>).</li><br/>
          <li><code>markersize</code>: Defines the size of the marker.</li><br/>
          <li><code>label</code>: Labels the lines for the legend.</li><br/>
          <li><code>title()</code>, <code>xlabel()</code>, <code>ylabel()</code>: Add a title and labels to the axes.</li>
        </ul><br/>

        <p>
          Line plots are a versatile and easy way to visualize data trends, and with Matplotlib, they can be highly customized to match your specific requirements.
        </p>
      </div>
    )}


          {selectedChapter === 'chapter81' && (
            <div className={style.chaptercontent}>
              <h1 className={style.heading}>  Matplotlib Labels  </h1>

      <p>
        In <strong>Matplotlib</strong>, labels are used to provide textual descriptions or identifiers for various components of a plot, such as axes, titles, legends, and data series. Labels are important for improving the clarity and understanding of the plot, making it easier to interpret the data.
      </p><br/>

      <h2 style={{paddingBottom:"6px"}}>Key Types of Labels in Matplotlib:</h2>

      <ol>
        <li>
          <strong>Title of the Plot:</strong> 
          The title is displayed at the top of the plot and provides a brief description of the visualization.
          <p><strong>Function:</strong> <code>plt.title()</code></p>
          <p><strong>Syntax:</strong></p>
          <pre><code>plt.title('Your Plot Title')</code></pre>
        </li><br/>
        <li>
          <strong>Labels for X and Y Axes:</strong> 
          The labels for the X and Y axes are important for identifying what each axis represents (e.g., time, temperature, distance, etc.).
          <p><strong>Function:</strong> <code>plt.xlabel()</code> for the X-axis, and <code>plt.ylabel()</code> for the Y-axis.</p>
          <p><strong>Syntax:</strong></p>
          <pre><code>plt.xlabel('X-axis Label')</code></pre>
          <pre><code>plt.ylabel('Y-axis Label')</code></pre>
        </li><br/>
        <li>
          <strong>Legends:</strong>
          Legends help identify which data series corresponds to which plot on the graph. This is especially useful when multiple data series are plotted on the same graph.
          <p><strong>Function:</strong> <code>plt.legend()</code></p>
          <p><strong>Syntax:</strong></p>
          <pre><code>plt.plot(x1, y1, label='Line 1')</code></pre>
          <pre><code>plt.legend()</code></pre>
        </li><br/>
        <li>
          <strong>Axis Ticks:</strong>
          Axis ticks are the marks along the X and Y axes. You can customize the tick labels to improve the clarity of the plot.
          <p><strong>Function:</strong> <code>plt.xticks()</code> and <code>plt.yticks()</code></p>
          <p><strong>Syntax:</strong></p>
          <pre><code>plt.xticks([0, 1, 2, 3], ['Zero', 'One', 'Two', 'Three'])</code></pre>
          <pre><code>plt.yticks([0, 10, 20], ['Low', 'Medium', 'High'])</code></pre>
        </li>
      </ol><br/>

      <h2>Examples:</h2>

      <h3>1. Adding Title and Axis Labels:</h3>
      <pre><code>
{`import matplotlib.pyplot as plt

# Data
x = [1, 2, 3, 4, 5]
y = [1, 4, 9, 16, 25]

# Create the plot
plt.plot(x, y)

# Add title and labels
plt.title('Square Numbers Plot')
plt.xlabel('X-axis (Input)')
plt.ylabel('Y-axis (Squared Output)')

# Show plot
plt.show()`}
      </code></pre>
      <p>This code will generate a plot with a title and axis labels that describe what the X and Y axes represent.</p><br/>

      <h3>2. Adding Legends:</h3>
      <pre><code>
{`import matplotlib.pyplot as plt

# Data for two plots
x1 = [1, 2, 3, 4, 5]
y1 = [1, 4, 9, 16, 25]
x2 = [1, 2, 3, 4, 5]
y2 = [1, 2, 3, 4, 5]

# Create the plots
plt.plot(x1, y1, label='y = x^2', color='blue')
plt.plot(x2, y2, label='y = x', color='red')

# Add a legend
plt.legend()

# Show plot
plt.show()`}
      </code></pre>
      <p>In this case, the legend will help differentiate between the two lines: one representing <code>y = x^2</code> and the other representing <code>y = x</code>.</p>
      <br/>
      <h3>3. Customizing Axis Ticks:</h3>
      <pre><code>
{`import matplotlib.pyplot as plt

# Data
x = [1, 2, 3, 4, 5]
y = [1, 4, 9, 16, 25]

# Create the plot
plt.plot(x, y)

# Customize tick labels
plt.xticks([1, 2, 3, 4, 5], ['One', 'Two', 'Three', 'Four', 'Five'])
plt.yticks([1, 4, 9, 16, 25], ['1', '4', '9', '16', '25'])

# Add title and labels
plt.title('Customized Axis Ticks')
plt.xlabel('X-axis (Numbers)')
plt.ylabel('Y-axis (Squares)')

# Show plot
plt.show()`}
      </code></pre>
      <p>In this example, the X-axis tick labels are replaced with custom text, and the Y-axis labels are customized with square values.</p>
      <br/>
      <h2>Summary of Common Labeling Functions in Matplotlib:</h2>
      <ul>
        <li><code>plt.title('Title')</code>: Adds a title to the plot.</li><br/>
        <li><code>plt.xlabel('Label')</code>: Adds a label to the X-axis.</li><br/>
        <li><code>plt.ylabel('Label')</code>: Adds a label to the Y-axis.</li><br/>
        <li><code>plt.legend()</code>: Displays a legend to identify different lines or plots.</li><br/>
        <li><code>plt.xticks()</code> and <code>plt.yticks()</code>: Customize the ticks on the X and Y axes.</li>
      </ul><br/>

      <p>Using labels properly makes your plots more informative and easier to understand, especially when sharing them with others or presenting your data.</p>
    </div>
  )}




          {selectedChapter === 'chapter82' && (
            <div className={style.chaptercontent}>
              <h1 className={style.heading}>  Matplotlib Gridlines </h1>


          <p>
            In <strong>Matplotlib</strong>, gridlines are the lines that appear in the background of the plot, helping to align the data points with specific values on the axes. Gridlines enhance the readability of a plot by making it easier to interpret the scale of the graph, especially when analyzing trends or patterns.
          </p><br/>

          <h2 style={{paddingBottom:"6px"}}>Key Features of Gridlines in Matplotlib:</h2>

          <h3>1. Basic Gridlines</h3>
          <p>
            By default, Matplotlib does not display gridlines, but you can easily add them to your plot using the <code>plt.grid()</code> function.
          </p>
          <pre>
            <code>
              {`plt.grid(True)  # This turns on the gridlines`}
            </code>
          </pre>
          <p>Example:</p>
          <pre>
            <code>
              {`import matplotlib.pyplot as plt

# Sample data
x = [1, 2, 3, 4, 5]
y = [2, 4, 6, 8, 10]

# Create a plot
plt.plot(x, y)

# Enable gridlines
plt.grid(True)

# Show the plot
plt.show()`}
            </code>
          </pre><br/>

          <h3>2. Gridline Customization</h3>
          <p>
            You can customize the appearance of the gridlines, such as their style, color, and width.
          </p>
          <p>
            Parameters for Customization:
            <ul>
              <li><strong>color</strong>: Specifies the color of the gridlines.</li>
              <li><strong>linestyle</strong>: Specifies the style of the gridlines.</li>
              <li><strong>linewidth</strong>: Controls the thickness of the gridlines.</li>
              <li><strong>which</strong>: Specifies which gridlines to apply (`'both'`, `'major'`, or `'minor'`).</li>
            </ul>
          </p>
          <p>Example:</p>
          <pre>
            <code>
              {`import matplotlib.pyplot as plt

# Sample data
x = [1, 2, 3, 4, 5]
y = [2, 4, 6, 8, 10]

# Create the plot
plt.plot(x, y)

# Customize gridlines
plt.grid(True, color='gray', linestyle='--', linewidth=1.5)

# Show plot
plt.show()`}
            </code>
          </pre><br/>

          <h3>3. Major and Minor Gridlines</h3>
          <p>
            In addition to the major gridlines, Matplotlib also supports minor gridlines, which appear at smaller intervals between the major ticks. You can enable and customize these minor gridlines separately.
          </p>
          <pre>
            <code>
              {`import matplotlib.pyplot as plt

# Sample data
x = [1, 2, 3, 4, 5]
y = [2, 4, 6, 8, 10]

# Create the plot
plt.plot(x, y)

# Enable major gridlines
plt.grid(True, which='major', color='blue', linestyle='-')

# Enable minor gridlines (you need to set the minor locator first)
plt.minorticks_on()
plt.grid(True, which='minor', color='red', linestyle=':')

# Show plot
plt.show()`}
            </code>
          </pre><br/>

          <h3>4. Controlling Axis Gridlines</h3>
          <p>
            You can enable or disable gridlines on specific axes (X or Y axis).
          </p>
          <pre>
            <code>
              {`import matplotlib.pyplot as plt

# Sample data
x = [1, 2, 3, 4, 5]
y = [2, 4, 6, 8, 10]

# Create the plot
plt.plot(x, y)

# Enable only horizontal gridlines (Y-axis gridlines)
plt.grid(axis='y', color='green', linestyle='-', linewidth=1)

# Show plot
plt.show()`}
            </code>
          </pre><br/>

          <h3>5. Turn Off Gridlines</h3>
          <p>
            You can turn off the gridlines by calling <code>plt.grid(False)</code>.
          </p>
          <pre>
            <code>
              {`import matplotlib.pyplot as plt

# Sample data
x = [1, 2, 3, 4, 5]
y = [2, 4, 6, 8, 10]

# Create the plot
plt.plot(x, y)

# Disable gridlines
plt.grid(False)

# Show plot
plt.show()`}
            </code>
          </pre><br/>

          <h2>Summary of Common Grid Parameters:</h2>
          <ul>
            <li><strong>color</strong>: Color of the gridlines.</li><br/>
            <li><strong>linestyle</strong>: Style of the gridlines (e.g., `'-'`, `'--'`, `':'`).</li><br/>
            <li><strong>linewidth</strong>: Thickness of the gridlines.</li><br/>
            <li><strong>which</strong>: Choose which gridlines to apply (`'major'`, `'minor'`, or `'both'`).</li><br/>
            <li><strong>axis</strong>: Choose whether to apply gridlines to the X-axis, Y-axis, or both.</li>
          </ul><br/>

          <h3>Example of Full Customization:</h3>
          <pre>
            <code>
              {`import matplotlib.pyplot as plt

# Sample data
x = [1, 2, 3, 4, 5]
y = [2, 4, 6, 8, 10]

# Create the plot
plt.plot(x, y)

# Enable gridlines with full customization
plt.grid(True, which='both', color='blue', linestyle='-', linewidth=1.5)

# Add title and labels
plt.title('Customized Gridlines Example')
plt.xlabel('X-axis')
plt.ylabel('Y-axis')

# Show plot
plt.show()`}
            </code>
          </pre>

          <p>
            In this example, gridlines are displayed for both axes with blue color, solid lines, and a thickness of 1.5.
          </p><br/>

          <h3>Conclusion</h3>
          <p>
            Gridlines are a crucial component of Matplotlib plots that help improve the readability and interpretation of data. With the flexibility of customizing gridline styles, colors, and the choice of major or minor gridlines, you can tailor your plots to be more informative and visually appealing.
          </p>
        </div>
      )}
   




          {selectedChapter === 'chapter83' && (
            <div className={style.chaptercontent}>
              <h1 className={style.heading}> Matplotlib Subplots  </h1>


        <p>
          In <strong>Matplotlib</strong>, a subplot is a way of displaying multiple plots in a single figure window.
          Subplots allow you to organize and visualize different datasets or variations of data together in a grid, making it easier to compare them.
        </p><br/>

        <h3 style={{paddingBottom:"6px"}}>Key Concepts of Subplots in Matplotlib:</h3>

        <ol>
          <li>
            <strong>Creating Subplots with <code>plt.subplot()</code>:</strong>
            <p>
              The <code>{`plt.subplot()`}</code> function is used to create multiple plots within a single figure. It divides the figure into a grid of rows and columns, and each plot is positioned within this grid. 
              The general syntax is:
            </p>
            <pre><code>{`plt.subplot(nrows, ncols, index)`}</code></pre>
            <p>
              Where:
              <ul>
                <li><code>nrows</code>: Number of rows in the grid.</li><br/>
                <li><code>ncols</code>: Number of columns in the grid.</li><br/>
                <li><code>index</code>: The index of the current plot (starting from 1).</li>
              </ul>
            </p>
          </li><br/>

          <li>
            <strong>Creating Subplots with <code>{`plt.subplots()`}</code>:</strong>
            <p>
              <code>{`plt.subplots()`}</code> is another method for creating subplots. It returns a figure object and an array of axes objects that you can use to create individual plots. The syntax is:
            </p>
            <pre><code>{`fig, axs = plt.subplots(nrows, ncols)`}</code></pre>
            <p>
              Where:
              <ul>
                <li><code>nrows</code>: Number of rows in the subplot grid.</li><br/>
                <li><code>ncols</code>: Number of columns in the subplot grid.</li><br/>
                <li><code>fig</code>: The figure object.</li><br/>
                <li><code>axs</code>: A 2D array (for multiple subplots) or a 1D array (for single row/column of subplots) of axes objects.</li>
              </ul>
            </p>
          </li>
        </ol><br/>

        <h3>Basic Usage with <code>plt.subplot()</code>:</h3>
        <pre><code>{`
          import matplotlib.pyplot as plt

          # Creating a 1x2 grid of subplots (1 row, 2 columns)
          plt.subplot(1, 2, 1)  # First subplot
          plt.plot([1, 2, 3], [1, 4, 9])
          plt.title("Plot 1")

          plt.subplot(1, 2, 2)  # Second subplot
          plt.plot([1, 2, 3], [1, 2, 3])
          plt.title("Plot 2")

          # Display the plots
          plt.show()
        </code></pre>

        <h3>Basic Usage with <code>plt.subplots()</code>:</h3>
        <pre><code>
          import matplotlib.pyplot as plt

          # Create a 2x2 grid of subplots
          fig, axs = plt.subplots(2, 2)

          # Plot on the first subplot
          axs[0, 0].plot([1, 2, 3], [1, 4, 9])
          axs[0, 0].set_title("Plot 1")

          # Plot on the second subplot
          axs[0, 1].plot([1, 2, 3], [1, 2, 3])
          axs[0, 1].set_title("Plot 2")

          # Plot on the third subplot
          axs[1, 0].plot([1, 2, 3], [2, 4, 6])
          axs[1, 0].set_title("Plot 3")

          # Plot on the fourth subplot
          axs[1, 1].plot([1, 2, 3], [3, 6, 9])
          axs[1, 1].set_title("Plot 4")

          # Adjust layout to prevent overlap
          plt.tight_layout()

          # Display the plots
          plt.show()`}
        </code></pre><br/>

        <h3 style={{paddingBottom:"6px"}}>Key Points:</h3>
        <ul>
          <li><strong>Grid Layout:</strong> Subplots are arranged in a grid format. You can specify the number of rows (<code>nrows</code>) and columns (<code>ncols</code>) when creating subplots.</li><br/>
          <li><strong>Indexing:</strong> The index of the subplot is typically 1-based, meaning the first subplot is at index 1.</li><br/>
          <li><strong>Accessing Axes:</strong> You can access individual subplots using the returned axes object (either with <code>plt.subplot()</code> or <code>plt.subplots()</code>).</li><br/>
          <li><strong>Customization:</strong> You can add titles, labels, and adjust each subplot individually, making it easy to control the appearance of each plot in the grid.</li>
        </ul><br/>

        <h3>Common Customizations:</h3>
        <ul>
          <li><code>tight_layout()</code>: Adjusts the spacing between subplots to ensure labels and titles do not overlap.</li><br/>
          <li><strong>Adding Titles:</strong> Use <code>ax.set_title('Title')</code> to set titles for individual subplots.</li><br/>
          <li><strong>Axis Labels:</strong> Use <code>ax.set_xlabel('X-axis label')</code> and <code>ax.set_ylabel('Y-axis label')</code> for axis labeling.</li>
        </ul><br/>

        <h3 style={{paddingBottom:"6px"}}>Example of Customizing Subplots:</h3>
        <pre><code>{`
          import matplotlib.pyplot as plt

          # Create a 2x1 grid of subplots
          fig, axs = plt.subplots(2, 1)

          # First subplot
          axs[0].plot([1, 2, 3], [1, 4, 9], 'r')
          axs[0].set_title('First Plot')
          axs[0].set_xlabel('X-axis')
          axs[0].set_ylabel('Y-axis')

          # Second subplot
          axs[1].plot([1, 2, 3], [1, 2, 3], 'g')
          axs[1].set_title('Second Plot')
          axs[1].set_xlabel('X-axis')
          axs[1].set_ylabel('Y-axis')

          # Adjust layout
          plt.tight_layout()

          # Show the plot
          plt.show()`}
        </code></pre><br/>

        <h3>Conclusion:</h3>
        <p>
          Subplots in Matplotlib allow you to create a grid of multiple plots within a single figure. You can customize each subplot's appearance individually, adding titles, labels, and adjusting spacing. The two main ways to create subplots are through <code>plt.subplot()</code> and <code>plt.subplots()</code>. The latter is generally preferred as it returns axes objects directly, making it easier to control individual subplots.
        </p>
      </div>
    )}




          {selectedChapter === 'chapter84' && (
            <div className={style.chaptercontent}>
              <h1 className={style.heading}>  Matplotlib Scatter Plot  </h1>

          <p>
            A <strong>scatter plot</strong> is a type of plot that displays individual data points on a two-dimensional graph. It is often used to observe relationships between two continuous variables or to visualize data distribution. Each point in the scatter plot represents a single observation, and the position of the point is determined by the values of the variables on the x-axis and y-axis.
          </p>

          <p>
            In <strong>Matplotlib</strong>, the scatter plot can be created using the <code>plt.scatter()</code> function. This function allows you to visualize how one variable is related to another.
          </p><br/>

          <h3>Basic Syntax:</h3>
          <pre>
            <code>
              {`plt.scatter(x, y, **kwargs)`}
            </code>
          </pre>
          <p>Where:</p>
          <ul>
            <li><strong>x</strong>: The data for the x-axis.</li><br/>
            <li><strong>y</strong>: The data for the y-axis.</li><br/>
            <li><strong>**kwargs</strong>: Additional customization options (color, size, label, etc.).</li>
          </ul><br/>

          <h3 style={{paddingBottom:"6px"}}>Key Features of Scatter Plots in Matplotlib:</h3>

          <h4>1. Creating a Simple Scatter Plot</h4>
          <p>To create a simple scatter plot, you provide the data points for both the x and y axes.</p>
          
          <h5>Example:</h5>
          <pre>
            <code>
              {`import matplotlib.pyplot as plt

# Data
x = [1, 2, 3, 4, 5]
y = [2, 3, 5, 7, 11]

# Create scatter plot
plt.scatter(x, y)

# Add labels and title
plt.xlabel("X-axis")
plt.ylabel("Y-axis")
plt.title("Simple Scatter Plot")

# Show plot
plt.show()`}
            </code>
          </pre><br/>

          <h4>2. Customizing Scatter Plots</h4>
          <p>You can customize the appearance of scatter plots using various parameters like color, size, and marker style.</p>
          
          <h5>Example:</h5>
          <pre>
            <code>
              {`import matplotlib.pyplot as plt

# Data
x = [1, 2, 3, 4, 5]
y = [2, 3, 5, 7, 11]
sizes = [20, 50, 80, 200, 500]  # Point sizes

# Create scatter plot with customizations
plt.scatter(x, y, color='red', s=sizes, marker='^', alpha=0.7)

# Add labels and title
plt.xlabel("X-axis")
plt.ylabel("Y-axis")
plt.title("Customized Scatter Plot")

# Show plot
plt.show()`}
            </code>
          </pre><br/>

          <h4>3. Color Mapping</h4>
          <p>You can use a color map to represent the values of a third variable using the <code>c</code> parameter, which allows for better visualization of relationships between three variables.</p>
          
          <h5>Example:</h5>
          <pre>
            <code>
              {`import matplotlib.pyplot as plt
import numpy as np

# Data
x = np.random.rand(50)
y = np.random.rand(50)
colors = np.random.rand(50)  # Random color values

# Create scatter plot with color map
plt.scatter(x, y, c=colors, cmap='viridis')

# Add labels and title
plt.xlabel("X-axis")
plt.ylabel("Y-axis")
plt.title("Scatter Plot with Color Mapping")

# Show plot
plt.colorbar()  # Display color bar
plt.show()`}
            </code>
          </pre><br/>

          <h4>4. Using <code>plt.scatter()</code> with a Size Variable</h4>
          <p>You can also scale the point sizes based on a variable. For example, the size of each point could be determined by an additional dataset, such as population size, weight, etc.</p>
          
          <h5>Example:</h5>
          <pre>
            <code>
              {`import matplotlib.pyplot as plt
import numpy as np

# Data
x = np.random.rand(50)
y = np.random.rand(50)
sizes = np.random.rand(50) * 1000  # Point sizes based on random values

# Create scatter plot with varying sizes
plt.scatter(x, y, s=sizes, alpha=0.6, c='blue')

# Add labels and title
plt.xlabel("X-axis")
plt.ylabel("Y-axis")
plt.title("Scatter Plot with Varying Point Sizes")

# Show plot
plt.show()`}
            </code>
          </pre><br/>

          <h4>5. 3D Scatter Plot</h4>
          <p>You can also create 3D scatter plots using Matplotlib's <code>Axes3D</code> module.</p>
          
          <h5>Example:</h5>
          <pre>
            <code>
              {`import matplotlib.pyplot as plt
from mpl_toolkits.mplot3d import Axes3D
import numpy as np

# Data
x = np.random.rand(50)
y = np.random.rand(50)
z = np.random.rand(50)

# Create 3D scatter plot
fig = plt.figure()
ax = fig.add_subplot(111, projection='3d')
ax.scatter(x, y, z)

# Add labels and title
ax.set_xlabel("X-axis")
ax.set_ylabel("Y-axis")
ax.set_zlabel("Z-axis")
ax.set_title("3D Scatter Plot")

# Show plot
plt.show()`}
            </code>
          </pre><br/>

          <h3 style={{paddingBottom:"6px"}}>Common Customizations in Scatter Plots:</h3>
          <ul>
            <li><strong>Title and Labels:</strong> You can set titles and labels for the x and y axes using <code>plt.title()</code>, <code>plt.xlabel()</code>, and <code>plt.ylabel()</code>.</li><br/>
            <li><strong>Gridlines:</strong> Use <code>plt.grid(True)</code> to display gridlines on the plot, which can help with data visualization.</li><br/>
            <li><strong>Legend:</strong> If you have different categories, use <code>plt.legend()</code> to display a legend for your scatter plot.</li>
          </ul><br/>

          <h3>Conclusion:</h3>
          <p>Scatter plots are a powerful tool for visualizing relationships between variables. Matplotlib provides flexibility to customize scatter plots, allowing you to adjust colors, sizes, transparency, and shapes of the data points. You can also incorporate color mappings, size scaling, and 3D visualizations to gain deeper insights from your data.</p>
        </div>
      )}
   




   {selectedChapter === 'chapter85' && (
  <div className={style.chaptercontent}>
    <h1 className={style.heading}>Matplotlib Bar Plots </h1>

    <p>
      A <strong>bar plot</strong> is a visualization that represents data using rectangular bars,
      where the length or height of each bar corresponds to the data's value. Bar plots are often
      used to compare discrete categories or display frequency distributions.
    </p>
    <p>
      In <strong>Matplotlib</strong>, bar plots can be created using the <code>plt.bar()</code>{" "}
      function for vertical bars and <code>plt.barh()</code> for horizontal bars. Both functions
      provide extensive customization options for appearance, labels, and grouping.
    </p>

    <br/>

    <h2 style={{paddingBottom:"6px"}}>Basic Syntax for Bar Plot:</h2>
    <pre>
      <code>{`plt.bar(x, height, **kwargs)`}</code>
    </pre>
    <ul>
      <li>
        <strong>x:</strong> The x-coordinates of the bars (categories).
      </li>
      <li>
        <strong>height:</strong> The height of the bars (values to be plotted).
      </li>
      <li>
        <strong>**kwargs:</strong> Additional parameters for customization (color, width, labels, etc.).
      </li>
    </ul><br/>

    <h2>1. Creating a Simple Bar Plot</h2>
    <pre>
      <code>{`import matplotlib.pyplot as plt

# Data
categories = ['A', 'B', 'C', 'D']
values = [3, 7, 8, 5]

# Create bar plot
plt.bar(categories, values)

# Add labels and title
plt.xlabel("Categories")
plt.ylabel("Values")
plt.title("Simple Bar Plot")

# Show plot
plt.show()`}</code>
    </pre><br/>

    <h2>2. Horizontal Bar Plot</h2>
    <pre>
      <code>{`import matplotlib.pyplot as plt

# Data
categories = ['A', 'B', 'C', 'D']
values = [3, 7, 8, 5]

# Create horizontal bar plot
plt.barh(categories, values, color='skyblue')

# Add labels and title
plt.xlabel("Values")
plt.ylabel("Categories")
plt.title("Horizontal Bar Plot")

# Show plot
plt.show()`}</code>
    </pre><br/>

    <h2>3. Customizing Bar Colors, Widths, and Alignment</h2>
    <pre>
      <code>{`import matplotlib.pyplot as plt

# Data
categories = ['A', 'B', 'C', 'D']
values = [3, 7, 8, 5]

# Create customized bar plot
plt.bar(categories, values, color=['red', 'green', 'blue', 'purple'], width=0.5)

# Add labels and title
plt.xlabel("Categories")
plt.ylabel("Values")
plt.title("Customized Bar Plot")

# Show plot
plt.show()`}</code>
    </pre><br/>

    <h2>4. Grouped Bar Plots</h2>
    <pre>
      <code>{`import matplotlib.pyplot as plt
import numpy as np

# Data
categories = ['A', 'B', 'C', 'D']
group1 = [3, 7, 8, 5]
group2 = [4, 6, 7, 8]

# Bar positions
x = np.arange(len(categories))
width = 0.35  # Width of each bar

# Create grouped bar plot
plt.bar(x - width/2, group1, width, label='Group 1', color='blue')
plt.bar(x + width/2, group2, width, label='Group 2', color='orange')

# Add labels, title, and legend
plt.xlabel("Categories")
plt.ylabel("Values")
plt.title("Grouped Bar Plot")
plt.xticks(x, categories)
plt.legend()

# Show plot
plt.show()`}</code>
    </pre><br/>

    <h2>5. Stacked Bar Plots</h2>
    <pre>
      <code>{`import matplotlib.pyplot as plt
import numpy as np

# Data
categories = ['A', 'B', 'C', 'D']
group1 = [3, 7, 8, 5]
group2 = [4, 6, 7, 8]

# Create stacked bar plot
plt.bar(categories, group1, label='Group 1', color='blue')
plt.bar(categories, group2, bottom=group1, label='Group 2', color='orange')

# Add labels, title, and legend
plt.xlabel("Categories")
plt.ylabel("Values")
plt.title("Stacked Bar Plot")
plt.legend()

# Show plot
plt.show()`}</code>
    </pre><br/>

    <h2>6. Adding Annotations</h2>
    <pre>
      <code>{`import matplotlib.pyplot as plt

# Data
categories = ['A', 'B', 'C', 'D']
values = [3, 7, 8, 5]

# Create bar plot
plt.bar(categories, values, color='green')

# Annotate bars
for i, value in enumerate(values):
    plt.text(i, value + 0.2, str(value), ha='center')

# Add labels and title
plt.xlabel("Categories")
plt.ylabel("Values")
plt.title("Bar Plot with Annotations")

# Show plot
plt.show()`}</code>
    </pre><br/>

    <h2>7. Error Bars</h2>
    <pre>
      <code>{`import matplotlib.pyplot as plt
import numpy as np

# Data
categories = ['A', 'B', 'C', 'D']
values = [3, 7, 8, 5]
errors = [0.5, 1.0, 0.7, 0.3]

# Create bar plot with error bars
plt.bar(categories, values, yerr=errors, capsize=5, color='skyblue')

# Add labels and title
plt.xlabel("Categories")
plt.ylabel("Values")
plt.title("Bar Plot with Error Bars")

# Show plot
plt.show()`}</code>
    </pre>

  

    <p>
      Bar plots are a versatile tool for visualizing categorical data. Matplotlib provides
      extensive options to customize colors, widths, alignments, and more. Grouped and stacked bar
      plots are particularly useful for comparing datasets, while annotations and error bars add
      more clarity and detail.
    </p>
  </div>
)}



          {selectedChapter === 'chapter86' && (
            <div className={style.chaptercontent}>
              <h1 className={style.heading}>  Matplotlib Histogram </h1>

      <p>
        A <strong>histogram</strong> is a graphical representation of the distribution of a dataset. It divides the data
        into bins (intervals) and represents the frequency of data points within each bin using rectangular bars.
        Histograms are useful for visualizing the shape, spread, and outliers of a dataset.
      </p>
      <p>
        In <strong>Matplotlib</strong>, histograms can be created using the <code>plt.hist()</code> function. This
        function provides a variety of options to customize the bins, colors, and labels.
      </p>

      <br/>

      <h2>Basic Syntax:</h2>
      <pre>
        <code>
          plt.hist(x, bins=None, **kwargs)
        </code>
      </pre>
      <p>
        Where:
        <ul>
          <li><code>x</code>: The input data (array-like).</li><br/>
          <li>
            <code>bins</code>: The number of bins or specific bin edges. If not specified, Matplotlib decides
            automatically.
          </li><br/>
          <li>
            <code>**kwargs</code>: Additional parameters for customization (color, density, labels, etc.).
          </li>
        </ul><br/>
      </p>

      <br/>

      <h2>1. Creating a Simple Histogram</h2>
      <pre>
        <code>{`
import matplotlib.pyplot as plt

# Data
data = [1, 2, 2, 3, 3, 3, 4, 4, 4, 4, 5, 5, 6]

# Create histogram
plt.hist(data)

# Add labels and title
plt.xlabel("Value")
plt.ylabel("Frequency")
plt.title("Simple Histogram")

# Show plot
plt.show()
        `}</code>
      </pre>

      <br/>

      <h2>2. Adjusting the Number of Bins</h2>
      <pre>
        <code>{`
import matplotlib.pyplot as plt

# Data
data = [1, 2, 2, 3, 3, 3, 4, 4, 4, 4, 5, 5, 6]

# Create histogram with custom bins
plt.hist(data, bins=5, color='skyblue')

# Add labels and title
plt.xlabel("Value")
plt.ylabel("Frequency")
plt.title("Histogram with 5 Bins")

# Show plot
plt.show()
        `}</code>
      </pre>

      <br/>

      <h2>3. Normalized Histogram</h2>
      <pre>
        <code>{`
import matplotlib.pyplot as plt

# Data
data = [1, 2, 2, 3, 3, 3, 4, 4, 4, 4, 5, 5, 6]

# Create normalized histogram
plt.hist(data, bins=5, density=True, color='orange')

# Add labels and title
plt.xlabel("Value")
plt.ylabel("Density")
plt.title("Normalized Histogram")

# Show plot
plt.show()
        `}</code>
      </pre>

      <br/>

      <h2>4. Adding a Grid and Customizing Appearance</h2>
      <pre>
        <code>{`
import matplotlib.pyplot as plt

# Data
data = [1, 2, 2, 3, 3, 3, 4, 4, 4, 4, 5, 5, 6]

# Create histogram with customizations
plt.hist(data, bins=5, color='green', edgecolor='black', alpha=0.7)

# Add labels, title, and grid
plt.xlabel("Value")
plt.ylabel("Frequency")
plt.title("Customized Histogram")
plt.grid(True)

# Show plot
plt.show()
        `}</code>
      </pre>

      <br/>

      <h2>5. Overlaying a Line Plot</h2>
      <pre>
        <code>{`
import matplotlib.pyplot as plt
import numpy as np

# Data
data = np.random.normal(0, 1, 1000)

# Create histogram
plt.hist(data, bins=30, density=True, alpha=0.6, color='blue')

# Overlay a line plot
x = np.linspace(-4, 4, 1000)
y = (1 / (np.sqrt(2 * np.pi))) * np.exp(-x**2 / 2)
plt.plot(x, y, color='red', label="PDF")

# Add labels, title, and legend
plt.xlabel("Value")
plt.ylabel("Density")
plt.title("Histogram with PDF Overlay")
plt.legend()

# Show plot
plt.show()
        `}</code>
      </pre>

      <br/>

      <h2>Conclusion:</h2>
      <p>
        Histograms are a powerful tool for visualizing data distributions. Matplotlib provides flexibility to customize
        binning, colors, and styles, making it easy to adapt histograms to specific needs. Additionally, overlaying
        plots or creating multiple histograms on the same plot enables deeper insights into data comparisons.
      </p>
    </div>
  )}



        {selectedChapter === 'chapter87' && (
            <div className={style.chaptercontent}>
              <h1 className={style.heading}> Matplotlib Pie Charts </h1>


        <p>
          A <strong>pie chart</strong> is a circular statistical plot divided
          into slices, with each slice representing a proportion of the whole.
          Pie charts are commonly used to show percentages or proportions of a
          dataset.
        </p>

        <p>
          In <strong>Matplotlib</strong>, you can create a pie chart using the{" "}
          <code>plt.pie()</code> function, which provides various customization
          options for labels, colors, and slice appearance.
        </p>

        <br/>

        <h2 style={{paddingBottom:"6px"}}>Basic Syntax</h2>
        <pre>
          <code>
            {`plt.pie(x, labels=None, **kwargs)

Where:
- x: Array-like data representing the size of each slice.
- labels: A list of strings, one for each slice.
- **kwargs: Additional parameters for customization (e.g., colors, autopct, explode).`}
          </code>
        </pre>

        <br/>

        <h2 style={{paddingBottom:"6px"}}>Examples</h2>

        <h3>1. Creating a Simple Pie Chart</h3>
        <pre>
          <code>
            {`import matplotlib.pyplot as plt

# Data
sizes = [25, 35, 20, 20]
labels = ['A', 'B', 'C', 'D']

# Create pie chart
plt.pie(sizes, labels=labels)

# Add title
plt.title("Simple Pie Chart")

# Show plot
plt.show()`}
          </code>
        </pre><br/>

        <h3>2. Adding Percentages to the Chart</h3>
        <pre>
          <code>
            {`import matplotlib.pyplot as plt

# Data
sizes = [25, 35, 20, 20]
labels = ['A', 'B', 'C', 'D']

# Create pie chart with percentages
plt.pie(sizes, labels=labels, autopct='%1.1f%%')

# Add title
plt.title("Pie Chart with Percentages")

# Show plot
plt.show()`}
          </code>
        </pre><br/>

        <h3>3. Customizing Colors</h3>
        <pre>
          <code>
            {`import matplotlib.pyplot as plt

# Data
sizes = [25, 35, 20, 20]
labels = ['A', 'B', 'C', 'D']
colors = ['gold', 'skyblue', 'lightgreen', 'salmon']

# Create pie chart with custom colors
plt.pie(sizes, labels=labels, autopct='%1.1f%%', colors=colors)

# Add title
plt.title("Custom Colors Pie Chart")

# Show plot
plt.show()`}
          </code>
        </pre>

       

        <br/>

        <h2>Conclusion</h2>
        <p>
          Pie charts are a popular way to visualize proportions. Matplotlib
          provides extensive options to customize the appearance, add legends,
          and create advanced variations like exploded and nested pie charts.
          Use them effectively to represent categorical data in an easily
          understandable manner.
        </p>
      </div>
    
  )}




          {selectedChapter === 'chapter88' && (
            <div className={style.chaptercontent}>
              <h1 className={style.heading}> Introduction to Python and MySQL  </h1>


            <p>
              <strong>Python</strong> can interact with <strong>MySQL</strong>, one of the most popular relational
              database management systems, to store and manage data. This is useful for building applications that need
              to handle data efficiently, like web apps, data analysis pipelines, or any system requiring structured
              data storage.
            </p>     <br/>    

          <section>
            <h2>Why Use Python with MySQL?</h2>
            <ul>
              <li>
                <strong>Data Storage</strong>: MySQL stores data in a structured format (tables, rows, and columns).
              </li><br/>
              <li>
                <strong>Ease of Integration</strong>: Python offers libraries that make working with MySQL
                straightforward.
              </li><br/>
              <li>
                <strong>Scalability</strong>: MySQL is powerful enough to handle small to large datasets efficiently.
              </li>
            </ul><br/>
          </section>
                 <section>
            <h2>Setting Up the Basics</h2>
            <ol>
              <li>
                <strong>MySQL Server</strong>: Install MySQL Server to create and manage databases.
              </li><br/>
              <li>
                <strong>Python Library</strong>: Use a library like <code>mysql-connector-python</code> or{' '}
                <code>PyMySQL</code> to connect Python to MySQL.
              </li><br/>
            </ol><br/>
          </section>         

          <section>
            <h2>Installation</h2>
            <ol>
              <li>
                <strong>Install MySQL Server</strong>: Download and install MySQL from the{' '}
                <a href="https://dev.mysql.com/downloads/" target="_blank" rel="noopener noreferrer">
                  MySQL website
                </a>
                .
              </li><br/>
              <li>
                <strong>Install the Connector Library</strong>: Install <code>mysql-connector-python</code> to enable
                Python to interact with MySQL:
                <pre>
                  <code>pip install mysql-connector-python</code>
                </pre>
              </li>
            </ol><br/>
          </section>

        

          <section>
            <h2>Connecting to MySQL</h2>
            <pre>
              <code>
                {`import mysql.connector

# Connect to the MySQL server
conn = mysql.connector.connect(
    host="localhost",       # Host (use '127.0.0.1' for localhost)
    user="yourusername",    # MySQL username
    password="yourpassword" # MySQL password
)

if conn.is_connected():
    print("Connected to MySQL!")
else:
    print("Connection failed.")`}
              </code>
            </pre>
          </section>
          <br/>
        

          <section>
            <h2>Basic Workflow</h2>
            <ol>
              <li>Connect to the MySQL server.</li>
              <li>Execute SQL commands (like creating databases or tables).</li>
              <li>Perform operations (insert, retrieve, update, or delete data).</li>
              <li>Close the connection once done.</li>
            </ol>
            <p>
              This is the foundational process for using MySQL with Python. Once you're comfortable with these basics,
              you can explore more advanced features like error handling, prepared statements, and transactions.
            </p>
          </section>
        </div>
      )}  





        {selectedChapter === 'chapter89' && (
            <div className={style.chaptercontent}>
              <h1 className={style.heading}> Introduction to MySQL Database Creation with Python  </h1>

        <h3>How to Create a MySQL Database using Python</h3>

        <p>
          Creating a MySQL database using Python involves a few simple steps: connecting to the MySQL server, running the SQL
          command to create the database, and then closing the connection. Here’s how to do it in a straightforward way.
        </p><br/>

        <h4>Steps:</h4>
        <ol>
          <li><strong>Install MySQL Connector:</strong> Before connecting Python with MySQL, you need to install the `mysql-connector-python` library. This library allows Python to communicate with MySQL. Run the following command to install it:</li>
          <pre><code>pip install mysql-connector-python</code></pre><br/>

          <li><strong>Connect to the MySQL Server:</strong> After installing the connector, you can use Python to connect to your MySQL server (usually running on localhost).</li><br/>

          <li><strong>Create the Database:</strong> Once connected, you can execute the `CREATE DATABASE` SQL command to create a new database.</li><br/>

          <li><strong>Close the Connection:</strong> Finally, after performing the operation, it is important to close the connection to free up resources.</li>
        </ol><br/>

        <h4 style={{paddingBottom:"6px"}}>Example Code to Create a Database in Python:</h4>
        <pre>
          <code>
            {`
import mysql.connector

# Step 1: Connect to the MySQL server
conn = mysql.connector.connect(
    host="localhost",       # The MySQL server (use 'localhost' for local MySQL server)
    user="root",            # MySQL username (replace with your own username)
    password="password"     # MySQL password (replace with your own password)
)

# Step 2: Check if the connection is successful
if conn.is_connected():
    print("Connected to MySQL!")
    
    # Step 3: Create a cursor to execute MySQL commands
    cursor = conn.cursor()
    
    # Step 4: Execute the SQL command to create a new database
    cursor.execute("CREATE DATABASE my_new_database")
    print("Database 'my_new_database' created successfully!")
    
    # Step 5: Close the cursor and connection
    cursor.close()
    conn.close()
else:
    print("Connection failed.")
            `}
          </code>
        </pre>
        <br/>

        <h4>Explanation:</h4>
        <ul>
          <li><strong>Connecting to MySQL:</strong> We use `mysql.connector.connect()` to connect Python with the MySQL server. The `host`, `user`, and `password` parameters are needed to establish the connection. Replace `"localhost"`, `"root"`, and `"password"` with your own MySQL credentials.</li><br/>
          <li><strong>Creating a Cursor:</strong> A <em>cursor</em> is created using `conn.cursor()`. The cursor is used to execute SQL commands.</li><br/>
          <li><strong>Creating the Database:</strong> We use the `cursor.execute()` function to run the SQL command `CREATE DATABASE my_new_database`. You can replace `my_new_database` with your preferred database name.</li><br/>
          <li><strong>Error Handling (Optional):</strong> If the database already exists, you will get an error. You can avoid this by adding `IF NOT EXISTS` in the SQL query:</li><br/>
          <pre><code>cursor.execute("CREATE DATABASE IF NOT EXISTS my_new_database")</code></pre>
          <li><strong>Closing the Connection:</strong> After executing the command, it's important to close both the <em>cursor</em> and <em>connection</em> to free up resources.</li>
        </ul><br/>

        <h4>Additional Tips:</h4>
        <ul>
          <li><strong>Privileges:</strong> Make sure the MySQL user you're connecting with has the necessary privileges to create databases.</li><br/>
          <li><strong>MySQL Workbench:</strong> After creating a database, you can use MySQL Workbench or the MySQL command line to see your newly created database.</li>
        </ul><br/>

        <h4>Conclusion:</h4>
        <p>
          In just a few simple steps, you can use Python to connect to a MySQL server, create a new database, and manage it with ease. This is the foundation for working with MySQL databases programmatically using Python!
        </p>
      </div>
    )}



          {selectedChapter === 'chapter90' && (
            <div className={style.chaptercontent}>
              <h1 className={style.heading}>  Create Table    </h1>

          <p>
            Creating a table in MySQL involves defining the structure of the table,
            including the columns, their data types, and any constraints (such as primary
            keys, foreign keys, etc.). Here's a simple breakdown of how to create a table in MySQL.
          </p><br/>

          <h3 style={{paddingBottom:"6px"}}>Steps to Create a Table in MySQL</h3>
          <ol>
            <li><strong>Connect to MySQL Database:</strong> Before creating a table, you need to be connected to the MySQL server and have access to a specific database.</li><br/>
            <li><strong>Use the `CREATE TABLE` SQL Command:</strong> The `CREATE TABLE` command is used to create a new table. You define the column names, their data types, and any constraints (like primary keys, unique keys, etc.).</li><br/>
            <li><strong>Define the Columns:</strong> You need to define the name of each column, its data type (e.g., `INT`, `VARCHAR`), and any optional constraints like `NOT NULL`, `DEFAULT`, `AUTO_INCREMENT`, etc.</li><br/>
            <li><strong>Execute the SQL Command:</strong> After defining the table structure, execute the command to create the table in the database.</li>
          </ol><br/>

          <h3 style={{paddingBottom:"6px"}}>Example: Creating a Table in MySQL</h3>

          <pre className={style.codeBlock}>
{`CREATE TABLE students (
    id INT AUTO_INCREMENT PRIMARY KEY,   -- Primary key with auto incrementing ID
    first_name VARCHAR(255) NOT NULL,     -- First name of the student (text, can't be NULL)
    last_name VARCHAR(255) NOT NULL,      -- Last name of the student (text, can't be NULL)
    age INT,                             -- Age of the student (integer)
    email VARCHAR(255) UNIQUE            -- Email (unique value for each student)
);`}
          </pre><br/>

          <h3 style={{paddingBottom:"6px"}}>Explanation of the SQL Command:</h3>
          <ul>
            <li><strong>CREATE TABLE students:</strong> This starts the command to create a table named `students`.</li><br/>
            <li><strong>id INT AUTO_INCREMENT PRIMARY KEY:</strong> `id` is the column name, `INT` specifies the data type (integer), `AUTO_INCREMENT` automatically generates a unique number for each new row, and `PRIMARY KEY` makes `id` the unique identifier for each row.</li><br/>
            <li><strong>first_name VARCHAR(255) NOT NULL:</strong> `VARCHAR(255)` defines a text field that can store up to 255 characters, and `NOT NULL` ensures the column cannot have a NULL value.</li><br/>
            <li><strong>last_name VARCHAR(255) NOT NULL:</strong> Defines the student's last name similarly to `first_name`.</li><br/>
            <li><strong>age INT:</strong> Specifies the student's age as an integer value.</li><br/>
            <li><strong>email VARCHAR(255) UNIQUE:</strong> Specifies a text field for the email, with the `UNIQUE` constraint to ensure each email is unique.</li>
          </ul><br/>

          <h3 style={{paddingBottom:"6px"}}>Additional Constraints You Can Use in a Table:</h3>
          <ul>
            <li><strong>`NOT NULL`:</strong> Ensures the column cannot contain NULL values.</li><br/>
            <li><strong>`DEFAULT`:</strong> Provides a default value for a column if no value is provided during insertion (e.g., <code>age INT DEFAULT 18</code>).</li><br/>
            <li><strong>`UNIQUE`:</strong> Ensures that all values in the column are unique.</li><br/>
            <li><strong>`AUTO_INCREMENT`:</strong> Automatically generates a unique value for the column, usually for primary keys.</li><br/>
            <li><strong>`PRIMARY KEY`:</strong> Defines the column that uniquely identifies each row in the table.</li><br/>
            <li><strong>`FOREIGN KEY`:</strong> Links a column to another table's primary key (used to establish relationships between tables).</li>
          </ul><br/>

          <h3 style={{paddingBottom:"6px"}}>Using `CREATE TABLE` in MySQL</h3>
          <ol>
            <li><strong>Step 1:</strong> Connect to MySQL. Use the `mysql` command line tool or a GUI like MySQL Workbench.</li><br/>
            <li><strong>Step 2:</strong> Select the database using the `USE` statement:
              <pre className={style.codeBlock}>USE my_database;</pre>
            </li><br/>
            <li><strong>Step 3:</strong> Create the table with the `CREATE TABLE` statement:
              <pre className={style.codeBlock}>
{`CREATE TABLE employees (
    employee_id INT AUTO_INCREMENT PRIMARY KEY,
    name VARCHAR(100),
    department VARCHAR(100),
    hire_date DATE
);`}
              </pre>
            </li>
          </ol><br/>

          <h3>Conclusion:</h3>
          <p>
            Creating a table in MySQL is a straightforward process where you define the structure, data types, and constraints for your table. By using the `CREATE TABLE` statement, you can efficiently organize and store data in your database.
          </p>
        </div>
      )}
   



            {selectedChapter === 'chapter91' && (
               <div className={style.chaptercontent}>
                   <h1 className={style.heading}>Insert</h1>

    <p>Inserting data into a MySQL table is one of the most common tasks in SQL. You use the <code>INSERT INTO</code> statement to add new rows of data into a table. This operation can be done for a single row or multiple rows at once.</p>
    <br/>
    <h3 style={{paddingBottom:"6px"}}>Steps to Insert Data into a MySQL Table:</h3>

    <ol>
      <li>
        <strong>Use the <code>INSERT INTO</code> SQL Command:</strong>
        <p>The general syntax for inserting a single row into a table is as follows:</p>
        <pre><code>{`
INSERT INTO table_name (column1, column2, column3, ...)
VALUES (value1, value2, value3, ...);
        `}</code></pre>
        <ul>
          <li><strong>table_name</strong>: The name of the table where you want to insert the data.</li><br/>
          <li><strong>(column1, column2, ...)</strong>: A list of column names where the data will be inserted.</li><br/>
          <li><strong>VALUES (value1, value2, ...)</strong>: A list of values corresponding to the columns in the same order.</li>
        </ul>
      </li><br/>

      <li>
        <strong>Inserting a Single Row:</strong>
        <p>Suppose you have a table called <code>students</code> defined like this:</p>
        <pre><code>{`
CREATE TABLE students (
    id INT AUTO_INCREMENT PRIMARY KEY,
    first_name VARCHAR(255),
    last_name VARCHAR(255),
    age INT,
    email VARCHAR(255) UNIQUE
);
        `}</code></pre>
        <p>To insert a new student record into this table, you would use:</p>
        <pre><code>{`
INSERT INTO students (first_name, last_name, age, email)
VALUES ('John', 'Doe', 22, 'johndoe@example.com');
        `}</code></pre>
        <p>In this example:</p>
        <ul>
          <li><strong>first_name</strong>, <strong>last_name</strong>, <strong>age</strong>, and <strong>email</strong> are the columns.</li><br/>
          <li><strong>'John'</strong>, <strong>'Doe'</strong>, <strong>22</strong>, and <strong>'johndoe@example.com'</strong> are the corresponding values being inserted.</li>
        </ul>
      </li><br/>

      <li>
        <strong>Inserting Multiple Rows:</strong>
        <p>You can also insert multiple rows in a single query. Here's an example of inserting multiple students at once:</p>
        <pre><code>{`
INSERT INTO students (first_name, last_name, age, email)
VALUES
  ('Alice', 'Smith', 20, 'alice@example.com'),
  ('Bob', 'Johnson', 23, 'bob@example.com'),
  ('Charlie', 'Lee', 21, 'charlie@example.com');
        `}</code></pre>
        <p>This command inserts three new rows into the <code>students</code> table in one go.</p>
      </li><br/>

      <li>
        <strong>Auto-increment Fields:</strong>
        <p>If a column has the <code>AUTO_INCREMENT</code> attribute (like the <code>id</code> in the example table), you do not need to provide a value for that column when inserting data. MySQL will automatically generate a unique value for it.</p>
        <pre><code>{`
INSERT INTO students (first_name, last_name, age, email)
VALUES ('Eve', 'Taylor', 24, 'eve@example.com');
        `}</code></pre>
      </li><br/>

      <li>
        <strong>Inserting NULL Values:</strong>
        <p>If you want to insert a <code>NULL</code> value into a column (assuming the column allows <code>NULL</code>), you can use the keyword <code>NULL</code> instead of a value.</p>
        <pre><code>{`
INSERT INTO students (first_name, last_name, age, email)
VALUES ('Grace', 'Olsen', NULL, 'grace@example.com');
        `}</code></pre>
        <p>Here, the <code>age</code> column will be set to <code>NULL</code>.</p>
      </li><br/>

      <li>
        <strong>Inserting Data with Default Values:</strong>
        <p>If you have columns with default values, you can omit them in the <code>INSERT</code> statement, and MySQL will automatically insert the default value for those columns.</p>
        <pre><code>{`
CREATE TABLE products (
    product_id INT AUTO_INCREMENT PRIMARY KEY,
    product_name VARCHAR(255),
    price DECIMAL(10, 2) DEFAULT 0.00
);

INSERT INTO products (product_name)
VALUES ('Laptop');
        `}</code></pre>
        <p>In this case, <code>price</code> will automatically be set to <code>0.00</code> because it has a default value defined.</p>
      </li>
    </ol><br/>

    <h3>Summary of the <code>INSERT INTO</code> Statement:</h3>
    <ul>
      <li><strong>Syntax:</strong> <code>INSERT INTO table_name (column1, column2, column3, ...) VALUES (value1, value2, value3, ...);</code></li><br/>
      <li><strong>Inserting Single Row:</strong> <code>INSERT INTO table_name (column1, column2, ...) VALUES (value1, value2, ...);</code></li><br/>
      <li><strong>Inserting Multiple Rows:</strong> <code>INSERT INTO table_name (column1, column2, ...) VALUES (value1, value2, ...), (value1, value2, ...);</code></li><br/>
      <li><strong>Auto-increment Columns:</strong> For columns with the <code>AUTO_INCREMENT</code> property, do not specify a value for that column in the <code>INSERT</code> statement.</li>
    </ul><br/>

    <h3>Conclusion:</h3>
    <p>The <code>INSERT INTO</code> statement in MySQL allows you to insert data into a table efficiently. Whether you're inserting one row or multiple rows, the process is straightforward, and MySQL offers features like auto-increment and default values to make the insertion process even easier.</p>
  </div>
)}



      {selectedChapter === 'chapter92' && (
        <div className={style.chaptercontent}>
           <h1 className={style.heading}>SELECT </h1>

    <p>The <code>SELECT</code> statement is used to query data from one or more tables in MySQL. It is one of the most commonly used SQL commands to retrieve information from a database.</p>

    <br/>

    <h3 style={{paddingBottom:"6px"}}>Syntax of the <code>SELECT</code> Statement</h3>
    <pre><code>
      SELECT column1, column2, ...
      FROM table_name
      WHERE condition
      ORDER BY column
      LIMIT number;
    </code></pre>

    <p>Here’s what each part means:</p>
    <ul>
      <li><strong><code>SELECT</code>:</strong> Specifies the columns you want to retrieve from the table.</li><br/>
      <li><strong><code>FROM</code>:</strong> Specifies the table from which to retrieve the data.</li><br/>
      <li><strong><code>WHERE</code>:</strong> Filters records to include only those that meet certain conditions.</li><br/>
      <li><strong><code>ORDER BY</code>:</strong> Orders the result set by one or more columns.</li><br/>
      <li><strong><code>LIMIT</code>:</strong> Limits the number of records returned.</li>
    </ul>

    <br/>

    <h3>Basic Usage</h3>

    <h4>1. Selecting All Columns</h4>
    <p>To retrieve all columns from a table, you can use the <code>*</code> wildcard:</p>
    <pre><code>
      SELECT * FROM students;
    </code></pre>
    <p>This will select all columns from the <code>students</code> table.</p><br/>

    <h4>2. Selecting Specific Columns</h4>
    <p>If you only need specific columns, list them after <code>SELECT</code>:</p>
    <pre><code>
      SELECT first_name, last_name, age FROM students;
    </code></pre>
    <p>This will return only the <code>first_name</code>, <code>last_name</code>, and <code>age</code> columns from the <code>students</code> table.</p>

    <br/>

    <h3>Using the <code>WHERE</code> Clause</h3>
    <p>The <code>WHERE</code> clause is used to filter records based on specific conditions.</p>

    <h4>1. Selecting Rows with Specific Conditions</h4>
    <pre><code>{`
      SELECT * FROM students WHERE age > 20;`}
    </code></pre>
    <p>This will return all columns for students whose <code>age</code> is greater than 20.</p><br/>

    <h4>2. Using <code>AND</code> / <code>OR</code> in Conditions</h4>
    <p>You can combine multiple conditions with <code>AND</code> or <code>OR</code>:</p>
    <pre><code>{`
      SELECT * FROM students WHERE age > 20 AND last_name = 'Doe';`}
    </code></pre>
    <p>This will return students whose <code>age</code> is greater than 20 <strong>and</strong> whose <code>last_name</code> is 'Doe'.</p>

    <pre><code>{`
      SELECT * FROM students WHERE age > 20 OR last_name = 'Doe';`}
    </code></pre>
    <p>This will return students whose <code>age</code> is greater than 20 <strong>or</strong> whose <code>last_name</code> is 'Doe'.</p>

    <br/>
    <h3>Using <code>ORDER BY</code> Clause</h3>
    <p>You can sort the results by one or more columns using the <code>ORDER BY</code> clause.</p>

    <h4>1. Ascending Order (Default)</h4>
    <pre><code>
      SELECT * FROM students ORDER BY first_name;
    </code></pre>
    <p>This will return students ordered alphabetically by <code>first_name</code> in ascending order (default).</p><br/>

    <h4>2. Descending Order</h4>
    <pre><code>
      SELECT * FROM students ORDER BY age DESC;
    </code></pre>
    <p>This will return students ordered by <code>age</code> in descending order.</p>

    <br/>

    <h3>Using <code>LIMIT</code> Clause</h3>
    <p>The <code>LIMIT</code> clause is used to limit the number of rows returned by the query.</p>

    <h4>1. Limit the Number of Rows</h4>
    <pre><code>
      SELECT * FROM students LIMIT 5;
    </code></pre>
    <p>This will return only the first 5 rows from the <code>students</code> table.</p><br/>

    <h4>2. Using <code>OFFSET</code> with <code>LIMIT</code></h4>
    <pre><code>
      SELECT * FROM students LIMIT 5 OFFSET 10;
    </code></pre>
    <p>This will skip the first 10 rows and return the next 5 rows.</p>

    <br/>

    <h3>Using <code>DISTINCT</code> to Avoid Duplicates</h3>
    <p>If you want to retrieve unique values from a column, you can use the <code>DISTINCT</code> keyword:</p>
    <pre><code>
      SELECT DISTINCT age FROM students;
    </code></pre>
    <p>This will return only unique ages from the <code>students</code> table, eliminating duplicates.</p>

    <br/>

    <h3>Joining Tables with <code>JOIN</code></h3>
    <p>You can combine rows from two or more tables using the <code>JOIN</code> clause. There are different types of joins like <code>INNER JOIN</code>, <code>LEFT JOIN</code>, <code>RIGHT JOIN</code>, etc.</p>

    <h4>1. Inner Join</h4>
    <pre><code>{`
      SELECT students.first_name, students.last_name, courses.course_name
      FROM students
      INNER JOIN enrollments ON students.id = enrollments.student_id
      INNER JOIN courses ON enrollments.course_id = courses.id;`}
    </code></pre>
    <p>This will return a list of students, their last names, and the courses they are enrolled in. It combines data from three tables: <code>students</code>, <code>enrollments</code>, and <code>courses</code>.</p>
    <br/>
    <h4>2. Left Join</h4>
    <pre><code>{`
      SELECT students.first_name, students.last_name, courses.course_name
      FROM students
      LEFT JOIN enrollments ON students.id = enrollments.student_id
      LEFT JOIN courses ON enrollments.course_id = courses.id;`}
    </code></pre>
    <p>This will return all students and their courses. If a student is not enrolled in any course, the result will still include the student, but with <code>NULL</code> values for the course details.</p>

    <br/>

    <h3>Conclusion</h3>
    <p>The <code>SELECT</code> statement is a fundamental SQL command that allows you to retrieve data from MySQL tables. Whether you need to select all columns, filter data using the <code>WHERE</code> clause, sort data with <code>ORDER BY</code>, limit the number of rows returned with <code>LIMIT</code>, or even join multiple tables, <code>SELECT</code> is a versatile command for querying data.</p>

    <p>By mastering <code>SELECT</code>, you can efficiently retrieve the data you need from your database.</p>
  </div>
)}



        {selectedChapter === 'chapter93' && (
         <div className={style.chaptercontent}>
           <h1 className={style.heading}>The WHERE  </h1>

    <p>
      The <code>WHERE</code> clause in MySQL is used to filter records from a database table based on specified conditions.
      It allows you to specify a condition or multiple conditions that the rows must meet in order to be included in the result set. Without a <code>WHERE</code> clause, a query will return all rows from the table.
    </p>

    <h2 style={{paddingBottom:"6px"}}>Basic Syntax of the <code>WHERE</code> Clause:</h2>
    <pre><code>
      SELECT column1, column2, ...<br/>
      FROM table_name<br/>
      WHERE condition;
    </code></pre>
    <p>- <code>condition</code>: The condition specifies the criteria for selecting rows. Only rows that meet the condition will be included in the result set.</p>
    <br/>
    <h3>Common Uses of the <code>WHERE</code> Clause:</h3>

    <h4>1. Filtering with Single Conditions:</h4>
    <p>To select rows based on a single condition, such as finding students older than 20:</p>
    <pre><code>
      SELECT * FROM students<br/>
      WHERE age &gt; 20;
    </code></pre>
    <p>- This query returns all columns (<code>*</code>) from the <code>students</code> table where the <code>age</code> is greater than 20.</p>
    <br/>
    <h4>2. Using Operators in the <code>WHERE</code> Clause:</h4>
    <p>The <code>WHERE</code> clause can include various operators to refine your query:</p>
    <ul>
      <li><b>Comparison Operators:</b>
        <ul>
          <li><code>=</code> (equal to)</li><br/>
          <li><code>&gt;</code> (greater than)</li><br/>
          <li><code>&lt;</code> (less than)</li><br/>
          <li><code>&gt;=</code> (greater than or equal to)</li><br/>
          <li><code>&lt;=</code> (less than or equal to)</li><br/>
          <li><code>!=</code> or <code>&lt;&gt;</code> (not equal to)</li>
        </ul>
      </li><br/>
      <li><b>Logical Operators:</b>
        <ul>
          <li><code>AND</code>: Combines multiple conditions, all of which must be true.</li><br/>
          <li><code>OR</code>: Combines multiple conditions, where at least one condition must be true.</li>
        </ul>
      </li>
    </ul>

    <p>Example:</p>
    <pre><code>
      SELECT * FROM students<br/>
      WHERE age &gt; 20 AND last_name = 'Smith';
    </code></pre>
    <p>- This query selects students whose <code>age</code> is greater than 20 <b>and</b> whose <code>last_name</code> is 'Smith'.</p>
    <br/>
    <p>Example:</p>
    <pre><code>
      SELECT * FROM students<br/>
      WHERE age &gt; 20 OR last_name = 'Doe';
    </code></pre>
    <p>- This query returns students whose <code>age</code> is greater than 20 <b>or</b> whose <code>last_name</code> is 'Doe'.</p>
    <br/>
    <h4>3. Using <code>BETWEEN</code> for Range Checking:</h4>
    <p>The <code>BETWEEN</code> operator is used to filter results based on a range of values.</p>
    <pre><code>
      SELECT * FROM students<br/>
      WHERE age BETWEEN 18 AND 22;
    </code></pre>
    <p>- This query returns students whose <code>age</code> is between 18 and 22, inclusive.</p><br/>

    <h4>4. Using <code>IN</code> to Match Multiple Values:</h4>
    <p>The <code>IN</code> operator allows you to specify multiple values in a condition, which can be useful when checking against a list of values.</p>
    <pre><code>
      SELECT * FROM students<br/>
      WHERE last_name IN ('Smith', 'Johnson', 'Williams');
    </code></pre>
    <p>- This query returns students whose <code>last_name</code> is either 'Smith', 'Johnson', or 'Williams'.</p><br/>

    <h4>5. Using <code>LIKE</code> for Pattern Matching:</h4>
    <p>The <code>LIKE</code> operator is used to search for a specified pattern in a column. It is often used with wildcard characters:</p>
    <ul>
      <li><code>%</code> represents zero or more characters.</li><br/>
      <li><code>_</code> represents a single character.</li>
    </ul>

    <p>Example:</p>
    <pre><code>
      SELECT * FROM students<br/>
      WHERE first_name LIKE 'J%';
    </code></pre>
    <p>- This query returns all students whose first name starts with 'J'.</p>

    <p>Example with <code>_</code>:</p>
    <pre><code>
      SELECT * FROM students<br/>
      WHERE first_name LIKE 'J_n';
    </code></pre>
    <p>- This will return all students whose first name is three characters long and starts with 'J' and ends with 'n' (e.g., 'Jan', 'Jon').</p><br/>

    <h4>6. Using <code>IS NULL</code> or <code>IS NOT NULL</code>:</h4>
    <p>The <code>IS NULL</code> or <code>IS NOT NULL</code> condition is used to check if a column contains a <code>NULL</code> value.</p>
    <pre><code>
      SELECT * FROM students<br/>
      WHERE age IS NULL;
    </code></pre>
    <p>- This query selects students where the <code>age</code> column is <code>NULL</code>.</p>

    <pre><code>
      SELECT * FROM students<br/>
      WHERE age IS NOT NULL;
    </code></pre>
    <p>- This query selects students where the <code>age</code> column is not <code>NULL</code>.</p><br/>

    <h4>7. Combining Conditions with Parentheses:</h4>
    <p>When combining multiple conditions, you can use parentheses to ensure the correct order of operations.</p>
    <pre><code>
      SELECT * FROM students<br/>
      WHERE (age &gt; 20 AND last_name = 'Smith') OR first_name = 'John';
    </code></pre>
    <p>- This query will select students who are older than 20 and have the last name 'Smith', or students whose first name is 'John'.</p><br/>

    <h3>Examples of <code>WHERE</code> Clause in Action:</h3>
    <h4>1. Selecting Records Based on a Single Condition:</h4>
    <pre><code>
      SELECT first_name, last_name FROM students<br/>
      WHERE age &gt; 18;
    </code></pre><br/>

    <h4>2. Using <code>AND</code> to Combine Conditions:</h4>
    <pre><code>
      SELECT * FROM students<br/>
      WHERE age &gt; 20 AND last_name = 'Doe';
    </code></pre><br/>

    <h4>3. Using <code>OR</code> to Combine Conditions:</h4>
    <pre><code>
      SELECT * FROM students<br/>
      WHERE age &gt; 20 OR last_name = 'Smith';
    </code></pre><br/>

    <h4>4. Using <code>BETWEEN</code> for Range Query:</h4>
    <pre><code>
      SELECT * FROM students<br/>
      WHERE age BETWEEN 18 AND 25;
    </code></pre><br/>

    <h4>5. Using <code>IN</code> to Filter Based on Multiple Values:</h4>
    <pre><code>
      SELECT * FROM students<br/>
      WHERE last_name IN ('Johnson', 'Doe');
    </code></pre><br/>

    <h4>6. Using <code>LIKE</code> for Pattern Matching:</h4>
    <pre><code>
      SELECT * FROM students<br/>
      WHERE first_name LIKE 'A%';
    </code></pre><br/>

    <h4>7. Checking for NULL Values:</h4>
    <pre><code>
      SELECT * FROM students<br/>
      WHERE email IS NULL;
    </code></pre><br/>

    <h3>Conclusion:</h3>
    <p>The <code>WHERE</code> clause is essential for filtering data in MySQL. It allows you to specify exactly what data you want to retrieve based on conditions such as equality, range, pattern matching, and more. Understanding how to use the <code>WHERE</code> clause with various operators is key to writing effective SQL queries.</p>
  </div>
)}




        {selectedChapter === 'chapter94' && (
          <div className={style.chaptercontent}>
             <h1 className={style.heading}>ORDER BY </h1>

    <p>
      The <code>ORDER BY</code> clause in MySQL is used to sort the result set of a query by one or more columns. 
      It allows you to arrange the records in ascending (default) or descending order based on the column values. 
      Sorting can help you organize your data to make it easier to analyze.
    </p><br/>

    <h2>Syntax of the <code>ORDER BY</code> Clause:</h2>
    <pre>
      <code>
        {`SELECT column1, column2, ... 
FROM table_name 
ORDER BY column_name [ASC|DESC];`}
      </code>
    </pre>

    <ul>
      <li><strong>column_name</strong>: The name of the column you want to sort by.</li><br/>
      <li><strong>ASC</strong>: Specifies ascending order (this is the default if not specified).</li><br/>
      <li><strong>DESC</strong>: Specifies descending order.</li>
    </ul><br/>

    <h3 style={{paddingBottom:"6px"}}>Basic Usage:</h3>
    <h4>1. Ascending Order (default)</h4>
    <p>
      By default, <code>ORDER BY</code> sorts the data in ascending order (from smallest to largest for numeric values or alphabetically for text).
    </p>
    <pre>
      <code>
        {`SELECT first_name, last_name FROM students 
ORDER BY first_name;`}
      </code>
    </pre>
    <p>
      This will return a list of students, ordered alphabetically by <code>first_name</code> in ascending order.
    </p><br/>

    <h4>2. Descending Order</h4>
    <p>
      You can sort data in descending order using <code>DESC</code>. This is useful when you want to sort from largest to smallest or in reverse alphabetical order.
    </p>
    <pre>
      <code>
        {`SELECT first_name, last_name FROM students 
ORDER BY age DESC;`}
      </code>
    </pre>
    <p>
      This query will return the students, ordered by <code>age</code> from highest to lowest.
    </p><br/>

    <h3>Sorting by Multiple Columns:</h3>
    <p>
      You can sort by more than one column. The result set will first be sorted by the first column, then by the second column, and so on.
    </p>
    <pre>
      <code>
        {`SELECT first_name, last_name, age FROM students 
ORDER BY last_name ASC, first_name DESC;`}
      </code>
    </pre>
    <p>
      This will first order the students by <code>last_name</code> in ascending order. If two students have the same last name, they will be ordered by <code>first_name</code> in descending order.
    </p><br/>

    <h3>Sorting with <code>NULL</code> Values:</h3>
    <p>
      By default, when sorting in ascending order, <code>NULL</code> values will appear at the end of the result set. In descending order, <code>NULL</code> values will appear at the beginning.
    </p>
    <pre>
      <code>
        {`SELECT first_name, age FROM students 
ORDER BY age DESC;`}
      </code>
    </pre>
    <p>
      Students with <code>NULL</code> values in the <code>age</code> column will be placed at the top (since we are ordering by descending age).
    </p><br/>

    <h3>Examples of Using <code>ORDER BY</code>:</h3>
    <ul>
      <li>
        <pre>
          <code>
            {`SELECT * FROM employees 
ORDER BY salary;`}
          </code>
        </pre>
        This sorts employees by <code>salary</code> in ascending order (lowest to highest).
      </li>
      <li>
        <pre>
          <code>
            {`SELECT * FROM products 
ORDER BY price DESC;`}
          </code>
        </pre>
        This will sort products by their <code>price</code> in descending order (highest to lowest).
      </li>
      <li>
        <pre>
          <code>
            {`SELECT first_name, last_name, salary FROM employees 
ORDER BY last_name ASC, salary DESC;`}
          </code>
        </pre>
        This sorts first by <code>last_name</code> in ascending order. For employees with the same <code>last_name</code>, it sorts by <code>salary</code> in descending order.
      </li>
      <li>
        <pre>
          <code>
            {`SELECT * FROM users 
ORDER BY age ASC;`}
          </code>
        </pre>
        <p><code>NULL</code> values in the <code>age</code> column will appear last in the result set since we're sorting in ascending order.</p>
      </li>
    </ul><br/>

    <h3>Conclusion:</h3>
    <p>
      The <code>ORDER BY</code> clause is an essential part of SQL queries for organizing and displaying data in a desired order. 
      It can be used with one or more columns, with ascending or descending sorting, and can handle <code>NULL</code> values based on the specified order. Sorting data in a meaningful way helps you analyze and interpret it more effectively.
    </p>
  </div>
)}




        {selectedChapter === 'chapter95' && (
          <div className={style.chaptercontent}>
            <h1 className={style.heading}> DELETE </h1>

    <p>
      The <code>DELETE</code> statement in MySQL is used to remove records from a table.
      Unlike <code>TRUNCATE</code>, which removes all records from a table, <code>DELETE</code>
      allows you to specify conditions to remove only specific rows. It is important to note that
      <code>DELETE</code> is a DML (Data Manipulation Language) command and is slower than
      <code>TRUNCATE</code>, but it allows you to delete individual rows based on a condition.
    </p><br/>

    <h2>Syntax of the <code>DELETE</code> Statement:</h2>
    <pre>
      <code>
        DELETE FROM table_name WHERE condition;
      </code>
    </pre>
    <ul>
      <li><strong>table_name</strong>: The name of the table from which you want to delete records.</li><br/>
      <li><strong>WHERE condition</strong>: The condition used to specify which rows to delete. If you omit the <code>WHERE</code> clause, all rows in the table will be deleted.</li>
    </ul><br/>

    <h2 style={{paddingBottom:"6px"}}> Key Points to Remember:</h2>
    <ol>
      <li>
        <strong>Without the <code>WHERE</code> clause</strong>: If you do not include a <code>WHERE</code> clause, all rows in the table will be deleted.
        <pre><code>DELETE FROM employees;</code></pre>
        This will delete all records from the <code>employees</code> table.
      </li><br/>
      <li>
        <strong>With the <code>WHERE</code> clause</strong>: You can specify conditions to delete only the rows that meet the criteria.
        <pre><code>DELETE FROM employees WHERE age {">"} 65;</code></pre>
        This will delete all employees whose age is greater than 65.
      </li><br/>
      <li>
        <strong>Deleting Specific Records</strong>: You can delete specific records by applying conditions on one or more columns.
        <pre><code>DELETE FROM employees WHERE first_name = 'John' AND last_name = 'Doe';</code></pre>
        This deletes records of employees named "John Doe".
      </li><br/>
      <li>
        <strong>Using <code>LIMIT</code></strong>: You can limit the number of records to be deleted using the <code>LIMIT</code> clause.
        <pre><code>DELETE FROM employees WHERE department = 'Sales' LIMIT 10;</code></pre>
        This will delete up to 10 records where the department is 'Sales'.
      </li><br/>
      <li>
        <strong>Deleting Based on Subqueries</strong>: You can delete records based on the results of a subquery.
        <pre><code>DELETE FROM employees WHERE department_id IN (SELECT department_id FROM departments WHERE location = 'New York');</code></pre>
        This will delete employees who work in departments located in 'New York'.
      </li><br/>
      <li>
        <strong>Referential Integrity and Foreign Keys</strong>: If a table has foreign key constraints, you may not be able to delete rows if they are being referenced by other tables.
        To handle this, you can define the behavior of foreign key constraints using options like <code>ON DELETE CASCADE</code>, <code>ON DELETE SET NULL</code>, etc.
      </li><br/>
    </ol>

    <h2>Example Scenarios for Using <code>DELETE</code>:</h2>
    <ul>
      <li>
        <strong>Deleting Records Based on a Condition:</strong>
        <pre><code>{`DELETE FROM products WHERE price < 10;`}</code></pre>
        This deletes all products with a price less than 10.
      </li><br/>
      <li>
        <strong>Deleting a Single Record:</strong>
        <pre><code>DELETE FROM students WHERE student_id = 12345;</code></pre>
        This deletes the student with the specific <code>student_id</code>.
      </li><br/>
      <li>
        <strong>Deleting All Records (Without a WHERE clause):</strong>
        <pre><code>DELETE FROM orders;</code></pre>
        This removes all records from the <code>orders</code> table but keeps the table structure intact.
      </li><br/>
      <li>
        <strong>Using Subqueries to Delete Data:</strong>
        <pre><code>{`DELETE FROM employees WHERE department_id IN (SELECT department_id FROM departments WHERE budget < 10000);`}</code></pre>
        This deletes employees working in departments with a budget less than 10,000.
      </li>
    </ul><br/>

    <h2>Performance Considerations:</h2>
    <ul>
      <li>
        <strong>Speed:</strong> <code>DELETE</code> can be slower than <code>TRUNCATE</code> because it removes rows one by one and checks constraints (like foreign keys) if present.
      </li><br/>
      <li>
        <strong>Rollback:</strong> Since <code>DELETE</code> is a transactional operation, it can be rolled back if executed within a transaction (using <code>ROLLBACK</code>). This makes it safer when you are not sure about the results.
      </li><br/>
    </ul>

    <h2>Example of <code>DELETE</code>:</h2>
    <p>
      Let's say we have an <code>employees</code> table:
    </p>

    <pre>
      <code>{`
        | employee_id | first_name | last_name | department |
        |-------------|------------|-----------|------------|
        | 1           | John       | Doe       | Sales      |
        | 2           | Jane       | Smith     | HR         |
        | 3           | Jim        | Brown     | IT         |
     `} </code>
    </pre>

    <p>
      To delete the record of the employee named "John Doe" from the <code>Sales</code> department, you would write:
    </p>

    <pre>
      <code>
        DELETE FROM employees WHERE first_name = 'John' AND last_name = 'Doe' AND department = 'Sales';
      </code>
    </pre>

    <p>
      After executing the above command, the table will be:
    </p>

    <pre>
      <code>{`
        | employee_id | first_name | last_name | department |
        |-------------|------------|-----------|------------|
        | 2           | Jane       | Smith     | HR         |
        | 3           | Jim        | Brown     | IT         |
     `} </code>
    </pre><br/>

    <h2>Conclusion:</h2>
    <p>
      The <code>DELETE</code> statement is essential for removing specific records from a table based on a condition. It’s powerful but should be used with caution to avoid accidental data loss, especially when omitting the <code>WHERE</code> clause. Always back up important data before performing bulk deletes, and ensure you have appropriate transaction management in place if needed.
    </p>
  </div>
)}




        {selectedChapter === 'chapter96' && (
         <div className={style.chaptercontent}>
            <h1 className={style.heading}>DROP TABLE </h1>

    <p>
      In MySQL, the <code>DROP TABLE</code> statement is used to completely remove a table from the database. This operation not only deletes the table structure but also removes all the data stored in the table. Once a table is dropped, it cannot be recovered unless there is a backup available.
    </p><br/>

    <h2>Syntax of the <code>DROP TABLE</code> Statement:</h2>
    <pre>
      <code>
        DROP TABLE table_name;
      </code>
    </pre>
    <ul>
      <li><strong>table_name:</strong> The name of the table you want to drop.</li>
    </ul><br/>

    <h3>Key Points to Remember:</h3>
    <ol>
      <li><strong>Permanently Deletes the Table:</strong> Once you execute the <code>DROP TABLE</code> command, the table is removed from the database, and all the data in it is lost.</li><br/>
      <li><strong>Cannot Be Rolled Back (unless in a transaction):</strong> If you drop a table, the operation cannot be undone unless you are using transactions (and have not yet committed the change).</li><br/>
      <li><strong>Foreign Key Constraints:</strong> If other tables reference the table you want to drop via foreign keys, the <code>DROP TABLE</code> operation will fail unless you handle the foreign keys (e.g., using <code>ON DELETE CASCADE</code> when setting up foreign keys).</li><br/>
      <li><strong>Use with Caution:</strong> Since this operation cannot be reversed easily, it is critical to back up the data or double-check the table name before performing it.</li>
    </ol><br/>

    <h3>Example of Dropping a Table:</h3>
    <p>
      To drop a table named <code>employees</code>:
    </p>
    <pre>
      <code>
        DROP TABLE employees;
      </code>
    </pre>
    <p>This will remove the <code>employees</code> table from the database.</p><br/>

    <h3>Dropping Multiple Tables:</h3>
    <p>
      You can also drop multiple tables at once by separating the table names with commas:
    </p>
    <pre>
      <code>
        DROP TABLE employees, departments, products;
      </code>
    </pre>
    <p>This will drop the <code>employees</code>, <code>departments</code>, and <code>products</code> tables.</p><br/>

    <h3>Using <code>IF EXISTS</code>:</h3>
    <p>
      To avoid errors if the table does not exist, you can use <code>IF EXISTS</code>:
    </p>
    <pre>
      <code>
        DROP TABLE IF EXISTS employees;
      </code>
    </pre>
    <p>This ensures that MySQL will only try to drop the table if it exists, preventing an error from being thrown if the table is missing.</p>
    <br/>
    <h3>Example Scenario:</h3>
    <p>
      Suppose you have a table <code>orders</code> that you no longer need. To delete this table, you would use:
    </p>
    <pre>
      <code>
        DROP TABLE orders;
      </code>
    </pre>
    <p>This will remove the entire <code>orders</code> table and all its data from the database.</p>
    <br/>
    <h3>Conclusion:</h3>
    <p>
      The <code>DROP TABLE</code> statement is a powerful command that permanently removes a table and its data from the database. Be sure to use this command with caution, especially in production environments, as once executed, the data and table structure are lost unless there is a backup.
    </p>
  </div>
)}




        {selectedChapter === 'chapter97' && (
         <div className={style.chaptercontent}>
           <h1 className={style.heading}>UPDATE   </h1>
    
    <p>
      In MySQL, the <code>UPDATE</code> statement is used to modify the existing records in a table.
      You can use the <code>UPDATE</code> statement to change one or more column values in one or more rows based on a specified condition.
    </p><br/>

    <h3 style={{paddingBottom:"6px"}}>Syntax of the <code>UPDATE</code> Statement:</h3>
    <pre>
      <code>
        {`UPDATE table_name
SET column1 = value1, column2 = value2, ...
WHERE condition;`}
      </code>
    </pre>
    <ul>
      <li><strong>table_name:</strong> The name of the table you want to update.</li><br/>
      <li><strong>column1, column2, ...:</strong> The columns whose values you want to update.</li><br/>
      <li><strong>value1, value2, ...:</strong> The new values you want to assign to the columns.</li><br/>
      <li><strong>WHERE condition:</strong> The condition that specifies which rows should be updated. If omitted, all rows will be updated.</li>
    </ul><br/>

    <h3>Key Points to Remember:</h3>
    <ol>
      <li><strong>The WHERE Clause is Crucial:</strong> Without it, <strong>all rows</strong> in the table will be updated. Be cautious to avoid unintended modifications.</li><br/>
      <li><strong>Transaction Management:</strong> The <code>UPDATE</code> statement can be rolled back in a transaction, provided the transaction hasn't been committed yet.</li><br/>
      <li><strong>Multiple Columns:</strong> You can update multiple columns in one statement by separating them with commas.</li><br/>
      <li><strong>Set Expressions:</strong> The column value can be set based on an expression, calculation, or the result of a subquery.</li>
    </ol><br/>

    <h3>Basic Usage:</h3>
    <h4>1. Updating a Single Column:</h4>
    <pre>
      <code>
        {`UPDATE employees
SET salary = 50000
WHERE employee_id = 1;`}
      </code>
    </pre>
    <p>This updates the <code>salary</code> of the employee with <code>employee_id = 1</code> to 50,000.</p>
    <br/>
    <h4>2. Updating Multiple Columns:</h4>
    <pre>
      <code>
        {`UPDATE employees
SET salary = 60000, department = 'HR'
WHERE employee_id = 2;`}
      </code>
    </pre>
    <p>This query updates both <code>salary</code> and <code>department</code> of the employee with <code>employee_id = 2</code>.</p>
    <br/>
    <h4>3. Using Expressions:</h4>
    <pre>
      <code>
        {`UPDATE employees
SET salary = salary * 1.10
WHERE department = 'Sales';`}
      </code>
    </pre>
    <p>This increases the salary of all employees in the 'Sales' department by 10%.</p>
    <br/>
    <h4>4. Using Subqueries:</h4>
    <pre>
      <code>
        {`UPDATE employees
SET department_id = (SELECT department_id FROM departments WHERE department_name = 'IT')
WHERE employee_id = 3;`}
      </code>
    </pre>
    <p>This query updates the <code>department_id</code> of the employee with <code>employee_id = 3</code> to the <code>department_id</code> of the 'IT' department.</p>
    <br/>
    <h3>Example Scenarios for Using <code>UPDATE</code>:</h3>
    <h4>1. Updating a Single Record:</h4>
    <pre>
      <code>
        {`UPDATE employees
SET phone_number = '123-456-7890'
WHERE employee_id = 5;`}
      </code>
    </pre><br/>

    <h4>2. Bulk Update Based on Conditions:</h4>
    <pre>
      <code>
        {`UPDATE employees
SET salary = salary + 2000
WHERE department = 'Marketing';`}
      </code>
    </pre><br/>

    <h4>3. Updating Based on Complex Conditions:</h4>
    <pre>
      <code>
        {`UPDATE orders
SET status = 'Closed'
WHERE order_date < NOW() - INTERVAL 30 DAY;`}
      </code>
    </pre><br/>

    <h3>Performance Considerations:</h3>
    <ul>
      <li><strong>Locking:</strong> The <code>UPDATE</code> operation can lock the rows it modifies, affecting performance when updating large datasets.</li><br/>
      <li><strong>Indexes:</strong> Ensure that columns used in the <code>WHERE</code> clause are indexed for improved performance.</li><br/>
      <li><strong>Bulk Updates:</strong> Bulk updates can be resource-intensive, so optimization is key.</li>
    </ul><br/>

    <h3>Conclusion:</h3>
    <p>
      The <code>UPDATE</code> statement in MySQL is a powerful tool for modifying existing records. Always ensure you use the <code>WHERE</code> clause to avoid unintentional updates. Consider using transactions for safety when performing bulk updates or critical changes.
    </p>
  </div>
)}




        {selectedChapter === 'chapter98' && (
          <div className={style.chaptercontent}>
           <h1 className={style.heading}> JOIN </h1>

    <p>
      In MySQL, a <strong>JOIN</strong> is used to combine rows from two or more tables based on a related column between them. This operation is essential when you want to retrieve data that is spread across multiple tables in a relational database. There are different types of JOINs in MySQL, each serving specific use cases for how the data should be combined.
    </p><br/>

    <h2 style={{paddingBottom:"6px"}}>Types of JOINs in MySQL:</h2>

    <h3>1. <strong>INNER JOIN</strong>:</h3>
    <ul>
      <li>The most common type of join.</li>
      <li>Returns only the rows that have matching values in both tables.</li>
      <li>If there is no match, the row is not included in the result.</li>
    </ul>
    <p><strong>Syntax:</strong></p>
    <pre>
      {`SELECT columns
FROM table1
INNER JOIN table2
ON table1.column = table2.column;`}
    </pre>
    <p><strong>Example:</strong></p>
    <pre>
      {`SELECT employees.name, departments.department_name
FROM employees
INNER JOIN departments
ON employees.department_id = departments.department_id;`}
    </pre>
    <p>
      This query retrieves the names of employees and their respective departments where the <code>department_id</code> matches in both the <code>employees</code> and <code>departments</code> tables.
    </p><br/>

    <h3>2. <strong>LEFT JOIN (or LEFT OUTER JOIN)</strong>:</h3>
    <ul>
      <li>Returns all rows from the left table (table1), and the matching rows from the right table (table2).</li>
      <li>If there is no match, NULL values are returned for columns from the right table.</li>
    </ul>
    <p><strong>Syntax:</strong></p>
    <pre>
      {`SELECT columns
FROM table1
LEFT JOIN table2
ON table1.column = table2.column;`}
    </pre>
    <p><strong>Example:</strong></p>
    <pre>
      {`SELECT employees.name, departments.department_name
FROM employees
LEFT JOIN departments
ON employees.department_id = departments.department_id;`}
    </pre>
    <p>
      This query retrieves all employees and their departments, including employees who do not belong to any department (their department name will be <code>NULL</code>).
    </p><br/>

    <h3>3. <strong>RIGHT JOIN (or RIGHT OUTER JOIN)</strong>:</h3>
    <ul>
      <li>The opposite of the LEFT JOIN.</li>
      <li>Returns all rows from the right table (table2), and the matching rows from the left table (table1).</li>
      <li>If there is no match, NULL values are returned for columns from the left table.</li>
    </ul>
    <p><strong>Syntax:</strong></p>
    <pre>
      {`SELECT columns
FROM table1
RIGHT JOIN table2
ON table1.column = table2.column;`}
    </pre>
    <p><strong>Example:</strong></p>
    <pre>
      {`SELECT employees.name, departments.department_name
FROM employees
RIGHT JOIN departments
ON employees.department_id = departments.department_id;`}
    </pre>
    <p>
      This query retrieves all departments and their employees, including departments with no employees (the employee name will be <code>NULL</code>).
    </p><br/>

    <h3>4. <strong>FULL JOIN (or FULL OUTER JOIN)</strong>:</h3>
    <ul>
      <li>Returns all rows when there is a match in one of the tables.</li>
      <li>It returns NULL values where there is no match.</li>
      <li>MySQL does not support the <code>FULL OUTER JOIN</code> directly. However, you can simulate it by combining a <code>LEFT JOIN</code> and a <code>RIGHT JOIN</code> with a <code>UNION</code>.</li>
    </ul>
    <p><strong>Syntax (simulating FULL OUTER JOIN):</strong></p>
    <pre>
      {`SELECT columns
FROM table1
LEFT JOIN table2
ON table1.column = table2.column
UNION
SELECT columns
FROM table1
RIGHT JOIN table2
ON table1.column = table2.column;`}
    </pre>
    <p><strong>Example:</strong></p>
    <pre>
      {`SELECT employees.name, departments.department_name
FROM employees
LEFT JOIN departments
ON employees.department_id = departments.department_id
UNION
SELECT employees.name, departments.department_name
FROM employees
RIGHT JOIN departments
ON employees.department_id = departments.department_id;`}
    </pre>
    <p>
      This query returns all employees and all departments, including those without corresponding matches.
    </p><br/>

    <h3>5. <strong>CROSS JOIN</strong>:</h3>
    <ul>
      <li>This join does not require a condition.</li>
      <li>It returns the Cartesian product of two tables, meaning it combines every row of the first table with every row of the second table.</li>
    </ul>
    <p><strong>Syntax:</strong></p>
    <pre>
      {`SELECT columns
FROM table1
CROSS JOIN table2;`}
    </pre>
    <p><strong>Example:</strong></p>
    <pre>
      {`SELECT employees.name, departments.department_name
FROM employees
CROSS JOIN departments;`}
    </pre>
    <p>
      This query returns a result set that includes every possible combination of employee names and department names.
    </p><br/>

    <h3>6. <strong>SELF JOIN</strong>:</h3>
    <ul>
      <li>A self join is a regular join, but the table is joined with itself.</li>
      <li>It is useful when you need to compare rows within the same table.</li>
    </ul>
    <p><strong>Syntax:</strong></p>
    <pre>
      {`SELECT columns
FROM table1 t1
JOIN table1 t2
ON t1.column = t2.column;`}
    </pre>
    <p><strong>Example:</strong></p>
    <pre>
      {`SELECT e1.name AS Employee, e2.name AS Manager
FROM employees e1
JOIN employees e2
ON e1.manager_id = e2.employee_id;`}
    </pre>
    <p>
      This query lists employees and their managers, where the <code>manager_id</code> in <code>employees</code> refers to an <code>employee_id</code> in the same table.
    </p><br/>

    <h2>JOIN Conditions:</h2>
    <p>
      <strong>ON Clause:</strong> Defines the condition on which two tables should be joined. Usually, this is a foreign key relationship.
    </p>
    <p>
      <strong>USING Clause:</strong> An alternative to the <code>ON</code> clause when both tables have a column with the same name.
    </p>
    <pre>
      {`SELECT employees.name, departments.department_name
FROM employees
JOIN departments
USING (department_id);`}
    </pre><br/>

    <h2>Key Points:</h2>
    <ul>
      <li><strong>INNER JOIN</strong>: Only rows with matching values in both tables are returned.</li><br/>
      <li><strong>LEFT JOIN</strong>: All rows from the left table are returned, with matching rows from the right table.</li><br/>
      <li><strong>RIGHT JOIN</strong>: All rows from the right table are returned, with matching rows from the left table.</li><br/>
      <li><strong>FULL JOIN</strong>: Combines the results of both LEFT and RIGHT joins.</li><br/>
      <li><strong>CROSS JOIN</strong>: Returns a Cartesian product of two tables.</li><br/>
      <li><strong>SELF JOIN</strong>: A table is joined with itself, often used for hierarchical data.</li>
    </ul><br/>

    <h2>Example Scenario:</h2>
    <p>Let’s say you have two tables: <code>employees</code> and <code>departments</code>.</p>

    <p><strong>employees</strong> Table:</p>
    <pre>
      {`| employee_id | name  | department_id |
|-------------|-------|---------------|
| 1           | John  | 101           |
| 2           | Alice | 102           |
| 3           | Bob   | 103           |`}
    </pre>

    <p><strong>departments</strong> Table:</p>
    <pre>
      {`| department_id | department_name |
|---------------|-----------------|
| 101           | HR              |
| 102           | IT              |
| 103           | Finance         |`}
    </pre>

    <p>
      To get the list of employees and their corresponding department names using an <strong>INNER JOIN</strong>, you would use:
    </p>
    <pre>
      {`SELECT employees.name, departments.department_name
FROM employees
INNER JOIN departments
ON employees.department_id = departments.department_id;`}
    </pre>

    <p><strong>Result:</strong></p>
    <pre>
      {`| name  | department_name |
|-------|-----------------|
| John  | HR              |
| Alice | IT              |
| Bob   | Finance         |`}
    </pre>
    <br/>
    <h2>Conclusion:</h2>
    <p>
      MySQL's JOIN operation is fundamental for working with relational databases, allowing you to combine data from multiple tables. Depending on the type of join you use, you can tailor your query to return exactly the data you need. Always be cautious when using joins, especially with large datasets, to avoid performance issues.
    </p>
  </div>
)}




        {selectedChapter === 'chapter99' && (
           <div className={style.chaptercontent}>
              <h1 className={style.heading}>LIMIT  </h1>

    <p>
      In MySQL, the <code>LIMIT</code> clause is used to specify the number of rows returned by a query. It is often used to restrict the result set, especially when dealing with large tables, to improve performance or return only a subset of the data.
    </p>
    <br/>
    <h2>Syntax:</h2>
    <pre>
      <code>
        {`SELECT columns
FROM table
LIMIT number_of_rows;`}
      </code>
    </pre>
    <p>
      - <strong>number_of_rows</strong>: Specifies how many rows to return. This can be a specific number or used in combination with <strong>OFFSET</strong>.
    </p>

    <p>
      You can also use <code>LIMIT</code> with an optional <strong>OFFSET</strong> to specify where to start returning rows from. This is helpful for pagination or retrieving a specific range of rows.
    </p><br/>

    <h2>Syntax with OFFSET:</h2>
    <pre>
      <code>
        {`SELECT columns
FROM table
LIMIT offset, number_of_rows;`}
      </code>
    </pre>
    <p>
      - <strong>offset</strong>: The number of rows to skip before starting to return results.
    </p>
    <p>
      - <strong>number_of_rows</strong>: The number of rows to return after skipping the <strong>offset</strong>.
    </p><br/>

    <h2>Examples:</h2>

    <h3>1. Limit the number of rows returned:</h3>
    <pre>
      <code>
        {`SELECT * FROM employees
LIMIT 5;`}
      </code>
    </pre>
    <p>This query will return the first 5 rows from the <code>employees</code> table.</p><br/>

    <h3>2. Limit with OFFSET:</h3>
    <pre>
      <code>
        {`SELECT * FROM employees
LIMIT 5 OFFSET 5;`}
      </code>
    </pre>
    <p>
      This query will return rows 6 through 10 from the <code>employees</code> table.
    </p><br/>

    <h3>3. Limit with both <code>OFFSET</code> and <code>number_of_rows</code>:</h3>
    <pre>
      <code>
        {`SELECT * FROM employees
LIMIT 5, 5;`}
      </code>
    </pre>
    <p>
      This query is the same as the previous one: it skips the first 5 rows and returns the next 5 rows (rows 6 to 10).
    </p><br/>

    <h2>Use Case: Pagination</h2>
    <p>
      <code>LIMIT</code> is often used for pagination in web applications, where you need to display a subset of rows from a large result set, for example, showing 10 rows per page.
    </p><br/>

    <h3>For page 1 (show rows 1 to 10):</h3>
    <pre>
      <code>
        {`SELECT * FROM employees
LIMIT 10;`}
      </code>
    </pre><br/>

    <h3>For page 2 (show rows 11 to 20):</h3>
    <pre>
      <code>
        {`SELECT * FROM employees
LIMIT 10 OFFSET 10;`}
      </code>
    </pre><br/>

    <h2>Notes:</h2>
    <ul>
      <li>
        <strong>Performance Consideration:</strong> When using <code>LIMIT</code> with large tables, it can help optimize query performance by retrieving only a subset of rows, especially when combined with <code>ORDER BY</code> to sort the results.
      </li><br/>
      <li>
        <strong>Default behavior:</strong> If you don’t specify a <code>LIMIT</code>, MySQL will return all rows that match the query.
      </li>
    </ul><br/>

    <h2>Conclusion:</h2>
    <p>
      The <code>LIMIT</code> clause in MySQL is essential for controlling the size of your result set, improving performance, and implementing features like pagination. It is highly useful when working with large datasets.
    </p>
  </div>
)}




        {selectedChapter === 'chapter100' && (
            <div className={style.chaptercontent}>
              <h1 className={style.heading}> Introduction to Python MongoD </h1>



        <h3>Introduction to Python MongoDB</h3>

        <p>
          MongoDB is a popular NoSQL database that stores data in a flexible, JSON-like format called <strong>BSON (Binary JSON)</strong>. Unlike traditional relational databases, MongoDB is schema-less, meaning that it doesn't require a fixed schema for the data. This makes MongoDB ideal for handling unstructured, semi-structured, or rapidly changing data.
        </p>

        <p>
          When using Python to interact with MongoDB, the most common tool is the <code>PyMongo</code> library, which provides a simple interface to communicate with a MongoDB database from Python.
        </p><br/>

        <h3>Setting up MongoDB with Python</h3>

        <p>To get started with MongoDB in Python, follow these steps:</p>
        <ol>
          <li><strong>Install MongoDB</strong>: First, you need to have MongoDB installed on your local machine or use a cloud service like MongoDB Atlas.</li><br/>
          <li><strong>Install PyMongo</strong>: PyMongo is the official Python driver for MongoDB. You can install it via pip:
            <pre><code>pip install pymongo</code></pre>
          </li><br/>
          <li><strong>Connect to MongoDB</strong>: After installing PyMongo, you can create a connection to your MongoDB database using the <code>MongoClient</code>.</li>
        </ol><br/>

        <h3>Example:</h3>
        <pre>
          <code>
            {`from pymongo import MongoClient

# Connect to the local MongoDB server
client = MongoClient("mongodb://localhost:27017/")

# Access a specific database (it will be created if it doesn't exist)
db = client["mydatabase"]

# Access a collection (like a table in SQL)
collection = db["mycollection"]`}
          </code>
        </pre>

        <p>
          In the above code:
          <ul>
            <li><code>MongoClient</code> connects to a MongoDB instance running on <code>localhost:27017</code>.</li><br/>
            <li>The <code>mydatabase</code> is the database you're connecting to, and the <code>mycollection</code> is the collection where your data will be stored.</li>
          </ul><br/>
        </p>

        <h3>MongoDB Structure Overview:</h3>
        <ul>
          <li><strong>Database</strong>: A container for collections.</li><br/>
          <li><strong>Collection</strong>: A collection is a group of MongoDB documents (similar to tables in relational databases).</li><br/>
          <li><strong>Document</strong>: A document is a record, and it is stored as a BSON (Binary JSON) object, similar to a JSON document.</li>
        </ul><br/>

        <h4>Example of a Document:</h4>
        <pre>
          <code>
            {`{
  "_id": 1,
  "name": "Alice",
  "age": 25,
  "city": "New York"
}`}
          </code>
        </pre><br/>

        <h3 style={{paddingBottom:"6px"}}>Benefits of Using MongoDB with Python:</h3>
        <ul>
          <li><strong>Flexible Schema</strong>: MongoDB allows documents in a collection to have different structures. This flexibility is useful when dealing with changing or evolving data.</li><br/>
          <li><strong>Scalability</strong>: MongoDB can easily scale horizontally by adding more machines, making it ideal for large datasets and high-performance applications.</li><br/>
          <li><strong>Integrated Python Support</strong>: The PyMongo library simplifies the process of interacting with MongoDB from Python, providing a straightforward API for database operations.</li>
        </ul><br/>

        <h3>Conclusion:</h3>
        <p>
          MongoDB is a powerful NoSQL database that integrates well with Python, allowing for flexible and efficient data management.
        </p>
      </div>
    )}



      {selectedChapter === 'chapter101' && (
       <div className={style.chaptercontent}>
         <h1 className={style.heading}>Create Databases  </h1>

    <p>
      In MongoDB, creating a database is a straightforward process. Unlike traditional relational databases, you don't explicitly create a database using a <code>CREATE DATABASE</code> command. Instead, MongoDB creates a database automatically when you insert data into it for the first time.
    </p><br/>

    <h3>Steps to Create a Database in MongoDB</h3>

    <ol>
      <li>
        <strong>Connect to MongoDB:</strong>
        <p>
          Before you can create a database, you need to connect to a MongoDB instance. This can be either a local MongoDB server or a cloud instance like MongoDB Atlas.
        </p>
        <p>If you're using the MongoDB shell, you connect by simply starting the shell:</p>
        <pre><code>mongo</code></pre>
        <p>For Python (using PyMongo), you'd use the following code to connect:</p>
        <pre><code>
{`from pymongo import MongoClient

# Connect to the MongoDB server
client = MongoClient("mongodb://localhost:27017/")  # Adjust the connection string as needed`}
        </code></pre>
      </li><br/>

      <li>
        <strong>Select or Create a Database:</strong>
        <p>
          In MongoDB, you select a database by simply referencing its name. If the database does not exist, MongoDB will create it automatically when data is added.
        </p>
        <p>In the MongoDB shell:</p>
        <pre><code>use mydatabase</code></pre>
        <p>In this case, <code>mydatabase</code> is the name of the database you're selecting or creating. MongoDB does not actually create the database until you insert a document into a collection.</p>
        <p>In Python, using PyMongo:</p>
        <pre><code>
{`db = client["mydatabase"]`}
        </code></pre>
        <p>If <code>mydatabase</code> doesn't exist, MongoDB will create it once you insert data into a collection within that database.</p>
      </li><br/>

      <li>
        <strong>Insert Data to Create the Database:</strong>
        <p>
          MongoDB databases are created when data is inserted into a collection. A collection is like a table in a relational database, and it stores documents (similar to rows in a table).
        </p>
        <p>Example in the MongoDB shell:</p>
        <pre><code>
{`db.mycollection.insertOne({name: "Alice", age: 30})`}
        </code></pre>
        <p>In this example, <code>mycollection</code> is the collection being created within the <code>mydatabase</code> database. When this document is inserted, MongoDB automatically creates both the database (<code>mydatabase</code>) and the collection (<code>mycollection</code>).</p>
        <p>Example in Python using PyMongo:</p>
        <pre><code>
{`collection = db["mycollection"]
collection.insert_one({"name": "Alice", "age": 30})`}
        </code></pre>
      </li><br/>

      <li>
        <strong>Verify the Database Creation:</strong>
        <p>
          Once you insert data into the collection, you can check if the database has been created.
        </p>
        <p>In the MongoDB shell, run:</p>
        <pre><code>show dbs</code></pre>
        <p>This will list all the databases on the MongoDB server, including <code>mydatabase</code> if it's been created.</p>
        <p>In Python, you can list all databases with:</p>
        <pre><code>
{`print(client.list_database_names())`}
        </code></pre>
      </li>
    </ol><br/>

    <h3>Example: Creating a Database in Python</h3>
    <p>Here’s a complete example in Python using the <code>PyMongo</code> library:</p>
    <pre><code>
{`from pymongo import MongoClient

# Connect to MongoDB server
client = MongoClient("mongodb://localhost:27017/")

# Create or select the database
db = client["mydatabase"]

# Create or select the collection within the database
collection = db["mycollection"]

# Insert a document into the collection (this will create the database and collection if they don't exist)
collection.insert_one({"name": "Alice", "age": 30})

# List all databases to confirm the new database has been created
print(client.list_database_names())`}
    </code></pre><br/>

    <h3>Key Points:</h3>
    <ul>
      <li><strong>Implicit Creation:</strong> MongoDB creates a database when you first insert data into a collection.</li><br/>
      <li><strong>No <code>CREATE DATABASE</code> Command:</strong> Unlike SQL databases, you don’t explicitly create a database; it's created automatically when data is inserted.</li>
      <li><strong>Flexibility:</strong> MongoDB allows you to use collections and databases without predefining a schema, offering flexibility for rapidly evolving applications.</li>
    </ul>

    <p>By following these steps, you can easily create and work with databases in MongoDB.</p>
  </div>
)}




        {selectedChapter === 'chapter102' && (
            <div className={style.chaptercontent}>
              <h1 className={style.heading}> :  Collection </h1>

          <p>
            In MongoDB, a collection is a group of documents within a database, similar to a table in a relational database. 
            Creating a collection in MongoDB is straightforward. Collections are created automatically when you insert a document 
            into them. However, you can also create a collection explicitly using MongoDB's API.
          </p><br/>

          <h2>Steps to Create a Collection in MongoDB:</h2>

          <h3>1. Implicit Creation:</h3>
          <p>
            In MongoDB, collections are created implicitly when you insert the first document into them. If you reference a 
            collection that doesn't exist, MongoDB automatically creates it when you insert data.
          </p>

          <p><strong>Example (MongoDB Shell):</strong></p>
          <pre>
            <code>
              {`use mydatabase\n`}
              {`db.mycollection.insertOne({ name: "Alice", age: 25 })`}
            </code>
          </pre>

          <p>In the example above:</p>
          <ul>
            <li><strong>mydatabase</strong> is the database you are working with.</li><br/>
            <li><strong>mycollection</strong> is the collection created implicitly when you insert the first document <code>{`{ name: "Alice", age: 25 }`}</code>.</li>
          </ul>

          <p><strong>Example (Python with PyMongo):</strong></p>
          <pre>
            <code>
              {`from pymongo import MongoClient\n`}
              {`client = MongoClient("mongodb://localhost:27017/")\n`}
              {`db = client["mydatabase"]\n`}
              {`db.mycollection.insert_one({"name": "Alice", "age": 25})`}
            </code>
          </pre><br/>

          <h3>2. Explicit Collection Creation:</h3>
          <p>
            You can explicitly create a collection using the <code>create_collection</code> method. This is useful if you 
            want to define certain properties for the collection, such as validation rules or capped collections.
          </p>

          <p><strong>Example (MongoDB Shell):</strong></p>
          <pre>
            <code>
              {`use mydatabase\n`}
              {`db.createCollection("mycollection")`}
            </code>
          </pre>

          <p><strong>Example (Python with PyMongo):</strong></p>
          <pre>
            <code>
              {`from pymongo import MongoClient\n`}
              {`client = MongoClient("mongodb://localhost:27017/")\n`}
              {`db = client["mydatabase"]\n`}
              {`db.create_collection("mycollection")`}
            </code>
          </pre><br/>

          <h3>3. Capped Collections:</h3>
          <p>
            A capped collection is a fixed-size collection that automatically overwrites the oldest documents when it reaches its size limit. 
            Capped collections are ideal for logging data or working with time-series data.
          </p>

          <p><strong>Example (Python with PyMongo):</strong></p>
          <pre>
            <code>
              {`from pymongo import MongoClient\n`}
              {`client = MongoClient("mongodb://localhost:27017/")\n`}
              {`db = client["mydatabase"]\n`}
              {`db.create_collection("mycappedcollection", capped=True, size=1048576, max=1000)`}
            </code>
          </pre><br/>

          <h3>4. Collection Validation:</h3>
          <p>
            MongoDB allows you to set up validation rules when creating a collection. This ensures that documents in the collection 
            meet specific criteria (e.g., required fields or types of fields).
          </p>

          <p><strong>Example (Python with PyMongo, with validation):</strong></p>
          <pre>
            <code>
              {`from pymongo import MongoClient\n`}
              {`client = MongoClient("mongodb://localhost:27017/")\n`}
              {`db = client["mydatabase"]\n`}
              {`db.create_collection(\n`}
              {`  "myvalidatedcollection",\n`}
              {`  validator={\n`}
              {`    "$jsonSchema": {\n`}
              {`      "bsonType": "object",\n`}
              {`      "required": ["name", "age"],\n`}
              {`      "properties": {\n`}
              {`        "name": {"bsonType": "string"},\n`}
              {`        "age": {"bsonType": "int"}\n`}
              {`      }\n`}
              {`    }\n`}
              {`  }\n`}
              {`)`}
            </code>
          </pre><br/>

          <h2>Key Points:</h2>
          <ul>
            <li><strong>Implicit Creation:</strong> Collections are created automatically when the first document is inserted.</li><br/>
            <li><strong>Explicit Creation:</strong> Use <code>create_collection()</code> to define properties like validation rules or capped settings.</li><br/>
            <li><strong>Capped Collections:</strong> Overwrite old documents when the collection size limit is reached, ideal for logs or time-series data.</li><br/>
            <li><strong>Collection Validation:</strong> Enforce data integrity using validation rules.</li>
          </ul><br/>

          <p>
            MongoDB's flexibility with collections makes it a great choice for working with unstructured or semi-structured data. 
            The ability to create collections automatically or with explicit configurations lets you manage your data efficiently.
          </p>
        </div>
      )}
  




          {selectedChapter === 'chapter103' && (
            <div className={style.chaptercontent}>
              <h1 className={style.heading}>   Insert   </h1>


          <p>
            In MongoDB, documents are the basic unit of data and are stored in collections. Each document is represented in BSON (Binary JSON) format, which is similar to JSON but includes additional data types. MongoDB allows you to insert documents into collections using Python, typically through the <code>PyMongo</code> library, which is the official Python driver for MongoDB.
          </p>
          <br/>
          <h2>How to Insert a Document in MongoDB Using Python:</h2>

          <ol>
            <li>
              <h4>Install PyMongo</h4>
              <p>If you haven't already installed <code>PyMongo</code>, you can do so via pip:</p>
              <pre>
                <code>pip install pymongo</code>
              </pre>
            </li><br/>

            <li>
              <h4>Import the Required Libraries</h4>
              <p>You need to import <code>MongoClient</code> from <code>pymongo</code> to establish a connection to the MongoDB server.</p>
              <pre>
                <code>from pymongo import MongoClient</code>
              </pre>
            </li><br/>

            <li>
              <h4>Connect to the MongoDB Server</h4>
              <p>Create a connection to the MongoDB server. If MongoDB is running on your local machine, the connection string would look like this:</p>
              <pre>
                <code>client = MongoClient("mongodb://localhost:27017/")</code>
              </pre>
              <p>If you're using MongoDB Atlas or another cloud service, you'll need to provide your cloud instance's connection string.</p>
            </li><br/>

            <li>
              <h4> Select the Database and Collection</h4>
              <p>MongoDB databases and collections are created dynamically when you insert data into them, so you don't need to explicitly create the database or collection beforehand.</p>
              <pre>
                <code>
                  db = client["mydatabase"]  {/* This selects the "mydatabase" database */}
                  collection = db["mycollection"]  {/* This selects the "mycollection" collection */}
                </code>
              </pre>
            </li><br/>

            <li>
              <h4> Insert a Document</h4>
              <p>You can insert a document into a collection using the <code>insert_one()</code> or <code>insert_many()</code> methods, depending on whether you're inserting one document or multiple documents.</p>

              <h4>Insert One Document:</h4>
              <pre>
                <code>
                  document = {`{"name": "Alice", "age": 30, "city": "New York"}`}
                  collection.insert_one(document)
                </code>
              </pre>
              <p>The <code>insert_one()</code> method inserts a single document into the collection. The document is a Python dictionary, which MongoDB automatically converts into BSON format.</p>

              <h4>Insert Multiple Documents:</h4>
              <pre>
                <code>{`
                  documents = [
                    {"name": "Bob", "age": 25, "city": "Los Angeles"},
                    {"name": "Charlie", "age": 35, "city": "Chicago"}
                  ]
                  collection.insert_many(documents)`}
                </code>
              </pre>
              <p>The <code>insert_many()</code> method inserts multiple documents into the collection in one operation.</p>
            </li><br/>

            <li>
              <h4>Verify the Insertion</h4>
              <p>To verify that your document(s) were successfully inserted, you can query the collection and print the documents.</p>
              <pre>
                <code>
                  # Fetch and print all documents in the collection
                  for doc in collection.find():
                    print(doc)
                </code>
              </pre>
            </li>
          </ol><br/>

          <h3>Example Code:</h3>
          <pre>
            <code>
              {`from pymongo import MongoClient

# Connect to MongoDB
client = MongoClient("mongodb://localhost:27017/")

# Select the database and collection
db = client["mydatabase"]
collection = db["mycollection"]

# Insert a single document
document = {"name": "Alice", "age": 30, "city": "New York"}
collection.insert_one(document)

# Insert multiple documents
documents = [
    {"name": "Bob", "age": 25, "city": "Los Angeles"},
    {"name": "Charlie", "age": 35, "city": "Chicago"}
]
collection.insert_many(documents)

# Verify insertion
for doc in collection.find():
    print(doc)
`}
            </code>
          </pre><br/>

          <h3>Important Notes:</h3>
          <ul>
            <li><strong>_id Field:</strong> MongoDB automatically adds an <code>_id</code> field to each document, which serves as the primary key. If you don't provide an <code>_id</code> field, MongoDB generates one automatically.</li><br/>
            <li><strong>Insert Options:</strong> You can pass additional options to the insert methods, such as <code>write_concern</code> and <code>bypass_document_validation</code>, depending on your requirements.</li><br/>
            <li><strong>Error Handling:</strong> Use error handling (try-except blocks) to catch any issues, such as connection errors or invalid data.</li>
          </ul><br/>

          <h3>Key Benefits:</h3>
          <ul>
            <li><strong>Schema Flexibility:</strong> MongoDB allows inserting documents without predefined schemas. Each document in a collection can have a different structure.</li><br/>
            <li><strong>Atomic Operations:</strong> Insert operations are atomic at the document level, ensuring consistency even if multiple documents are inserted.</li><br/>
            <li><strong>Scalability:</strong> MongoDB can scale horizontally, allowing you to insert large amounts of data efficiently.</li>
          </ul><br/>

          <p>
            In conclusion, inserting documents in MongoDB using Python is easy with the <code>PyMongo</code> library. Whether you're inserting a single document or multiple documents, MongoDB's flexible schema and efficient insert methods provide great tools for managing your data.
          </p>
        </div>
      )}
   




         {selectedChapter === 'chapter104' && (
           <div className={style.chaptercontent}>
              <h1 className={style.heading}>  Find</h1>

    <p>In MongoDB, <strong>find</strong> is a method used to retrieve documents from a collection. It's one of the most commonly used operations in MongoDB for querying and reading data from a database. With Python, you can use the <code>PyMongo</code> library to perform the <strong>find</strong> operation.</p>
    <br/>
    <h3 style={{paddingBottom:"6px"}}>How to Use <code>find()</code> in PyMongo</h3>

    <h4>1. Basic Find Query</h4>
    <p>To retrieve all documents from a collection, you use the <code>find()</code> method. If no query criteria is provided, <code>find()</code> will return all documents from the collection.</p>

    <pre><code>{`from pymongo import MongoClient

# Connect to MongoDB
client = MongoClient("mongodb://localhost:27017/")

# Select database and collection
db = client["mydatabase"]
collection = db["mycollection"]

# Find all documents in the collection
for doc in collection.find():
    print(doc)`}</code></pre>

    <p>In this example:</p>
    <ul>
      <li><code>collection.find()</code> retrieves all documents from <code>mycollection</code>.</li><br/>
      <li>The <code>for</code> loop iterates over each document and prints it.</li>
    </ul><br/>

    <h4>2. Find with Query Criteria</h4>
    <p>You can filter the documents by passing a query criteria as a dictionary. This works similarly to filtering data in a SQL database.</p>

    <pre><code>{`# Find documents where the 'age' is greater than 30
query = {"age": {"$gt": 30}}
for doc in collection.find(query):
    print(doc)`}</code></pre>

    <p>In this example:</p>
    <ul>
      <li><code>{`query = {"age": {"$gt": 30}}`}</code> filters documents where the <code>age</code> field is greater than 30.</li><br/>
      <li>The operator <code>$gt</code> stands for "greater than".</li>
    </ul><br/>

    <h4>3. Projection: Select Specific Fields</h4>
    <p>You can also specify which fields to include or exclude in the result. This is called <strong>projection</strong>. If you want to only return certain fields, pass a projection dictionary as the second argument to <code>find()</code>.</p>

    <pre><code>{`# Find documents and only include the 'name' and 'age' fields
projection = {"name": 1, "age": 1, "_id": 0}
for doc in collection.find(query, projection):
    print(doc)`}</code></pre>

    <p>In this example:</p>
    <ul>
      <li><code>{`projection = {"name": 1, "age": 1, "_id": 0}`}</code> includes the <code>name</code> and <code>age</code> fields and excludes the <code>_id</code> field.</li><br/>
      <li>The <code>1</code> means include the field, and the <code>0</code> means exclude it.</li>
    </ul><br/>

    <h4>4. Find One Document</h4>
    <p>If you want to retrieve only one document that matches the query, you can use the <code>find_one()</code> method. This is useful if you're expecting just one result.</p>

    <pre><code>{`# Find one document where the 'name' is 'Alice'
document = collection.find_one({"name": "Alice"})
print(document)`}</code></pre>

    <p>In this example:</p>
    <ul>
      <li><code>find_one()</code> returns the first document that matches the query criteria. If no match is found, it returns <code>None</code>.</li>
    </ul><br/>

    <h4>5. Using Logical Operators</h4>
    <p>MongoDB supports various logical operators like <code>$and</code>, <code>$or</code>, <code>$lt</code> (less than), and more. You can use these operators in your queries to perform more complex searches.</p>

    <pre><code>{`# Find documents where 'age' is greater than 30 and 'city' is "New York"
query = {"$and": [{"age": {"$gt": 30}}, {"city": "New York"}]}
for doc in collection.find(query):
    print(doc)`}</code></pre>

    <p>In this example:</p>
    <ul>
      <li><code>$and</code> combines two conditions: <code>age</code> greater than 30 and <code>city</code> equal to "New York".</li>
    </ul><br/>

    <h4>6. Limit the Number of Results</h4>
    <p>To limit the number of documents returned by the <code>find()</code> query, you can use the <code>limit()</code> method. This is useful when you're dealing with large collections and want to restrict the number of results.</p>

    <pre><code>{`# Find the first 3 documents in the collection
for doc in collection.find().limit(3):
    print(doc)`}</code></pre>

    <p>In this example:</p>
    <ul>
      <li><code>.limit(3)</code> restricts the query to return only the first 3 documents.</li>
    </ul><br/>

    <h4>7. Sorting the Results</h4>
    <p>You can sort the results using the <code>sort()</code> method. This allows you to order the documents based on a field in ascending or descending order.</p>

    <pre><code>{`# Sort documents by 'age' in ascending order
for doc in collection.find().sort("age", 1):
    print(doc)

# Sort documents by 'age' in descending order
for doc in collection.find().sort("age", -1):
    print(doc)`}</code></pre>

    <p>In this example:</p>
    <ul>
      <li><code>.sort("age", 1)</code> sorts the documents by the <code>age</code> field in ascending order.</li><br/>
      <li><code>.sort("age", -1)</code> sorts the documents by the <code>age</code> field in descending order.</li>
    </ul><br/>

    <h3 style={{paddingBottom:"6px"}}>Key Points about <code>find()</code> in MongoDB with PyMongo</h3>
    <ul>
      <li><strong>Returns a Cursor:</strong> The <code>find()</code> method returns a cursor, which allows you to iterate through the results. It doesn’t return all the results at once but yields them one at a time.</li><br/>
      <li><strong>No Result:</strong> If no documents match the query, <code>find()</code> will return an empty result set (you’ll just get an empty cursor).</li><br/>
      <li><strong>Projection:</strong> You can control which fields to include or exclude using projection. Be mindful that if you exclude <code>_id</code>, MongoDB will not return the <code>_id</code> field by default.</li><br/>
      <li><strong>Performance:</strong> The <code>find()</code> operation can be slow if you're querying a large collection without proper indexes. You can optimize queries by adding indexes on the fields that you frequently query.</li>
    </ul><br/>

    <h3>Conclusion</h3>
    <p>The <code>find()</code> method in MongoDB is a powerful way to query documents in a collection. With PyMongo, you can use various filtering criteria, project specific fields, limit results, and even sort data. It allows for flexible, dynamic queries and is a fundamental part of working with MongoDB in Python.</p>
  </div>
)}




        {selectedChapter === 'chapter105' && (
         <div className={style.chaptercontent}>
          <h1 className={style.heading}> Query  </h1>
    <p>
      In Python MongoDB, the <code>myQuery</code> typically refers to a custom query or filter that is used to retrieve documents from a MongoDB collection based on specific criteria. MongoDB queries are often structured as dictionaries, where the keys represent the field names and the values represent the query criteria or conditions.
    </p><br/>

    <h2>Using <code>myQuery</code> in MongoDB with PyMongo</h2>
    <p>
      To perform queries in MongoDB using Python, you would typically use the <code>find()</code> method from the <code>pymongo</code> library, along with a query (such as <code>myQuery</code>) to filter documents. The query is usually a Python dictionary, where you can specify conditions like equality, comparison operators, logical operators, etc.
    </p><br/>

    <h3 style={{paddingBottom:"6px"}}>Example of <code>myQuery</code> in MongoDB with PyMongo</h3>
    <pre>
      <code>
        {`from pymongo import MongoClient\n
# Connect to MongoDB\n
client = MongoClient("mongodb://localhost:27017/")\n
\n
# Select the database and collection\n
db = client["mydatabase"]\n
collection = db["mycollection"]\n
\n
# Define a query to find documents where the 'age' is greater than 30\n
myQuery = {"age": {"$gt": 30}}\n
\n
# Use the query to find matching documents\n
for doc in collection.find(myQuery):\n
    print(doc)`}\n
      </code>
    </pre>

    <h3 style={{paddingBottom:"6px"}}>Explanation of the Code:</h3>
    <ul>
      <li><strong>Connecting to MongoDB:</strong> We connect to the MongoDB server running on <code>localhost</code> at port <code>27017</code> using <code>MongoClient</code>.</li><br/>
      <li><strong>Select Database and Collection:</strong> We select a database (<code>mydatabase</code>) and a collection (<code>mycollection</code>) within the database.</li><br/>
      <li><strong>Define <code>myQuery</code>:</strong> The query <code>myQuery</code> is defined as a dictionary. Here, it specifies that we are looking for documents where the <code>age</code> field is greater than <code>30</code>. The <code>$gt</code> operator stands for "greater than".</li><br/>
      <li><strong>Use <code>myQuery</code> with <code>find()</code>:</strong> We pass <code>myQuery</code> as an argument to the <code>find()</code> method of the collection to retrieve documents that match the condition. The <code>find()</code> method returns a cursor that we iterate over using a <code>for</code> loop, and each matching document is printed.</li>
    </ul><br/>

    <h3>MongoDB Query Operators</h3>
    <p>MongoDB provides several operators that can be used in your queries. Some common ones include:</p>
    <ul>
      <li><strong>Equality:</strong> <code>{`{"age": 30}`}</code> — Find documents where <code>age</code> equals <code>30</code>.</li><br/>
      <li><strong>Comparison Operators:</strong><br/>
        <ul>
          <li><code>$gt</code> (greater than): <code>{`{"age": {"$gt": 30}}`}</code></li><br/>
          <li><code>$lt</code> (less than): <code>{`{"age": {"$lt": 30}}`}</code></li><br/>
          <li><code>$gte</code> (greater than or equal to): <code>{`{"age": {"$gte": 30}}`}</code></li><br/>
          <li><code>$lte</code> (less than or equal to): <code>{`{"age": {"$lte": 30}}`}</code></li><br/>
          <li><code>$ne</code> (not equal to): <code>{`{"age": {"$ne": 30}}`}</code></li>
        </ul><br/>
      </li>
      <li><strong>Logical Operators:</strong><br/>
        <ul>
          <li><code>$and</code>: <code>{`{"$and": [{"age": {"$gt": 30}}, {"city": "New York"}]}`}</code></li><br/>
          <li><code>$or</code>: <code>{`{"$or": [{"age": {"$gt": 30}}, {"city": "New York"}]}`}</code></li><br/>
          <li><code>$not</code>: <code>{`{"age": {"$not": {"$gt": 30}}}`}</code></li>
        </ul><br/>
      </li><br/>
      <li><strong>Array Operators:</strong>
        <ul>
          <li><code>$in</code>: <code>{`{"age": {"$in": [30, 25]}}`}</code> — Find documents where <code>age</code> is either <code>30</code> or <code>25</code>.</li><br/>
          <li><code>$all</code>: <code>{`{"tags": {"$all": ["tech", "python"]}}`}</code> — Find documents where the <code>tags</code> array contains both "tech" and "python".</li>
        </ul><br/>
      </li>
    </ul>

    <h3>Advanced Example: Using <code>myQuery</code> with Multiple Conditions</h3>
    <pre>
      <code>
        {`# Define a more complex query with multiple conditions\n
myQuery = {\n
    "age": {"$gt": 25},\n
    "city": "New York",\n
    "tags": {"$in": ["technology", "python"]}\n
}\n
\n
# Find documents that match the complex query\n
for doc in collection.find(myQuery):\n
    print(doc)`}\n
      </code>
    </pre><br/>

    <h3>Projection with <code>myQuery</code></h3>
    <p>You can also use projection to return only specific fields. For example:</p>
    <pre>
      <code>
        {`# Define the query to find documents with a specific age\n
myQuery = {"age": {"$gt": 30}}\n
\n
# Define the projection to include only 'name' and 'age' fields\n
projection = {"name": 1, "age": 1, "_id": 0}\n
\n
# Use the query and projection to find matching documents\n
for doc in collection.find(myQuery, projection):\n
    print(doc)`}\n
      </code>
    </pre><br/>

    <h3>Conclusion</h3>
    <p>
      In MongoDB with Python (via the <code>PyMongo</code> library), a query (such as <code>myQuery</code>) is typically represented as a dictionary containing conditions that filter the documents in the collection. You can use various operators and logic to create complex queries. The <code>find()</code> method is used to retrieve documents that match the criteria specified in the query.
    </p>
    <p>
      You can also use projections to limit the fields returned and optimize query performance with proper indexing.
    </p>
  </div>
)}




        {selectedChapter === 'chapter106' && (
          <div className={style.chaptercontent}>
           <h1 className={style.heading}>Sort</h1>

    <p>In MongoDB, sorting allows you to order the results of a query based on one or more fields. This can be done in both ascending and descending order. When working with MongoDB in Python, you use the <code>sort()</code> method to specify how the query results should be ordered.</p>
    <br/>
    <h3>How Sorting Works in MongoDB with PyMongo</h3>
    <p>In PyMongo, the <code>sort()</code> method is used in conjunction with a <code>find()</code> query to order the results. The <code>sort()</code> method accepts one or more fields to sort by and the direction of the sort.</p>
    <br/>
    <h4>Syntax for Sorting in PyMongo:</h4>
    <pre><code>
      collection.find(query).sort("field_name", direction)
    </code></pre>
    <p>Where:</p>
    <ul>
      <li><strong>query</strong> is the filter that determines which documents to retrieve.</li><br/>
      <li><strong>"field_name"</strong> is the name of the field by which to sort the results.</li><br/>
      <li><strong>direction</strong> is either <code>1</code> for ascending or <code>-1</code> for descending.</li>
    </ul><br/>

    <h4>Example: Sorting Documents in Ascending Order</h4>
    <pre><code>{`
      from pymongo import MongoClient

      # Connect to MongoDB
      client = MongoClient("mongodb://localhost:27017/")

      # Select the database and collection
      db = client["mydatabase"]
      collection = db["mycollection"]

      # Find all documents and sort by 'age' in ascending order
      for doc in collection.find().sort("age", 1):  # 1 for ascending order
          print(doc)`}
    </code></pre>
    <p>In this example:</p>
    <ul>
      <li>The query <code>find()</code> retrieves all documents from the collection.</li><br/>
      <li>The <code>sort("age", 1)</code> sorts the results by the <code>age</code> field in <strong>ascending</strong> order (<code>1</code> indicates ascending).</li>
    </ul><br/>

    <h4>Example: Sorting Documents in Descending Order</h4>
    <pre><code>{`
      # Find all documents and sort by 'age' in descending order
      for doc in collection.find().sort("age", -1):  # -1 for descending order
          print(doc)`}
    </code></pre>
    <p>In this example:</p>
    <ul>
      <li>The query retrieves all documents from the collection.</li><br/>
      <li>The <code>sort("age", -1)</code> sorts the results by the <code>age</code> field in <strong>descending</strong> order (<code>-1</code> indicates descending).</li>
    </ul><br/>

    <h4>Sorting by Multiple Fields</h4>
    <pre><code>{`
      # Sort by 'city' in ascending order and 'age' in descending order
      for doc in collection.find().sort([("city", 1), ("age", -1)]):
          print(doc)`}
    </code></pre>
    <p>In this example:</p>
    <ul>
      <li>The documents are first sorted by the <code>city</code> field in <strong>ascending</strong> order (<code>1</code>), and then by the <code>age</code> field in <strong>descending</strong> order (<code>-1</code>).</li>
    </ul><br/>

    <h4>Sorting with a Query</h4>
    <pre><code>{`
      # Find documents where 'age' is greater than 30 and sort by 'name' in ascending order
      myQuery = {"age": {"$gt": 30}}
      for doc in collection.find(myQuery).sort("name", 1):  # Sort by 'name' in ascending order
          print(doc)`}
    </code></pre>
    <p>This example demonstrates how you can combine queries and sorting:</p>
    <ul>
      <li>We filter documents where <code>age</code> is greater than 30, and then sort them by <code>name</code> in <strong>ascending</strong> order.</li>
    </ul><br/>

    <h4>Key Points:</h4>
    <ul>
      <li><code>sort()</code> returns a cursor that you can iterate over.</li><br/>
      <li><code>1</code> means ascending order, and <code>-1</code> means descending order.</li><br/>
      <li>You can sort by multiple fields by passing a list of tuples (e.g., <code>[(field1, 1), (field2, -1)]</code>).</li><br/>
      <li>The <code>sort()</code> method can be combined with queries, projections, and limits to refine the results.</li>
    </ul><br/>

    <h4>Performance Consideration:</h4>
    <p>Sorting can be a performance bottleneck, especially if you have a large dataset. MongoDB can optimize sorting if there are appropriate <strong>indexes</strong> on the fields you're sorting by. To improve the performance of sorts, ensure that you create indexes on the fields frequently used in queries and sorts.</p>

    <h4>Example: Sorting with Indexes</h4>
    <pre><code>{`
      # Create an index on the 'age' field to optimize sorting
      collection.create_index([("age", 1)])

      # Now, the sort will be faster
      for doc in collection.find().sort("age", 1):
          print(doc)`}
    </code></pre>

    <p>This creates an index on the <code>age</code> field in ascending order to improve the sorting performance.</p>
    <br/>
    <h4>Conclusion:</h4>
    <p>The <code>sort()</code> method in PyMongo allows you to order query results by one or more fields. You can sort in ascending or descending order and combine it with filtering queries to get the exact documents you need. Remember to use indexes for better performance when sorting large collections.</p>
  </div>
)}




{selectedChapter === 'chapter107' && (
  <div className={style.chaptercontent}>
    <h1 className={style.heading}> Delete   </h1>

    <p>
      In Python, when working with MongoDB, the <code>delete()</code> method allows you to remove documents from a collection. There are different ways to delete documents, depending on the criteria or how many documents you want to delete. The PyMongo library provides several methods for deleting documents:
    </p>
    <br/>
    <h2>1. <code>delete_one()</code></h2>
    <p>
      This method deletes a single document that matches the specified query.
    </p>
    <p>
      <strong>Syntax:</strong>
      <pre><code>collection.delete_one(query)</code></pre>
    </p>
    <p>
      <strong>Example:</strong>
      <pre><code>{`
from pymongo import MongoClient

# Connect to MongoDB
client = MongoClient("mongodb://localhost:27017/")

# Select the database and collection
db = client["mydatabase"]
collection = db["mycollection"]

# Delete one document where the 'name' is 'John'
result = collection.delete_one({"name": "John"})

# Print the number of documents deleted
print(f"Documents deleted: {result.deleted_count}")`}
      </code></pre>
    </p>

    <p>
      In this example:
      <ul>
        <li>The query <code>{`{"name": "John"}`}</code> is used to find and delete the first document with the name "John".</li><br/>
        <li>The method <code>delete_one()</code> will delete <strong>one document</strong> that matches the query.</li>
      </ul>
    </p><br/>

    <h2>2. <code>delete_many()</code></h2>
    <p>
      This method deletes <strong>multiple documents</strong> that match a given query. It will remove all documents that satisfy the query.
    </p>
    <p>
      <strong>Syntax:</strong>
      <pre><code>collection.delete_many(query)</code></pre>
    </p>
    <p>
      <strong>Example:</strong>
      <pre><code>{`
# Delete all documents where 'age' is less than 30
result = collection.delete_many({"age": {"$lt": 30}})

# Print the number of documents deleted
print(f"Documents deleted: {result.deleted_count}")`}
      </code></pre>
    </p>

    <p>
      In this example:
      <ul>
        <li>The query <code>{`{"age": {"$lt": 30}}`}</code> is used to delete all documents where the <code>age</code> field is less than 30.</li><br/>
        <li>The <code>delete_many()</code> method will delete <strong>all matching documents</strong>.</li>
      </ul>
    </p><br/>

    <h2>3. <code>drop()</code></h2>
    <p>
      The <code>drop()</code> method deletes the entire collection, including all its documents and indexes.
    </p>
    <p>
      <strong>Syntax:</strong>
      <pre><code>collection.drop()</code></pre>
    </p>
    <p>
      <strong>Example:</strong>
      <pre><code>
# Drop the 'mycollection' collection
collection.drop()

print("Collection dropped.")
      </code></pre>
    </p>

    <p>
      In this example:
      <ul>
        <li>The <code>drop()</code> method removes the entire <code>mycollection</code> from the database, including all its documents and indexes.</li>
      </ul><br/>
    </p>

    <h3 style={{paddingBottom:"6px"}}>Key Points to Remember:</h3>
    <ul>
      <li><code>delete_one()</code>: Deletes a single document that matches the query.</li><br/>
      <li><code>delete_many()</code>: Deletes all documents that match the query.</li><br/>
      <li><code>drop()</code>: Removes the entire collection, including all documents and indexes.</li><br/>
      <li>Both <code>delete_one()</code> and <code>delete_many()</code> return a result object that contains information about the operation, such as the number of documents deleted (<code>deleted_count</code>).</li><br/>
      <li>Query operators like <code>$lt</code> (less than), <code>$gt</code> (greater than), <code>$eq</code> (equals), and <code>$ne</code> (not equal) can be used to specify which documents should be deleted.</li>
    </ul><br/>

    <h3>Example with Query Operators:</h3>
    <pre><code>{`
# Delete documents where the 'age' is greater than or equal to 60
result = collection.delete_many({"age": {"$gte": 60}})

print(f"Documents deleted: {result.deleted_count}")`}
    </code></pre>

    <p>
      In this example:
      <ul>
        <li>The query <code>{`{"age": {"$gte": 60}}`}</code> deletes all documents where the <code>age</code> field is greater than or equal to 60.</li>
      </ul>
    </p><br/>

    <h3>Conclusion:</h3>
    <ul>
      <li>Use <code>delete_one()</code> to remove a single document matching a query.</li><br/>
      <li>Use <code>delete_many()</code> to delete multiple documents that match a query.</li><br/>
      <li>Use <code>drop()</code> to delete the entire collection.</li><br/>
      <li>Always be careful when using delete operations, as they remove data permanently.</li>
    </ul>
  </div>
)}




        {selectedChapter === 'chapter108' && (
         <div className={style.chaptercontent}>
            <h1 className={style.heading}> Drop Collection</h1>

    <p>
      In MongoDB, the <code>drop()</code> method is used to delete an entire collection from a database. This operation removes all documents, indexes, and the collection itself. It's a powerful method that should be used with caution because it cannot be undone. Here's how the <code>drop()</code> method works in Python using the PyMongo library.
    </p>
    <br/>
    <h2>How to Drop a Collection in MongoDB with PyMongo:</h2>

    <h3>Syntax:</h3>
    <pre><code>collection.drop()</code></pre>

    <p>- <code>collection</code>: The collection object that you want to drop.</p>
    <br/>
    <h3>Example: Dropping a Collection in MongoDB</h3>
    <pre><code>{`
from pymongo import MongoClient

# Connect to MongoDB
client = MongoClient("mongodb://localhost:27017/")

# Select the database and collection
db = client["mydatabase"]
collection = db["mycollection"]

# Drop the collection
collection.drop()

print("Collection dropped.")`}
    </code></pre><br/>

    <h3>Explanation:</h3>
    <ol>
      <li><strong>Connect to MongoDB</strong>: A connection is established to the local MongoDB server using the <code>MongoClient</code>.</li><br/>
      <li><strong>Select Database and Collection</strong>: The code selects the <code>mydatabase</code> database and the <code>mycollection</code> collection within it.</li><br/>
      <li><strong>Drop the Collection</strong>: The <code>drop()</code> method is called on the <code>collection</code> object to remove it completely from the database.</li><br/>
      <li><strong>Print Message</strong>: A message is printed to confirm that the collection has been dropped.</li>
    </ol><br/>

    <h3>Key Points:</h3>
    <ul>
      <li>The <code>drop()</code> method removes the collection, along with all its documents and indexes.</li><br/>
      <li>This operation is <strong>permanent</strong> and cannot be undone, so it’s important to be absolutely sure before executing it.</li><br/>
      <li>The <code>drop()</code> method doesn’t require a query because it's designed to remove the entire collection.</li><br/>
      <li>If the collection doesn’t exist, MongoDB will throw an error, so it’s good practice to check if the collection exists before calling <code>drop()</code>.</li>
    </ul><br/>

    <h3>Example with Error Handling:</h3>
    <pre><code>{`
from pymongo import MongoClient
from pymongo.errors import OperationFailure

# Connect to MongoDB
client = MongoClient("mongodb://localhost:27017/")

# Select the database and collection
db = client["mydatabase"]
collection = db["mycollection"]

try:
    # Try to drop the collection
    collection.drop()
    print("Collection dropped.")
except OperationFailure as e:
    print(f"Error: {e}")`}
    </code></pre><br/>

    <h3>Performance Considerations:</h3>
    <ul>
      <li>Dropping a collection can be resource-intensive if the collection is large or has many indexes.</li><br/>
      <li>If a collection contains large amounts of data, dropping it could take some time and potentially impact the performance of the database.</li>
    </ul><br/>

    <h3>Use Cases:</h3>
    <ul>
      <li><strong>Cleaning Up</strong>: If you no longer need a collection, you can drop it to reclaim storage and maintain database organization.</li><br/>
      <li><strong>Database Management</strong>: For testing purposes or during development, dropping collections might be part of the workflow to reset the database state.</li>
    </ul><br/>

    <h3>Conclusion:</h3>
    <ul>
      <li><code>drop()</code> is used to delete an entire collection from a database.</li><br/>
      <li>It is an irreversible operation, so it should be used with caution.</li><br/>
      <li>You can enhance error handling to ensure smoother execution when dropping collections.</li>
    </ul>
  </div>
)}





          {selectedChapter === 'chapter109' && (
            <div className={style.chaptercontent}>
              <h1 className={style.heading}>  Update   </h1>


      <p>
        In MongoDB, the <code>update()</code> method (or its more commonly used variants like <code>update_one()</code> and <code>update_many()</code>) allows you to modify existing documents in a collection. This method can be used to change specific fields of a document based on certain conditions or criteria.
      </p>
      <br/>
      <h2>1. <code>update_one()</code></h2>
      <p>The <code>update_one()</code> method updates a single document that matches the query condition.</p>

      <h3>Syntax:</h3>
      <pre>
        <code>
          collection.update_one(filter, update, upsert=false)
        </code>
      </pre>
      <ul>
        <li><strong>filter:</strong> A dictionary that specifies the condition to find the document.</li><br/>
        <li><strong>update:</strong> A dictionary that defines the changes to be applied to the document.</li><br/>
        <li><strong>upsert (optional):</strong> If set to <code>true</code>, this will insert a new document if no document matches the <code>filter</code> (default is <code>false</code>).</li>
      </ul>

      <h3>Example:</h3>
      <pre>
        <code>{`
          from pymongo import MongoClient

          # Connect to MongoDB
          client = MongoClient("mongodb://localhost:27017/")

          # Select the database and collection
          db = client["mydatabase"]
          collection = db["mycollection"]

          # Update one document where 'name' is 'John' to change the 'age' to 30
          result = collection.update_one(
              {"name": "John"},
              {"$set": {"age": 30}}
          )

          print(f"Matched {result.matched_count} document(s), modified {result.modified_count} document(s).")`}
        </code>
      </pre><br/>

      <h2>2. <code>update_many()</code></h2>
      <p>The <code>update_many()</code> method updates all documents that match the query condition.</p>

      <h3>Syntax:</h3>
      <pre>
        <code>
          collection.update_many(filter, update, upsert=false)
        </code>
      </pre>
      <ul>
        <li><strong>filter:</strong> A dictionary that specifies the condition to find the documents.</li><br/>
        <li><strong>update:</strong> A dictionary that defines the changes to be applied to the documents.</li><br/>
        <li><strong>upsert (optional):</strong> If set to <code>true</code>, a new document will be inserted if no documents match the <code>filter</code> (default is <code>false</code>).</li>
      </ul>

      <h3>Example:</h3>
      <pre>
        <code>{`
          # Update all documents where 'age' is less than 30 to set 'status' to 'young'
          result = collection.update_many(
              {"age": {"$lt": 30}},
              {"$set": {"status": "young"}}
          )

          print(f"Matched {result.matched_count} document(s), modified {result.modified_count} document(s).")`}
        </code>
      </pre><br/>

      <h2>3. <code>upsert</code></h2>
      <p>If you want to insert a document when no matching document is found, you can use the <code>upsert</code> option.</p>

      <h3>Example:</h3>
      <pre>
        <code>{`
          # Try to update a document with 'name' = 'Alice', if not found, insert a new one
          result = collection.update_one(
              {"name": "Alice"},
              {"$set": {"age": 25, "status": "active"}},
              upsert=True  # Insert the document if not found
          )

          if result.upserted_id:
              print(f"Inserted a new document with _id {result.upserted_id}")
          else:
              print(f"Matched and modified {result.matched_count} document(s).")`}
        </code>
      </pre><br/>

      <h2>4. Modifying Arrays</h2>
      <p>You can also update elements in an array field using update operators such as <code>$push</code>, <code>$pull</code>, <code>$addToSet</code>, etc.</p>

      <h3>Example: Adding an Element to an Array</h3>
      <pre>
        <code>{`
          # Add a new hobby to the 'hobbies' array of a document where 'name' is 'John'
          result = collection.update_one(
              {"name": "John"},
              {"$push": {"hobbies": "reading"}}  # Add 'reading' to the 'hobbies' array
          )
          print(f"Matched {result.matched_count} document(s), modified {result.modified_count} document(s).")`}
        </code>
      </pre><br/>

      <h2>Key Points to Remember</h2>
      <ul>
        <li><strong><code>update_one()</code>:</strong> Updates only the first document that matches the filter.</li><br/>
        <li><strong><code>update_many()</code>:</strong> Updates all documents that match the filter.</li><br/>
        <li><strong><code>$set</code>:</strong> This operator is used to set a value for a field.</li><br/>
        <li><strong><code>upsert</code>:</strong> If <code>true</code>, MongoDB will insert a new document if no match is found.</li><br/>
        <li><strong>Array Modifications:</strong> You can modify elements of an array using operators like <code>$push</code>, <code>$pull</code>, and <code>$addToSet</code>.</li>
      </ul><br/>

      <h2>Example with Query Operators:</h2>
      <pre>
        <code>{`
          # Increment the 'age' field by 1 for all users with age less than 30
          result = collection.update_many(
              {"age": {"$lt": 30}},
              {"$inc": {"age": 1}}   # Update: increment 'age' by 1
          )
          print(f"Matched {result.matched_count} document(s), modified {result.modified_count} document(s).")`}
        </code>
      </pre><br/>

      <h2>Conclusion</h2>
      <p>The <code>update()</code> method in MongoDB allows you to modify documents in a collection based on specified criteria. You can update a single document with <code>update_one()</code>, multiple documents with <code>update_many()</code>, or even insert new documents using the <code>upsert</code> option. Additionally, you can modify array fields and use various update operators for more complex changes. Always ensure that your queries and updates are specific to avoid unintentional changes.</p>
    </div>
  )}



        {selectedChapter === 'chapter110' && (
          <div className={style.chaptercontent}>
            <h1 className={style.heading}>MongoDB limit() Method</h1>

    <p>
      In MongoDB, the <code>limit()</code> method is used to restrict the number of documents returned by a query. This is useful when you only need a subset of documents from a collection, such as when you're working with pagination or only need to examine a few records.
    </p>
    <br/>
    <h3>Syntax:</h3>
    <pre>
      <code>
        collection.find(query).limit(n)
      </code>
    </pre>

    <ul>
      <li>
        <strong>query</strong>: The filter condition to select documents (optional; if omitted, it returns all documents).
      </li><br/>
      <li>
        <strong>n</strong>: The maximum number of documents to return. If <code>n</code> is a positive integer, MongoDB will return up to <code>n</code> documents. If <code>n</code> is negative, it will return documents in reverse order (i.e., it behaves like <code>skip()</code> combined with <code>limit()</code> for reverse order querying).
      </li>
    </ul><br/>

    <h3>Example 1: Using <code>limit()</code> to Retrieve the First 5 Documents</h3>
    <pre>
      <code>
        from pymongo import MongoClient{"\n\n"}
        # Connect to MongoDB{"\n"}
        client = MongoClient("mongodb://localhost:27017/"){"\n\n"}
        # Select the database and collection{"\n"}
        db = client["mydatabase"]{"\n"}
        collection = db["mycollection"]{"\n\n"}
        # Retrieve the first 5 documents from the collection{"\n"}
        result = collection.find().limit(5){"\n\n"}
        for doc in result:{"\n"}
            print(doc)
      </code>
    </pre>

    <p><strong>Explanation:</strong></p>
    <ul>
      <li>The <code>collection.find()</code> retrieves all documents in the collection, but the <code>limit(5)</code> restricts the result to only 5 documents.</li><br/>
      <li>The <code>for</code> loop prints each document retrieved by the query.</li>
    </ul><br/>

    <h3>Example 2: Using <code>limit()</code> with a Query Condition</h3>
    <pre>
      <code>{`
        # Retrieve the first 3 documents where age > 30{"\n"}
        result = collection.find({"age": {"$gt": 30}}).limit(3){"\n\n"}
        for doc in result:{"\n"}
            print(doc)`}
      </code>
    </pre><br/>

    <p><strong>Explanation:</strong></p>
    <ul>
      <li>This query filters the documents where the <code>age</code> field is greater than 30 (<code>{`{"age": {"$gt": 30}}`}</code>).</li><br/>
      <li>The <code>limit(3)</code> restricts the result to only 3 matching documents.</li>
    </ul><br/>

    <h3>Example 3: Negative Limit (Reverse Order)</h3>
    <pre>
      <code>{`
        # Retrieve the last 3 documents sorted by 'age' in descending order{"\n"}
        result = collection.find().sort("age", -1).limit(3){"\n\n"}
        for doc in result:{"\n"}
            print(doc)`}
      </code>
    </pre>

    <p><strong>Explanation:</strong></p>
    <ul>
      <li><code>sort("age", -1)</code> sorts the documents by the <code>age</code> field in descending order.</li><br/>
      <li><code>limit(3)</code> restricts the result to the last 3 documents based on that sorting.</li>
    </ul><br/>

    <h3>Key Points to Remember:</h3>
    <ul>
      <li><code>limit(n)</code>: Limits the number of documents returned by a query to <code>n</code>.</li><br/>
      <li><strong>Pagination:</strong> <code>limit()</code> is often used in combination with <code>skip()</code> for pagination.</li><br/>
      <li><strong>Use Cases:</strong> Limiting results is useful when displaying a subset of records, such as showing the first few items or implementing a paging mechanism.</li><br/>
      <li><strong>Order of Documents:</strong> <code>limit()</code> does not guarantee the order of documents unless combined with <code>sort()</code>.</li>
    </ul><br/>

    <h3>Conclusion:</h3>
    <p>
      The <code>limit()</code> method is an essential part of working with large datasets in MongoDB. It helps you retrieve only the necessary amount of data, which can improve performance and prevent overloading your application with unnecessary documents.
    </p>
  </div>
)}




          {selectedChapter === 'chapter111' && (
            <div className={style.chaptercontent}>
              <h1 className={style.heading}>Python Interview Questions  </h1>

        
        
        <h2 style={{paddingBottom:"6px"}}>Basic Python Interview Questions</h2>
        <ol>
          <li>
            <strong>What is Python?</strong>
            <p><strong>Answer:</strong> Python is a high-level, interpreted, and dynamically-typed programming language known for its readability, simplicity, and large community support. It is used for web development, data analysis, machine learning, automation, and more.</p>
          </li><br/>
          <li>
            <strong>What are the key features of Python?</strong>
            <p><strong>Answer:</strong>
              <ul>
                <li>Easy to learn and use</li>
                <li>Interpreted language</li>
                <li>Dynamically typed</li>
                <li>Supports multiple programming paradigms (procedural, object-oriented, functional)</li>
                <li>Extensive standard library</li>
                <li>Cross-platform compatibility</li>
              </ul>
            </p>
          </li><br/>
          <li>
            <strong>What is the difference between Python 2.x and Python 3.x?</strong>
            <p><strong>Answer:</strong> Python 3 introduced improvements like the <code>print()</code> function, better Unicode handling, and more consistent division behavior. Python 2 is now outdated and no longer officially supported.</p>
          </li><br/>
          <li>
            <strong>What are Python’s core data types?</strong>
            <p><strong>Answer:</strong>
              <ul>
                <li>Integers (<code>int</code>)</li>
                <li>Floats (<code>float</code>)</li>
                <li>Strings (<code>str</code>)</li>
                <li>Lists (<code>list</code>)</li>
                <li>Tuples (<code>tuple</code>)</li>
                <li>Dictionaries (<code>dict</code>)</li>
                <li>Sets (<code>set</code>)</li>
                <li>Booleans (<code>bool</code>)</li>
              </ul>
            </p>
          </li><br/>
          <li>
            <strong>What is the difference between lists and tuples?</strong>
            <p><strong>Answer:</strong>
              <ul>
                <li><strong>Lists</strong> are mutable, meaning their elements can be changed after creation.</li>
                <li><strong>Tuples</strong> are immutable, meaning once created, their elements cannot be modified.</li>
              </ul>
            </p>
          </li><br/>
          <li>
            <strong>Explain what a list is in Python.</strong>
            <p><strong>Answer:</strong> A list is an ordered, mutable collection of items. Lists can hold items of any type and can be modified after creation.</p>
          </li><br/>
          <li>
            <strong>What is a dictionary in Python?</strong>
            <p><strong>Answer:</strong> A dictionary is an unordered collection of key-value pairs. It is mutable and allows fast lookups based on keys.</p>
          </li><br/>
          <li>
            <strong>What is a set in Python?</strong>
            <p><strong>Answer:</strong> A set is an unordered collection of unique elements. Sets do not allow duplicates and are mutable.</p>
          </li><br/>
          <li>
            <strong>What is the difference between <code>is</code> and <code>==</code> in Python?</strong>
            <p><strong>Answer:</strong>
              <ul>
                <li><code>==</code> checks if two objects have the same value.</li>
                <li><code>is</code> checks if two objects refer to the same memory location (identity).</li>
              </ul>
            </p>
          </li><br/>
          <li>
            <strong>What are Python’s built-in functions?</strong>
            <p><strong>Answer:</strong> Some commonly used built-in functions include: <code>print()</code>, <code>len()</code>, <code>sum()</code>, <code>range()</code>, <code>max()</code>, <code>min()</code>, <code>type()</code>, <code>str()</code>, <code>int()</code>, <code>list()</code>, etc.</p>
          </li><br/>
        </ol>
        
        

        <h2 style={{paddingBottom:"6px"}}>Intermediate Python Interview Questions</h2>
        <ol>
          <li>
            <strong>What is a lambda function in Python?</strong>
            <p><strong>Answer:</strong> A lambda function is an anonymous, small function defined using the <code>lambda</code> keyword. It can take any number of arguments but has a single expression.</p>
          </li><br/>
          <li>
            <strong>What is the purpose of the <code>self</code> keyword in Python?</strong>
            <p><strong>Answer:</strong> The <code>self</code> keyword refers to the instance of the class. It is used to access instance variables and methods within the class.</p>
          </li><br/>
          <li>
            <strong>How is exception handling done in Python?</strong>
            <p><strong>Answer:</strong> Python uses <code>try</code>, <code>except</code>, <code>else</code>, and <code>finally</code> blocks for exception handling. Code that might raise an exception is placed in the <code>try</code> block, and exceptions are caught in the <code>except</code> block.</p>
          </li><br/>
          <li>
            <strong>What is the difference between <code>del</code> and <code>remove()</code> in Python?</strong>
            <p><strong>Answer:</strong>
              <ul>
                <li><code>del</code> removes an item by its index in a list.</li>
                <li><code>remove()</code> removes the first matching item in the list by its value.</li>
              </ul>
            </p>
          </li><br/>
          <li>
            <strong>What is the <code>map()</code> function in Python?</strong>
            <p><strong>Answer:</strong> The <code>map()</code> function applies a given function to each item in an iterable (like a list) and returns a map object (an iterator).</p>
          </li><br/>
          <li>
            <strong>What is the <code>filter()</code> function in Python?</strong>
            <p><strong>Answer:</strong> The <code>filter()</code> function applies a filtering function to an iterable and returns only those elements for which the function returns <code>True</code>.</p>
          </li><br/>
          <li>
            <strong>What is the <code>reduce()</code> function in Python?</strong>
            <p><strong>Answer:</strong> The <code>reduce()</code> function from the <code>functools</code> module applies a rolling computation to sequential pairs of values in an iterable and reduces the iterable to a single value.</p>
          </li><br/>
          <li>
            <strong>What is a generator in Python?</strong>
            <p><strong>Answer:</strong> A generator is a special type of iterator defined using a function with the <code>yield</code> keyword. It generates values one at a time and is useful for handling large datasets or infinite sequences.</p>
          </li><br/>
          <li>
            <strong>What is the <code>with</code> statement in Python?</strong>
            <p><strong>Answer:</strong> The <code>with</code> statement simplifies exception handling by managing the setup and cleanup actions automatically. It is often used with file operations.</p>
          </li><br/>
        </ol>
        
        <br/>
        
        <h2 style={{paddingBottom:"6px"}}>Advanced Python Interview Questions</h2>
        <ol>
          <li>
            <strong>What is the Global Interpreter Lock (GIL) in Python?</strong>
            <p><strong>Answer:</strong> The GIL is a mechanism that prevents multiple native threads from executing Python bytecodes in parallel. It is used in CPython to manage memory and ensure thread safety but limits multi-threading performance.</p>
          </li><br/>
          <li>
            <strong>What are metaclasses in Python?</strong>
            <p><strong>Answer:</strong> A metaclass is a class of a class that defines how classes themselves are created. It can be used to customize the creation of classes, methods, and their behavior.</p>
          </li><br/>
          <li>
            <strong>What is the <code>asyncio</code> library in Python?</strong>
            <p><strong>Answer:</strong> The <code>asyncio</code> library provides infrastructure for writing asynchronous programs using <code>async</code> and <code>await</code> keywords. It is used to manage concurrency and perform I/O-bound tasks efficiently.</p>
          </li><br/>
          <li>
            <strong>What is the difference between <code>@staticmethod</code> and <code>@classmethod</code> in Python?</strong>
            <p><strong>Answer:</strong>
              <ul>
                <li><code>@staticmethod</code> defines a method that does not operate on an instance of the class, and it doesn't take <code>self</code> or <code>cls</code> as a parameter.</li>
                <li><code>@classmethod</code> defines a method that operates on the class itself, and it takes <code>cls</code> as a parameter instead of <code>self</code>.</li>
              </ul>
            </p>
          </li><br/>
          <li>
            <strong>What is a closure in Python?</strong>
            <p><strong>Answer:</strong> A closure is a function object that has access to variables in its enclosing lexical scope, even after the outer function has finished executing.</p>
          </li><br/>
          <li>
            <strong>What is the difference between deep copy and shallow copy?</strong>
            <p><strong>Answer:</strong>
              <ul>
                <li><strong>Shallow copy</strong> creates a new object but does not recursively copy objects within it. It copies references to nested objects.</li>
                <li><strong>Deep copy</strong> creates a completely independent copy of an object and all objects nested within it.</li>
              </ul>
            </p>
          </li><br/>
          <li>
            <strong>How can you optimize memory usage in Python?</strong>
            <p><strong>Answer:</strong>
              <ul>
                <li>Use generators instead of lists for large datasets.</li>
                <li>Use <code>__slots__</code> in classes to limit memory usage by preventing the creation of a default dictionary for each object.</li>
                <li>Delete unused objects using <code>del</code>.</li>
              </ul>
            </p>
          </li><br/>
          <li>
            <strong>What are Python decorators?</strong>
            <p><strong>Answer:</strong> A decorator is a function that modifies or enhances another function or method without changing its source code. It is commonly used to add functionality like logging, authorization, etc.</p>
          </li><br/>
        </ol>
      </div>
    )}





          {selectedChapter === 'chapter112' && (
            <div className={style.chaptercontent}>
              <h1 className={style.heading}> Python Practice Questions </h1>


          <p>Here are some practice questions for Python, covering a range of topics from basic to advanced. You can try these to strengthen your understanding of Python concepts:</p>

          <div className={style.section}>
            <h2 className={style.subHeading}>Basic Python Practice Questions:</h2>
            <ol className={style.list}>
              <li>Write a Python program to print "Hello, World!" on the screen.</li><br/>
              <li>Write a Python function that takes a number as an argument and returns its square.</li><br/>
              <li>Write a Python function to check whether a given number is even or odd.</li><br/>
              <li>Create a list of 5 integers and write a Python function that calculates the sum of the numbers in the list.</li><br/>
              <li>Write a Python program that takes a string as input and prints it in reverse order.</li><br/>
              <li>Write a Python program that counts the number of vowels in a given string.</li><br/>
              <li>Write a Python function that takes a list of numbers and returns the largest number from the list.</li><br/>
              <li>Write a Python program to calculate the factorial of a number using recursion.</li><br/>
              <li>Write a Python program that checks if a string is a palindrome.</li><br/>
              <li>Write a Python program to find the common elements between two lists.</li>
            </ol>
          </div>
          <br/>
          <div className={style.section}>
            <h2 className={style.subHeading}>Intermediate Python Practice Questions:</h2>
            <ol className={style.list}>
              <li>Write a Python function to check if a given number is prime.</li><br/>
              <li>Write a Python program to find the intersection of two lists.</li><br/>
              <li>Create a Python function that takes a list of integers and returns the second smallest number.</li><br/>
              <li>Write a Python program to sort a list of tuples based on the second element of each tuple.</li><br/>
              <li>Write a Python program to merge two sorted lists into one sorted list.</li><br/>
              <li>Write a Python program that finds the most frequent element in a list.</li><br/>
              <li>Write a Python program to remove duplicates from a list.</li><br/>
              <li>Write a Python program to convert a string to an integer without using the built-in function.</li><br/>
              <li>Create a Python function to find the sum of digits in a number using recursion.</li><br/>
              <li>Write a Python program to check if a given string contains only digits.</li>
            </ol>
          </div>
          <br/>
          <div className={style.section}>
            <h2 className={style.subHeading}>Advanced Python Practice Questions:</h2>
            <ol className={style.list}>
              <li>Write a Python function that implements a basic calculator (addition, subtraction, multiplication, division).</li><br/>
              <li>Write a Python program to find the longest common prefix in a list of strings.</li><br/>
              <li>Write a Python program that converts a string into a list of words.</li><br/>
              <li>Write a Python function that accepts a number and returns whether it is a perfect number.</li><br/>
              <li>Write a Python program to implement a stack using a list.</li><br/>
              <li>Write a Python program to implement a queue using two stacks.</li><br/>
              <li>Write a Python function to find all permutations of a string.</li><br/>
              <li>Write a Python program that generates a Fibonacci sequence up to a given number using dynamic programming.</li><br/>
              <li>Write a Python program that uses a decorator to measure the execution time of a function.</li><br/>
              <li>Write a Python program that checks whether a number is a power of two.</li>
            </ol>
          </div>
        </div>
      )}
   




        </div>
      </div>
    </div>

  );

}


export default Pythoncoursedata;


